import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { forwardRef } from 'react';

var _excluded$7H = ["title", "titleId"];

var SvgBookmarkFilled = function SvgBookmarkFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.35 18.8V1h13.3v18l-6.7-6.8-6.6 6.6z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7H = /*#__PURE__*/forwardRef(SvgBookmarkFilled);

var _excluded$7G = ["title", "titleId"];

var SvgButtonCheckmarkFilled = function SvgButtonCheckmarkFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1c-1.8 0-3.5.5-5 1.5s-2.6 2.4-3.3 4C1 8.2.8 10 1.2 11.8c.3 1.7 1.2 3.3 2.5 4.6s2.9 2.1 4.6 2.5c1.7.3 3.6.2 5.2-.5s3.1-1.8 4-3.3c1-1.5 1.5-3.2 1.5-5 0-2.4-1-4.7-2.6-6.4C14.7 2 12.4 1 10 1zM6.9 9.1 8.8 11l4.4-4.4 1.2 1.2-5.6 5.6-3-3 1.1-1.3z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7G = /*#__PURE__*/forwardRef(SvgButtonCheckmarkFilled);

var _excluded$7F = ["title", "titleId"];

var SvgButtonCheckmarkIcon = function SvgButtonCheckmarkIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.8 11 6.9 9.1l-1.2 1.2 3 3 5.6-5.6-1.2-1.2L8.8 11z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7F = /*#__PURE__*/forwardRef(SvgButtonCheckmarkIcon);

var _excluded$7E = ["title", "titleId"];

var SvgButtonCheckmarkOutlined = function SvgButtonCheckmarkOutlined(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5C6.5 1.5 8.2 1 10 1c2.4 0 4.7 1 6.4 2.6C18 5.3 19 7.6 19 10c0 1.8-.5 3.5-1.5 5s-2.4 2.6-4 3.3c-1.6.7-3.5.9-5.2.5-1.7-.3-3.3-1.2-4.6-2.5s-2.1-2.9-2.5-4.6C.8 10 1 8.2 1.7 6.6 2.4 4.9 3.5 3.5 5 2.5zm.9 13.6c1.2.8 2.6 1.2 4.1 1.2 1.9 0 3.8-.8 5.2-2.1 1.4-1.4 2.1-3.2 2.1-5.2 0-1.4-.4-2.9-1.2-4.1-.8-1.2-1.9-2.1-3.3-2.7-1.3-.5-2.8-.7-4.2-.4s-2.7 1-3.8 2c-1 1-1.7 2.3-2 3.8-.3 1.4-.1 2.9.4 4.2.6 1.3 1.5 2.5 2.7 3.3zm1-7L8.8 11l4.4-4.4 1.2 1.2-5.6 5.6-3-3 1.1-1.3z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7E = /*#__PURE__*/forwardRef(SvgButtonCheckmarkOutlined);

var _excluded$7D = ["title", "titleId"];

var SvgButtonXFilled = function SvgButtonXFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1c-1.8 0-3.5.5-5 1.5s-2.6 2.4-3.3 4C1 8.2.8 10 1.2 11.8c.3 1.7 1.2 3.3 2.5 4.6s2.9 2.1 4.6 2.5c1.7.3 3.6.2 5.2-.5s3.1-1.8 4-3.3c1-1.5 1.5-3.2 1.5-5 0-2.4-1-4.7-2.6-6.4C14.7 2 12.4 1 10 1zm0 7.8 1.9-1.9L13 8.1 11.2 10l1.9 1.9-1.2 1.1-1.9-1.8L8.1 13 7 11.8 8.8 10 7 8.1l1.2-1.2L10 8.8z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7D = /*#__PURE__*/forwardRef(SvgButtonXFilled);

var _excluded$7C = ["title", "titleId"];

var SvgButtonXIcon = function SvgButtonXIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m11.85 6.95-1.9 1.9-1.9-1.9-1.1 1.2 1.8 1.9-1.8 1.8 1.1 1.2 1.9-1.9 1.9 1.9 1.2-1.2-1.9-1.8 1.8-1.9-1.1-1.2z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7C = /*#__PURE__*/forwardRef(SvgButtonXIcon);

var _excluded$7B = ["title", "titleId"];

var SvgButtonXOutlined = function SvgButtonXOutlined(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.9 16.1c1.2.8 2.6 1.2 4.1 1.2 1.9 0 3.8-.8 5.2-2.1 1.4-1.4 2.1-3.2 2.1-5.2 0-1.4-.4-2.9-1.2-4.1-.8-1.2-1.9-2.1-3.3-2.7-1.3-.5-2.8-.7-4.2-.4s-2.7 1-3.8 2c-1 1-1.7 2.3-2 3.8-.3 1.4-.1 2.9.4 4.2.6 1.3 1.5 2.5 2.7 3.3zM5 2.5C6.5 1.5 8.2 1 10 1c2.4 0 4.7 1 6.4 2.6C18 5.3 19 7.6 19 10c0 1.8-.5 3.5-1.5 5s-2.4 2.6-4 3.3c-1.6.7-3.5.9-5.2.5-1.7-.3-3.3-1.2-4.6-2.5s-2.1-2.9-2.5-4.6C.8 10 1 8.2 1.7 6.6 2.4 4.9 3.5 3.5 5 2.5zm5 6.3 1.9-1.9L13 8.1 11.2 10l1.9 1.9-1.2 1.1-1.9-1.8L8.1 13 7 11.8 8.8 10 7 8.1l1.2-1.2L10 8.8z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7B = /*#__PURE__*/forwardRef(SvgButtonXOutlined);

var _excluded$7A = ["title", "titleId"];

var SvgButtonDownFilled = function SvgButtonDownFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.02 9.998c0 1.8.5 3.5 1.5 5s2.4 2.6 4 3.3c1.6.7 3.5.9 5.2.5 1.7-.3 3.3-1.2 4.6-2.5 1.3-1.3 2.1-2.9 2.5-4.6.3-1.7.2-3.6-.5-5.2s-1.8-3.1-3.3-4c-1.5-1-3.2-1.5-5-1.5-2.4 0-4.7 1-6.4 2.6-1.6 1.7-2.6 4-2.6 6.4zm5.2-.9 1.2-1.2 2.6 2.5 2.5-2.6 1.1 1.2-3.6 3.8-3.8-3.7z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7A = /*#__PURE__*/forwardRef(SvgButtonDownFilled);

var _excluded$7z = ["title", "titleId"];

var SvgButtonDownIcon = function SvgButtonDownIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.4 6 9.5 7.5 8l2.5 2.6L12.5 8 14 9.5l-4 3.9z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7z = /*#__PURE__*/forwardRef(SvgButtonDownIcon);

var _excluded$7y = ["title", "titleId"];

var SvgButtonDownOutlined = function SvgButtonDownOutlined(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5C6.5 1.5 8.2 1 10 1c2.4 0 4.7 1 6.4 2.6C18 5.3 19 7.6 19 10c0 1.8-.5 3.5-1.5 5s-2.4 2.6-4 3.3c-1.6.7-3.5.9-5.2.5-1.7-.3-3.3-1.2-4.6-2.5s-2.1-2.9-2.5-4.6C.8 10 1 8.2 1.7 6.6 2.4 4.9 3.5 3.5 5 2.5zm.9 13.6c1.2.8 2.6 1.2 4.1 1.2 1.9 0 3.8-.8 5.2-2.1 1.4-1.4 2.1-3.2 2.1-5.2 0-1.4-.4-2.9-1.2-4.1-.8-1.2-1.9-2.1-3.3-2.7-1.3-.5-2.8-.7-4.2-.4s-2.7 1-3.8 2c-1 1-1.7 2.3-2 3.8-.3 1.4-.1 2.9.4 4.2.6 1.3 1.5 2.5 2.7 3.3zm1.6-8.2 2.5 2.5 2.5-2.5 1.2 1.2-3.7 3.7-3.7-3.7 1.2-1.2z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7y = /*#__PURE__*/forwardRef(SvgButtonDownOutlined);

var _excluded$7x = ["title", "titleId"];

var SvgButtonLeftFilled = function SvgButtonLeftFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 19c1.8 0 3.5-.5 5-1.5s2.6-2.4 3.3-4c.7-1.6.9-3.5.5-5.2-.3-1.7-1.2-3.3-2.5-4.6s-2.9-2.1-4.6-2.5C10 .8 8.2 1 6.6 1.7 4.9 2.4 3.5 3.5 2.5 5S1 8.2 1 10c0 2.4 1 4.7 2.6 6.4C5.3 18 7.6 19 10 19zm.7-12.6 1.2 1.2-2.5 2.6 2.6 2.5-1.2 1.2L7 10.1l3.7-3.7z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7x = /*#__PURE__*/forwardRef(SvgButtonLeftFilled);

var _excluded$7w = ["title", "titleId"];

var SvgButtonLeftIcon = function SvgButtonLeftIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10.5 14-3.9-4 3.9-4L12 7.5 9.4 10l2.6 2.5-1.5 1.5z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7w = /*#__PURE__*/forwardRef(SvgButtonLeftIcon);

var _excluded$7v = ["title", "titleId"];

var SvgButtonLeftOutlined = function SvgButtonLeftOutlined(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5c-1.5 1-3.2 1.5-5 1.5-2.4 0-4.7-1-6.4-2.6C2 14.7 1 12.4 1 10c0-1.8.5-3.5 1.5-5s2.4-2.6 4-3.3c1.7-.7 3.5-.9 5.3-.5 1.7.3 3.3 1.2 4.6 2.5s2.1 2.9 2.5 4.6c.3 1.7.2 3.6-.5 5.2-.8 1.6-1.9 3-3.4 4zm-.9-13.6c-1.2-.8-2.6-1.2-4.1-1.2-1.9 0-3.8.8-5.2 2.1C3.4 6.2 2.7 8.1 2.7 10c0 1.4.4 2.9 1.2 4.1s1.9 2.1 3.3 2.7c1.3.6 2.8.7 4.2.4s2.7-1 3.8-2 1.7-2.3 2-3.8.1-2.9-.4-4.2c-.6-1.3-1.5-2.5-2.7-3.3zm-3.4 2.5 1.2 1.2-2.5 2.6 2.6 2.5-1.2 1.2L7 10.1l3.7-3.7z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7v = /*#__PURE__*/forwardRef(SvgButtonLeftOutlined);

var _excluded$7u = ["title", "titleId"];

var SvgButtonMinusFilled = function SvgButtonMinusFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1c-1.8 0-3.5.5-5 1.5s-2.6 2.4-3.3 4C1 8.2.8 10 1.2 11.8c.3 1.7 1.2 3.3 2.5 4.6s2.9 2.1 4.6 2.5c1.7.3 3.6.2 5.2-.5s3.1-1.8 4-3.3c1-1.5 1.5-3.2 1.5-5 0-2.4-1-4.7-2.6-6.4C14.7 2 12.4 1 10 1zM6.6 9.2h6.9v1.7H6.6V9.2z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7u = /*#__PURE__*/forwardRef(SvgButtonMinusFilled);

var _excluded$7t = ["title", "titleId"];

var SvgButtonMinusIcon = function SvgButtonMinusIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.35 9.15h-6.8v1.7h6.9v-1.7h-.1z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7t = /*#__PURE__*/forwardRef(SvgButtonMinusIcon);

var _excluded$7s = ["title", "titleId"];

var SvgButtonMinusOutlined = function SvgButtonMinusOutlined(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5C6.5 1.5 8.2 1 10 1c2.4 0 4.7 1 6.4 2.6C18 5.3 19 7.6 19 10c0 1.8-.5 3.5-1.5 5s-2.4 2.6-4 3.3c-1.6.7-3.5.9-5.2.5-1.7-.3-3.3-1.2-4.6-2.5s-2.1-2.9-2.5-4.6C.8 10 1 8.2 1.7 6.6 2.4 4.9 3.5 3.5 5 2.5zm.9 13.6c1.2.8 2.6 1.2 4.1 1.2 1.9 0 3.8-.8 5.2-2.1 1.4-1.4 2.1-3.2 2.1-5.2 0-1.4-.4-2.9-1.2-4.1-.8-1.2-1.9-2.1-3.3-2.7-1.3-.5-2.8-.7-4.2-.4s-2.7 1-3.8 2c-1 1-1.7 2.3-2 3.8-.3 1.4-.1 2.9.4 4.2.6 1.3 1.5 2.5 2.7 3.3zm.7-6.9h6.9v1.7H6.6V9.2z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7s = /*#__PURE__*/forwardRef(SvgButtonMinusOutlined);

var _excluded$7r = ["title", "titleId"];

var SvgButtonPlusFilled = function SvgButtonPlusFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5C6.5 1.5 8.2 1 10 1c2.4 0 4.7 1 6.4 2.6C18 5.3 19 7.6 19 10c0 1.8-.5 3.5-1.5 5s-2.4 2.6-4 3.3c-1.6.7-3.5.9-5.2.5-1.7-.3-3.3-1.2-4.6-2.5s-2.1-2.9-2.5-4.6C.8 10 1 8.2 1.7 6.6 2.4 4.9 3.5 3.5 5 2.5zm4.2 4.1h1.7v2.6h2.6v1.7h-2.6v2.6H9.2v-2.6H6.6V9.2h2.6V6.6z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7r = /*#__PURE__*/forwardRef(SvgButtonPlusFilled);

var _excluded$7q = ["title", "titleId"];

var SvgButtonPlusIcon = function SvgButtonPlusIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6.55h-1.6v2.6h-2.6v1.7h2.6v2.6h1.7v-2.6h2.6v-1.7h-2.6v-2.6h-.1z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7q = /*#__PURE__*/forwardRef(SvgButtonPlusIcon);

var _excluded$7p = ["title", "titleId"];

var SvgButtonPlusOutlined = function SvgButtonPlusOutlined(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5C6.5 1.5 8.2 1 10 1c2.4 0 4.7 1 6.4 2.6C18 5.3 19 7.6 19 10c0 1.8-.5 3.5-1.5 5s-2.4 2.6-4 3.3c-1.6.7-3.5.9-5.2.5-1.7-.3-3.3-1.2-4.6-2.5s-2.1-2.9-2.5-4.6C.8 10 1 8.2 1.7 6.6 2.4 4.9 3.5 3.5 5 2.5zm.9 13.6c1.2.8 2.6 1.2 4.1 1.2 1.9 0 3.8-.8 5.2-2.1 1.4-1.4 2.1-3.2 2.1-5.2 0-1.4-.4-2.9-1.2-4.1-.8-1.2-1.9-2.1-3.3-2.7-1.3-.5-2.8-.7-4.2-.4s-2.7 1-3.8 2c-1 1-1.7 2.3-2 3.8-.3 1.4-.1 2.9.4 4.2.6 1.3 1.5 2.5 2.7 3.3zm3.3-9.5h1.7v2.6h2.6v1.7h-2.6v2.6H9.2v-2.6H6.6V9.2h2.6V6.6z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7p = /*#__PURE__*/forwardRef(SvgButtonPlusOutlined);

var _excluded$7o = ["title", "titleId"];

var SvgButtonRightFilled = function SvgButtonRightFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 19c1.8 0 3.5-.5 5-1.5s2.6-2.4 3.3-4c.7-1.6.9-3.5.5-5.2-.3-1.7-1.2-3.3-2.5-4.6s-2.9-2.1-4.6-2.5C10 .8 8.2 1 6.6 1.7 4.9 2.4 3.5 3.5 2.5 5S1 8.2 1 10c0 2.4 1 4.7 2.6 6.4C5.3 18 7.6 19 10 19zm-.9-5.2-1.2-1.2 2.5-2.6-2.5-2.4L9 6.4l3.8 3.6-3.7 3.8z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7o = /*#__PURE__*/forwardRef(SvgButtonRightFilled);

var _excluded$7n = ["title", "titleId"];

var SvgButtonRightIcon = function SvgButtonRightIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14 8 12.5l2.6-2.5L8 7.5 9.5 6l3.9 4-3.9 4z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7n = /*#__PURE__*/forwardRef(SvgButtonRightIcon);

var _excluded$7m = ["title", "titleId"];

var SvgButtonRightOutlined = function SvgButtonRightOutlined(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5C6.5 1.5 8.2 1 10 1c2.4 0 4.7 1 6.4 2.6C18 5.3 19 7.6 19 10c0 1.8-.5 3.5-1.5 5s-2.4 2.6-4 3.3c-1.6.7-3.5.9-5.2.5-1.7-.3-3.3-1.2-4.6-2.5s-2.1-2.9-2.5-4.6C.8 10 1 8.2 1.7 6.6 2.4 4.9 3.5 3.5 5 2.5zm.9 13.6c1.2.8 2.6 1.2 4.1 1.2 1.9 0 3.8-.8 5.2-2.1 1.4-1.4 2.1-3.2 2.1-5.2 0-1.4-.4-2.9-1.2-4.1-.8-1.2-1.9-2.1-3.3-2.7-1.3-.5-2.8-.7-4.2-.4s-2.7 1-3.8 2c-1 1-1.7 2.3-2 3.8-.3 1.4-.1 2.9.4 4.2.6 1.3 1.5 2.5 2.7 3.3zm4.5-6.1L7.9 7.4l1.2-1.2 3.7 3.8L9 13.6l-1.2-1.2 2.6-2.4z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7m = /*#__PURE__*/forwardRef(SvgButtonRightOutlined);

var _excluded$7l = ["title", "titleId"];

var SvgButtonUpFilled = function SvgButtonUpFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 10c0-1.8-.5-3.5-1.5-5s-2.4-2.6-4-3.3C11.8 1 10 .8 8.2 1.2c-1.7.3-3.3 1.2-4.6 2.4-1.2 1.3-2.1 2.9-2.4 4.6-.4 1.8-.2 3.6.5 5.2s1.8 3.1 3.3 4c1.5 1 3.2 1.5 5 1.5 2.4 0 4.7-1 6.4-2.6C18 14.7 19 12.4 19 10zm-5.2.9-1.2 1.2L10 9.6l-2.5 2.6L6.4 11 10 7.2l3.8 3.7z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7l = /*#__PURE__*/forwardRef(SvgButtonUpFilled);

var _excluded$7k = ["title", "titleId"];

var SvgButtonUpIcon = function SvgButtonUpIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12 10 9.4 7.5 12 6 10.5l4-3.9 4 3.9-1.5 1.5z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7k = /*#__PURE__*/forwardRef(SvgButtonUpIcon);

var _excluded$7j = ["title", "titleId"];

var SvgButtonUpOutlined = function SvgButtonUpOutlined(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.002 2.498c1.5-1 3.2-1.5 5-1.5 2.4 0 4.7 1 6.4 2.6 1.6 1.7 2.6 4 2.6 6.4 0 1.8-.5 3.5-1.5 5s-2.4 2.6-4 3.3c-1.6.7-3.5.9-5.2.5-1.7-.3-3.3-1.2-4.6-2.5s-2.1-2.9-2.5-4.6c-.4-1.7-.2-3.5.5-5.1.7-1.7 1.8-3.1 3.3-4.1zm.9 13.6c1.2.8 2.6 1.2 4.1 1.2 1.9 0 3.8-.8 5.2-2.1 1.4-1.4 2.1-3.2 2.1-5.2 0-1.4-.4-2.9-1.2-4.1s-1.9-2.1-3.3-2.7c-1.3-.5-2.8-.7-4.2-.4s-2.7 1-3.8 2c-1 1-1.7 2.3-2 3.8-.3 1.4-.1 2.9.4 4.2.6 1.3 1.5 2.5 2.7 3.3zm1.6-4-1.2-1.2 3.7-3.7 3.7 3.7-1.2 1.2-2.5-2.5-2.5 2.5z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7j = /*#__PURE__*/forwardRef(SvgButtonUpOutlined);

var _excluded$7i = ["title", "titleId"];

var SvgCaretDown = function SvgCaretDown(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10 14.5 9-9H1l9 9zm0-2.4-5-5h10l-5 5z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7i = /*#__PURE__*/forwardRef(SvgCaretDown);

var _excluded$7h = ["title", "titleId"];

var SvgCaretUp = function SvgCaretUp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10 5.5-9 9h18l-9-9zm0 2.4 5 5H5l5-5z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7h = /*#__PURE__*/forwardRef(SvgCaretUp);

var _excluded$7g = ["title", "titleId"];

var SvgCheck = function SvgCheck(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.8 3.3 6 15.1l-3.8-3.9L1 12.4l5 5.1 13-13-1.2-1.2z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7g = /*#__PURE__*/forwardRef(SvgCheck);

var _excluded$7f = ["title", "titleId"];

var SvgCross = function SvgCross(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m8.65 10.05-4.2 4.2 1.4 1.4 4.2-4.2 4.2 4.2 1.4-1.4-4.2-4.2 4.2-4.2-1.4-1.4-4.2 4.2-4.2-4.3-1.5 1.5 4.3 4.2z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7f = /*#__PURE__*/forwardRef(SvgCross);

var _excluded$7e = ["title", "titleId"];

var SvgFlagFilled = function SvgFlagFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.2 19h1.7v-7.2H19l-5.4-5.4L19 1H2.2v18z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7e = /*#__PURE__*/forwardRef(SvgFlagFilled);

var _excluded$7d = ["title", "titleId"];

var SvgHeartFilled = function SvgHeartFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 2c.6.3 1.104.632 1.6 1.1 1 .9 1.5 2.2 1.5 3.5s-.4 2.6-1.3 3.6L10 19l-7.7-8.8C1.4 9.2 1 7.9 1 6.6S1.5 4 2.5 3.1l.2-.2c.5-.4 1-.8 1.6-1s1.2-.3 1.9-.3c.6 0 1.2.1 1.8.4s1.1.6 1.6 1.1l.4.4.4-.5c.5-.5 1-.9 1.6-1.1.6-.3 1.3-.4 1.9-.4.71.039 1.4.2 2 .5z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7d = /*#__PURE__*/forwardRef(SvgHeartFilled);

var _excluded$7c = ["title", "titleId"];

var SvgMoreOptions = function SvgMoreOptions(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1h-2.6v2.7h2.7V1h-.1zm0 15.3h-2.6V19h2.7v-2.7h-.1zm-2.6-7.6h2.7v2.7h-2.7V8.7z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7c = /*#__PURE__*/forwardRef(SvgMoreOptions);

var _excluded$7b = ["title", "titleId"];

var SvgPinFilled = function SvgPinFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m11 2.3 1.2-1.2L19 7.9 17.8 9l-.8-.7-3.6 3.7-1.1 4.7.6.6-1.2 1.2L7.2 14l-5.1 5L1 17.7l5.1-5-4.4-4.4 1.2-1.2.6.6 4.7-1.1L11.8 3l-.8-.7z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7b = /*#__PURE__*/forwardRef(SvgPinFilled);

var _excluded$7a = ["title", "titleId"];

var SvgStarBorder = function SvgStarBorder(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3 6.6 15l.6-3.7-2.6-2.6 3.7-.5L10 4.7l1.7 3.4 3.7.5-2.7 2.6.6 3.7-3.3-1.6zm9-5.8-6.2-.9L10 1 7.2 6.6 1 7.5l4.5 4.4-1.1 6.2 5.6-2.9 5.6 2.9-1.1-6.2L19 7.5z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$7a = /*#__PURE__*/forwardRef(SvgStarBorder);

var _excluded$79 = ["title", "titleId"];

var SvgStarFilled = function SvgStarFilled(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$79);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.8 6.6 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2L1 7.5l6.2-.9L10 1l2.8 5.6z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$79 = /*#__PURE__*/forwardRef(SvgStarFilled);

var _excluded$78 = ["title", "titleId"];

var SvgStarHalf = function SvgStarHalf(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$78);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3V4.7l1.7 3.4 3.7.5-2.7 2.6.6 3.7-3.3-1.6zm9-5.8-6.2-.9L10 1 7.2 6.6 1 7.5l4.5 4.4-1.1 6.2 5.6-2.9 5.6 2.9-1.1-6.2L19 7.5z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$78 = /*#__PURE__*/forwardRef(SvgStarHalf);

var _excluded$77 = ["title", "titleId"];

var SvgAbout = function SvgAbout(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$77);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.92 19.027H2.087V8.96L10 1.007l7.92 7.953v10.067zM3.754 17.333h12.5V9.648L10 3.374 3.754 9.646v7.687zM10.84 7.4H9.173v1.607h1.667V7.4zm-1.667 2.72h1.667v5.46H9.173v-5.46z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$77 = /*#__PURE__*/forwardRef(SvgAbout);

var _excluded$76 = ["title", "titleId"];

var SvgAccelerateGrowth = function SvgAccelerateGrowth(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$76);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.67 1H1.005v18h17.944v-1.667H2.67V1zm10.498.012v1.666h2.979L3.824 15.001l1.179 1.178L17.329 3.853v2.98h1.667v-5.82h-5.828zM5.71 7.3c.129.12.3.185.476.179a.642.642 0 1 0 0-1.284 2.3 2.3 0 0 1-.832-4.465V1h1.667v.731a2.31 2.31 0 0 1 1.515 2.155h-1.67a.684.684 0 0 0-1.366 0 .664.664 0 0 0 .686.641 2.3 2.3 0 0 1 .835 4.464v.731H5.354v-.73a2.312 2.312 0 0 1-1.517-2.156H5.5a.665.665 0 0 0 .21.463z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$76 = /*#__PURE__*/forwardRef(SvgAccelerateGrowth);

var _excluded$75 = ["title", "titleId"];

var SvgAccessibleToilet = function SvgAccessibleToilet(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$75);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.931 12.911a5.868 5.868 0 0 0-5.057-5.645v-.545a2.911 2.911 0 1 0-1.667-.013v.56A5.9 5.9 0 0 0 8.055 19h.012a5.875 5.875 0 0 0 5.571-4.048l3.052 2.972 1.163-1.194-3.922-3.819zm-6.75-8.11a1.253 1.253 0 1 1 1.77-1.774A1.253 1.253 0 0 1 7.18 4.8zm3.855 11.29a4.214 4.214 0 0 1-2.969 1.238h-.012a4.233 4.233 0 0 1-.848-8.379v5.156h4.942a4.202 4.202 0 0 1-1.113 1.988v-.004zm-2.162-3.652V8.95a4.22 4.22 0 0 1 3.344 3.49H8.874z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$75 = /*#__PURE__*/forwardRef(SvgAccessibleToilet);

var _excluded$74 = ["title", "titleId"];

var SvgAccidentalDentalCare = function SvgAccidentalDentalCare(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$74);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.668 2.475a4.355 4.355 0 0 0-6.329-.001l-.355.33-.318-.331a4.355 4.355 0 0 0-6.329.002A4.648 4.648 0 0 0 2.1 6.155l2.256 12.957 5.636-4.576 5.664 4.576 2.228-12.77.013-.206a4.648 4.648 0 0 0-1.229-3.661zM4.655 3.513a2.687 2.687 0 0 1 3.805.112l1.46 1.517 1.57-1.46.062-.064c.034-.036.07-.07.105-.1a2.685 2.685 0 0 1 3.8.1 2.984 2.984 0 0 1 .786 2.347l-.983 5.71-5.218-5.216-2.17 2.172L3.91 4.669c.138-.391.356-.749.64-1.051.033-.035.068-.07.105-.105zm5.335 8.87-4.48 3.682-1.566-9 3.927 3.928 2.171-2.173 4.87 4.87-.412 2.375-4.51-3.681z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$74 = /*#__PURE__*/forwardRef(SvgAccidentalDentalCare);

var _excluded$73 = ["title", "titleId"];

var SvgAccumulate = function SvgAccumulate(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$73);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.005 2.642V.975h4.95v4.95h-1.667v-2.08L3.28 14.012l-1.027-1.314L15.121 2.642h-2.116zm-6.05 9.593h4.667V9.142h6.333v9.833h-1.667V10.81h-3v8.166h-1.666v-5.074h-3v5.074H6.955v-1.949h-3v1.95H2.288V15.36h4.667v-3.125z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$73 = /*#__PURE__*/forwardRef(SvgAccumulate);

var _excluded$72 = ["title", "titleId"];

var SvgActivecopy = function SvgActivecopy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$72);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m14.7 4.875.514.047L19 14.824l-3.298 3.225-.949.951-9.744-9.691L4.5 8.8l-.076-.077-.589-.59L11.009 1l.917.905.029.3c.038.672.33 1.304.815 1.77a3.136 3.136 0 0 0 1.93.9zm-8.5 3.26 8.552 8.513 2.306-2.249-.76-1.989-2.232.808-.569-1.564 2.206-.8-.456-1.193-2.192.794-.568-1.565 2.166-.784-.631-1.651a4.806 4.806 0 0 1-2.428-1.3 4.335 4.335 0 0 1-.969-1.42L6.2 8.135zm-.384 5.586H1v1.665h4.816v-1.665zm3.578 3.613H1v1.665h8.394v-1.665z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$72 = /*#__PURE__*/forwardRef(SvgActivecopy);

var _excluded$71 = ["title", "titleId"];

var SvgActive = function SvgActive(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$71);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.613 7.994H9.6V1.112H7.931v6.882H2.678V1.112H1.012v18h18v-5.273L9.613 7.994zm7.732 9.45H2.678V9.662h6.459l1.111.69L8.9 12.458l1.416.88 1.347-2.106 1.74 1.082-1.348 2.107 1.416.88 1.347-2.107 2.527 1.57v2.68z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$71 = /*#__PURE__*/forwardRef(SvgActive);

var _excluded$70 = ["title", "titleId"];

var SvgAddActivity = function SvgAddActivity(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$70);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_activity_svg__Icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.add_activity_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "add_activity_svg__st0",
    d: "M14.7 3.3V1H13v2.3H7V1H5.3v2.3H2.2V19h15.7V3.3h-3.2zm1.5 14H3.8V8.8h12.3v8.5h.1zm0-10.2H3.8V5h12.3v2.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "add_activity_svg__st0",
    d: "M9.2 16.2h1.6v-2.4h2.4v-1.7h-2.4V9.8H9.2v2.3H6.8v1.7h2.4z"
  }));
};

var ForwardRef$70 = /*#__PURE__*/forwardRef(SvgAddActivity);

var _excluded$6$ = ["title", "titleId"];

var SvgAddContact = function SvgAddContact(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_contact_svg__Icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.add_contact_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "add_contact_svg__st0",
    d: "M16.7 3.3V1H15v2.3h-2.3V5H15v2.3h1.7V5H19V3.3zM10.5 8.1c1.7-1.5 1.8-4.1.3-5.8C9.3.7 6.7.6 5 2.1c-1.6 1.5-1.7 4.1-.2 5.7.1.1.2.2.2.3-2.4 1.1-4 3.5-4 6.2V19h1.6v-4.7c.1-2.8 2.5-5 5.4-4.9 2.7.1 4.8 2.2 4.9 4.9V19h1.7v-4.7c0-2.7-1.6-5.1-4.1-6.2zm-2.7-.6c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4 2.4 1.1 2.4 2.4-1.1 2.4-2.4 2.4z"
  }));
};

var ForwardRef$6$ = /*#__PURE__*/forwardRef(SvgAddContact);

var _excluded$6_ = ["title", "titleId"];

var SvgAddFile = function SvgAddFile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zM9.149 6.339h1.669v2.812h2.829v1.67h-2.829v2.812H9.149v-2.812H6.353v-1.67h2.796V6.339z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6_ = /*#__PURE__*/forwardRef(SvgAddFile);

var _excluded$6Z = ["title", "titleId"];

var SvgAdvisor1 = function SvgAdvisor1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "advisor_1_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.advisor_1_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "advisor_1_svg__st0",
    d: "M16.534 11.745a7.847 7.847 0 0 0-3.509-2.887 4.473 4.473 0 1 0-5.85-.058 7.847 7.847 0 0 0-4.987 7.3v2.889h1.666v-2.895a6.167 6.167 0 0 1 2.831-5.181l3.2 7.391 3.308-7.491a6.167 6.167 0 0 1 2.995 5.281v2.889h1.666v-2.889a7.847 7.847 0 0 0-1.32-4.349zM9.9 14.142 8.2 10.2a6.09 6.09 0 0 1 3.464-.048L9.9 14.141zm2.98-8.148a2.8 2.8 0 0 1-5.546-.539 2.808 2.808 0 0 1 2.8-2.805 2.8 2.8 0 0 1 2.746 3.344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "advisor_1_svg__st0",
    d: "M13.012 14.25h1.667v1.966h-1.667z"
  }));
};

var ForwardRef$6Z = /*#__PURE__*/forwardRef(SvgAdvisor1);

var _excluded$6Y = ["title", "titleId"];

var SvgAdvisor2 = function SvgAdvisor2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.632.983a7.253 7.253 0 0 0-5.686 11.765L.891 17.8l1.178 1.179 5.056-5.056A7.256 7.256 0 1 0 11.632.983zm3.148 11.876a5.575 5.575 0 0 1-6.3 0v-.118a3.151 3.151 0 0 1 6.3 0v.118zm-4.223-6.08a1.138 1.138 0 1 1 2.276 0 1.138 1.138 0 0 1-2.276 0zm5.7 4.6a4.825 4.825 0 0 0-2.341-2.89 2.806 2.806 0 1 0-4.472-.048 4.801 4.801 0 0 0-2.435 2.934 5.59 5.59 0 1 1 9.248.005z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6Y = /*#__PURE__*/forwardRef(SvgAdvisor2);

var _excluded$6X = ["title", "titleId"];

var SvgAgent = function SvgAgent(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.789 8.596v.054l2.202 4.175h-2.2v4.4h-3.145V19h-1.692v-3.445H15.1v-4.4h1.1L15.112 9.08l-.012-.44a6.128 6.128 0 0 0-6.359-5.965A6.188 6.188 0 0 0 4.408 4.58a6.047 6.047 0 0 0-.976 7.085 6.136 6.136 0 0 0 1.853 2.104l.8.57V19H4.393v-3.8l-.1-.071A7.814 7.814 0 0 1 1.016 9a7.7 7.7 0 0 1 2.165-5.572A7.877 7.877 0 0 1 8.7 1a7.808 7.808 0 0 1 8.089 7.596zm-7.06-1.481a.789.789 0 0 0-.562-.215v.003a.766.766 0 1 0 0 1.527A2.427 2.427 0 0 1 10 13.152v.87H8.333v-.87a2.439 2.439 0 0 1-1.645-2.288h1.671a.765.765 0 1 0 .808-.764 2.427 2.427 0 0 1-.834-4.723v-.87H10v.87a2.44 2.44 0 0 1 1.646 2.286H9.975a.788.788 0 0 0-.247-.548z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6X = /*#__PURE__*/forwardRef(SvgAgent);

var _excluded$6W = ["title", "titleId"];

var SvgAgile = function SvgAgile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.977 9.846A6.493 6.493 0 0 0 7.491 3.36c-.064 0-.129.005-.193.01a3.688 3.688 0 0 1-.124.009l1.2-1.2L7.2 1 3.7 4.5 7.2 8l1.174-1.177-1.717-1.717c.275-.05.554-.077.834-.08a4.82 4.82 0 0 1 0 9.639H1v1.667h6.491a6.494 6.494 0 0 0 6.486-6.486zM15.5 12l-1.179 1.178 1.489 1.488h-2.582a6.53 6.53 0 0 1-2.075 1.667h4.656l-1.488 1.487L15.5 19l3.5-3.5-3.5-3.5zm-12.106.38A4.82 4.82 0 0 0 4.8 13.845H2.4a6.465 6.465 0 0 1 .215-8.272l1.254 1.1a4.819 4.819 0 0 0-.475 5.709z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6W = /*#__PURE__*/forwardRef(SvgAgile);

var _excluded$6V = ["title", "titleId"];

var SvgAi = function SvgAi(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.666 3.48a7.711 7.711 0 0 0-5.426-2.413h-.207a7.726 7.726 0 0 0-7.76 7.56v.04l-2.167 4.18h2.167v4.38h3.093v1.766h1.667V15.56H4.94v-4.38H3.853l1.073-2.067v-.44a6.066 6.066 0 0 1 6.094-5.947h.16a6.099 6.099 0 0 1 5.231 8.952 6.134 6.134 0 0 1-1.825 2.102l-.793.567v4.666h1.667v-3.806l.1-.074a7.814 7.814 0 0 0 3.226-6.106 7.711 7.711 0 0 0-2.12-5.547zM9.053 5.333 7.72 9.08h1.134l.266-.853h.934l.266.853h1.133l-1.34-3.746h-1.06zm.734 2H9.4l.193-.606.194.606zm1.966-2h1.094V9.08h-1.094V5.333z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6V = /*#__PURE__*/forwardRef(SvgAi);

var _excluded$6U = ["title", "titleId"];

var SvgAirplane = function SvgAirplane(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.543 10.569h-2.486l-4.008-6.486h-4.7l2.965 6.483h-2.1l-1.2-2.754H1v8.105h15.322a2.68 2.68 0 0 0 .221-5.348zm-.221 3.681H2.667V9.478h.962l1.2 2.755h6.083L7.944 5.75H9.12l4.008 6.483h3.307a1.012 1.012 0 0 1-.113 2.017z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6U = /*#__PURE__*/forwardRef(SvgAirplane);

var _excluded$6T = ["title", "titleId"];

var SvgAlarm = function SvgAlarm(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.832 1v1.56a8.238 8.238 0 1 1-1.668 0V1h1.668zM6.349 16.22A6.571 6.571 0 0 0 10 17.329a6.579 6.579 0 0 0 6.571-6.571 6.571 6.571 0 1 0-10.222 5.464zM8.185 7.74l1.84 1.839 2.927-2.921 1.178 1.18-4.107 4.098-3.017-3.017 1.179-1.179zM3.638 1.607 1 4.161l1.16 1.198 2.638-2.553-1.16-1.199zm11.564 1.198 1.16-1.198L19 4.16l-1.16 1.198-2.638-2.553z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6T = /*#__PURE__*/forwardRef(SvgAlarm);

var _excluded$6S = ["title", "titleId"];

var SvgAluminium = function SvgAluminium(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.281 3.351h.838a1.65 1.65 0 0 1 1.649 1.65v12.37a1.65 1.65 0 0 1-1.649 1.647H5.705a1.65 1.65 0 0 1-1.649-1.648V5a1.65 1.65 0 0 1 1.649-1.649h5.219l2.333-2.334L14.436 2.2l-1.155 1.151zM5.723 17.37l8.378-.018-.001-12.35-8.395.016.018 12.352zm5.292-9.953h1.667v7.634h-1.667V7.416z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6S = /*#__PURE__*/forwardRef(SvgAluminium);

var _excluded$6R = ["title", "titleId"];

var SvgAmbulance = function SvgAmbulance(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.394 3.445h9.615l-.001 12.185h-2.4a2.665 2.665 0 0 1-5.284 0H8.67a2.665 2.665 0 0 1-5.284 0H1.009V8.584l5.138-5.14h1.58V2.279h1.667v1.167zM5.481 16.106a.99.99 0 0 0 .547.172 1 1 0 0 0 1-.99.99.99 0 1 0-1.547.818zm7.938 0a.99.99 0 0 0 .547.172 1 1 0 0 0 1-.99.99.99 0 1 0-1.547.818zm2.855-2.143h1.068l-.004-8.851h-10.5L2.676 9.274v4.689H3.72a2.666 2.666 0 0 1 4.616 0h3.321a2.667 2.667 0 0 1 4.617 0zm-1.859-2.366h-1.666V9.68h-1.917V8.013h1.917V6.097h1.666v1.916h1.917V9.68h-1.917v1.917z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6R = /*#__PURE__*/forwardRef(SvgAmbulance);

var _excluded$6Q = ["title", "titleId"];

var SvgAngleDown = function SvgAngleDown(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zM7.453 7.88 10 10.428l2.547-2.547 1.179 1.179L10 12.786 6.274 9.06l1.179-1.179z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6Q = /*#__PURE__*/forwardRef(SvgAngleDown);

var _excluded$6P = ["title", "titleId"];

var SvgAngleUp = function SvgAngleUp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zm1.525-3.976L6.275 10.94 10 7.215l3.725 3.725-1.178 1.178L10 9.572l-2.547 2.546z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6P = /*#__PURE__*/forwardRef(SvgAngleUp);

var _excluded$6O = ["title", "titleId"];

var SvgApple = function SvgApple(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.068 3.812h-.083c-.78.046-1.54.265-2.225.64V2.681L9.079 1 7.9 2.178l1.194 1.194v1.08a5.327 5.327 0 0 0-2.241-.639h-.081A4.782 4.782 0 0 0 2 8.577v2.495A7.95 7.95 0 0 0 9.929 19h.005a7.953 7.953 0 0 0 7.92-7.931v-2.5a4.786 4.786 0 0 0-4.786-4.757zm3.119 7.256a6.281 6.281 0 0 1-6.256 6.265 6.279 6.279 0 0 1-6.263-6.262V8.579a3.107 3.107 0 0 1 3.081-3.1h.035a3.629 3.629 0 0 1 2.518 1.233l.628.721.629-.721a3.617 3.617 0 0 1 2.5-1.233h.034a3.11 3.11 0 0 1 3.1 3.1l-.006 2.489z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6O = /*#__PURE__*/forwardRef(SvgApple);

var _excluded$6N = ["title", "titleId"];

var SvgArrowLeft = function SvgArrowLeft(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zm4.981-9.86 1.189 1.174-2.524 2.558 2.575 2.469-1.157 1.206-3.797-3.642 3.714-3.765z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6N = /*#__PURE__*/forwardRef(SvgArrowLeft);

var _excluded$6M = ["title", "titleId"];

var SvgArrowRight = function SvgArrowRight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zm4.498-6.128L7.902 7.408l1.189-1.174 3.714 3.765-3.797 3.642-1.157-1.206 2.575-2.469z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6M = /*#__PURE__*/forwardRef(SvgArrowRight);

var _excluded$6L = ["title", "titleId"];

var SvgArtery = function SvgArtery(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.443 1.112H3.776v18h1.667v-18zm7.387 2.082L9.269 6.757V1.112H7.602v9.67l6.407-6.41-1.18-1.178zm-5.228 10.65 7.915-7.96 1.182 1.175-7.43 7.473v4.58H7.602v-5.268z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6L = /*#__PURE__*/forwardRef(SvgArtery);

var _excluded$6K = ["title", "titleId"];

var SvgAward = function SvgAward(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.098 7.52a6.094 6.094 0 0 1-1.127 3.102l4.05 4.005-3.573.734-.733 3.573-4.694-4.666-4.693 4.666-.734-3.573-3.573-.734 4.05-4.005A6.095 6.095 0 1 1 16.098 7.52zm-10.09 6.427.327 1.621 2.505-2.477-.04-.039a6.066 6.066 0 0 1-2.586-1.22l-1.819 1.789 1.613.326zm1.553-3.184A4.427 4.427 0 1 0 12.479 3.4a4.427 4.427 0 0 0-4.918 7.363zm6.147 4.805.327-1.621 1.617-.326-1.82-1.789a6.06 6.06 0 0 1-2.584 1.22l-.04.039 2.5 2.477zM8.387 4.636a2.94 2.94 0 1 1 3.266 4.891 2.94 2.94 0 0 1-3.266-4.89zm.928 3.502a1.274 1.274 0 1 0 1.422-2.113 1.274 1.274 0 0 0-1.422 2.113z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6K = /*#__PURE__*/forwardRef(SvgAward);

var _excluded$6J = ["title", "titleId"];

var SvgBaby = function SvgBaby(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.686 7.5-1.178-1.178-1.765 1.8a4.2 4.2 0 0 0-1.408-1.588 3.25 3.25 0 1 0-4.617 0c-.6.403-1.085.954-1.409 1.6L4.531 6.322 3.353 7.5l2.509 2.543v4.79a4.167 4.167 0 1 0 8.334 0v-4.809l2.49-2.524zm-6.661-4.833a1.583 1.583 0 1 1-.002 3.166 1.583 1.583 0 0 1 .002-3.166zm2.5 12.166a2.5 2.5 0 1 1-5 0V10a2.5 2.5 0 0 1 5 0v4.833z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6J = /*#__PURE__*/forwardRef(SvgBaby);

var _excluded$6I = ["title", "titleId"];

var SvgBadgeDollar = function SvgBadgeDollar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 13.9V1h15.666v12.9L10 19l-7.833-5.1zM10 16.989l6.167-3.973V2.666H3.833v10.35L10 16.989zm-.562-5.62c.152.144.354.221.562.216a.765.765 0 1 0 0-1.528 2.426 2.426 0 0 1-.834-4.723v-.87h1.671v.87a2.44 2.44 0 0 1 1.642 2.289h-1.671a.766.766 0 1 0-.808.764 2.427 2.427 0 0 1 .837 4.723v.871H9.166v-.87a2.44 2.44 0 0 1-1.645-2.29h1.671a.788.788 0 0 0 .246.549z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6I = /*#__PURE__*/forwardRef(SvgBadgeDollar);

var _excluded$6H = ["title", "titleId"];

var SvgBadgeNo = function SvgBadgeNo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 13.9V1h15.666v12.9L10 19l-7.833-5.1zM10 16.989l6.167-3.973V2.666H3.833v10.35L10 16.989zm-.006-6.591-2.357 2.357-1.178-1.179 2.357-2.357-2.352-2.351 1.179-1.179 2.351 2.352 2.358-2.357 1.178 1.178-2.357 2.357 2.362 2.363-1.178 1.178-2.363-2.362z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6H = /*#__PURE__*/forwardRef(SvgBadgeNo);

var _excluded$6G = ["title", "titleId"];

var SvgBadgeOk = function SvgBadgeOk(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 13.9V1h15.666v12.9L10 19l-7.833-5.1zM10 16.989l6.167-3.973V2.666H3.833v10.35L10 16.989zm3.328-11.138 1.194 1.167-5.61 5.575-3.028-3.037 1.167-1.194 1.874 1.878 4.403-4.39z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6G = /*#__PURE__*/forwardRef(SvgBadgeOk);

var _excluded$6F = ["title", "titleId"];

var SvgBadgeUp = function SvgBadgeUp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 13.9V1h15.666v12.9L10 19l-7.833-5.1zM10 16.989l6.167-3.973V2.666H3.833v10.35L10 16.989zm-.833-3.008V7.655L6.869 9.953 5.691 8.775l4.311-4.311 4.307 4.306-1.178 1.178-2.298-2.297v6.33H9.167z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6F = /*#__PURE__*/forwardRef(SvgBadgeUp);

var _excluded$6E = ["title", "titleId"];

var SvgBalance = function SvgBalance(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.753 4.833h1.76V3.166H2.473v1.667h1.754l-3.2 6.5.213.38a3.373 3.373 0 0 0 2.947 1.72h.193a3.367 3.367 0 0 0 2.953-1.686l.213-.387-3.253-6.527h4.874v10.293H7.66v1.667h4.633v-1.667h-1.46V4.833h4.854l-3.2 6.5.213.38a3.367 3.367 0 0 0 2.947 1.72h.193a3.367 3.367 0 0 0 2.933-1.713l.214-.387-3.234-6.5zM4.42 11.793h-.247a1.7 1.7 0 0 1-1.24-.54l1.334-2.72 1.333 2.72a1.687 1.687 0 0 1-1.213.54h.033zm11.46 0h-.22a1.7 1.7 0 0 1-1.24-.54l1.333-2.72 1.334 2.72a1.688 1.688 0 0 1-1.234.54h.027z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6E = /*#__PURE__*/forwardRef(SvgBalance);

var _excluded$6D = ["title", "titleId"];

var SvgBall = function SvgBall(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 1 0-.02 18A9 9 0 0 0 10 1zm-.31 1.681a7.326 7.326 0 0 1-7 7.021 7.327 7.327 0 0 1 7-7.021zm-6.885 8.681A8.98 8.98 0 0 0 11.35 2.8a7.344 7.344 0 0 1 5.85 5.866 8.98 8.98 0 0 0-8.521 8.542 7.34 7.34 0 0 1-5.874-5.846zm7.529 5.955a7.326 7.326 0 0 1 6.972-6.99 7.328 7.328 0 0 1-6.972 6.99z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6D = /*#__PURE__*/forwardRef(SvgBall);

var _excluded$6C = ["title", "titleId"];

var SvgBandage = function SvgBandage(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.573 1.112c1.175 0 2.302.466 3.134 1.295a4.443 4.443 0 0 1-.001 6.267l-9.14 9.14A4.431 4.431 0 1 1 2.3 11.547l9.14-9.14a4.439 4.439 0 0 1 3.133-1.295zm-.792 9.131-3.91-3.91L6.29 9.918l3.91 3.91 3.58-3.585zm-7.29 6.99c.336-.14.641-.343.898-.6l1.628-1.622-3.91-3.91-1.63 1.622a2.765 2.765 0 0 0 3.015 4.51zm8.469-8.169L16.527 7.5a2.766 2.766 0 0 0-3.91-3.914l-1.568 1.568 3.91 3.91zm-6.227.884L9.911 8.77l1.403 1.402-1.178 1.178-1.403-1.402z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6C = /*#__PURE__*/forwardRef(SvgBandage);

var _excluded$6B = ["title", "titleId"];

var SvgBank = function SvgBank(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.727 9.265 10 1l8.273 8.265H1.727zM14.25 7.6l-4.243-4.246L5.762 7.6h8.488zm-7.936 3.206H4.65v5.017h1.664v-5.017zm11.528 6.53H2.175V19h15.667v-1.664zm-4.14-6.53h1.664v5.017h-1.664v-5.017zm-2.862 0H9.176v5.017h1.664v-5.017z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6B = /*#__PURE__*/forwardRef(SvgBank);

var _excluded$6A = ["title", "titleId"];

var SvgBeachBall = function SvgBeachBall(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.329c-.422 0-.843-.037-1.258-.11l-.3-9.275A3.871 3.871 0 0 0 9.629 7.5l6.414 6.644A7.324 7.324 0 0 1 10 17.329zm-7.2-5.981a8.94 8.94 0 0 1 3.107-4c.245.237.542.415.867.52l.283 8.838A7.355 7.355 0 0 1 2.8 11.348zm3.39-7.6.169.377c-.216.176-.407.38-.569.606a2.368 2.368 0 0 0-.411.962 10.8 10.8 0 0 0-2.355 2.061 7.367 7.367 0 0 1 3.163-4.011l.003.005zm5.584-.855c-.66.12-1.308.302-1.934.543a3.273 3.273 0 0 0-1.988-.065l-.152-.33a7.32 7.32 0 0 1 4.067-.153l.007.005zm-4.387 3.42a.5.5 0 0 1-.361-.22.508.508 0 0 1 .126-.4 1.9 1.9 0 0 1 .879-.632 2.1 2.1 0 0 1 .742-.144c.384 0 .649.127.7.257a.508.508 0 0 1-.126.4 1.91 1.91 0 0 1-.879.632 1.91 1.91 0 0 1-1.079.107h-.002zM17.329 10c0 .881-.159 1.756-.47 2.58l-6.024-6.24a2.074 2.074 0 0 0 .255-1.572 9.11 9.11 0 0 1 2.623-.384c.354-.003.707.017 1.058.06A7.311 7.311 0 0 1 17.329 10zM10 1a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6A = /*#__PURE__*/forwardRef(SvgBeachBall);

var _excluded$6z = ["title", "titleId"];

var SvgBear = function SvgBear(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.013 20.013",
    style: {
      enableBackground: 'new 0 0 20.0126 20.0126'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.486 9.501 2 .9 1.52-1.76-1-1.46-.61-1.46-.06-.08a3.29 3.29 0 0 0-.66-.63v-1.21h-2.05c-1.23-.6-2.62-.19-4.1.21-.657.191-1.325.345-2 .46-.37 0-.73 0-1.1-.09a5.72 5.72 0 0 0-4.05.7c-3 1.74-2.57 5.16-1.79 11.36v.09h2.71v-1.69h-1.23c-.61-5.06-.66-7.28 1.14-8.34a4.11 4.11 0 0 1 3-.49c.448.06.899.094 1.35.1h.1a18.15 18.15 0 0 0 2.35-.5c1.18-.31 2.28-.64 2.94-.33.734.317 1.41.753 2 1.29l.56 1.44.14.2-.5-.2a3.57 3.57 0 0 0-3.35.35c-1.81 1.21-2.61 4-2.61 8.19h2.7v-1.71h-1a9.73 9.73 0 0 1 1-4.25l1.54 5.92h2.65v-1.67h-1.32l-1.4-5.42a2 2 0 0 1 1.13.08zm-8.77 1.8a3 3 0 0 1-1.92-.12l-.53 1.58c.35.114.707.198 1.07.25l.82 3.49h2.66v-1.66h-1.34l-.47-1.9h.07a4.11 4.11 0 0 0 2.27-1.33l-1.21-1.14a2.52 2.52 0 0 1-1.42.83z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6z = /*#__PURE__*/forwardRef(SvgBear);

var _excluded$6y = ["title", "titleId"];

var SvgBicycle = function SvgBicycle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m14.627 5 .517 3.567.001.007a4.056 4.056 0 1 1-1.646.263l-.116-.8H6.672l-.1.817a4.052 4.052 0 1 1-1.644-.287l.272-2.2h7.94l-.44-3.034h5.143V5h-3.216zm-7.579 8.942a2.39 2.39 0 1 0-3.974-2.656 2.39 2.39 0 0 0 3.974 2.656zm6.572.655a2.39 2.39 0 1 0 2.656-3.975 2.39 2.39 0 0 0-2.656 3.975zM3.334 3.333h4.851V5H3.334V3.333z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6y = /*#__PURE__*/forwardRef(SvgBicycle);

var _excluded$6x = ["title", "titleId"];

var SvgBill = function SvgBill(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 1v1.67h2.333V19h13.334V2.669H19V1H1zm14 16.331H5V2.669h4.166v.87A2.427 2.427 0 0 0 10 8.263a.765.765 0 1 1-.808.764H7.521a2.44 2.44 0 0 0 1.645 2.289v.87h1.671v-.871A2.427 2.427 0 0 0 10 6.592a.766.766 0 1 1 .808-.763h1.671a2.44 2.44 0 0 0-1.642-2.289v-.871H15v14.662z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6x = /*#__PURE__*/forwardRef(SvgBill);

var _excluded$6w = ["title", "titleId"];

var SvgBinoculars = function SvgBinoculars(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.309 14.675H2.9l.407-8.162h3.56l.076 1.22h-.785v5.484h1.074l.077 1.458zM2.764 17.32l.051-.972H7.38l.051.972H2.764zM4.213 3.843h1.813v1H4.213v-1zm3.618 5.563h4.276v2.137H7.831V9.406zm5.3-2.893H16.7l.4 8.162h-4.4l.077-1.458h1.013V7.733h-.724l.076-1.22h-.011zM14 3.843h1.813v1H14v-1zm-1.422 13.478.051-.972h4.556l.051.972h-4.658zM19 19l-.716-14.161h-.8v-2.67h-5.158v2.67h-.781l-.164 2.894H8.619l-.164-2.894H7.7v-2.67H2.539v2.67h-.812L1 18.999h8.185l-.277-5.777h2.184L10.815 19H19z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6w = /*#__PURE__*/forwardRef(SvgBinoculars);

var _excluded$6v = ["title", "titleId"];

var SvgBiometric = function SvgBiometric(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "biometric_svg__Icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.biometric_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "biometric_svg__st0",
    d: "M19 5.967h-1.667V2.668h-3.3V1.001H19zM14.033 18.999v-1.667h3.3v-3.299H19v4.966zM1 14.033h1.667v3.299h3.3v1.667H1zM5.967 1.001v1.667h-3.3v3.299H1V1.001zM6.304 6.688h1.593v1.667H6.304zM12.103 6.688h1.593v1.667h-1.593zM10 14.167a3.7 3.7 0 0 1-3.695-3.7h1.666a2.029 2.029 0 0 0 4.058 0H13.7a3.7 3.7 0 0 1-3.7 3.7z"
  }));
};

var ForwardRef$6v = /*#__PURE__*/forwardRef(SvgBiometric);

var _excluded$6u = ["title", "titleId"];

var SvgBlog1 = function SvgBlog1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.333 14.686-6.5 1.284V5.942l6.5-1.284v10.028zM2.667 4.658l6.5 1.284V15.97l-6.5-1.284V4.658zM10 4.408 1 2.63v13.425l9 1.778 9-1.778V2.63l-9 1.778z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6u = /*#__PURE__*/forwardRef(SvgBlog1);

var _excluded$6t = ["title", "titleId"];

var SvgBlog2 = function SvgBlog2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.333 15.79-6.5-1.334V5.544l6.5-1.334v11.58zM2.667 4.21l6.5 1.334v8.912l-6.5 1.334V4.21zM10 4.014 1 2.167v15.666l9-1.847 9 1.847V2.167l-9 1.847z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6t = /*#__PURE__*/forwardRef(SvgBlog2);

var _excluded$6s = ["title", "titleId"];

var SvgBody = function SvgBody(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.905 11.6-4.742-4.781a4.361 4.361 0 0 0-1.275-.883A2.734 2.734 0 1 0 8.333 5.9a4.37 4.37 0 0 0-1.354.92L2.238 11.6l1.178 1.178 2.284-2.29v5.728h1.555v2.889h1.666V14.55H7.365V9.911a2.706 2.706 0 1 1 5.412 0v4.611h-1.689v4.591h1.667v-2.925h1.689v-5.7l2.282 2.287 1.179-1.175zm-7.774-6.688a1.067 1.067 0 1 1 .004-2.134 1.067 1.067 0 0 1-.004 2.134z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6s = /*#__PURE__*/forwardRef(SvgBody);

var _excluded$6r = ["title", "titleId"];

var SvgBonus = function SvgBonus(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.353 3.64v3.72L19 10l-2.621 2.653v3.7H12.64L10 19l-2.641-2.622H3.646V12.64L1 10l2.627-2.615V3.646H7.36L10 1l2.639 2.64h3.714zm-1.655 11.03v-2.71l1.932-1.951-1.957-1.952V5.32h-2.729L10 3.378 8.057 5.326h-2.75v2.757L3.38 10l1.946 1.943V14.7h2.726l1.942 1.926 1.948-1.956h2.756zm-4.131-6.816a.789.789 0 0 0-.562-.215.765.765 0 1 0 0 1.528 2.427 2.427 0 0 1 .837 4.723v.87H9.171v-.87a2.438 2.438 0 0 1-1.645-2.29H9.2a.765.765 0 1 0 .805-.763 2.427 2.427 0 0 1-.834-4.724v-.87h1.671v.871a2.441 2.441 0 0 1 1.642 2.289h-1.671a.788.788 0 0 0-.246-.549z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6r = /*#__PURE__*/forwardRef(SvgBonus);

var _excluded$6q = ["title", "titleId"];

var SvgBookmark = function SvgBookmark(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.356 1v17.847l6.567-6.614L16.644 19V1H3.356zM11.1 11.051 9.923 9.868 8.749 11.05l-3.731 3.759V2.674h9.964v12.288L11.1 11.051z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6q = /*#__PURE__*/forwardRef(SvgBookmark);

var _excluded$6p = ["title", "titleId"];

var SvgBottle = function SvgBottle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.62 7.292V1.017H7.358v6.275L5 9.65v9.368h9.976V9.65L12.62 7.292zm.691 10.06H6.667V10.34l2.358-2.358v-5.3h1.928v5.3l2.358 2.358v7.011z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6p = /*#__PURE__*/forwardRef(SvgBottle);

var _excluded$6o = ["title", "titleId"];

var SvgBottom = function SvgBottom(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M10 13.4 6 9.5 7.5 8l2.5 2.6L12.5 8 14 9.5z"
  }));
};

var ForwardRef$6o = /*#__PURE__*/forwardRef(SvgBottom);

var _excluded$6n = ["title", "titleId"];

var SvgBottomLeft = function SvgBottomLeft(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.847 17.333 19 2.18 17.82 1 2.667 16.16V5.853H1V19l13.047-.007v-1.666l-10.2.006z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6n = /*#__PURE__*/forwardRef(SvgBottomLeft);

var _excluded$6m = ["title", "titleId"];

var SvgBottomRight = function SvgBottomRight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.152 17.331 1 2.179l1.178-1.178 15.157 15.157v-8.24h1.667v11.081L7.92 18.993l.001-1.666 8.231.004z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6m = /*#__PURE__*/forwardRef(SvgBottomRight);

var _excluded$6l = ["title", "titleId"];

var SvgBoxingGlove = function SvgBoxingGlove(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.032 7.337c0-.46-.148-.908-.423-1.277a4.09 4.09 0 0 0 .253-2.443A3.572 3.572 0 0 0 12.427 1H7.5C5.439 1 3.941 2.722 3.941 5.1v4.007A6.284 6.284 0 0 0 5.4 13.122V19h8.982v-5.64a6 6 0 0 0 1.647-4.106l.003-1.917zM5.607 5.1c0-1.452.762-2.428 1.9-2.428h4.924a1.9 1.9 0 0 1 1.827 1.39c.054.384.02.776-.1 1.145a2.183 2.183 0 0 0-.281-.02h-2.583a2.325 2.325 0 0 0 0 4.649h1.382V8.164h-1.382a.658.658 0 1 1 0-1.316h2.583a.49.49 0 0 1 .488.489v1.917a4.37 4.37 0 0 1-2.333 3.836h-4.1a4.563 4.563 0 0 1-2.325-3.983V5.1zm1.463 9.656h2.058v2.577H7.07v-2.577zm5.649 2.577h-1.925v-2.577h1.925v2.577z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6l = /*#__PURE__*/forwardRef(SvgBoxingGlove);

var _excluded$6k = ["title", "titleId"];

var SvgBrain = function SvgBrain(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.24 10.13a4.089 4.089 0 0 0-.957-2.636c.043-.208.065-.42.066-.631A3.556 3.556 0 0 0 14.6 3.406a2.733 2.733 0 0 0-4.6-1.5 2.734 2.734 0 0 0-4.6 1.5 3.555 3.555 0 0 0-2.759 3.457c.001.212.023.423.066.63a4.1 4.1 0 0 0 .1 5.38 3.534 3.534 0 0 0 2.772 4.565 2.718 2.718 0 0 0 4.418.916 2.719 2.719 0 0 0 4.418-.915 3.537 3.537 0 0 0 2.776-4.57 4.083 4.083 0 0 0 1.05-2.739zM8.481 6.572c.234-.034.463-.1.681-.193v2.646c-.068 0-.134 0-.2.01a2.7 2.7 0 0 0-1.337-1.376l-.7 1.512c.219.102.396.276.5.494a2.731 2.731 0 0 0-.982 2.1h1.663a1.073 1.073 0 0 1 1.056-1.07v1.914a1.074 1.074 0 0 1-.919 1.054l.238 1.649a2.72 2.72 0 0 0 .681-.192v1.273a1.067 1.067 0 0 1-2.129.113.68.68 0 0 1 .268-.567l-1.079-1.27a2.382 2.382 0 0 0-.722 1.03 1.878 1.878 0 0 1-1.2-1.746v-.03c.277.112.565.195.86.245l.275-1.643a2.43 2.43 0 0 1 0-4.792l-.267-1.642c-.262.045-.52.115-.768.209a1.885 1.885 0 0 1 1.233-1.23c.138.285.325.543.553.763l1.151-1.206a1.034 1.034 0 0 1-.319-.758 1.072 1.072 0 1 1 1.225 1.053l.238 1.65zm6.065 5.954.277 1.643c.294-.05.582-.133.86-.245h.006v.032a1.876 1.876 0 0 1-1.2 1.748 2.379 2.379 0 0 0-.719-1.028l-1.079 1.27a.693.693 0 0 1 .271.543v.035a1.067 1.067 0 0 1-2.128-.124v-1.282c.217.093.446.158.68.192l.24-1.649a1.075 1.075 0 0 1-.92-1.054v-1.914a1.071 1.071 0 0 1 1.055 1.07h1.667a2.735 2.735 0 0 0-.982-2.1c.104-.218.28-.393.5-.494l-.7-1.512a2.7 2.7 0 0 0-1.337 1.376 3.305 3.305 0 0 0-.2-.01V6.379c.217.094.446.159.68.193l.24-1.65a1.068 1.068 0 1 1 1.224-1.053 1.037 1.037 0 0 1-.319.758l1.151 1.206c.228-.22.415-.478.552-.763A1.882 1.882 0 0 1 15.59 6.3a4.132 4.132 0 0 0-.767-.208l-.277 1.643a2.43 2.43 0 0 1 0 4.792v-.001z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6k = /*#__PURE__*/forwardRef(SvgBrain);

var _excluded$6j = ["title", "titleId"];

var SvgBriefcase = function SvgBriefcase(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.976 2.167h8.048v1.667H5.976V2.167zM1 17.833V4.742h18v13.09H1zm1.667-1.666h2.476V6.409H2.667v9.758zm4.143 0h6.38V6.409H6.81v9.758zm8.047 0h2.476V6.409h-2.476v9.758z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6j = /*#__PURE__*/forwardRef(SvgBriefcase);

var _excluded$6i = ["title", "titleId"];

var SvgBrightness = function SvgBrightness(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.814 1H9.147v3.273h1.667V1zm-6.59 2.048L3.046 4.226 5.36 6.539l1.178-1.178-2.314-2.313zM10.028 5.2a4.775 4.775 0 1 0-.006 9.551 4.775 4.775 0 0 0 .006-9.551zm0 7.883a3.108 3.108 0 1 1 0-6.219 3.108 3.108 0 0 1 0 6.22v-.001zM4.272 9.168H1v1.667h3.272V9.168zm11.456 0H19v1.667h-3.272V9.168zm-2.267 5.474 1.179-1.178 2.313 2.313-1.178 1.178-2.314-2.313zm-4.314 1.085h1.667V19H9.147v-3.273zm6.608-12.68L13.44 5.362 14.62 6.54l2.314-2.315-1.178-1.177zM3.026 15.774l2.315-2.314 1.178 1.178-2.314 2.314-1.179-1.178z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6i = /*#__PURE__*/forwardRef(SvgBrightness);

var _excluded$6h = ["title", "titleId"];

var SvgBuilding = function SvgBuilding(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m8.857 1.019-.001 7.134H.986L.985 19.016h1.668l.001-9.195h6.202l-.001 9.195h1.668l.002-16.329h6.792l-.002 16.329h1.668l.002-17.997H8.857zm7.006 4.937h-3.808v1.668h3.808V5.956zm-3.808 4.091h3.808v1.668h-3.808v-1.668z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6h = /*#__PURE__*/forwardRef(SvgBuilding);

var _excluded$6g = ["title", "titleId"];

var SvgBuildings = function SvgBuildings(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.373 1v5.113h4.167V19h-1.667V7.78h-2.5V19h-1.666V2.667h-5.58V19H3.46V1h8.913zm-4.76 18H5.947v-5.373h3.94V19H8.22v-3.707h-.607V19zm-.46-11.834H5.9v1.667h1.253V7.166zM5.9 4.153h1.253V5.82H5.9V4.153zm1.253 6.027H5.9v1.667h1.253V10.18zM8.5 7.167h1.253v1.666H8.5V7.166zm1.253-3.014H8.5V5.82h1.253V4.153zM8.5 10.18h1.253v1.667H8.5V10.18zm5.753-.753H13v1.666h1.253V9.427zM13 12.434h1.253V14.1H13v-1.666z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6g = /*#__PURE__*/forwardRef(SvgBuildings);

var _excluded$6f = ["title", "titleId"];

var SvgBull = function SvgBull(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.013 20.013",
    style: {
      enableBackground: 'new 0 0 20.0126 20.0126'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.426 15.631a41.344 41.344 0 0 0-1.33-6.42c.58.27 1 .77 1.29 2.39l1.62-.31c-.56-2.92-1.68-3.48-3.1-3.89a3.29 3.29 0 0 1-1.26-.58c-1.59-1.11-6.34-3.07-9-3.07-1.83 0-3 2.37-3.22 3.19a6.462 6.462 0 0 0-.27 2v.11l-1.15.79 1.38.52-.98.64 1.74.64.34.87 1.64-.38.61-.84c.17.268.358.526.56.77l-1.46 2.7-.34.63v.07l-.49.78h1.93l1.67-3.12.28.14v3h1.67v-4.26l-.65-.14c-.9-.2-1.67-1-2.27-2.48l-.58-1.38-.87 1.2-.78 1.07-.6-1.5c.005-.45.072-.898.2-1.33.22-.69 1-2 1.64-2 2.32 0 6.91 2 8.07 2.77a.271.271 0 0 1 .08.07.18.18 0 0 1 .07.05c.57.5 1.39 3.94 1.84 7l.12.89h1.68l-.08-.6v.01zm-6.03-5.63-1.55.6c.351.808.89 1.521 1.57 2.08.136.113.28.217.43.31l-.66 1.61-.68 1.65h1.8l1.08-2.61c.246.068.497.115.75.14l.15-1.66a3.76 3.76 0 0 1-1.8-.72 4.28 4.28 0 0 1-1.09-1.4z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6f = /*#__PURE__*/forwardRef(SvgBull);

var _excluded$6e = ["title", "titleId"];

var SvgBus = function SvgBus(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1v15.169h2.32V19h1.667v-2.831h7.7V19h1.666v-2.831h2.309V1H2.167zm14 13.5H3.833V9.418h12.334V14.5zm0-6.751H3.833V2.667h12.334v5.082zm-8.874 3.69H5.286v1.667h2.007v-1.667zm5.392 0h2.006v1.667h-2.006v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6e = /*#__PURE__*/forwardRef(SvgBus);

var _excluded$6d = ["title", "titleId"];

var SvgCafe = function SvgCafe(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.671 4.835c.13-.226.198-.482.197-.742 0-.363-.183-.572-.568-.972A2.972 2.972 0 0 1 8.273.984h1.685c0 .365.183.573.564.973a2.965 2.965 0 0 1 1.031 2.135 3.157 3.157 0 0 1-1.662 2.786l-.763-1.5c.226-.13.413-.317.543-.543zm-3.227-.742A1.475 1.475 0 0 1 5.7 5.378l.762 1.5a3.156 3.156 0 0 0 1.666-2.785A2.963 2.963 0 0 0 7.1 1.958c-.381-.4-.565-.608-.565-.973H4.849a2.972 2.972 0 0 0 1.03 2.136c.382.4.565.609.565.972zm11.699 5.414a2.988 2.988 0 0 0-2.469-.766V7.38L.985 7.362v5.865a5.774 5.774 0 0 0 5.768 5.767l3.154.022a5.773 5.773 0 0 0 5.467-3.945 3.677 3.677 0 0 0 2.508-1.053 3.5 3.5 0 0 0 1.1-2.488 2.772 2.772 0 0 0-.839-2.022zm-4.153 3.74a4.087 4.087 0 0 1-4.083 4.083l-3.154-.021a4.087 4.087 0 0 1-4.083-4.083V9.045l11.32.02v4.182zm2.722-.443c-.287.28-.65.47-1.043.549V10.447a1.382 1.382 0 0 1 1.3.274 1.101 1.101 0 0 1 .326.809 1.807 1.807 0 0 1-.583 1.27v.004z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6d = /*#__PURE__*/forwardRef(SvgCafe);

var _excluded$6c = ["title", "titleId"];

var SvgCake = function SvgCake(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.023 17.332H3.668v-4.173h12.355v4.173zM13.631 7.319v4.173H6.043V7.319h7.588zm1.668 4.173V5.651h-4.633V1H8.999v4.651H4.376v5.841H2V19h15.69v-7.508h-2.391z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6c = /*#__PURE__*/forwardRef(SvgCake);

var _excluded$6b = ["title", "titleId"];

var SvgCalculator = function SvgCalculator(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 19V1h15.666v18H2.167zm1.666-1.667h12.334V2.667H3.833v14.666zM5.858 5.294h8.283v1.667H5.858V5.294zm0 3.869h3.28v1.667h-3.28V9.163zm3.28 3.876h-3.28v1.667h3.28v-1.667zm1.723-3.876h3.28v1.667h-3.28V9.163zm3.28 3.876h-3.28v1.667h3.28v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6b = /*#__PURE__*/forwardRef(SvgCalculator);

var _excluded$6a = ["title", "titleId"];

var SvgCallback = function SvgCallback(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.813 12.213.36.367a4 4 0 0 1-.366 5.253 4 4 0 0 1-5.627 0l-10-10.046a4 4 0 0 1-.78-4.56A3.953 3.953 0 0 1 6.667 1.4 4 4 0 0 1 8.52 6.707l-.06.12 4.707 4.7.12-.06a3.954 3.954 0 0 1 4.526.746zm-1.897 4.956c.28-.117.536-.287.75-.502a2.333 2.333 0 0 0 .194-3.027l-.24-.24a2.287 2.287 0 0 0-2.62-.433l-1.167.606L6.44 7.187 7.02 6a2.307 2.307 0 0 0-1.06-3.1 2.288 2.288 0 0 0-3.08 1.04 2.306 2.306 0 0 0 .453 2.667l10.06 10.06a2.314 2.314 0 0 0 2.523.502zm-.523-11.382H18v1.666h-5.447V2h1.667v2.607l3.28-3.28L18.68 2.5l-3.287 3.287z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$6a = /*#__PURE__*/forwardRef(SvgCallback);

var _excluded$69 = ["title", "titleId"];

var SvgCamera = function SvgCamera(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$69);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.973 5.13v9.99h.01v1.666h-18V5.13h4.833V2.286h8.324V5.13h4.833zM2.65 15.12h14.656V6.8h-4.833V3.953h-4.99V6.8H2.65v8.32zm5.58-6.865a3.155 3.155 0 1 1 3.505 5.246A3.155 3.155 0 0 1 8.23 8.255zm.926 3.86a1.488 1.488 0 1 0 1.653-2.474 1.488 1.488 0 0 0-1.653 2.474z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$69 = /*#__PURE__*/forwardRef(SvgCamera);

var _excluded$68 = ["title", "titleId"];

var SvgCar = function SvgCar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$68);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.125 2.114 1.022 5.112L19 7.23v7.7h-1.99v2.852h-1.663V14.93h-10.6v2.848H3.08v-2.852H1v-7.7h1.853l1.022-5.112h12.25zM14.759 3.78H5.242l-.689 3.445h10.894l-.688-3.445zM2.667 13.263h14.666V8.892H2.667v4.37zm3.207-2.986h-1.96v1.667h1.96v-1.667zm10.303 0h-1.96v1.667h1.96v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$68 = /*#__PURE__*/forwardRef(SvgCar);

var _excluded$67 = ["title", "titleId"];

var SvgCareerAdvancement = function SvgCareerAdvancement(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$67);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.923 6.035a3.697 3.697 0 0 0-.467-.392 2.812 2.812 0 1 0-4.262 0 3.652 3.652 0 0 0-1.544 2.993v.537H6.276v3.916H1v5.913h1.667v-4.25h3.609v4.25h1.667v-8.164h3.707v8.164h1.667V8.634a2.008 2.008 0 1 1 4.016 0v10.368H19V8.634a3.652 3.652 0 0 0-1.077-2.6zm-2.6-1.076a1.145 1.145 0 1 1 .002 0h-.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$67 = /*#__PURE__*/forwardRef(SvgCareerAdvancement);

var _excluded$66 = ["title", "titleId"];

var SvgCarrot = function SvgCarrot(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$66);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 5.756h-3.412c-.043-.067-.085-.134-.13-.2l3.132-3.131-1.178-1.178-3.127 3.127a4.91 4.91 0 0 0-.244-.162V1.028h-1.666v2.526c-.303-.06-.61-.09-.919-.09a4.898 4.898 0 0 0-3.984 2.059l-5.9 8.541A3.11 3.11 0 0 0 5.91 18.4l8.362-6.06a4.864 4.864 0 0 0 1.977-4.916H19V5.756zm-5.7 5.228L9.285 13.9l-1.839-1.84-1.178 1.173 1.651 1.652-2.978 2.158a1.445 1.445 0 0 1-2-2.023l4.83-6.993 2.338 2.339 1.178-1.178-2.558-2.554.1-.151a3.218 3.218 0 1 1 4.469 4.5l.002.001z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$66 = /*#__PURE__*/forwardRef(SvgCarrot);

var _excluded$65 = ["title", "titleId"];

var SvgCart = function SvgCart(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$65);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.564 1.19 5.213 5.2H19l-2.406 12.421H3.41L1 6.39h1.262l5.209-5.201 1.286 1.074L4.62 6.39h10.799l-4.141-4.127 1.286-1.073zM4.781 17.136h10.44l1.749-9.07H3.025l1.756 9.07zm8.645-7.911 1.194 1.166-5.61 5.575-3.028-3.037 1.167-1.194 1.874 1.879 4.403-4.389z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$65 = /*#__PURE__*/forwardRef(SvgCart);

var _excluded$64 = ["title", "titleId"];

var SvgCarton = function SvgCarton(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$64);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.692 8.7-5.839-5.843v-1.84H9.187v1.867L3.373 8.7v10.317h13.321V8.7h-.002zm-6.659-4.306L14.339 8.7H5.728l4.305-4.306zm5 12.957H5.039v-6.985h9.989l.005 6.985z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$64 = /*#__PURE__*/forwardRef(SvgCarton);

var _excluded$63 = ["title", "titleId"];

var SvgCash1 = function SvgCash1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$63);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.047 16.253v-12.5h17.907v12.5H1.047zm1.666-1.666h14.574V5.42H2.714v9.167zm8.466-1.765a3.088 3.088 0 0 1-1.18.245h-.053a3.087 3.087 0 0 1 0-6.173 3.107 3.107 0 0 1 3.114 3.06 3.086 3.086 0 0 1-1.88 2.868zm-.17-3.854a1.433 1.433 0 0 0-2.013.008A1.42 1.42 0 0 0 10 11.4a1.42 1.42 0 0 0 1.44-1.433 1.434 1.434 0 0 0-.432-.999zm-5.41.178H3.9v1.667h1.7V9.146zm8.8 0h1.7v1.667h-1.7V9.146z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$63 = /*#__PURE__*/forwardRef(SvgCash1);

var _excluded$62 = ["title", "titleId"];

var SvgCash2 = function SvgCash2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$62);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 16.245V3.755h18v12.49H1zm1.667-1.663h14.666V5.42H2.667v9.16zm7.026-2.994a.434.434 0 0 0 .307.127.435.435 0 0 0 0-.87 2.1 2.1 0 0 1-.833-4.025v-.735h1.666v.735A2.1 2.1 0 0 1 12.1 8.746h-1.666A.434.434 0 1 0 10 9.18a2.1 2.1 0 0 1 .853 4.02v.74H9.187v-.723A2.1 2.1 0 0 1 7.9 11.28h1.666c0 .115.046.225.127.307zM5.598 9.18H3.9v1.666h1.699V9.18zm8.804 0h1.699v1.666h-1.699V9.18z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$62 = /*#__PURE__*/forwardRef(SvgCash2);

var _excluded$61 = ["title", "titleId"];

var SvgCashBenefit = function SvgCashBenefit(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$61);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.02 1.008V8.6H19V1.008H7.02zm10.3 5.913H8.7V2.684h8.627L17.32 6.92zm-4.31-.962a1.157 1.157 0 1 0 0-2.315 1.157 1.157 0 0 0 0 2.315zm-.719 6.033h5.876v-.002a.833.833 0 0 1 .589 1.422l-5.334 5.334a.828.828 0 0 1-.589.244H1v-1.666h11.488l3.667-3.668h-4.91a2.332 2.332 0 0 1-1.286.385H6.231v-1.667h3.728a.687.687 0 1 0 0-1.374H5.774l-4.323 1.21L1 10.61l4.434-1.244a.856.856 0 0 1 .225-.031h4.3a2.336 2.336 0 0 1 2.332 2.657z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$61 = /*#__PURE__*/forwardRef(SvgCashBenefit);

var _excluded$60 = ["title", "titleId"];

var SvgCashier = function SvgCashier(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$60);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.833 8.71v7.457H19v1.666H1v-1.666h1.167V8.71h10.4V7.1h-3.6V2.167h8.866V7.1h-3.6v1.61h3.6zm-7.2-4.873v1.6h5.533v-1.6h-5.533zm-6.8 12.33h12.333l.001-5.791H3.833v5.791zm1.776-4.172h2.828v1.667H5.609v-1.667zm5.779 0H9.614v1.667h1.774v-1.667zm1.18 0h1.774v1.667h-1.774v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$60 = /*#__PURE__*/forwardRef(SvgCashier);

var _excluded$5$ = ["title", "titleId"];

var SvgCashless = function SvgCashless(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.23 4.052V1H1.561v18H3.23v-3.052h15.209V4.052H3.23zm13.54 10.229H3.23v-1.513h4V11.1h-4V8.6h13.54v5.681zm0-7.345H3.23V5.719h13.54v1.217z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5$ = /*#__PURE__*/forwardRef(SvgCashless);

var _excluded$5_ = ["title", "titleId"];

var SvgCaution = function SvgCaution(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 16.667 10 1.08l9 15.588H1zM16.113 15 10 4.413 3.887 15h12.226zm-5.279-7.772H9.167v4.667h1.667V7.228zm0 5.342H9.167v1.667h1.667V12.57z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5_ = /*#__PURE__*/forwardRef(SvgCaution);

var _excluded$5Z = ["title", "titleId"];

var SvgCells = function SvgCells(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.349 2.345a2.631 2.631 0 0 0-2.359 3.808l-1.034 1.034a4.15 4.15 0 0 0-5.23-.566L6.005 4.9A2.64 2.64 0 1 0 4.84 6.092l1.7 1.7a4.157 4.157 0 0 0 .532 5.287L6.01 14.133a2.612 2.612 0 0 0-2.665.15 2.637 2.637 0 1 0 4.102 2.192 2.61 2.61 0 0 0-.268-1.15L8.5 14a4.157 4.157 0 0 0 5.377-5.377l1.286-1.286a2.637 2.637 0 0 0 3.76-2.925 2.636 2.636 0 0 0-2.576-2.065l.002-.002zm-11.544 15.1a.97.97 0 1 1 0-1.94.97.97 0 0 1 0 1.94zM3.636 4.719a.971.971 0 1 1-.002-1.942.971.971 0 0 1 .002 1.942zm6.357 7.893a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm6.356-6.66a.97.97 0 1 1 0-1.94.97.97 0 0 1 0 1.94z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5Z = /*#__PURE__*/forwardRef(SvgCells);

var _excluded$5Y = ["title", "titleId"];

var SvgChangeOfLifeInsured = function SvgChangeOfLifeInsured(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 6.213a1.235 1.235 0 0 1 1.238-1.235h7.283l-1.227 1.233 1.178 1.178 3.2-3.207-3.2-3.207-1.178 1.18 1.152 1.156H6.238a2.906 2.906 0 0 0-2.9 2.9v2.79H5V6.212zm5.119 2a.465.465 0 0 1 .464.463h1.666a2.135 2.135 0 0 0-1.3-1.96v-.5H9.284v.5a2.132 2.132 0 0 0 .834 4.093.464.464 0 1 1-.466.465H7.986a2.134 2.134 0 0 0 1.3 1.961v.505h1.667v-.505a2.131 2.131 0 0 0-.833-4.093.464.464 0 0 1-.001-.93zm0 0h.001-.002.001zm4.519 6.398c.231-.232.362-.546.362-.873v-2.783h1.668v2.784a2.9 2.9 0 0 1-2.9 2.9H6.56L7.712 17.8l-1.178 1.175-3.2-3.207 3.2-3.207 1.178 1.18-1.227 1.232h7.28c.327 0 .641-.13.873-.362z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5Y = /*#__PURE__*/forwardRef(SvgChangeOfLifeInsured);

var _excluded$5X = ["title", "titleId"];

var SvgChangeOfLifeInsuredAlternate = function SvgChangeOfLifeInsuredAlternate(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.552 7.794a3 3 0 1 0-2.891 0A4.908 4.908 0 0 0 10 9.817a4.91 4.91 0 0 0-2.661-2.023 3 3 0 1 0-2.891 0A4.9 4.9 0 0 0 1 12.469v5.364h1.667V12.47a3.226 3.226 0 1 1 6.453 0v5.364h1.76V12.47a3.227 3.227 0 0 1 6.453 0v5.364H19V12.47a4.901 4.901 0 0 0-3.448-4.675zm-9.659-3.96a1.334 1.334 0 1 1 0 2.667 1.334 1.334 0 0 1 0-2.668zm8.213 0a1.334 1.334 0 1 1 0 2.667 1.334 1.334 0 0 1 0-2.668z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5X = /*#__PURE__*/forwardRef(SvgChangeOfLifeInsuredAlternate);

var _excluded$5W = ["title", "titleId"];

var SvgChart = function SvgChart(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.178 14.608V8.693h-6.345v-3.3a2.276 2.276 0 1 0-1.666 0v3.3H2.822v5.915a2.276 2.276 0 1 0 1.666 0V10.36h4.679v4.248a2.276 2.276 0 1 0 1.666 0V10.36h4.679v4.248a2.276 2.276 0 1 0 1.666 0zM3.655 17.333a.609.609 0 1 1 0-1.217.609.609 0 0 1 0 1.217zm6.345 0a.609.609 0 1 1 0-1.218.609.609 0 0 1 0 1.218zm0-13.448a.609.609 0 1 1 0-1.218.609.609 0 0 1 0 1.218zm6.345 13.448a.609.609 0 1 1 0-1.218.609.609 0 0 1 0 1.218z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5W = /*#__PURE__*/forwardRef(SvgChart);

var _excluded$5V = ["title", "titleId"];

var SvgChart1 = function SvgChart1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.154 2.642V.975h4.95v4.95h-1.667V3.921l-7.39 7.47-2.798-2.832-4.96 5.017-1.185-1.17 6.145-6.218 2.798 2.832 6.311-6.378h-2.204zM1.104 17.31h18v1.667h-18V17.31z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5V = /*#__PURE__*/forwardRef(SvgChart1);

var _excluded$5U = ["title", "titleId"];

var SvgChart2 = function SvgChart2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.095 2.642V.975h4.949v4.95h-1.666V3.926L12.36 9.02 8.39 5.01l1.184-1.173 2.784 2.811 3.945-4.005h-2.208zM6.118 7.29l-5.073 5.113 1.183 1.174 5.073-5.114L6.118 7.29zm12.926 10.02h-18v1.666h18V17.31z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5U = /*#__PURE__*/forwardRef(SvgChart2);

var _excluded$5T = ["title", "titleId"];

var SvgChartHistory = function SvgChartHistory(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.872 2.006A9.02 9.02 0 0 1 10 1a9.001 9.001 0 1 1-3.331 17.364l.616-1.548a7.327 7.327 0 1 0-3.56-10.611h2.221v1.667H1v-4.95h1.663V4.79a9.02 9.02 0 0 1 3.21-2.784zm7.875 4.254a5.314 5.314 0 0 1 1.553 3.749h.001a5.311 5.311 0 0 1-10.622 0v-.833h4.485V4.7H10a5.314 5.314 0 0 1 3.747 1.56zm-2.919 4.581H6.44a3.646 3.646 0 1 0 4.388-4.382v4.382zm-6.803 3.417-1.356.969a9.001 9.001 0 0 0 1.92 1.967l1-1.331a7.399 7.399 0 0 1-1.564-1.605zM1 10h1.663c0 .867.154 1.727.455 2.54l-1.564.577A8.975 8.975 0 0 1 1 10z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5T = /*#__PURE__*/forwardRef(SvgChartHistory);

var _excluded$5S = ["title", "titleId"];

var SvgCheckBox = function SvgCheckBox(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2 2h16v16H2V2zM0 20V0h20v20H0zM6.9 9.1 8.8 11l4.4-4.4 1.2 1.2-5.6 5.6-3-3 1.1-1.3z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5S = /*#__PURE__*/forwardRef(SvgCheckBox);

var _excluded$5R = ["title", "titleId"];

var SvgCheckBoxIndeterminate = function SvgCheckBoxIndeterminate(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.013 20.013",
    style: {
      enableBackground: 'new 0 0 20.0126 20.0126'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.006 2.006h16v16h-16v-16zm-2 18v-20h20v20h-20zm5.7-9.3h8.6v-2h-8.6v2z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5R = /*#__PURE__*/forwardRef(SvgCheckBoxIndeterminate);

var _excluded$5Q = ["title", "titleId"];

var SvgCheckBoxOutlineBlank = function SvgCheckBoxOutlineBlank(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.013 20.013",
    style: {
      enableBackground: 'new 0 0 20.0126 20.0126'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.006 2.006h-16v16h16v-16zm-18-2v20h20v-20h-20z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5Q = /*#__PURE__*/forwardRef(SvgCheckBoxOutlineBlank);

var _excluded$5P = ["title", "titleId"];

var SvgChecked = function SvgChecked(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.98 18.96A8.98 8.98 0 1 0 9.98 1a8.98 8.98 0 0 0 0 17.96zm-1.272-8.38 1.722-1.722 2.47-2.47 1.496 1.496-2.47 2.47-3.218 3.218-3.218-3.218 1.496-1.496 1.722 1.722z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5P = /*#__PURE__*/forwardRef(SvgChecked);

var _excluded$5O = ["title", "titleId"];

var SvgChecklist = function SvgChecklist(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m2.178 2.196 1.205 1.205L5.784 1l1.178 1.179-3.579 3.579L1 3.374l1.178-1.178zM19 2.627H8.334v1.667H19V2.627zM2.178 8.801l1.205 1.205 2.401-2.401 1.178 1.179-3.579 3.579L1 9.98l1.178-1.179zm6.156.432H19V10.9H8.334V9.233zM19 15.87H8.334v1.667H19V15.87zm-16.822-.432 1.205 1.205 2.401-2.401 1.178 1.179L3.383 19 1 16.617l1.178-1.179z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5O = /*#__PURE__*/forwardRef(SvgChecklist);

var _excluded$5N = ["title", "titleId"];

var SvgCheque = function SvgCheque(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.58 1.046 19 4.476l-2.464 2.457h2.441v10.9H1V6.973h8.665l5.915-5.927zm-.001 2.362L10.846 8.15v1.063h1.041l4.754-4.741-1.062-1.065zm1.73 12.757V8.6L14.864 8.6l-2.286 2.282h-3.4V8.64h-6.51v7.524h14.641zm-8.136-3.218h6.754v1.668H9.173v-1.668z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5N = /*#__PURE__*/forwardRef(SvgCheque);

var _excluded$5M = ["title", "titleId"];

var SvgChess = function SvgChess(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 17.333H5V16.15h10v1.183zM9.022 9.7a2.367 2.367 0 0 0 1.065-.471l-1.045-1.3a.865.865 0 0 1-.978 0l-.447-.36L4.81 9.2a1.235 1.235 0 0 1-.05-1.05l3.258-3.255a4.563 4.563 0 0 1 4.231 4.544h1.667A6.231 6.231 0 0 0 8.712 3.3v-.581a6.592 6.592 0 0 1 5.749 6.53 6.506 6.506 0 0 1-.72 2.993 5.032 5.032 0 0 0-.627 2.242H6.776A14.873 14.873 0 0 1 9.022 9.7zm5.76 4.789c.032-.524.183-1.033.443-1.489a8.153 8.153 0 0 0 .9-3.753A8.258 8.258 0 0 0 7.879 1h-.834v2.511L3.582 6.974A2.319 2.319 0 0 0 3 8.74c.018.664.28 1.3.734 1.784l.779.78 2.4-1.4a13.705 13.705 0 0 0-1.826 4.578H3.334V19h13.333v-4.516l-1.884.005z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5M = /*#__PURE__*/forwardRef(SvgChess);

var _excluded$5L = ["title", "titleId"];

var SvgChildBoy = function SvgChildBoy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.017 2.517a9 9 0 0 1 5-1.517 9.01 9.01 0 0 1 9 9 9 9 0 1 1-14-7.483zm8.245 2.411A5.31 5.31 0 0 0 16 5.766a7.344 7.344 0 0 0-4.643-2.975 5.311 5.311 0 0 0 1.905 2.137zm-6.487.002A5.308 5.308 0 0 0 8.68 2.79a7.343 7.343 0 0 0-4.646 2.975 5.308 5.308 0 0 0 2.74-.837zm-.157 11.568a7.332 7.332 0 0 0 6.798.001 7.33 7.33 0 0 0 3.472-9.06h-.742a6.976 6.976 0 0 1-6.128-3.607 6.975 6.975 0 0 1-6.127 3.607h-.745a7.332 7.332 0 0 0 3.472 9.06zm-.314-8.472h1.593v1.667H6.304V8.026zm7.392 0h-1.593v1.667h1.593V8.026zm-5.13 5.217c.38.38.896.594 1.434.595a2.03 2.03 0 0 0 2.029-2.029h1.663a3.7 3.7 0 0 1-7.392 0h1.67c.002.538.215 1.054.596 1.434z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5L = /*#__PURE__*/forwardRef(SvgChildBoy);

var _excluded$5K = ["title", "titleId"];

var SvgChildBoy1 = function SvgChildBoy1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.21 13.038A7.333 7.333 0 1 0 9.5 2.685a2.02 2.02 0 0 0 1.953 1.501v1.666a3.692 3.692 0 0 1-3.591-2.867 7.333 7.333 0 0 0-2.651 12.57zm1.077-7.529H7.88v1.667H6.287V8.026zm7.392 0h-1.593v1.667h1.593V8.026zm-5.13 5.217c.38.38.896.594 1.434.595a2.03 2.03 0 0 0 2.029-2.029h1.667a3.7 3.7 0 0 1-7.392 0h1.667c0 .538.215 1.054.595 1.434z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5K = /*#__PURE__*/forwardRef(SvgChildBoy1);

var _excluded$5J = ["title", "titleId"];

var SvgChildGirl1 = function SvgChildGirl1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.364 3.636A9 9 0 0 1 19 10v9h-1.667v-3.792a8.986 8.986 0 0 1-14.666 0V19H1v-9a9 9 0 0 1 15.364-6.364zM5.211 15.555A7.333 7.333 0 1 0 9.5 2.685a2.02 2.02 0 0 0 1.953 1.501v1.666a3.692 3.692 0 0 1-3.591-2.867 7.333 7.333 0 0 0-2.651 12.57zm1.076-7.529H7.88v1.667H6.287V8.026zm7.392 0h-1.593v1.667h1.593V8.026zm-5.13 5.217c.38.38.896.594 1.434.595a2.03 2.03 0 0 0 2.029-2.029h1.667a3.7 3.7 0 0 1-7.392 0h1.667c0 .538.215 1.054.595 1.434z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5J = /*#__PURE__*/forwardRef(SvgChildGirl1);

var _excluded$5I = ["title", "titleId"];

var SvgChildGirl2 = function SvgChildGirl2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.364 3.624A9 9 0 0 1 19 9.988v9.003h-1.667V15.2a8.986 8.986 0 0 1-14.666 0v3.788H1v-9a9 9 0 0 1 15.364-6.364zm-3.12 1.293a5.307 5.307 0 0 0 2.738.837 7.344 7.344 0 0 0-4.643-2.975 5.308 5.308 0 0 0 1.905 2.138zm-6.486 0a5.31 5.31 0 0 0 1.906-2.138 7.343 7.343 0 0 0-4.646 2.975 5.31 5.31 0 0 0 2.74-.837zM6.6 16.487a7.332 7.332 0 0 0 10.269-9.06h-.743A6.976 6.976 0 0 1 10 3.82a6.975 6.975 0 0 1-6.126 3.607h-.745a7.332 7.332 0 0 0 3.472 9.06zm-.314-8.472H7.88v1.667H6.287V8.015zm7.391 0h-1.592v1.667h1.592V8.015zM8.55 13.232c.38.38.895.593 1.433.594a2.031 2.031 0 0 0 2.029-2.026h1.666a3.7 3.7 0 0 1-7.391 0h1.667a2.03 2.03 0 0 0 .596 1.432z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5I = /*#__PURE__*/forwardRef(SvgChildGirl2);

var _excluded$5H = ["title", "titleId"];

var SvgChristmastree = function SvgChristmastree(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m11.888 10.324 2.921 4.638H5.158l2.921-4.638h3.809zM9.974 3.933l3.217 4.725H6.724l3.25-4.725zm7.856 12.7-3.973-6.3h2.49L9.956.96l-6.389 9.363H6.11l-3.947 6.3h6.99v2.333h1.666v-2.33l7.011.006z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5H = /*#__PURE__*/forwardRef(SvgChristmastree);

var _excluded$5G = ["title", "titleId"];

var SvgCircleCheckmark = function SvgCircleCheckmark(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zM6.95 9.117l1.875 1.88 4.403-4.39 1.194 1.167-5.61 5.574-3.028-3.037 1.166-1.194z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5G = /*#__PURE__*/forwardRef(SvgCircleCheckmark);

var _excluded$5F = ["title", "titleId"];

var SvgCircleX = function SvgCircleX(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.928 16.094A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zM5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zM10 8.796l1.853-1.853 1.181 1.182-1.852 1.853 1.852 1.852-1.181 1.182-1.853-1.853-1.852 1.853-1.181-1.182L8.82 9.978 6.968 8.125l1.181-1.182 1.852 1.853z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5F = /*#__PURE__*/forwardRef(SvgCircleX);

var _excluded$5E = ["title", "titleId"];

var SvgCleanRoom = function SvgCleanRoom(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 2.17 17.818.993 9.934 8.92a3.7 3.7 0 0 0-2-.585h-.013a3.759 3.759 0 0 0-2.635 1.088L1 13.027l5.979 5.98 3.583-4.25a3.778 3.778 0 0 0 1.11-2.665 3.73 3.73 0 0 0-.567-1.986L19 2.17zM6.882 16.705 3.3 13.126l2.58-2.167 3.173 3.173-2.171 2.574zM10 12.726 7.28 10c.209-.069.427-.106.647-.11h.01A2.156 2.156 0 0 1 10 12.726z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5E = /*#__PURE__*/forwardRef(SvgCleanRoom);

var _excluded$5D = ["title", "titleId"];

var SvgClock = function SvgClock(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.928 16.094A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zM5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm2.942 4.215 2.088 2.087 3.286-3.28 1.18 1.183-4.468 4.459L6.76 7.913l1.182-1.181z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5D = /*#__PURE__*/forwardRef(SvgClock);

var _excluded$5C = ["title", "titleId"];

var SvgClothesHanger = function SvgClothesHanger(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.072 12.944 10.606 8.2c.03-.262.127-.513.28-.728l.684-.958a2.009 2.009 0 0 0-1.635-3.181H8.406V5h1.529a.343.343 0 0 1 .279.542L9.53 6.5a3.222 3.222 0 0 0-.6 1.886v.107L1.916 12.95a2.024 2.024 0 0 0 1.109 3.717h13.948a2.024 2.024 0 0 0 1.1-3.723h-.001zm-.757 1.8a.335.335 0 0 1-.342.255H3.025a.335.335 0 0 1-.342-.255.33.33 0 0 1 .137-.394L10 9.784l7.17 4.561a.336.336 0 0 1 .145.4v-.001z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5C = /*#__PURE__*/forwardRef(SvgClothesHanger);

var _excluded$5B = ["title", "titleId"];

var SvgCloudy = function SvgCloudy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.441 15.587H3.869a2.846 2.846 0 0 1-.915-5.542 3.79 3.79 0 0 1 3.333-2.677 4.644 4.644 0 0 1 8.93 1.062h.224a3.577 3.577 0 0 1 3.36 4.962 3.58 3.58 0 0 1-3.36 2.195zM6.577 9.024a2.112 2.112 0 0 0-2.1 1.822l-.085.647-.649.073a1.18 1.18 0 0 0 .122 2.355h11.576a1.912 1.912 0 0 0 0-3.824h-1.849V9.05a2.975 2.975 0 0 0-5.878-.657l-.164.728-.742-.084a1.937 1.937 0 0 0-.231-.012z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5B = /*#__PURE__*/forwardRef(SvgCloudy);

var _excluded$5A = ["title", "titleId"];

var SvgCoffee = function SvgCoffee(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.18 4.253a1.454 1.454 0 0 1-.733 1.274L7.2 7.013A3.127 3.127 0 0 0 8.847 4.26a2.933 2.933 0 0 0-1.02-2.113c-.38-.394-.56-.6-.56-.96H5.6a2.933 2.933 0 0 0 1.02 2.106c.373.393.56.6.56.96zm11.707 7.34a2.747 2.747 0 0 0-.834-2 2.96 2.96 0 0 0-2.446-.76V7.5H1.267v5.807a5.713 5.713 0 0 0 5.706 5.706H9.9a5.713 5.713 0 0 0 5.433-3.913 3.64 3.64 0 0 0 2.48-1.04 3.467 3.467 0 0 0 1.074-2.467zm-4.947 1.7a4.046 4.046 0 0 1-4.04 4.04H6.973a4.046 4.046 0 0 1-4.04-4.04v-4.14H13.94v4.14zm2.667-.44a2.06 2.06 0 0 1-1.034.547V10.52a1.333 1.333 0 0 1 1.287.273 1.094 1.094 0 0 1 .32.8c.001.472-.183.924-.513 1.26h-.06zM9.759 4.99c.13-.223.196-.478.194-.736 0-.36-.18-.567-.553-.96a2.933 2.933 0 0 1-1-2.107h1.667c0 .36.18.567.56.96a2.934 2.934 0 0 1 1.02 2.114A3.128 3.128 0 0 1 10 7.013l-.78-1.486c.224-.128.41-.314.54-.538z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5A = /*#__PURE__*/forwardRef(SvgCoffee);

var _excluded$5z = ["title", "titleId"];

var SvgCoin = function SvgCoin(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zm4.633-8.241A.788.788 0 0 0 10 7.638a.766.766 0 1 0 0 1.527 2.427 2.427 0 0 1 .836 4.723v.871H9.165v-.87a2.44 2.44 0 0 1-1.645-2.29h1.672a.764.764 0 1 0 .808-.763 2.427 2.427 0 0 1-.835-4.724v-.87h1.672v.871a2.44 2.44 0 0 1 1.642 2.288h-1.671a.788.788 0 0 0-.247-.548z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5z = /*#__PURE__*/forwardRef(SvgCoin);

var _excluded$5y = ["title", "titleId"];

var SvgCollaboration = function SvgCollaboration(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.428 2.784a.68.68 0 1 0-.756 1.128.68.68 0 0 0 .756-1.128zm-.861 2.95c-.432.087-.829.3-1.139.613v.001a2.205 2.205 0 0 0-.651 1.571H6.109a3.863 3.863 0 0 1 1.144-2.752c.238-.236.505-.44.795-.609a2.348 2.348 0 1 1 3.988.044 3.862 3.862 0 0 1 1.86 3.316h-1.668a2.223 2.223 0 0 0-2.661-2.184zm-3.977 8.13a.68.68 0 1 0-.754 1.13.68.68 0 0 0 .754-1.13zm9.574 0a.68.68 0 1 0-.754 1.13.68.68 0 0 0 .754-1.13zm1.603 1.822c.261.16.503.349.72.564l.001-.002A3.862 3.862 0 0 1 18.628 19H16.96a2.223 2.223 0 0 0-4.446 0h-1.668a3.861 3.861 0 0 1 1.929-3.36 2.323 2.323 0 0 1-.214-1.966L10 11.105l-2.571 2.57a2.323 2.323 0 0 1-.214 1.964A3.863 3.863 0 0 1 9.154 19H7.486a2.223 2.223 0 1 0-4.446 0H1.372a3.862 3.862 0 0 1 1.86-3.31 2.344 2.344 0 0 1 3.134-3.3l2.8-2.8V6.658h1.667v2.928l2.8 2.8a2.344 2.344 0 0 1 3.134 3.3z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5y = /*#__PURE__*/forwardRef(SvgCollaboration);

var _excluded$5x = ["title", "titleId"];

var SvgComingTogether = function SvgComingTogether(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.141 5.144 12.955 6.33l2.832 2.83h-3.77c-.879-.954-3.789-4.034-5.619-5a5.734 5.734 0 0 0-2.754-.633H1v1.66h2.644a4.233 4.233 0 0 1 1.923.413l.04.023A27.288 27.288 0 0 1 10.524 10a27.256 27.256 0 0 1-4.917 4.377l-.04.023c-.6.286-1.259.427-1.923.412H1v1.665h2.644a5.736 5.736 0 0 0 2.756-.634c1.83-.97 4.741-4.05 5.619-5.005h3.776l-2.834 2.832 1.186 1.186L19 10l-4.859-4.856z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5x = /*#__PURE__*/forwardRef(SvgComingTogether);

var _excluded$5w = ["title", "titleId"];

var SvgComment = function SvgComment(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.219 4.585a9.797 9.797 0 0 0-1.6-1.641 8.921 8.921 0 0 0-5.6-1.961 8.938 8.938 0 0 0-7.04 3.394 9.049 9.049 0 0 0-1.958 5.61v9h9.009a9 9 0 0 0 7.189-14.4v-.002zM10.03 17.316H2.688V9.987a7.37 7.37 0 0 1 1.6-4.573 7.318 7.318 0 0 1 10.305-1.155c.48.392.913.837 1.293 1.327a7.33 7.33 0 0 1-5.856 11.73zm3.329-9.93H6.134v1.668h7.225V7.387zm-7.225 3.535h7.225v1.667H6.134V10.92z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5w = /*#__PURE__*/forwardRef(SvgComment);

var _excluded$5v = ["title", "titleId"];

var SvgCommunication = function SvgCommunication(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.721 1h1.451v1.667H6.721V1zm.493 8.231a7.064 7.064 0 0 0-5.957-6.812L1 4.066a5.4 5.4 0 0 1 4.548 5.207l.011.415.915 1.759h-.923v3.947H2.76V19h1.667v-1.94h2.79v-3.946h2L7.215 9.261l-.001-.03zm7.236 2.216h-.924l.915-1.758.011-.415A5.4 5.4 0 0 1 19 4.066l-.257-1.647a7.064 7.064 0 0 0-5.957 6.812l-2.006 3.883h2v3.946h2.79V19h1.67v-3.606h-2.79v-3.947zM10.729 1H9.278v1.667h1.451V1zm1.107 0h1.451v1.667h-1.451V1z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5v = /*#__PURE__*/forwardRef(SvgCommunication);

var _excluded$5u = ["title", "titleId"];

var SvgCommunicationsTower = function SvgCommunicationsTower(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m4.356 1 1.178 1.179H5.53a5.863 5.863 0 0 0 .048 8.306L4.4 11.664A7.533 7.533 0 0 1 4.356 1zM7.53 4.171 6.353 2.993A4.714 4.714 0 0 0 6.4 9.671l1.179-1.178a3.049 3.049 0 0 1-.048-4.322zM10 4.147A2.16 2.16 0 0 0 9.167 8.3V19h1.666V8.3A2.161 2.161 0 0 0 10 4.147zm3.647-1.154-1.178 1.178a3.049 3.049 0 0 1-.048 4.322L13.6 9.671a4.712 4.712 0 0 0 .048-6.678h-.001zm.819-.814L15.644 1a7.531 7.531 0 0 1-.044 10.664l-1.182-1.18a5.862 5.862 0 0 0 .048-8.305z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5u = /*#__PURE__*/forwardRef(SvgCommunicationsTower);

var _excluded$5t = ["title", "titleId"];

var SvgCompare = function SvgCompare(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m3.867 11.462 4.004.001v1.676L1 13.14V6.276h1.677v4.005L11.959 1l1.186 1.186-9.278 9.276zm8.262-2.956V6.83H19v6.863h-1.677V9.688L8.023 19l-1.186-1.186 9.296-9.308h-4.004z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5t = /*#__PURE__*/forwardRef(SvgCompare);

var _excluded$5s = ["title", "titleId"];

var SvgComplimentaryBenefits = function SvgComplimentaryBenefits(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.245 11.47V4.166l-1.488 1.488-1.178-1.179 3.499-3.5 3.5 3.5-1.178 1.18-1.488-1.489v7.304h-1.667zM7.054 6.001v2.81H8.72V6l1.488 1.488 1.179-1.178-3.5-3.5-3.5 3.5L5.566 7.49l1.488-1.488zm11.79 6.488a.834.834 0 0 0-.77-.515H12.2c.014-.1.021-.2.022-.3a2.357 2.357 0 0 0-2.355-2.356h-4.3a.822.822 0 0 0-.226.031L.908 10.594l.45 1.605 4.323-1.214h4.186a.687.687 0 0 1 0 1.374H6.139v1.667h3.728c.457 0 .904-.134 1.286-.385h4.91L12.4 17.31H.908v1.666h11.833a.829.829 0 0 0 .589-.244l5.334-5.33a.834.834 0 0 0 .18-.912z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5s = /*#__PURE__*/forwardRef(SvgComplimentaryBenefits);

var _excluded$5r = ["title", "titleId"];

var SvgConversation = function SvgConversation(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.369 1v5.486H19V19l-3.248-3.248H6.631v-5.486H4.248L1 13.514V1h12.369zM3.558 8.6h3.073V6.486H11.7V2.667H2.667v6.825l.891-.892zm12.882 5.486.891.891.004-6.824H8.3v5.933h8.14zm-6.887-3.665h1.667v1.667H9.553v-1.667zm4.166 0h-1.667v1.667h1.667v-1.667zm.832 0h1.667v1.667h-1.667v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5r = /*#__PURE__*/forwardRef(SvgConversation);

var _excluded$5q = ["title", "titleId"];

var SvgCopyPaste = function SvgCopyPaste(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.019 1.022h5.266v1.666h4.796V8.03L19 10.942v8.036H1V2.688h5.019v1.667h5.262V2.689H6.019V1.022zm5.539 10.736h4.811v1.667h-4.811v-1.667zm4.811 2.81h-4.811v1.667h4.811v-1.667zM2.667 17.312H9.02L9.015 8.03h5.395V4.355h-1.824v1.667H4.507V4.355h-1.84v12.957zm8.014 0h6.657l-.005-5.56-2.073-2.068h-4.579v7.628z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5q = /*#__PURE__*/forwardRef(SvgCopyPaste);

var _excluded$5p = ["title", "titleId"];

var SvgCorn = function SvgCorn(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m5.727 5.331-.304 2.984a9.38 9.38 0 0 0-1.261-.084h-.833V14.6A4.434 4.434 0 0 0 7.792 19l3.99-.03h-.005l.005.002v-.002l1.42-.01.1-.025a4.524 4.524 0 0 0 3.366-4.335V8.23h-.833c-.35-.006-.7.01-1.046.045l-.313-2.944a4.375 4.375 0 0 0-8.749 0zm7.423 3.277-.341-3.23a2.71 2.71 0 0 0-3.756-2.549A2.709 2.709 0 0 0 7.484 4.63H8.99v1.678H7.312v-.04L7.064 8.7a8.384 8.384 0 0 1 2.895 1.69 8.675 8.675 0 0 1 3.191-1.782zm-2.06 3.005c1.15 1.507 1.873 3.44 2.025 5.64a2.88 2.88 0 0 0 1.89-2.651V9.94a6.861 6.861 0 0 0-3.915 1.673zM5 9.941V14.6a2.8 2.8 0 0 0 2.791 2.731l3.662-.026c-.3-4.1-2.835-6.982-6.453-7.366v.002zm5.805-1.465H9.128V6.798h1.677v1.678z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5p = /*#__PURE__*/forwardRef(SvgCorn);

var _excluded$5o = ["title", "titleId"];

var SvgCoverage = function SvgCoverage(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coverage_svg__Icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.coverage_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "coverage_svg__st0",
    d: "m13.46 5.723-.144-.156a2.248 2.248 0 0 0-1.663-.739c-.634 0-1.238.27-1.663.74l-.19.208-.192-.208a2.246 2.246 0 0 0-1.664-.74c-.634 0-1.238.27-1.663.739l-.145.156a2.6 2.6 0 0 0 0 3.459L9.8 13.148l3.66-3.966c.88-.985.88-2.474 0-3.459zM12.175 8.4 9.8 10.977 7.419 8.4a1.177 1.177 0 0 1 0-1.549l.125-.134a.877.877 0 0 1 1.317 0L9.8 7.733l.936-1.014a.878.878 0 0 1 1.318 0l.124.134a1.176 1.176 0 0 1-.003 1.547z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverage_svg__st0",
    d: "M15.964 12.957 9.8 16.93l-6.17-3.973V2.607h12.334v10.35zM1.963.941v12.9l7.834 5.1 7.833-5.1V.941H1.963z"
  }));
};

var ForwardRef$5o = /*#__PURE__*/forwardRef(SvgCoverage);

var _excluded$5n = ["title", "titleId"];

var SvgCreditCard = function SvgCreditCard(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 15.836V4.164h18v11.672H1zm1.672-1.672h14.656v-5.3H2.672v5.3zm0-6.97h14.656V5.835H2.672v1.357zm.661 4.271h5.116v1.667H3.333v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5n = /*#__PURE__*/forwardRef(SvgCreditCard);

var _excluded$5m = ["title", "titleId"];

var SvgCriticalIllness = function SvgCriticalIllness(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.539 3.177a4.905 4.905 0 0 0-7.12-.001l-.429.454-.437-.454a4.881 4.881 0 0 0-6.9-.2l-.2.2a5.286 5.286 0 0 0-.158 7.112l7.7 8.808L17.7 10.3a5.287 5.287 0 0 0-.161-7.123zM9.99 16.567l-4.969-5.69-.014-.016 1.949-1.949 3.267 3.27L12.2 10.2h3.362l-.016.02-5.556 6.346zm6.9-8.03h-5.381l-1.286 1.286-3.267-3.269L3.908 9.6H3.9l-.348-.4a3.625 3.625 0 0 1 .246-5.009 3.214 3.214 0 0 1 4.549.14L10 6.044l1.63-1.724a3.24 3.24 0 0 1 4.7 0 3.625 3.625 0 0 1 .564 4.216h-.004z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5m = /*#__PURE__*/forwardRef(SvgCriticalIllness);

var _excluded$5l = ["title", "titleId"];

var SvgCrown = function SvgCrown(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.98 5.61-4.154 4.154-4.842-6.431-4.825 6.429L1 5.6l.02 12.229H19L18.98 5.61zM2.682 16.168l-.01-6.538 2.658 2.658 4.686-6.245 4.67 6.216 2.636-2.635.01 6.544H2.682z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5l = /*#__PURE__*/forwardRef(SvgCrown);

var _excluded$5k = ["title", "titleId"];

var SvgDacadoo = function SvgDacadoo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.003 2.514a9 9 0 0 1 9.96-.02 9 9 0 0 1 1.521 13.744l-1.2-1.157A7.285 7.285 0 0 0 17.3 10.7h-1.581V9.039h1.545A7.3 7.3 0 0 0 15.7 5.4l-1.1 1.1-1.178-1.177 1.094-1.094a7.288 7.288 0 0 0-3.683-1.514v1.441H9.167V2.715A7.305 7.305 0 0 0 5.452 4.25l1.1 1.1-1.179 1.178-1.1-1.1a7.29 7.29 0 0 0-1.541 3.609h1.55V10.7H2.7a7.278 7.278 0 0 0 2.105 4.476l-1.181 1.176a9 9 0 0 1 1.38-13.838zm7.763 4.594c.286.127.543.313.753.546l.145.156a2.594 2.594 0 0 1 0 3.459L10 15.235l-3.663-3.966a2.594 2.594 0 0 1 0-3.459l.144-.156a2.245 2.245 0 0 1 3.327 0l.192.208.193-.208a2.246 2.246 0 0 1 2.573-.546zM10 13.064l2.378-2.576a1.176 1.176 0 0 0 .001-1.548l-.124-.134a.877.877 0 0 0-1.318 0L10 9.819l-.936-1.013a.877.877 0 0 0-1.318 0l-.124.134a1.175 1.175 0 0 0 0 1.548L10 13.064z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5k = /*#__PURE__*/forwardRef(SvgDacadoo);

var _excluded$5j = ["title", "titleId"];

var SvgDate = function SvgDate(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.727 1v2.341h3.13V19H2.143V3.341h3.13V1h1.673v2.341h6.108V1h1.673zM3.815 17.328h12.37V8.776H3.815v8.552zm0-10.225h12.37v-2.09H3.815v2.09zm2.006 2.946h1.633v1.672H5.821v-1.672z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5j = /*#__PURE__*/forwardRef(SvgDate);

var _excluded$5i = ["title", "titleId"];

var SvgDateRange = function SvgDateRange(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.815 8.776v8.552h12.37V8.776H3.815zM16.185 7.1V5.013H3.815V7.1h12.37zM14.727 1v2.341h3.13V19H2.143V3.341h3.13V1h1.673v2.341h6.108V1h1.673zM5.82 10.049h1.634v1.672H5.82v-1.672zm8.359 0h-1.633v1.672h1.633v-1.672zm-4.996 0h1.633v1.672H9.183v-1.672z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5i = /*#__PURE__*/forwardRef(SvgDateRange);

var _excluded$5h = ["title", "titleId"];

var SvgDayView = function SvgDayView(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.982 1H1v1.671h17.982V1zm0 16.329H1V19h17.982v-1.671zM1 14.383V5.617h18v8.766H1zm1.665-1.666h14.67V7.288H2.665v5.429z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5h = /*#__PURE__*/forwardRef(SvgDayView);

var _excluded$5g = ["title", "titleId"];

var SvgDeath = function SvgDeath(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "death_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.death_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("g", {
    id: "death_svg__Artwork"
  }, /*#__PURE__*/React.createElement("path", {
    className: "death_svg__st0",
    d: "M6.673 7.488h6.654v1.667H6.673zM7.924 10.31h4.151v1.667H7.924zM.999 17.334h18.002v1.667H.999z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "death_svg__st0",
    d: "M16.667 18.069H15V7.666a5 5 0 0 0-10 0v10.4H3.333v-10.4a6.667 6.667 0 1 1 13.334 0v10.403z"
  })));
};

var ForwardRef$5g = /*#__PURE__*/forwardRef(SvgDeath);

var _excluded$5f = ["title", "titleId"];

var SvgDebt = function SvgDebt(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.065 4.217h2.6L19 17.884H1L3.324 4.217h3.019a3.925 3.925 0 0 1 7.722 0zM11.53 3.096a2.265 2.265 0 0 0-1.323-.429 2.263 2.263 0 0 0-2.145 1.55h4.291a2.266 2.266 0 0 0-.823-1.121zm3.725 2.788H4.734L2.971 16.217h14.047L15.255 5.884zm-4.897 3.552a.465.465 0 0 0-.328-.136l.003-.003a.465.465 0 0 0 0 .93 2.131 2.131 0 0 1 .834 4.093v.84H9.2v-.84a2.135 2.135 0 0 1-1.3-1.96h1.668a.465.465 0 1 0 .465-.466A2.132 2.132 0 0 1 9.2 7.8v-.844h1.662v.847a2.134 2.134 0 0 1 1.3 1.961h-1.667a.465.465 0 0 0-.136-.328z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5f = /*#__PURE__*/forwardRef(SvgDebt);

var _excluded$5e = ["title", "titleId"];

var SvgDelete = function SvgDelete(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.313 1h5.394v1.668H7.313V1zm0 6.661h1.668v7.991H7.313V7.661zm5.393 0h-1.668v7.991h1.668V7.661zM2.167 5.831V4.162h15.666v1.669h-1.22V19H3.334V5.831H2.167zM5 17.332h9.945l-.002-11.501H5v11.501z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5e = /*#__PURE__*/forwardRef(SvgDelete);

var _excluded$5d = ["title", "titleId"];

var SvgDeleteFile = function SvgDeleteFile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zm2.48-8.18h7.238v1.67H6.316V9.15z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5d = /*#__PURE__*/forwardRef(SvgDeleteFile);

var _excluded$5c = ["title", "titleId"];

var SvgDesktop = function SvgDesktop(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 3.286V14.88h-8.226v1.237h1.577v1.67H7.575v-1.67h1.53V14.88H1V3.286h18zM2.669 4.956v8.255h14.663V4.955H2.669zm6.497 6.022h1.669v1.63H9.166v-1.63z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5c = /*#__PURE__*/forwardRef(SvgDesktop);

var _excluded$5b = ["title", "titleId"];

var SvgDigital = function SvgDigital(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.033 1v1.667h3.3v3.3H19V1h-4.967zm-2.27 5.415a3.084 3.084 0 0 0-1.705-.37c-.532.035-1.047.2-1.502.477l-.871-1.44a4.991 4.991 0 0 1 2.249-.725 4.739 4.739 0 0 1 4.543 2.508l-1.483.787a3.083 3.083 0 0 0-1.231-1.237zm3.176 6.248c-.057.355-.124.709-.208 1.063a9.828 9.828 0 0 1-.22.82l-1.62-.473a13.167 13.167 0 0 0 .376-1.67c.157-.958.216-1.93.175-2.9a2.615 2.615 0 0 0-.018-.187 2.556 2.556 0 0 1-.022-.286 4.653 4.653 0 0 0-.1-.562l1.637-.416c.063.252.11.507.14.765.04.2.057.403.051.607a16.038 16.038 0 0 1-.19 3.239zM5.323 9.345l1.687.079c.016-.433.096-.861.236-1.271.139-.405.361-.776.652-1.091L6.667 5.937A4.76 4.76 0 0 0 5.66 7.579a5.917 5.917 0 0 0-.337 1.766zm-.855 2.533c.246-.121.47-.283.663-.478a.724.724 0 0 0 .215-.29 2.802 2.802 0 0 0 0-.533v-.152l1.686-.025v.127c.015.286.002.572-.04.855a2.248 2.248 0 0 1-.618 1.175 4.13 4.13 0 0 1-1.124.82l-.782-1.5zm6.043.555a6.447 6.447 0 0 1-.054.3c-.05.22-.107.433-.168.647a9.232 9.232 0 0 1-.467 1.254c-.142.305-.3.601-.473.888l1.446.872a11.142 11.142 0 0 0 1.324-3.29c.01-.067.022-.134.038-.2.055-.243.097-.49.125-.738l-1.686-.158c-.033.107-.06.272-.085.425zm.763-5.136c.35.19.636.478.824.828.228.437.354.92.366 1.413.022.529.013 1.058-.028 1.586l-1.687-.129c.028-.46.028-.922 0-1.383a1.7 1.7 0 0 0-.146-.7.348.348 0 0 0-.36-.175.521.521 0 0 0-.461.31 3.29 3.29 0 0 0-.078 1.074v.23a6.255 6.255 0 0 1-.253 2.2 5.277 5.277 0 0 1-1.125 1.861 6.893 6.893 0 0 1-1.338 1.09 5.36 5.36 0 0 1-.49.281l-.781-1.5c.13-.067.259-.141.383-.219a4.969 4.969 0 0 0 1-.81c.339-.36.6-.787.765-1.254.147-.529.2-1.079.157-1.626v-.213a4.642 4.642 0 0 1 .174-1.687 2.205 2.205 0 0 1 1.935-1.418c.396-.033.793.05 1.143.24zm2.76 10.036h3.299v-3.3H19V19h-4.967v-1.667zm-11.367-3.3H1V19h4.967v-1.667h-3.3v-3.3zm3.3-11.366h-3.3v3.3H1V1h4.967v1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5b = /*#__PURE__*/forwardRef(SvgDigital);

var _excluded$5a = ["title", "titleId"];

var SvgDigitalCustomerLeader = function SvgDigitalCustomerLeader(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.15 7.365c.237.356.364.774.364 1.201v2.907l3.666 2.667v4.906h-1.666v-4.06l-2-1.446v.806h-1.667v-5.78a.496.496 0 1 0-.993 0v9.36l-2.98-2.84a.432.432 0 0 0-.476-.11.42.42 0 0 0-.138.69l2.187 2.207-1.187 1.173-1.813-1.826H3.24a2 2 0 0 1-2-2V3.066a2 2 0 0 1 2-2h6.94a2 2 0 0 1 2 2v3.5c.395.165.732.443.97.799zm-3.016-4.659H3.24a.36.36 0 0 0-.36.36v1h7.614v-1a.36.36 0 0 0-.36-.36zm-.947 11.36v-5.5a2.166 2.166 0 0 1 1.3-1.986v-.847H2.88v9.487a.36.36 0 0 0 .36.36h2.227v-.18a2.086 2.086 0 0 1 3.567-1.48l.153.146zM7.09 8.078v.002l.142.327 1.32.133.46.04-.346.307-1.007.886c.093.46.187.9.287 1.334l.1.453-.394-.233-1.16-.667-1.153.667-.4.233.107-.453c.093-.454.186-.894.286-1.334l-.986-.886L4 8.58l.453-.04 1.334-.133.533-1.234.187-.42.186.42c.137.304.267.604.398.905zm6.702 1.142 1.174 1.186a4.567 4.567 0 0 0 0-6.566l-1.174 1.187a2.902 2.902 0 0 1 0 4.193zM16.72 12l-1.173-1.207v-.006a5.072 5.072 0 0 0 0-7.334l1.173-1.166a6.732 6.732 0 0 1 0 9.713z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$5a = /*#__PURE__*/forwardRef(SvgDigitalCustomerLeader);

var _excluded$59 = ["title", "titleId"];

var SvgDiscount = function SvgDiscount(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$59);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.353 3.64v3.72L19 10l-2.621 2.653v3.7H12.64L10 19l-2.641-2.622H3.646V12.64L1 10l2.627-2.615V3.646h3.732L10 1l2.639 2.64h3.714zm-1.655 11.03v-2.71l1.931-1.951-1.956-1.952V5.32h-2.73L10 3.377 8.056 5.326H5.307v2.757L3.38 10l1.946 1.943V14.7h2.725l1.942 1.927 1.949-1.957h2.756zm-7.75-7.799h1.68v1.774h-1.68V6.871zm6.107 4.547h-1.68v1.774h1.68v-1.774zm-6.23.585L12.02 6.82l1.186 1.189-5.193 5.183-1.187-1.19z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$59 = /*#__PURE__*/forwardRef(SvgDiscount);

var _excluded$58 = ["title", "titleId"];

var SvgDiversification = function SvgDiversification(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$58);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 15.28v-1.231h-1.667l.008 2.115-4.035-4.031A3.358 3.358 0 0 0 10.848 8.2V4.179l1.49 1.5L13.514 4.5l-.871-.871L10.017 1 8.838 2.179 6.517 4.5 7.7 5.679l1.487-1.5V8.2a3.351 3.351 0 0 0-2.462 3.9l-4.066 4.064.008-2.115H1V19h4.95v-1.668l-2.111.009 3.666-3.662a3.346 3.346 0 0 0 5.006.016l3.65 3.646-2.111-.009V19H19v-3.72zm-8.981-2.133a1.694 1.694 0 1 1 1.194-.497 1.7 1.7 0 0 1-1.198.497h.004z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$58 = /*#__PURE__*/forwardRef(SvgDiversification);

var _excluded$57 = ["title", "titleId"];

var SvgDna = function SvgDna(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$57);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.738 5.56-.671.671-3.194-3.194.671-.671-1.175-1.174-.811.808a3.921 3.921 0 0 0-.985 3.885A5.601 5.601 0 0 0 5.7 11.836a3.918 3.918 0 0 0-3.82 1l-.812.811 1.175 1.175.671-.671 3.196 3.195-.671.671 1.175 1.175.811-.811a3.922 3.922 0 0 0 .98-3.9c.091 0 .182.014.274.014a5.6 5.6 0 0 0 5.614-5.942A3.892 3.892 0 0 0 18.1 7.546l.811-.811-1.173-1.175zm-5.272 2.158c.2.648.229 1.337.086 2l-2.084-2.087a3.955 3.955 0 0 1 1.998.087zm-1.422 4.34-2.92-2.919a3.767 3.767 0 0 1 .74-.757l2.936 2.934a3.767 3.767 0 0 1-.756.742zM6.25 14.012a2.254 2.254 0 0 1 .65 1.777L4.473 13.36a2.254 2.254 0 0 1 1.777.652zm1.275-1.354a3.96 3.96 0 0 1-.11-1.88l1.99 1.99a3.96 3.96 0 0 1-1.88-.11zm6.208-6.287a2.251 2.251 0 0 1-.652-1.777l2.429 2.43c-.059 0-.12.009-.18.009a2.242 2.242 0 0 1-1.597-.662z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$57 = /*#__PURE__*/forwardRef(SvgDna);

var _excluded$56 = ["title", "titleId"];

var SvgDocument = function SvgDocument(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$56);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.262 1H2.167v18h15.666V5.565L13.262 1zm2.9 16.33H3.836V2.67h8.738l3.59 3.59-.002 11.07zm-2.543-9.922H6.381v1.67h7.238v-1.67zm-7.238 3.541h7.238v1.67H6.381v-1.67z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$56 = /*#__PURE__*/forwardRef(SvgDocument);

var _excluded$55 = ["title", "titleId"];

var SvgDollar = function SvgDollar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$55);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.765 7.353v-.164a3.713 3.713 0 0 0-2.887-3.584v-1.46H9.127V3.6a3.714 3.714 0 0 0-2.892 3.589A3.73 3.73 0 0 0 10 10.876a1.937 1.937 0 1 1-2.013 1.935v-.164H6.235v.164A3.713 3.713 0 0 0 9.127 16.4v1.459h1.751V16.4A3.679 3.679 0 0 0 10 9.124a1.976 1.976 0 0 1-2.013-1.935 2.015 2.015 0 0 1 4.026 0v.164h1.752z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$55 = /*#__PURE__*/forwardRef(SvgDollar);

var _excluded$54 = ["title", "titleId"];

var SvgDown = function SvgDown(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$54);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.657 10-5.813 5.81V1H9.176v14.803L3.344 10l-1.18 1.179L10.012 19l7.824-7.821L16.656 10z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$54 = /*#__PURE__*/forwardRef(SvgDown);

var _excluded$53 = ["title", "titleId"];

var SvgDownload = function SvgDownload(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$53);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.813 7.733 1.18 1.18-6.866 6.874-6.934-6.94 1.18-1.18L9.3 12.593V1h1.667v11.587l4.846-4.854zm-13.773 9.6H18V19H2.04v-1.666z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$53 = /*#__PURE__*/forwardRef(SvgDownload);

var _excluded$52 = ["title", "titleId"];

var SvgDrink = function SvgDrink(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$52);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.755 6.859V3.97H8.734L5.724.961 4.543 2.142 6.371 3.97H3.422v2.889l5.831 5.865v4.566H6.362v1.671h7.453V17.29h-2.891v-4.566l5.831-5.865zm-6.667 4.33L5.093 6.175v-.534h9.991v.534l-4.996 5.014z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$52 = /*#__PURE__*/forwardRef(SvgDrink);

var _excluded$51 = ["title", "titleId"];

var SvgDuplicate = function SvgDuplicate(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$51);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.231 2.679V1.012H19v1.667h-.007v12.583h-1.667V2.679H5.231zm9.435 2.644h-12v12h12v-12zm1.664 13.665H1V3.657h15.33v15.331z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$51 = /*#__PURE__*/forwardRef(SvgDuplicate);

var _excluded$50 = ["title", "titleId"];

var SvgEarbuds = function SvgEarbuds(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$50);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.633 2.057a3.744 3.744 0 0 1 2.65-1.09v.009h1.634v13.307H7.264V8.455a3.744 3.744 0 0 1-2.631-6.398zM5.798 3.24c-.388.391-.606.92-.607 1.47A2.093 2.093 0 0 0 7.264 6.8V2.62a2.093 2.093 0 0 0-1.466.62zm9.976 3.513A3.749 3.749 0 0 1 16.872 9.4a3.748 3.748 0 0 1-3.726 3.739v5.828h-1.653V5.66h1.634v-.005a3.749 3.749 0 0 1 2.647 1.098zm-2.628.552v4.18a2.091 2.091 0 0 0 0-4.18z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$50 = /*#__PURE__*/forwardRef(SvgEarbuds);

var _excluded$4$ = ["title", "titleId"];

var SvgEasyApplication = function SvgEasyApplication(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.63 1v1.772h3.037V19H3.333V2.772h3.128V1h7.169zm-1.665 1.666H8.13l-.002 1.877h3.837V2.666zM5 17.334h10V4.438h-1.37V6.21H6.461V4.438H5v12.896zm1.848-6.746 1.874 1.879 4.403-4.389 1.194 1.167-5.61 5.574-3.028-3.037 1.167-1.194z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4$ = /*#__PURE__*/forwardRef(SvgEasyApplication);

var _excluded$4_ = ["title", "titleId"];

var SvgEdit = function SvgEdit(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m4.658 17.323-1.993.006V15.34L14.657 3.355l1.987 1.988-11.986 11.98zM14.657 1 1 14.65V19l4.35-.013L19 5.343 14.657 1z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4_ = /*#__PURE__*/forwardRef(SvgEdit);

var _excluded$4Z = ["title", "titleId"];

var SvgEducation = function SvgEducation(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.96 8.12 10 3.193 1.007 8.12l3.48 1.913v6.774h10.846V10.14l2-1.093v4.94H19V8.12h-.04zm-5.287 7.02H6.16v-4.18L10 13.067l3.687-2-.014 4.073zm-3.686-4-5.52-3.013L10 5.093l5.52 3.034-5.533 3.013z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4Z = /*#__PURE__*/forwardRef(SvgEducation);

var _excluded$4Y = ["title", "titleId"];

var SvgEggs = function SvgEggs(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.878 14.407a6.387 6.387 0 0 0 4.508 1.87h.005A6.386 6.386 0 0 0 12.615 19 6.387 6.387 0 0 0 19 12.621a10.037 10.037 0 0 0-3.266-7.738 4.773 4.773 0 0 0-3.8-1.111A7.885 7.885 0 0 0 10.5 2.16a4.773 4.773 0 0 0-6.41.16A10.865 10.865 0 0 0 1.006 9.9a6.387 6.387 0 0 0 1.872 4.507zm7.405-10.075a6.36 6.36 0 0 0-.825-.875l-.034-.028a3.107 3.107 0 0 0-4.187.1A9.332 9.332 0 0 0 2.672 9.89a4.719 4.719 0 0 0 3.859 4.642 6.38 6.38 0 0 1-.295-1.908c0-2.832 1.107-5.553 3.084-7.581a4.77 4.77 0 0 1 .963-.712zm.184 1.921a3.1 3.1 0 0 1 4.185-.101l.03.026a8.343 8.343 0 0 1 2.644 6.443 4.713 4.713 0 0 1-9.426 0v-.008a9.326 9.326 0 0 1 2.567-6.36z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4Y = /*#__PURE__*/forwardRef(SvgEggs);

var _excluded$4X = ["title", "titleId"];

var SvgElevator = function SvgElevator(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.834 1H2.167v1.667h15.667V1zm0 16.333H2.167V19h15.667v-1.667zM3.333 16.14V10.2a3.141 3.141 0 0 1 1.204-2.479 2.455 2.455 0 1 1 3.921 0 3.126 3.126 0 0 1 1.2 2.479v5.941H7.991V10.2A1.5 1.5 0 1 0 5 10.2v5.94H3.333zM6.939 5.594a.789.789 0 1 0-.875 1.313.789.789 0 0 0 .875-1.313zm7.066 9.445 2.662-2.662-1.18-1.178-1.481 1.482-1.481-1.482-1.18 1.178 2.66 2.662zm2.662-7.1-1.18 1.178-1.48-1.483-1.483 1.483-1.178-1.179 2.662-2.661 2.659 2.662z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4X = /*#__PURE__*/forwardRef(SvgElevator);

var _excluded$4W = ["title", "titleId"];

var SvgEmail = function SvgEmail(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.891 3.316v13.333h18V3.316h-18zm14.648 1.667L9.89 10.632l-5.649-5.65h11.298zm-12.981 10V5.657l7.332 7.332 7.334-7.334v9.328H2.558z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4W = /*#__PURE__*/forwardRef(SvgEmail);

var _excluded$4V = ["title", "titleId"];

var SvgEmergencyExit = function SvgEmergencyExit(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.487 5.066V1h13.346v18H4.487v-4.689h1.667v3.022h10.013V2.667H6.154v2.399H4.487zm4.648 2.942a2.157 2.157 0 0 0-1.069.562L4.98 11.684H2.167v-1.667h2.119l1.991-2.009h-1.79V6.341h4.654c.171.001.342.018.51.05a2.464 2.464 0 1 1 2.332 2.03c-.028-.002-.056-.004-.083-.004.057.184.095.373.114.564h2.941v1.667h-3.294c-.06.114-.13.223-.205.327l-.078.092L9.5 12.958l2.433 2.432-1.178 1.178-3.607-3.606 3-3.022a1.24 1.24 0 0 0-1.013-1.932zm3.369-2.693a.788.788 0 1 0-.876 1.31.788.788 0 0 0 .876-1.31z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4V = /*#__PURE__*/forwardRef(SvgEmergencyExit);

var _excluded$4U = ["title", "titleId"];

var SvgEmotions = function SvgEmotions(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.116 3.482a6.2 6.2 0 0 1 1.302 3.198 6.2 6.2 0 1 1-6.743 6.82 6.2 6.2 0 1 1 5.44-10.018zm-8.175.742c-.79.84-1.23 1.95-1.231 3.103a4.546 4.546 0 0 0 4.023 4.509A6.174 6.174 0 0 1 8 8.991a.86.86 0 0 0-1.613.421H4.724a2.525 2.525 0 0 1 4.492-1.58 6.179 6.179 0 0 1 2.533-1.079A4.538 4.538 0 0 0 3.94 4.224zm6.38 12.405a4.54 4.54 0 1 0 5.044-7.55 4.54 4.54 0 0 0-5.044 7.55zm1.913-2.55a.864.864 0 0 0 1.472-.609h1.664a2.526 2.526 0 1 1-5.052 0h1.663c0 .228.091.447.253.609z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4U = /*#__PURE__*/forwardRef(SvgEmotions);

var _excluded$4T = ["title", "titleId"];

var SvgEngagementRing = function SvgEngagementRing(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.309 5 1.762-1.762L11.793.96H8.176L5.9 3.239l1.76 1.76a7.177 7.177 0 1 0 4.649 0zM8.865 2.624H11.1l.615.615-1.382 1.386c-.116 0-.231-.017-.348-.017-.117 0-.233.012-.349.017L8.25 3.239l.615-.615zM9.985 17.3a5.514 5.514 0 1 1 5.515-5.516A5.52 5.52 0 0 1 9.985 17.3z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4T = /*#__PURE__*/forwardRef(SvgEngagementRing);

var _excluded$4S = ["title", "titleId"];

var SvgEpsSvg = function SvgEpsSvg(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zM8.399 5.853c.464.308.806.769.966 1.303a5.688 5.688 0 0 1 4.291 4.544 2.4 2.4 0 1 1-1.685.065 4.024 4.024 0 0 0-2.728-2.921 2.383 2.383 0 1 1-.844-2.99zM6.686 8.434c.119.08.258.122.401.122v-.001a.722.722 0 1 0-.401-.12zm6.628 4.925a.722.722 0 0 0-.401-.122v-.001a.723.723 0 1 0 .401.123z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4S = /*#__PURE__*/forwardRef(SvgEpsSvg);

var _excluded$4R = ["title", "titleId"];

var SvgEstateLiquidity = function SvgEstateLiquidity(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.207 19h1.667l-.05-10.103L9.931 1 2.176 8.765 2.126 19h1.667V9.507l6.136-6.162.002.002.001-.002 6.275 6.294V19zm-6.228-8.281a.79.79 0 0 1 .809.764h1.672a2.442 2.442 0 0 0-1.643-2.29v-.871H9.145v.87a2.43 2.43 0 0 0 .834 4.727.766.766 0 1 1-.808.764H7.5a2.442 2.442 0 0 0 1.646 2.291v.87h1.672v-.871a2.43 2.43 0 0 0-.838-4.726.765.765 0 1 1-.001-1.528z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4R = /*#__PURE__*/forwardRef(SvgEstateLiquidity);

var _excluded$4Q = ["title", "titleId"];

var SvgExcalatorDown = function SvgExcalatorDown(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 16.113V9.54a3.787 3.787 0 0 0-1.114-2.667 3.854 3.854 0 0 0-.58-.48 2.793 2.793 0 1 0-4.306.013 3.843 3.843 0 0 0-.527.434 3.78 3.78 0 0 0-1.073 2.146L4.253 4.253H1V5.92h2.58l12.127 11.86H19v-1.667h-2.333zm-3.86-12.667A1.127 1.127 0 1 1 11.693 4.6c0-.3.119-.586.33-.797.212-.211.485-.357.784-.357zM10.72 9.533a2.147 2.147 0 0 1 4.293 0v5.233l-4.293-4.2V9.533z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4Q = /*#__PURE__*/forwardRef(SvgExcalatorDown);

var _excluded$4P = ["title", "titleId"];

var SvgExcalatorUp = function SvgExcalatorUp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.79 4.082-4.935 4.937a3.793 3.793 0 0 0-1.525-2.22 2.818 2.818 0 1 0-4.3 0 3.784 3.784 0 0 0-1.636 3.116v6.252h-2.37v1.666H4.4L16.48 5.749h2.544V4.082H15.79zM7.128 7.8h.106A2.12 2.12 0 0 1 9.3 9.915v.66l-4.24 4.24v-4.9A2.12 2.12 0 0 1 7.128 7.8zm-1.1-2.814a1.152 1.152 0 0 1 1.95-.834 1.151 1.151 0 0 1-.762 1.979h-.07a1.15 1.15 0 0 1-1.115-1.147l-.003.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4P = /*#__PURE__*/forwardRef(SvgExcalatorUp);

var _excluded$4O = ["title", "titleId"];

var SvgExchange = function SvgExchange(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.1 7.785h2.1v1.679H1.012V4.4h1.679v2.454a8.453 8.453 0 0 1 7.35-4.4 8.212 8.212 0 0 1 3.136.618 3.5 3.5 0 1 1-1.145 2.574 3.45 3.45 0 0 1 .2-1.141 6.537 6.537 0 0 0-2.187-.372A6.77 6.77 0 0 0 4.1 7.785zm12.418-3.64a1.806 1.806 0 0 0-1.004-.304h.002a1.808 1.808 0 0 0-1.507 2.805 1.806 1.806 0 1 0 2.509-2.5zm-.618 8.07h-2.1v-1.679h5.192V15.6h-1.679v-2.449a8.453 8.453 0 0 1-7.35 4.4 8.212 8.212 0 0 1-3.136-.618 3.5 3.5 0 1 1 1.145-2.574 3.45 3.45 0 0 1-.2 1.141c.701.246 1.44.37 2.183.367a6.77 6.77 0 0 0 5.945-3.652zm-12.42 3.64a1.805 1.805 0 1 0 2.008-3.001 1.805 1.805 0 0 0-2.008 3z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4O = /*#__PURE__*/forwardRef(SvgExchange);

var _excluded$4N = ["title", "titleId"];

var SvgExit = function SvgExit(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 17.333h9.436V13.55l1.666-1.666V19H3.333V1h12.769v7.021l-1.666-1.667V2.667H5v14.666zm11.102-7.898v-.011l.524.524-.524.524-1.666 1.667v-.003l-2.156 2.156-1.177-1.177 2.332-2.333-5.279.002-.001-1.666 5.282-.002-2.333-2.333 1.173-1.173.005-.006 2.154 2.153v.012l1.666 1.666z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4N = /*#__PURE__*/forwardRef(SvgExit);

var _excluded$4M = ["title", "titleId"];

var SvgExpenseEfficiency = function SvgExpenseEfficiency(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.047 16.28a6.233 6.233 0 1 1 5.547-9.08l1.48-.767a7.894 7.894 0 1 0-3.26 10.56L12 15.527a6.24 6.24 0 0 1-2.953.753zm.006-8.633a.807.807 0 0 1 .827.78h1.667a2.453 2.453 0 0 0-1.66-2.307v-.88H8.22v.887a2.44 2.44 0 0 0 .833 4.753.788.788 0 0 1 .096 1.56.787.787 0 0 1-.922-.78H6.553A2.453 2.453 0 0 0 8.22 14v.887h1.667V14a2.44 2.44 0 0 0-.834-4.753.786.786 0 0 1-.322-1.53c.104-.034.156-.06.322-.07zm7.367 7.2 1.64-1.647 1.18 1.18-3.653 3.66-3.653-3.653 1.173-1.18 1.647 1.64V7.814h1.666v7.033z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4M = /*#__PURE__*/forwardRef(SvgExpenseEfficiency);

var _excluded$4L = ["title", "titleId"];

var SvgExport = function SvgExport(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.167 15.7V4.193L5.84 7.52 4.66 6.34 10 1l5.347 5.347-1.18 1.173-3.334-3.327V15.7H9.167zm8.166 1.633V7.566H19V19H1V7.566h1.667v9.767h14.666z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4L = /*#__PURE__*/forwardRef(SvgExport);

var _excluded$4K = ["title", "titleId"];

var SvgEye1 = function SvgEye1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.204 13.303a7.883 7.883 0 0 0 2.902-3.203l.037-.076-.036-.075a7.967 7.967 0 0 0-3.587-3.61A7.92 7.92 0 0 0 2.893 9.9l-.037.08.037.074a7.98 7.98 0 0 0 7.121 4.441h.035a7.883 7.883 0 0 0 4.155-1.191zm.056-8.455a9.637 9.637 0 0 1 4.34 4.37l.4.812-.4.811a9.54 9.54 0 0 1-8.546 5.317h-.038A9.657 9.657 0 0 1 1.4 10.785L1 9.972l.4-.81a9.584 9.584 0 0 1 12.86-4.314zm-5.004 6.127a1.339 1.339 0 1 0 1.486-2.228 1.339 1.339 0 0 0-1.486 2.228zm-.923-3.611a3 3 0 1 1 3.333 4.988 3 3 0 0 1-3.333-4.988z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4K = /*#__PURE__*/forwardRef(SvgEye1);

var _excluded$4J = ["title", "titleId"];

var SvgEye2 = function SvgEye2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m2.856 10 .037.078a7.925 7.925 0 0 0 2.743 3.112l1.788-1.785A2.979 2.979 0 0 1 7 9.889a3.01 3.01 0 0 1 3-3.008 2.97 2.97 0 0 1 1.518.428l1.266-1.267a7.8 7.8 0 0 0-2.79-.518 7.885 7.885 0 0 0-7.1 4.4L2.856 10zm5.805-.111c0 .084.01.168.025.25l1.566-1.565a1.31 1.31 0 0 0-1.199.367 1.34 1.34 0 0 0-.392.948zm-2.732 5.365-1.7 1.7-1.179-1.18 1.39-1.383a9.587 9.587 0 0 1-3.04-3.576L1 10l.4-.815a9.549 9.549 0 0 1 12.651-4.41l1.729-1.73 1.177 1.18-1.415 1.415-1.2 1.2-1.682 1.683-1.324 1.326-1.377 1.377-1.326 1.325-1.443 1.443-1.261 1.26zM16.8 6.74a9.542 9.542 0 0 1 1.8 2.5l.4.814-.4.812a9.54 9.54 0 0 1-8.548 5.326h-.038a9.347 9.347 0 0 1-2.353-.313l1.418-1.42c.31.04.622.061.935.064h.034a7.882 7.882 0 0 0 7.058-4.4l.037-.075-.036-.075a7.88 7.88 0 0 0-1.483-2.058L16.8 6.74z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4J = /*#__PURE__*/forwardRef(SvgEye2);

var _excluded$4I = ["title", "titleId"];

var SvgFamily = function SvgFamily(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.647 7.589a4.653 4.653 0 0 0-.981-.745 2.869 2.869 0 1 0-4.486-.053 4.648 4.648 0 0 0-1.072.8c-.083.084-.158.175-.235.265a2.842 2.842 0 0 0-1.719.027c-.085-.1-.167-.2-.259-.294a4.685 4.685 0 0 0-.982-.745 2.87 2.87 0 1 0-4.485-.053A4.648 4.648 0 0 0 1.35 9.089 4.594 4.594 0 0 0 1 10.86v6.979h1.67V10.86a2.956 2.956 0 0 1 5.046-2.092c.026.027.048.056.074.084a2.85 2.85 0 0 0 0 3.508 4.633 4.633 0 0 0-2.425 4.069v1.409h1.669v-1.41a2.958 2.958 0 1 1 5.913 0v1.41h1.667v-1.41a4.59 4.59 0 0 0-1.355-3.268 4.658 4.658 0 0 0-.981-.746 2.86 2.86 0 0 0-.006-3.626l.016-.018a2.956 2.956 0 0 1 5.047 2.09v6.98H19v-6.98a4.592 4.592 0 0 0-1.353-3.271zm-3.2-3.755a1.2 1.2 0 1 1-.004 0h.004zM11.256 10.6a1.2 1.2 0 1 1-2.401 0 1.2 1.2 0 0 1 2.401 0zM5.69 3.834a1.2 1.2 0 1 1 0 2.401 1.2 1.2 0 0 1 0-2.401z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4I = /*#__PURE__*/forwardRef(SvgFamily);

var _excluded$4H = ["title", "titleId"];

var SvgFax = function SvgFax(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m2.667 17.333-.03-3.857H17.3l.029 3.857H2.667zM4.979 2.667h7.3l2.741 2.74v6.414H4.979V2.667zm11.667 2.009L12.96 1H3.354v10.821H1V19h18v-7.179h-2.333l-.021-7.145zm-9.664.854v1.646h6.028V5.53H6.982zm6.028 4.615H6.982V8.478h6.028v1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4H = /*#__PURE__*/forwardRef(SvgFax);

var _excluded$4G = ["title", "titleId"];

var SvgFemaleSymbol = function SvgFemaleSymbol(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.837 12.017a5.542 5.542 0 1 0-1.67 0V14.3H5.952v1.67h3.217V19h1.669v-3.033h3.217V14.3h-3.217v-2.283zM6.13 6.544a3.873 3.873 0 1 1 7.746 0 3.873 3.873 0 0 1-7.746 0z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4G = /*#__PURE__*/forwardRef(SvgFemaleSymbol);

var _excluded$4F = ["title", "titleId"];

var SvgFemaleToilet = function SvgFemaleToilet(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.931 5.394a2.733 2.733 0 1 0-4.322.025L4 16.107h3.019v2.9h1.665v-4.57H6.322l2.723-8.062c.477.133.98.13 1.456-.007l2.741 8.07h-2.358v4.569h1.666v-2.9h3.021l-3.64-10.713zM8.694 3.74a1.067 1.067 0 1 1 2.134 0 1.067 1.067 0 0 1-2.134 0z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4F = /*#__PURE__*/forwardRef(SvgFemaleToilet);

var _excluded$4E = ["title", "titleId"];

var SvgFerry = function SvgFerry(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.549 16.287a4.142 4.142 0 0 0-.979-.906l.419-2.795-1.945-1.945V3.315h-4.22V.982H9.176v2.333H5.022v7.26l-2.011 2.01.589 3.93-.226-.228A3.061 3.061 0 0 0 1 15.034v1.649c.527 0 .791.263 1.187.725A2.988 2.988 0 0 0 4.56 18.66a2.989 2.989 0 0 0 2.374-1.253s.61-.66 1.121-.66h.132c.527 0 .725.2 1.187.726a3.1 3.1 0 0 0 2.373 1.252h.066a2.99 2.99 0 0 0 2.374-1.252s.589-.66 1.055-.66h.132c.527 0 .725.2 1.186.726A3.133 3.133 0 0 0 19 18.792v-1.648a2.086 2.086 0 0 1-1.451-.857zM6.67 4.963h6.73v4.03L10 5.6 6.67 8.927V4.963zm6.13 11.324c-.461.46-.659.725-1.187.725h-.063c-.462 0-.66-.2-1.121-.725a2.99 2.99 0 0 0-2.374-1.253 2.475 2.475 0 0 0-1.714.594c-.359.339-.7.726-1.028 1.006l-.522-3.454L10 7.97l5.209 5.21-.291 1.92a3.65 3.65 0 0 0-2.118 1.187z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4E = /*#__PURE__*/forwardRef(SvgFerry);

var _excluded$4D = ["title", "titleId"];

var SvgFileFolder = function SvgFileFolder(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.711 5.668 6.375 3.336H1v13.328h18v-11l-10.289.004zM17.332 15H2.668V5.005h3.018l2.347 2.329h9.3L17.332 15z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4D = /*#__PURE__*/forwardRef(SvgFileFolder);

var _excluded$4C = ["title", "titleId"];

var SvgFilter = function SvgFilter(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 1H1l6.55 6.547V19l1.667-1.646v-.036l3.233-3.23V7.547L19 1zM9.217 14.96V6.832h-.024L5.011 2.667h9.978l-4.182 4.165h-.024v6.562L9.217 14.96z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4C = /*#__PURE__*/forwardRef(SvgFilter);

var _excluded$4B = ["title", "titleId"];

var SvgFinancialWellness = function SvgFinancialWellness(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.912 1.903c.614.263 1.169.649 1.629 1.134a5.286 5.286 0 0 1 .153 7.12l-7.7 8.8L2.3 10.149a5.286 5.286 0 0 1 .357-7.312 4.878 4.878 0 0 1 6.9.2l.437.454.428-.454a4.9 4.9 0 0 1 5.49-1.134zM9.994 16.426l6.447-7.365h.002a3.623 3.623 0 0 0-.115-4.88 3.242 3.242 0 0 0-4.7 0l-.428.454-1.2 1.27-1.208-1.258-.436-.454a3.214 3.214 0 0 0-4.685-.015 3.625 3.625 0 0 0-.113 4.88l6.436 7.368zm.335-7.768a.465.465 0 1 0-.329.794 2.131 2.131 0 0 1 .834 4.093v.505H9.168v-.505a2.132 2.132 0 0 1-1.3-1.961h1.667a.465.465 0 1 0 .465-.465 2.132 2.132 0 0 1-.833-4.094v-.5h1.665v.5a2.133 2.133 0 0 1 1.3 1.96h-1.667a.465.465 0 0 0-.136-.327z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4B = /*#__PURE__*/forwardRef(SvgFinancialWellness);

var _excluded$4A = ["title", "titleId"];

var SvgFire = function SvgFire(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.7a5.001 5.001 0 0 1-3.565 2.56v-3.818H9.166v3.818a5.013 5.013 0 0 1-3.589-7.3l3.291-5.642 2.57 4.433 1.139-1.981 1.605 2.756.216.4a5.023 5.023 0 0 1 0 4.772l.002.002zm1.468-5.563-3.3-5.695-1.136 1.974L8.872 1 4.121 9.152A6.683 6.683 0 0 0 9.992 19a6.687 6.687 0 0 0 5.874-9.864l.002.001z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4A = /*#__PURE__*/forwardRef(SvgFire);

var _excluded$4z = ["title", "titleId"];

var SvgFireExtinguisher = function SvgFireExtinguisher(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.444 4.64V1h-1.666v.947h-2.719a6.521 6.521 0 0 0-.833.06l-.136.021a6.522 6.522 0 0 0-5.534 6.426v3.655h1.666V8.455a4.86 4.86 0 0 1 3.868-4.742V4.92a3.547 3.547 0 0 0-2.709 3.539V19h7.089V8.211a3.536 3.536 0 0 0-2.713-3.291V3.613h2.021V4.64h1.666zM12.8 8.286V17.333H9.047V8.43a1.88 1.88 0 0 1 3.753-.144z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4z = /*#__PURE__*/forwardRef(SvgFireExtinguisher);

var _excluded$4y = ["title", "titleId"];

var SvgFireHose = function SvgFireHose(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.412 8.938v6.837h.802v1.667h-.8V19h-1.667v-1.558h-.819v-1.667h.819v-2.156a7.823 7.823 0 1 1 1.665-4.811v.13zM6.187 13.915A6.143 6.143 0 0 0 9.6 14.95a6.148 6.148 0 0 0 6.141-6.142 6.142 6.142 0 1 0-9.554 5.107zM9.6 3.8a5.01 5.01 0 1 0-.002 10.02A5.01 5.01 0 0 0 9.6 3.8zm0 8.352a3.343 3.343 0 1 1 3.343-3.343A3.347 3.347 0 0 1 9.6 12.151v.001zm0-5.687a2.344 2.344 0 1 0-.002 4.687A2.344 2.344 0 0 0 9.6 6.465zm0 3.021a.678.678 0 1 1-.002-1.357.678.678 0 0 1 .002 1.357z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4y = /*#__PURE__*/forwardRef(SvgFireHose);

var _excluded$4x = ["title", "titleId"];

var SvgFirstAid = function SvgFirstAid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.215 1h7.407v1.667H6.215V1zM1 4.333V19h18V4.333H1zm16.333 13H2.667V6h14.666v11.333zm-8.166-1.644h1.666v-3.333h3.334v-1.667h-3.334V7.356H9.167v3.333H5.833v1.667h3.334v3.333z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4x = /*#__PURE__*/forwardRef(SvgFirstAid);

var _excluded$4w = ["title", "titleId"];

var SvgFish = function SvgFish(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.656 10.03a7.328 7.328 0 0 0 7.328 7.298h3.861v-2.369a4.676 4.676 0 0 1-6.951-4.087v-.078A4.622 4.622 0 0 1 8.11 7.661L9.343 8.79a2.947 2.947 0 0 0-.773 1.837c4.059-.035 6.855-3.233 7.718-4.365a7.292 7.292 0 0 0-6.304-3.59A7.328 7.328 0 0 0 2.656 9.97v.06zm-1.67.019H.984V1h8.907a9 9 0 0 1 8.129 4.944l.215.426-.256.4c-.147.231-3.448 5.292-9.058 5.522a3.007 3.007 0 0 0 5.084.345l1.512-2.078V19H9.984a9 9 0 0 1-8.998-8.951zM4.76 2.672H2.656v2.105a9 9 0 0 1 2.105-2.105zm6.342 3.603a1.119 1.119 0 1 0 0-2.238 1.119 1.119 0 0 0 0 2.238z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4w = /*#__PURE__*/forwardRef(SvgFish);

var _excluded$4v = ["title", "titleId"];

var SvgFlag = function SvgFlag(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.187 19h1.667v-7.165L19 11.848l-5.433-5.43L18.994 1H2.187v18zm12.77-16.332h-11.1v7.501l11.124.01-3.769-3.755 3.745-3.756z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4v = /*#__PURE__*/forwardRef(SvgFlag);

var _excluded$4u = ["title", "titleId"];

var SvgFlexibility = function SvgFlexibility(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m4.5 8 1.175-1.178-1.31-1.3H4.6A4.572 4.572 0 0 1 8.368 7.51l1.188-1.188A6.229 6.229 0 0 0 4.6 3.856h-.611l1.686-1.674L4.5 1.007l-.87.87L1 4.5 4.5 8zm11.869 4.871L15.5 12l-1.174 1.174 1.506 1.5h-.419a4.575 4.575 0 0 1-3.849-2.111l-1.2 1.2a6.229 6.229 0 0 0 5.044 2.582h.4l-1.491 1.478 1.183 1.17 2.32-2.32L19 15.5l-2.628-2.627-.003-.002zM10.837 10.1c0-.11-.011-.218-.016-.327L9.291 11.3c.118.606.327 1.192.619 1.736l1.253-1.253a4.542 4.542 0 0 1-.326-1.683zm-1.665 0c0 .047.006.091.007.138l1.5-1.5a6.213 6.213 0 0 0-.656-1.7L8.788 8.27c.253.577.384 1.2.384 1.831zm2.498-2.59a4.57 4.57 0 0 1 3.77-1.988h.2l-1.31 1.3L15.5 8 19 4.5l-3.498-3.496-1.177 1.178 1.686 1.674h-.57a6.226 6.226 0 0 0-4.959 2.467c.351.585.6 1.225.738 1.893l.45-.705zM8.2 12.69a4.572 4.572 0 0 1-3.77 1.99h-.269l1.514-1.5L4.5 12 1 15.5l3.498 3.498 1.177-1.178-1.482-1.47h.233a6.226 6.226 0 0 0 4.958-2.467 6.053 6.053 0 0 1-.738-1.893l-.446.7z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4u = /*#__PURE__*/forwardRef(SvgFlexibility);

var _excluded$4t = ["title", "titleId"];

var SvgFlexibilityAlt = function SvgFlexibilityAlt(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.353 4.373 9.993 1.02 6.647 4.373l1.18 1.174 1.34-1.34L9.16 18.96h1.667l.006-14.747 1.34 1.34 1.18-1.18zm-7.58 2.614V5.32l-4.753.006.013 4.734 1.667-.007-.007-1.893 3.094 3.093-.02 7.72 1.666.007.02-8.414-3.58-3.58h1.9zm8.454-.014V5.307l4.753.006-.013 4.734-1.667-.007.007-1.893-3.094 3.093-.006 7.74-1.66-.007v-8.42l3.58-3.58h-1.9z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4t = /*#__PURE__*/forwardRef(SvgFlexibilityAlt);

var _excluded$4s = ["title", "titleId"];

var SvgFlexibleAccess = function SvgFlexibleAccess(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 6.98V5.313h6.08c.225 0 .449.025.668.073L6.933 6.98H1zm7.689-1.24-.76 1.489a1.618 1.618 0 0 1 .731 1.025l.021.1 1.46-.936A3.3 3.3 0 0 0 8.689 5.74zm1.715 2.698-1.497.96.411 1.901 1.497-.96-.411-1.901zm2.353 4.519c.164.04.332.06.5.063H19v1.667h-5.741c-.434 0-.866-.074-1.276-.216l.774-1.514zm-1.702-1.584-1.439.927c.312.707.821 1.31 1.467 1.734l.766-1.5a2.3 2.3 0 0 1-.794-1.161z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4s = /*#__PURE__*/forwardRef(SvgFlexibleAccess);

var _excluded$4r = ["title", "titleId"];

var SvgFlower = function SvgFlower(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.56 9.93 1.108 1.11a4.617 4.617 0 0 1-6.513 6.544L10.03 16.46l-1.134 1.134-.036.036c-.029.03-.063.066-.099.099a4.618 4.618 0 0 1-6.379-6.678l1.12-1.12-1.11-1.11a4.617 4.617 0 0 1 6.513-6.543L10.03 3.4l1.11-1.107a4.617 4.617 0 0 1 6.543 6.513L16.56 9.93zm-2.144 7.257a2.952 2.952 0 0 0 2.052-.911h.001a2.948 2.948 0 0 0 .006-4.076l-2.269-2.27 2.288-2.287a2.95 2.95 0 0 0-4.187-4.157l-2.273 2.273L7.746 3.47a2.952 2.952 0 1 0-4.16 4.187L5.857 9.93l-2.312 2.31a2.952 2.952 0 1 0 4.157 4.189l2.327-2.33 2.287 2.29a2.953 2.953 0 0 0 2.1.797zm-6.04-9.73a2.976 2.976 0 1 1 3.308 4.949 2.976 2.976 0 0 1-3.307-4.95zm.927 3.563a1.31 1.31 0 1 0 1.455-2.178 1.31 1.31 0 0 0-1.455 2.178z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4r = /*#__PURE__*/forwardRef(SvgFlower);

var _excluded$4q = ["title", "titleId"];

var SvgFocusRoom = function SvgFocusRoom(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.72 6.711v1.665h5.662v-.004h.001V2.71H6.718v2.823L2.185 1 1.007 2.177l4.534 4.534H2.72zm8.112 2.456H9.167v1.665h1.665V9.167zm-8.11 2.457H8.39v5.663H6.724v-2.821L2.19 19l-1.177-1.177 4.533-4.534H2.723v-1.665zm11.737 1.664h2.82v-1.666h-5.661v.005h-.001v5.662h1.665v-2.823l4.533 4.533 1.178-1.177-4.534-4.534zM17.28 8.38h-5.662v-.002h-.004V2.716h1.665v2.821l4.534-4.534 1.177 1.178-4.534 4.533h2.824V8.38z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4q = /*#__PURE__*/forwardRef(SvgFocusRoom);

var _excluded$4p = ["title", "titleId"];

var SvgFormCompleted = function SvgFormCompleted(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zm1.942-6.367 1.167-1.195 1.874 1.879 4.403-4.389 1.194 1.167L8.806 14l-3.028-3.037z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4p = /*#__PURE__*/forwardRef(SvgFormCompleted);

var _excluded$4o = ["title", "titleId"];

var SvgFormEmpty = function SvgFormEmpty(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.631 4.55-2.415 2.42v-4.8H1v15.663h12.216V13.7L19 7.928 15.631 4.55zm-4.08 11.619H2.665V3.83h8.886v4.808l-2.2 2.2v3.37h2.2v1.96zm.461-3.623h-.994v-1.017l4.613-4.621 1.015 1.017-4.634 4.62z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4o = /*#__PURE__*/forwardRef(SvgFormEmpty);

var _excluded$4n = ["title", "titleId"];

var SvgFormLong = function SvgFormLong(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.07 6.753c.254-.034.51-.051.766-.053h.001A6.15 6.15 0 1 1 6.8 14H1.013V1h8.062l2.995 2.975v2.778zm-9.388 5.582h4.03a6.159 6.159 0 0 1 3.689-5.13V4.668l-2.014-2H2.682v9.667zm7.664 4.245a4.482 4.482 0 0 0 2.49.755v-.003a4.487 4.487 0 0 0 4.482-4.479 4.482 4.482 0 1 0-6.972 3.727zm1.473-3.15 3.215-3.188 1.178 1.182-4.401 4.37-2.35-2.386 1.187-1.173 1.171 1.195z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4n = /*#__PURE__*/forwardRef(SvgFormLong);

var _excluded$4m = ["title", "titleId"];

var SvgFormPaper = function SvgFormPaper(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.493 1.013H2.42v18h15.167V5.08l-4.094-4.067zm2.427 16.32H4.087V2.667h8.72L15.92 5.76v11.573z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4m = /*#__PURE__*/forwardRef(SvgFormPaper);

var _excluded$4l = ["title", "titleId"];

var SvgFormSearch = function SvgFormSearch(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zm3.862-6.359a3.42 3.42 0 0 1-.514-1.8h.004a3.443 3.443 0 1 1 1.7 2.969l-2.083 2.083-1.179-1.178 2.072-2.074zm4.413-.811a1.78 1.78 0 1 0-2.96-1.978 1.78 1.78 0 0 0 2.96 1.978z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4l = /*#__PURE__*/forwardRef(SvgFormSearch);

var _excluded$4k = ["title", "titleId"];

var SvgFormSimple = function SvgFormSimple(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m13.28 11.507 2.309-2.313L19 12.614 12.6 19H9.208v-2.626H1V2.167h12.28v9.34zM2.666 3.832v10.877h7.419l1.53-1.533V3.832H2.666zm8.208 13.502h1.035l4.735-4.723-1.055-1.059-4.715 4.725v1.057zM5.078 8.428 6.25 9.623l3.215-3.188 1.178 1.182-4.402 4.37-2.349-2.386 1.186-1.173z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4k = /*#__PURE__*/forwardRef(SvgFormSimple);

var _excluded$4j = ["title", "titleId"];

var SvgFrisbee = function SvgFrisbee(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.99 8.45a7.45 7.45 0 1 0-14.527 2.33l-3.453.97.451 1.607 3.579-1H8.5a.431.431 0 0 1 0 .861H5.4v1.669h2.387a7.431 7.431 0 0 0 4.207.998l-1.446 1.446h-9.5V19h9.846c.22 0 .433-.088.589-.244l3.847-3.896a7.453 7.453 0 0 0 3.66-6.41zm-9.841 0a2.391 2.391 0 1 1 4.783-.002 2.391 2.391 0 0 1-4.783.002zm2.391 5.781a5.82 5.82 0 0 1-1.377-.168 2.08 2.08 0 0 0 .4-1.678 4.061 4.061 0 1 0-2.409-1.7h-1.94a5.777 5.777 0 1 1 5.326 3.548v-.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4j = /*#__PURE__*/forwardRef(SvgFrisbee);

var _excluded$4i = ["title", "titleId"];

var SvgFullscreen = function SvgFullscreen(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.901 3.333V5h3.251L12.02 9.131l1.179 1.179 4.134-4.135v3.25H19V3.333h-6.099zm4.432 11.643-14.666.021V5.022L11.459 5l-.005-1.667L1 3.36v13.307l18-.027v-5.282h-1.667v3.618z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4i = /*#__PURE__*/forwardRef(SvgFullscreen);

var _excluded$4h = ["title", "titleId"];

var SvgFundUnits = function SvgFundUnits(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16 .976a3 3 0 0 0-2.657 4.39l-1.955 1.953a3 3 0 0 0-4.045 4.046L5.388 13.32a3.015 3.015 0 1 0 1.2 1.154L8.5 12.568a2.994 2.994 0 0 0 4.095-4.095L14.5 6.568a2.999 2.999 0 0 0 4.452-3.18A3 3 0 0 0 16 .977zM4 17.31a1.334 1.334 0 1 1-.002-2.668A1.334 1.334 0 0 1 4 17.31zm6-6a1.334 1.334 0 1 1-.002-2.669A1.334 1.334 0 0 1 10 11.31zm6-6a1.334 1.334 0 1 1-.002-2.668A1.334 1.334 0 0 1 16 5.31z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4h = /*#__PURE__*/forwardRef(SvgFundUnits);

var _excluded$4g = ["title", "titleId"];

var SvgFundsSwitches = function SvgFundsSwitches(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.135 1v1.686A7.342 7.342 0 0 0 2.72 9.129H1.04A9.014 9.014 0 0 1 9.135 1zm8.145 8.129h1.68A9.014 9.014 0 0 0 10.8 1v1.678a7.34 7.34 0 0 1 6.48 6.451zm-6.443 5.63v-.871A2.427 2.427 0 0 0 10 9.165a.765.765 0 1 1 .808-.764h1.671a2.441 2.441 0 0 0-1.642-2.289v-.871H9.166v.87A2.427 2.427 0 0 0 10 10.835a.766.766 0 1 1-.808.764H7.521a2.441 2.441 0 0 0 1.645 2.29v.87h1.671zM2.72 10.871H1.04A9.014 9.014 0 0 0 9.135 19v-1.686a7.34 7.34 0 0 1-6.415-6.443zM10.8 19v-1.678a7.34 7.34 0 0 0 6.48-6.451h1.679A9.014 9.014 0 0 1 10.799 19z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4g = /*#__PURE__*/forwardRef(SvgFundsSwitches);

var _excluded$4f = ["title", "titleId"];

var SvgGame = function SvgGame(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.833 5V2.167H9.167V5H1v11.667h18V5h-8.167zm6.5 10H2.667V6.667h14.666V15zM5.218 13.083h1.667v-1.416h1.416V10H6.885V8.583H5.218V10H3.801v1.667h1.417v1.416zm10.284-.38a2.25 2.25 0 1 1-2.504-3.74 2.25 2.25 0 0 1 2.504 3.74zm-.924-2.354a.584.584 0 1 0-.65.971.584.584 0 0 0 .65-.972z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4f = /*#__PURE__*/forwardRef(SvgGame);

var _excluded$4e = ["title", "titleId"];

var SvgGear = function SvgGear(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.123 13.854a5.468 5.468 0 0 0 3.861 1.608h.024a5.468 5.468 0 1 0-3.885-1.608zM19 9.168v1.664h-1.922a7.055 7.055 0 0 1-1.488 3.581l1.362 1.362-1.177 1.178-1.363-1.364a7.163 7.163 0 0 1-3.58 1.484V19H9.167v-1.92a7.058 7.058 0 0 1-3.586-1.48l-1.356 1.353-1.177-1.178L4.4 14.423a7.056 7.056 0 0 1-1.494-3.591H1V9.168h1.9a7.089 7.089 0 0 1 1.5-3.595L3.048 4.225l1.177-1.177L5.573 4.4a7.1 7.1 0 0 1 3.594-1.5V1h1.665v1.909A7.076 7.076 0 0 1 14.424 4.4l1.351-1.352 1.178 1.177L15.6 5.578a7.05 7.05 0 0 1 1.481 3.59H19zm-8.394 2.31c.196-.081.374-.2.523-.351h-.001a1.6 1.6 0 0 0 .472-1.138 1.612 1.612 0 0 0-3.223.001 1.612 1.612 0 0 0 2.23 1.488zm-1.89-4.53c.404-.16.836-.24 1.271-.232h-.003a3.3 3.3 0 0 1 2.318.958 3.275 3.275 0 0 1-2.315 5.591 3.276 3.276 0 0 1-2.353-5.61c.31-.305.678-.545 1.082-.706z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4e = /*#__PURE__*/forwardRef(SvgGear);

var _excluded$4d = ["title", "titleId"];

var SvgGift = function SvgGift(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12 4.47 2.3-2.278L13.115 1 9.983 4.118 6.882 1 5.7 2.177 7.974 4.47H2.163V19H17.83V4.47H12zM9.11 17.324H3.837V6.144H9.11v11.18zm7.046 0h-5.373V6.144h5.373v11.18z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4d = /*#__PURE__*/forwardRef(SvgGift);

var _excluded$4c = ["title", "titleId"];

var SvgGlobe = function SvgGlobe(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.2 16.993a12.346 12.346 0 0 0 1.777-6.158h3.303a7.348 7.348 0 0 1-5.08 6.158zm-9.48-6.158h3.19a12.4 12.4 0 0 0 1.744 6.107 7.347 7.347 0 0 1-4.934-6.107zm4.934-7.777A12.4 12.4 0 0 0 5.91 9.165H2.72a7.346 7.346 0 0 1 4.934-6.107zm-.071 6.107c.165-3.056 1.211-5.36 2.358-6.171 1.148.811 2.194 3.115 2.358 6.171H7.583zm2.358 7.841c-1.147-.811-2.193-3.115-2.358-6.171H12.3c-.164 3.056-1.21 5.36-2.358 6.171h-.001zm7.339-7.841h-3.307A12.346 12.346 0 0 0 12.2 3.007a7.348 7.348 0 0 1 5.08 6.158zM10 1a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4c = /*#__PURE__*/forwardRef(SvgGlobe);

var _excluded$4b = ["title", "titleId"];

var SvgGolf = function SvgGolf(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "golf_svg__Icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.golf_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "golf_svg__st0",
    d: "M4.354 1.018h1.667v17.268H4.354z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "golf_svg__st0",
    cx: 15.804,
    cy: 18.12,
    r: 0.865
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "golf_svg__st0",
    cx: 5.52,
    cy: 18.13,
    rx: 2.168,
    ry: 0.863
  }), /*#__PURE__*/React.createElement("path", {
    className: "golf_svg__st0",
    d: "M5.571 11.149 4.803 9.67l5.891-3.061-5.79-3.158.798-1.463 8.538 4.656z"
  }));
};

var ForwardRef$4b = /*#__PURE__*/forwardRef(SvgGolf);

var _excluded$4a = ["title", "titleId"];

var SvgGrandparents = function SvgGrandparents(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.432 5.3a2.805 2.805 0 0 1-.632 1.77 4.42 4.42 0 0 1 2.217 3.83v8.09h-1.659V10.9a2.761 2.761 0 1 0-5.522 0v8.088H9.164V9.41a2.758 2.758 0 0 0-2.67-2.75c-.016 0-.032-.003-.047-.006S6.416 6.65 6.4 6.65A2.765 2.765 0 0 0 3.642 9.41v9.578H1.983V9.41a4.424 4.424 0 0 1 2.279-3.862 2.835 2.835 0 1 1 4.409.074 4.442 4.442 0 0 1 1.829 2.13 4.46 4.46 0 0 1 .9-.683 2.807 2.807 0 0 1-.639-1.769 2.836 2.836 0 0 1 5.671 0zM5.513 3.173A1.175 1.175 0 0 0 6.4 4.99c.023 0 .045.003.066.005.021.003.041.005.062.005a1.178 1.178 0 1 0-1.015-1.827zm7.106 1.474a1.177 1.177 0 1 0 1.957 1.309 1.177 1.177 0 0 0-1.957-1.31zm1.073 8.764h-1.541v-1.667h3.208v7.244h-1.667v-5.577z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$4a = /*#__PURE__*/forwardRef(SvgGrandparents);

var _excluded$49 = ["title", "titleId"];

var SvgGrowth1 = function SvgGrowth1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$49);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.133 5.859 12.991 1l4.854 4.853-1.186 1.186-2.832-2.831V19H12.15V4.213L9.318 7.045 8.133 5.859zm.686 2.051h1.675V19H8.819V7.91zm-3.332 3.353h1.675V19H5.487v-7.737zM3.83 14.615H2.155V19H3.83v-4.385z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$49 = /*#__PURE__*/forwardRef(SvgGrowth1);

var _excluded$48 = ["title", "titleId"];

var SvgGrowth2 = function SvgGrowth2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$48);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.821 3.631.87.87-1.175 1.176-1.49-1.5v14.818H12.36V4.178l-1.487 1.5-1.179-1.18 2.322-2.32 1.178-1.18 2.63 2.63-.003.003zM6.809 5.368l2.629 2.63L9.435 8l.871.871-1.176 1.175-1.49-1.5v10.456H5.974V8.547l-1.487 1.499-1.178-1.178L5.63 6.546l1.179-1.178z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$48 = /*#__PURE__*/forwardRef(SvgGrowth2);

var _excluded$47 = ["title", "titleId"];

var SvgGuaranteedCost = function SvgGuaranteedCost(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$47);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.753 1.006 14.832 1a2.97 2.97 0 0 1 3.014 3.01v3.818h-4.38l-.066 8.745L10.987 19l-1.6-1.6-1.6 1.6-1.6-1.6-1.6 1.6-2.429-2.43V4.6a3.6 3.6 0 0 1 3.595-3.594zm5.981 14.868L11.822 4c0-.46.107-.915.313-1.327H5.753A1.931 1.931 0 0 0 3.807 4.6v11.277l.763.762 1.6-1.6 1.6 1.6 1.6-1.6 1.6 1.6.764-.765zm1.742-9.717h2.7V4.01a1.346 1.346 0 0 0-1.337-1.341h-.132a1.345 1.345 0 0 0-1.216 1.337l-.015 2.15zm-5.308 4a.764.764 0 0 0-.413-.15 2.427 2.427 0 0 1-.834-4.723v-.87h1.671v.87a2.44 2.44 0 0 1 1.642 2.29H8.563a.764.764 0 1 0-.808.763 2.427 2.427 0 0 1 .837 4.723v.87H6.921v-.87a2.438 2.438 0 0 1-1.645-2.288h1.671a.765.765 0 1 0 1.22-.615z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$47 = /*#__PURE__*/forwardRef(SvgGuaranteedCost);

var _excluded$46 = ["title", "titleId"];

var SvgGuaranteedDeathBenefit = function SvgGuaranteedDeathBenefit(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$46);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.63 13.936V.976h14.911v12.96l-7.455 5.04-7.456-5.04zm7.46 2.806 5.6-3.789V2.826H4.49v10.127l5.6 3.79zm.824-3.67H9.247v-4.07H7.145V7.333h2.102V4.912h1.667v2.422h2.101v1.667h-2.101v4.07z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$46 = /*#__PURE__*/forwardRef(SvgGuaranteedDeathBenefit);

var _excluded$45 = ["title", "titleId"];

var SvgGym = function SvgGym(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$45);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.161 9.167h7.091V4.254h1.666v11.492h-1.666v-4.913H6.161v4.913H4.494V4.254h1.667v4.913zm-4.192 0H1v1.666h.969v3.436h1.667V5.73H1.969v3.436zm16.062 0V5.73h-1.666v8.538h1.666v-3.436H19V9.167h-.969z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$45 = /*#__PURE__*/forwardRef(SvgGym);

var _excluded$44 = ["title", "titleId"];

var SvgHackySack = function SvgHackySack(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$44);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.256 6.151a2.817 2.817 0 1 1-3.13-4.684 2.817 2.817 0 0 1 3.13 4.684zm-.925-3.299a1.151 1.151 0 1 0-1.28 1.914 1.151 1.151 0 0 0 1.28-1.914zm-2.395 6.07 6.835-2.188L19 9.963l-9.055 9.029L1 10.059l1.178-1.18 3.01 3L7.363 9.7l-4.03-4.013 1.178-1.178 4.425 4.413zm-.27 1.835-2.3 2.3 3.576 3.577 6.7-6.676-1.33-1.33-1.242.4v1.65h-1.664V9.562l-.88.281v1.821H9.86v-1.289l-1.194.382z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$44 = /*#__PURE__*/forwardRef(SvgHackySack);

var _excluded$43 = ["title", "titleId"];

var SvgHamburger = function SvgHamburger(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$43);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 3.362H1v1.667h18V3.362zm0 5.795H1v1.667h18V9.157zM1 14.972h18v1.667H1v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$43 = /*#__PURE__*/forwardRef(SvgHamburger);

var _excluded$42 = ["title", "titleId"];

var SvgHandWaving = function SvgHandWaving(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$42);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.061 2.653V1A5.067 5.067 0 0 0 1 6.061h1.653a3.412 3.412 0 0 1 3.408-3.408zM16.266 10.1a1.9 1.9 0 0 0-.836-2.545 1.963 1.963 0 0 0-.285-.114 1.98 1.98 0 0 0-1.471-2.454 1.914 1.914 0 0 0-2.5-2 1.85 1.85 0 0 0-.678.4 1.953 1.953 0 0 0-.4-.276 1.982 1.982 0 0 0-2.657.872L5.684 7.437a2 2 0 0 0-2.6-.228 2 2 0 0 0-.766 2.147L3.544 13.9l-2.051 5.019h8.641l.884-1.451 1.234-1.1A10.636 10.636 0 0 0 14.7 13.2l1.566-3.1zm-5.093 5.059-1.417 1.254-.536.879H3.915l1.343-3.285-1.366-5.074a.38.38 0 0 1 .143-.402.376.376 0 0 1 .58.2l.825 2.799 3.444-6.818a.35.35 0 0 1 .626.316l-.81 1.6-1.012 2 1.452.734 1.821-3.6.55-1.087a.28.28 0 0 1 .167-.144.29.29 0 0 1 .348.4L12 4.985l-2.348 4.64 1.452.734 1.832-3.624a.348.348 0 0 1 .632.069.35.35 0 0 1-.02.267l-1.822 3.6 1.452.734 1.157-2.287a.268.268 0 1 1 .476.241l-1.569 3.1a9.029 9.029 0 0 1-2.069 2.697v.003zM5.217 5.217a1.083 1.083 0 0 0-.317.762H3.233a2.75 2.75 0 0 1 2.746-2.746V4.9c-.286.001-.56.115-.762.317zm12.13 8.722a3.413 3.413 0 0 1-3.408 3.408V19A5.066 5.066 0 0 0 19 13.939h-1.653zm-3.326 2.825V15.1a1.083 1.083 0 0 0 1.079-1.082h1.667a2.75 2.75 0 0 1-2.746 2.746z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$42 = /*#__PURE__*/forwardRef(SvgHandWaving);

var _excluded$41 = ["title", "titleId"];

var SvgHandshake = function SvgHandshake(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$41);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.605 7.625h2.322l1.373 1.25H19V7.208h-4.054l-1.375-1.25h-.977a2.56 2.56 0 0 0 .048-.572A2.058 2.058 0 0 0 10.5 3.354H6.071L2.543 7.3H1v1.67h2.289L6.817 5.02H10.5c.148 0 .455 0 .48.411v.048a.67.67 0 0 1-.114.383.415.415 0 0 1-.257.095H8.541A2.06 2.06 0 0 0 6.4 7.99a2.3 2.3 0 0 0 .552 1.61 2.08 2.08 0 0 0 1.589.634H11.4l3.109 2.787-4.703 1.836L4.255 12.7H1.006v1.666h2.936l5.864 2.281 6.428-2.506H19v-1.668h-2.6l-4.36-3.905h-3.5a.545.545 0 0 1-.365-.1.666.666 0 0 1-.115-.418.409.409 0 0 1 .48-.427h1.96c.034.007.069.003.105.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$41 = /*#__PURE__*/forwardRef(SvgHandshake);

var _excluded$40 = ["title", "titleId"];

var SvgHandwashing = function SvgHandwashing(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$40);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "handwashing_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.handwashing_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("g", {
    id: "handwashing_svg__Artwork"
  }, /*#__PURE__*/React.createElement("path", {
    className: "handwashing_svg__st0",
    d: "M12.822 19H1.037v-1.66h11.441l3.652-3.652h-5.277v-1.66h7.281a.829.829 0 0 1 .586 1.416l-5.312 5.313a.825.825 0 0 1-.586.243"
  }), /*#__PURE__*/React.createElement("path", {
    className: "handwashing_svg__st0",
    d: "M9.96 14.071H6.247v-1.66H9.96a.685.685 0 0 0 0-1.369H5.791l-4.306 1.209-.448-1.6 4.415-1.24a.815.815 0 0 1 .225-.031H9.96a2.345 2.345 0 0 1 0 4.689M15.145 1s-3.257 3.526-3.257 6.073a3.259 3.259 0 0 0 6.517 0c0-2.547-3.26-6.073-3.26-6.073zm0 7.668a1.608 1.608 0 0 1-1.605-1.635c0-1.28 1.606-3.382 1.606-3.382s1.608 2.1 1.608 3.382a1.6 1.6 0 0 1-1.607 1.635h-.002z"
  })));
};

var ForwardRef$40 = /*#__PURE__*/forwardRef(SvgHandwashing);

var _excluded$3$ = ["title", "titleId"];

var SvgHappy = function SvgHappy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.917 17.574a9 9 0 0 0 5 1.517 9.01 9.01 0 0 0 9-9 9 9 0 1 0-14 7.483zm.925-13.581a7.333 7.333 0 0 1 4.075-1.236 7.342 7.342 0 0 1 7.333 7.334A7.334 7.334 0 1 1 5.842 3.993zm.362 3.457h1.593v1.667H6.204V7.45zm7.391 0h-1.593v1.667h1.593V7.45zm-6.31 6.396a3.7 3.7 0 0 0 6.315-2.613h-1.671a2.029 2.029 0 0 1-4.058 0H6.2a3.7 3.7 0 0 0 1.085 2.613z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3$ = /*#__PURE__*/forwardRef(SvgHappy);

var _excluded$3_ = ["title", "titleId"];

var SvgHeadset = function SvgHeadset(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 0 0-9 9v2.789a2.092 2.092 0 0 0 2.09 2.09h3.047V8.252H3.09c-.07.003-.14.01-.21.022a7.324 7.324 0 0 1 14.24 0 1.825 1.825 0 0 0-.21-.022h-3.046v6.627h1.353V16a1.33 1.33 0 0 1-1.329 1.329H10V19h3.888a3 3 0 0 0 3-3v-1.121h.026A2.092 2.092 0 0 0 19 12.789V10a9 9 0 0 0-9-9zM3.09 9.919h1.38v3.293H3.09a.43.43 0 0 1-.423-.423v-2.446a.429.429 0 0 1 .423-.424zm14.243 2.87a.43.43 0 0 1-.423.423h-1.38V9.919h1.38a.43.43 0 0 1 .423.424v2.446z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3_ = /*#__PURE__*/forwardRef(SvgHeadset);

var _excluded$3Z = ["title", "titleId"];

var SvgHealth = function SvgHealth(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.901 2.042c.615.264 1.17.65 1.63 1.135a5.287 5.287 0 0 1 .163 7.12l-7.706 8.8-7.7-8.808a5.286 5.286 0 0 1 .358-7.312 4.88 4.88 0 0 1 6.9.2l.437.453.428-.453a4.9 4.9 0 0 1 5.49-1.135zM9.983 16.566 16.43 9.2a3.625 3.625 0 0 0-.108-4.879 3.24 3.24 0 0 0-4.7 0L9.993 6.045 8.338 4.326a3.215 3.215 0 0 0-4.682-.006 3.624 3.624 0 0 0-.112 4.88l6.439 7.366zm-.844-9.149h1.667v1.917h1.916V11h-1.916v1.917H9.139V11H7.222V9.334h1.917V7.417z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3Z = /*#__PURE__*/forwardRef(SvgHealth);

var _excluded$3Y = ["title", "titleId"];

var SvgHearingAid = function SvgHearingAid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.569 1.1a5.954 5.954 0 0 1 3.612 1.65 5.874 5.874 0 0 1 1.84 4.279c0 .403-.04.805-.121 1.2a5.907 5.907 0 0 1-.625 1.626l-3.8 7.008a3.834 3.834 0 0 1-3.057 2.232c-.057.005-.113.005-.169.005a2.888 2.888 0 0 1-2.668-4.059l1.524.675a1.222 1.222 0 0 0 1.216 1.712c.626-.035 1.181-.488 1.7-1.383l3.79-6.987c.207-.364.359-.756.451-1.164.058-.283.087-.572.087-.861a4.22 4.22 0 0 0-1.319-3.078 4.274 4.274 0 0 0-3.182-1.187 4.342 4.342 0 0 0-4.087 4.183c-.014.57.088 1.139.3 1.669l-1.546.624a5.955 5.955 0 0 1 6.054-8.145zm2.642 6.857a2.726 2.726 0 0 1-.756 1.358l-2.348 2.305a.541.541 0 0 0 0 .766l.139.139-1.179 1.179-.139-.139a2.206 2.206 0 0 1 .014-3.133l2.336-2.3a1.08 1.08 0 0 0 .3-.509 1.592 1.592 0 0 0-2.703-1.422 1.612 1.612 0 0 0-.46 1.07c0 .124.013.249.041.37L6.9 8.274a3.222 3.222 0 0 1 .422-2.807 3.267 3.267 0 0 1 5.697.559c.172.403.26.837.258 1.276 0 .22-.022.44-.066.655z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3Y = /*#__PURE__*/forwardRef(SvgHearingAid);

var _excluded$3X = ["title", "titleId"];

var SvgHeart = function SvgHeart(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.441 9.112-6.447 7.362-6.439-7.37a3.625 3.625 0 0 1 .246-5.01 3.215 3.215 0 0 1 4.549.14l1.655 1.72 1.628-1.725a3.24 3.24 0 0 1 4.7 0 3.625 3.625 0 0 1 .11 4.882h-.002zm1.1-6.027a4.912 4.912 0 0 0-7.121 0l-.428.454-.437-.454a4.88 4.88 0 0 0-7.1 0A5.285 5.285 0 0 0 2.3 10.2l7.7 8.808 7.706-8.8a5.287 5.287 0 0 0-.156-7.122l-.009-.001z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3X = /*#__PURE__*/forwardRef(SvgHeart);

var _excluded$3W = ["title", "titleId"];

var SvgHeight = function SvgHeight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.718 6.465a3.01 3.01 0 0 1-1.312 1.442 4.917 4.917 0 0 1 3.458 4.693v5.379H9.193V12.6a3.236 3.236 0 1 0-6.472 0v5.379H1.049V12.6a4.916 4.916 0 0 1 3.457-4.693 3.009 3.009 0 1 1 4.212-1.442zM6.7 4.16a1.337 1.337 0 1 0-1.486 2.224A1.337 1.337 0 0 0 6.7 4.16zm12.349-1.893v1.672h-2.475v3.006h2.475v1.672h-2.475v3.006h2.475v1.672h-2.475v3.006h2.475v1.671h-2.475v.003h-1.671v-.003h-2.476v-1.671h2.476V3.939h-2.476V2.267h6.622z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3W = /*#__PURE__*/forwardRef(SvgHeight);

var _excluded$3V = ["title", "titleId"];

var SvgHighPerformingTeam = function SvgHighPerformingTeam(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.087 2.773a6.927 6.927 0 0 1 6.666 5.034l1.58-.474a8.574 8.574 0 0 0-16.5 0l1.607.454a6.926 6.926 0 0 1 6.647-5.014zM18 13.38a3.566 3.566 0 0 0-.787-.593 2.293 2.293 0 1 0-3.393-.034c-.188.102-.367.22-.534.354a3.526 3.526 0 0 0-1.52-1.654 2.293 2.293 0 1 0-3.393-.033 3.56 3.56 0 0 0-1.58 1.687 3.553 3.553 0 0 0-.473-.32 2.293 2.293 0 1 0-3.394-.034 3.56 3.56 0 0 0-1.893 3.14v2.874H2.7V15.9a1.89 1.89 0 1 1 3.78 0v2.873h1.667V14.56a1.89 1.89 0 0 1 3.78 0v4.207h1.666v-2.874a1.89 1.89 0 0 1 3.78 0v2.874h1.667v-2.874A3.533 3.533 0 0 0 18 13.38zM4.666 10.6a.626.626 0 1 1 0 1.252.626.626 0 0 1 0-1.252zm5.447-1.333a.627.627 0 1 1-.026 0h.026zM15.56 10.6a.626.626 0 1 1-.034 0h.034zM9.253 3.453h1.667v2.393H9.253V3.453zm3.509.582-1.268 2.03 1.413.883 1.268-2.03-1.413-.883zm.489 3.396 2.151-1.05.73 1.499-2.15 1.049-.731-1.498zM7.408 4.033l-1.414.883 1.268 2.03 1.414-.883-1.269-2.03zm-3.37 3.84.73-1.498 2.15 1.049-.73 1.498-2.15-1.05z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3V = /*#__PURE__*/forwardRef(SvgHighPerformingTeam);

var _excluded$3U = ["title", "titleId"];

var SvgHistory = function SvgHistory(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.636 3.636A9 9 0 0 1 10 1a9 9 0 1 1-7.333 14.2v1.95H1V12.2h4.95v1.667H3.773A7.341 7.341 0 1 0 2.667 10H1a9 9 0 0 1 2.636-6.364zm10.027 2.16 1.178 1.18-4.585 4.578-2.993-2.992 1.178-1.18 1.816 1.816 3.406-3.401z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3U = /*#__PURE__*/forwardRef(SvgHistory);

var _excluded$3T = ["title", "titleId"];

var SvgHistoryBadge = function SvgHistoryBadge(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.636 3.636A9 9 0 0 1 10 1a9 9 0 1 1-7.333 14.2v1.95H1V12.2h4.95v1.667H3.773A7.341 7.341 0 1 0 2.667 10H1a9 9 0 0 1 2.636-6.364zm9.975 2.232v4.923l-3.595 3.6-3.627-3.6V5.868h7.222zM8.056 7.534v2.612l1.956 1.9 1.933-1.99V7.533H8.056z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3T = /*#__PURE__*/forwardRef(SvgHistoryBadge);

var _excluded$3S = ["title", "titleId"];

var SvgHoliday = function SvgHoliday(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 10.325H8.136L2.175 4.439 1 5.625l2.42 2.387-.741 2.313H1v1.666h1.145L1 15.561h1.7l1.161-3.57h13.473v3.57H19v-5.236zM4.735 9.31l1.028 1.015H4.405l.33-1.015z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3S = /*#__PURE__*/forwardRef(SvgHoliday);

var _excluded$3R = ["title", "titleId"];

var SvgHolidayChair = function SvgHolidayChair(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 10.325H8.136L2.175 4.439 1 5.625l2.42 2.387-.741 2.313H1v1.666h1.145L1 15.561h1.7l1.161-3.57h13.473v3.57H19v-5.236zM4.735 9.31l1.028 1.015H4.405l.33-1.015z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3R = /*#__PURE__*/forwardRef(SvgHolidayChair);

var _excluded$3Q = ["title", "titleId"];

var SvgHome = function SvgHome(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10.083 1-7.9 7.886V19h15.638V8.87L10.083 1zM8.32 17.335v-4.919h3.359v4.919H8.32zm7.836 0h-2.812v-6.584H6.655v6.584H3.844V9.574l6.24-6.214 6.072 6.205v7.77z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3Q = /*#__PURE__*/forwardRef(SvgHome);

var _excluded$3P = ["title", "titleId"];

var SvgHome2 = function SvgHome2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.183 8.886 10.083 1l7.738 7.87V19H2.183V8.886zm1.661 8.449h12.312v-7.77L10.084 3.36l-6.24 6.214v7.761zm5.21-8.918c.287.127.543.313.754.545L10 9.17l.192-.208a2.249 2.249 0 0 1 2.574-.546c.286.128.543.314.753.546l.144.156a2.594 2.594 0 0 1 0 3.459L10 16.543l-3.663-3.966a2.594 2.594 0 0 1 0-3.459l.144-.156a2.243 2.243 0 0 1 2.573-.545zm2.18 1.478a.88.88 0 0 0-.298.219L10 11.127l-.936-1.01a.879.879 0 0 0-1.318 0l-.124.135a1.175 1.175 0 0 0 0 1.548L10 14.372l2.378-2.575a1.175 1.175 0 0 0 0-1.548l-.124-.135a.879.879 0 0 0-1.02-.22z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3P = /*#__PURE__*/forwardRef(SvgHome2);

var _excluded$3O = ["title", "titleId"];

var SvgHospital = function SvgHospital(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.904 1.097v7.584h5.143v10.416H17.38v-8.749h-3.476v8.75h-1.667V2.762H2.713v16.334H1.047v-18h12.857zM6.654 4.62h1.667v1.917h1.916v1.667H8.321v1.916H6.654V8.203H4.737V6.536h1.917V4.62z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3O = /*#__PURE__*/forwardRef(SvgHospital);

var _excluded$3N = ["title", "titleId"];

var SvgHospitalBed = function SvgHospitalBed(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.71 4.597v7.54h16.334v5.793h-1.667v-4.127H2.71v4.127H1.044V4.597H2.71zm8.167 5.5H9.21V8.18H7.294V6.513h1.917V4.597h1.666v1.916h1.917V8.18h-1.917v1.917z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3N = /*#__PURE__*/forwardRef(SvgHospitalBed);

var _excluded$3M = ["title", "titleId"];

var SvgHotel = function SvgHotel(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 12.449V14.12H1V12.449a9 9 0 0 1 8.165-8.88V1h1.671v2.569A9 9 0 0 1 19 12.449zM4.818 7.267a7.33 7.33 0 0 0-2.147 5.182h14.658A7.33 7.33 0 0 0 4.818 7.267zm-3.045 8.9h17.224v1.666H1v-1.666h.773z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3M = /*#__PURE__*/forwardRef(SvgHotel);

var _excluded$3L = ["title", "titleId"];

var SvgHourglass = function SvgHourglass(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 2.667h-1.535v3.422L11.22 10l3.912 3.91v3.423h1.535V19H3.333v-1.667h1.619V13.91L8.863 10 4.952 6.088V2.667H3.333V1h13.334v1.667zm-3.202 14.665V14.6l-3.423-3.423L6.618 14.6v2.732h6.847zM6.618 5.4l3.424 3.42 3.423-3.42V2.667H6.618V5.4zm.905 9.296h4.921v1.667H7.523v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3L = /*#__PURE__*/forwardRef(SvgHourglass);

var _excluded$3K = ["title", "titleId"];

var SvgHusbandAndWife = function SvgHusbandAndWife(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.929 2.174 10.012 4.09 8.095 2.174 9.268 1l.744.744.744-.744 1.173 1.174zm4.513 6.466a2.81 2.81 0 0 1-.637 1.769 4.424 4.424 0 0 1 2.217 3.831V19h-1.66v-4.76a2.763 2.763 0 0 0-5.526 0V19H9.164v-6.249a2.761 2.761 0 0 0-2.67-2.753c-.016 0-.032-.002-.047-.004s-.031-.005-.047-.005a2.766 2.766 0 0 0-2.76 2.762V19H1.98v-6.25A4.424 4.424 0 0 1 4.26 8.886a2.806 2.806 0 0 1-.6-1.726 2.838 2.838 0 0 1 5.675 0 2.81 2.81 0 0 1-.662 1.8 4.45 4.45 0 0 1 1.832 2.132c.27-.265.572-.495.9-.683a2.809 2.809 0 0 1-.637-1.769 2.838 2.838 0 0 1 5.675 0zm-9.973-.308c.02.002.04.003.061.003h.004a1.154 1.154 0 1 0-.065-.003zm6.478 1.284a1.177 1.177 0 1 0 1.316-1.953 1.177 1.177 0 0 0-1.316 1.953z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3K = /*#__PURE__*/forwardRef(SvgHusbandAndWife);

var _excluded$3J = ["title", "titleId"];

var SvgHypertargeting = function SvgHypertargeting(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.2 9.167A7.25 7.25 0 0 0 10.83 2.8V1H9.163v1.8A7.248 7.248 0 0 0 2.8 9.167H1v1.666h1.8A7.247 7.247 0 0 0 9.167 17.2V19h1.666v-1.8a7.248 7.248 0 0 0 6.367-6.367H19V9.167h-1.8zm-4.07 5.453a5.568 5.568 0 0 1-6.267 0c0-.043-.006-.085-.006-.127a3.141 3.141 0 1 1 6.28 0c-.001.039-.005.083-.007.127zm-4.2-6.083a1.132 1.132 0 1 1 2.267 0 1.132 1.132 0 0 1-2.269 0h.002zm5.681 4.608a4.825 4.825 0 0 0-2.35-2.9 2.799 2.799 0 1 0-4.433-.044 4.828 4.828 0 0 0-2.439 2.933 5.584 5.584 0 1 1 9.223.007l-.001.004z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3J = /*#__PURE__*/forwardRef(SvgHypertargeting);

var _excluded$3I = ["title", "titleId"];

var SvgIceCream = function SvgIceCream(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.9 1C7.2 1 5 3.2 5 5.9c0 .8.2 1.6.6 2.3h.6L9.9 19l3.8-10.8h.6c.4-.7.6-1.4.6-2.3-.1-2.7-2.3-4.9-5-4.9zm0 1.7c1.8 0 3.2 1.4 3.2 3.2 0 .2 0 .4-.1.6H6.7c-.067-.195-.1-.4-.1-.6.1-1.8 1.5-3.2 3.3-3.2zm2 5.4-2 5.7-2-5.7h4z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3I = /*#__PURE__*/forwardRef(SvgIceCream);

var _excluded$3H = ["title", "titleId"];

var SvgId = function SvgId(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.806 1.001h4.418v1.667H7.806V1.001zM3.333 3.333V19h13.334V3.333H3.333zm11.667 14H5V5h10v12.333zm-6.77-2.96a2.284 2.284 0 0 1 .563-1.533 1.63 1.63 0 0 1 2.507 0c.37.424.57.97.563 1.533v.413h1.667v-.413a3.948 3.948 0 0 0-.989-2.646 3.62 3.62 0 0 0-.554-.5 2.35 2.35 0 1 0-3.881 0 3.672 3.672 0 0 0-.554.5 3.947 3.947 0 0 0-.988 2.646v.412H8.23v-.412zm1.817-5.158a.686.686 0 1 1 0 1.371.686.686 0 0 1 0-1.371z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3H = /*#__PURE__*/forwardRef(SvgId);

var _excluded$3G = ["title", "titleId"];

var SvgIdea = function SvgIdea(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.041 1.773c.93.5 1.723 1.22 2.311 2.096l-.003.001a6.487 6.487 0 0 1-1.767 9l-.082.055v3.34h-1.666v-4.229l.82-.551a4.78 4.78 0 1 0-5.308 0l.82.551v4.229H6.497v-3.34l-.082-.055A6.486 6.486 0 0 1 9.981 1h.038a6.481 6.481 0 0 1 3.022.773zM13.681 19H6.357v-1.669h7.324V19z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3G = /*#__PURE__*/forwardRef(SvgIdea);

var _excluded$3F = ["title", "titleId"];

var SvgImport = function SvgImport(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m13.671 9.652 1.186 1.186-4.859 4.859-4.853-4.853 1.186-1.186 2.832 2.831V1h1.677v11.484l2.831-2.832zm3.662 7.68V7.567H19V19H1V7.566h1.667v9.767h14.666z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3F = /*#__PURE__*/forwardRef(SvgImport);

var _excluded$3E = ["title", "titleId"];

var SvgInPatient = function SvgInPatient(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.083 2v1.917H19v1.667h-1.917V7.5h-1.666V5.584H13.5V3.917h1.917V2h1.666zM5.304 11.015A2.767 2.767 0 1 1 2.23 6.413a2.767 2.767 0 0 1 3.074 4.602zm-.926-3.216a1.1 1.1 0 1 0-1.222 1.829 1.1 1.1 0 0 0 1.222-1.829zM19 9.411H7.402v1.667H19V9.411zM1 12.687h18v4.98h-1.666v-3.314H2.668v3.314H1.002L1 12.687z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3E = /*#__PURE__*/forwardRef(SvgInPatient);

var _excluded$3D = ["title", "titleId"];

var SvgIncomeSupport = function SvgIncomeSupport(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.21 6.168-4.35 4.709-4.349-4.709a3.08 3.08 0 0 1 0-4.106l.172-.185a2.667 2.667 0 0 1 3.055-.647c.34.151.644.372.894.648l.228.247.228-.247a2.666 2.666 0 0 1 3.055-.648c.34.15.644.371.894.647l.172.185a3.08 3.08 0 0 1 0 4.106zm-7.322-3.183-.164.176a1.55 1.55 0 0 0 .001 2.039l3.135 3.4L17 5.2a1.549 1.549 0 0 0 0-2.039l-.163-.176a1.156 1.156 0 0 0-1.737 0l-1.24 1.336-1.235-1.336a1.156 1.156 0 0 0-1.737 0zm1.402 9.02h5.87a.833.833 0 0 1 .589 1.421l-5.329 5.33a.835.835 0 0 1-.589.244H1.007v-1.668h11.479l3.664-3.665h-4.906a2.34 2.34 0 0 1-1.285.384H6.234v-1.665h3.725a.688.688 0 1 0 0-1.373H5.774l-4.32 1.213-.45-1.6 4.43-1.245a.856.856 0 0 1 .225-.031h4.3a2.355 2.355 0 0 1 2.331 2.655z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3D = /*#__PURE__*/forwardRef(SvgIncomeSupport);

var _excluded$3C = ["title", "titleId"];

var SvgInfinity = function SvgInfinity(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.225 9.6a4.882 4.882 0 0 0-1.793-8.405 4.885 4.885 0 0 0-5.498 2.071l-.04.06A4.888 4.888 0 0 0 9.167 5.9v8.2a3.22 3.22 0 1 1-5.3-2.442l1.223-1.13v2.28h1.665V7.793H1.834v1.667h1.958l-1.017.94a4.877 4.877 0 0 0 .4 7.741c.86.544 1.852.841 2.869.858a4.914 4.914 0 0 0 4.022-2.264l.04-.06a4.888 4.888 0 0 0 .727-2.57V5.9a3.22 3.22 0 1 1 5.3 2.442l-1.223 1.13V7.19h-1.665v5.017h4.92V10.54h-1.957l1.017-.939z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3C = /*#__PURE__*/forwardRef(SvgInfinity);

var _excluded$3B = ["title", "titleId"];

var SvgInfo1 = function SvgInfo1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9zm0 16.329A7.329 7.329 0 1 1 17.329 10 7.338 7.338 0 0 1 10 17.329zm.837-8.76H9.166v5.473h1.671V8.569zM9.166 5.71h1.671v1.62H9.166V5.71z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3B = /*#__PURE__*/forwardRef(SvgInfo1);

var _excluded$3A = ["title", "titleId"];

var SvgInfo2 = function SvgInfo2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.926 13.58A7.334 7.334 0 0 0 10 17.333 7.341 7.341 0 0 0 17.333 10a7.334 7.334 0 1 0-11.407 6.097zm4.552-10.219a2.658 2.658 0 0 0-3.151 2.616h1.667a.989.989 0 0 1 1.187-.974 1.016 1.016 0 0 1 .806.828.971.971 0 0 1-.487 1.03 2.4 2.4 0 0 0-1.308 2.115v.064h1.666V11.5a.735.735 0 0 1 .423-.65 2.631 2.631 0 0 0 1.345-2.801 2.664 2.664 0 0 0-2.148-2.171zm.371 6.8H9.182v1.671h1.667v-1.671z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3A = /*#__PURE__*/forwardRef(SvgInfo2);

var _excluded$3z = ["title", "titleId"];

var SvgInstrument = function SvgInstrument(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m11.524 12.8-2.456 2.458a1.069 1.069 0 0 1-1.507 0l-.147-.147a1.063 1.063 0 0 1-.179-1.257l2.844-2.835a1.086 1.086 0 0 1 1.3.134l.147.147a1.067 1.067 0 0 1 0 1.5h-.002zm.867-8.173 2.91 2.9-3.222.312.312-3.217v.005zm.1 5.408a2.483 2.483 0 0 0-.724-.49l7.207-.7-7.9-7.884L10.35 8.4 9.26 9.484 7.935 8.16 6.757 9.338l1.323 1.32-1.1 1.1-1.322-1.32-1.182 1.178L5.8 12.935 3.125 15.6l-.97-.968-1.179 1.176 3.158 3.153 1.178-1.177L4.3 16.777l1.42-1.416c.131.323.327.617.574.864l.147.147a2.65 2.65 0 0 0 3.74 0l2.456-2.453a2.642 2.642 0 0 0 0-3.733l-.148-.147.002-.004z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3z = /*#__PURE__*/forwardRef(SvgInstrument);

var _excluded$3y = ["title", "titleId"];

var SvgIrisId = function SvgIrisId(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iris_id_svg__Icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.iris_id_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "iris_id_svg__st0",
    d: "M14.02 1v1.67h3.31v3.32H19V1zM17.33 17.33h-3.31V19H19v-4.98h-1.67zM2.68 14.02H1V19h4.99v-1.67H2.68zM2.68 2.67h3.31V1H1v4.98h1.68zM10.01 7.78A2.22 2.22 0 1 0 12.23 10a2.23 2.23 0 0 0-2.22-2.22zm0 2.78a.56.56 0 0 1-.56-.56.56.56 0 0 1 1.11 0 .56.56 0 0 1-.55.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "iris_id_svg__st0",
    d: "m16.69 10.31.13-.31-.13-.31a7.32 7.32 0 0 0-6.68-4.48 7.12 7.12 0 0 0-6.68 4.48l-.14.31.14.32a7.41 7.41 0 0 0 6.68 4.48 7.47 7.47 0 0 0 6.68-4.49zm-6.68 2.82a5.7 5.7 0 0 1-5-3.13 5.51 5.51 0 0 1 5-3.12 5.74 5.74 0 0 1 5 3.12 5.79 5.79 0 0 1-5 3.13z"
  }));
};

var ForwardRef$3y = /*#__PURE__*/forwardRef(SvgIrisId);

var _excluded$3x = ["title", "titleId"];

var SvgJpgGifPng = function SvgJpgGifPng(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 11.94v4.39h12.328v-3.57h-4.923L7.128 9.647 3.836 12.94zm0-2.358 2.795-2.795.015.015.497-.497 4.789 4.789h4.232V6.26l-3.59-3.59H3.836v7.912zm8.238-1.218a2.387 2.387 0 1 0 0-4.774 2.387 2.387 0 0 0 0 4.774zm0-3.109a.722.722 0 1 1 0 1.445.722.722 0 0 1 0-1.445z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3x = /*#__PURE__*/forwardRef(SvgJpgGifPng);

var _excluded$3w = ["title", "titleId"];

var SvgKeepSilent = function SvgKeepSilent(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.8 1 19 2.2l-4.4 4.4-1.7 1.7-3.6 3.6-1.7 1.7L2.1 19 .9 17.8l4.3-4.3H3.3v-7H9L14.5 1v3.3L17.8 1zM5 11.8h1.9l5.9-5.9V5L9.7 8.1H5v3.7zm5.2.5 2.6 2.6V9.7L14.5 8v11L9 13.5l1.2-1.2z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3w = /*#__PURE__*/forwardRef(SvgKeepSilent);

var _excluded$3v = ["title", "titleId"];

var SvgKey = function SvgKey(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.635 6.693a2.01 2.01 0 1 1 0-4.02 2.01 2.01 0 0 1 0 4.02zm0-5.693a3.687 3.687 0 0 0-3.683 3.684c0 .695.198 1.376.572 1.962L1 16.215 3.785 19l1.184-1.183-1.605-1.605 1.662-1.669 1.594 1.594 1.18-1.184-1.6-1.6 5.509-5.536A3.682 3.682 0 1 0 13.635 1z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3v = /*#__PURE__*/forwardRef(SvgKey);

var _excluded$3u = ["title", "titleId"];

var SvgKidney = function SvgKidney(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.708 12.251c.444-.4.712-.96.747-1.557V10.6L7.848 12A3.818 3.818 0 0 1 6.8 13.51a3.376 3.376 0 0 1-2.478.836 3.687 3.687 0 0 1-3.282-3.463V5.845A3.961 3.961 0 0 1 2.358 3.11a3.368 3.368 0 0 1 2.478-.837 3.687 3.687 0 0 1 3.285 3.463V8.085L6.455 6.42v-.57a2.024 2.024 0 0 0-1.747-1.914 1.7 1.7 0 0 0-1.256.433c-.444.401-.712.96-.747 1.557v4.844a2.026 2.026 0 0 0 1.747 1.915 1.698 1.698 0 0 0 1.256-.433zm13.329-6.406a3.964 3.964 0 0 0-1.318-2.735 3.368 3.368 0 0 0-2.478-.837 3.688 3.688 0 0 0-3.283 3.463V8.1l1.664-1.664v-.59a2.024 2.024 0 0 1 1.747-1.914 1.7 1.7 0 0 1 1.256.433c.443.401.712.96.747 1.557v4.844a2.026 2.026 0 0 1-1.747 1.915 1.698 1.698 0 0 1-1.256-.433c-.444-.4-.712-.96-.747-1.557v-.069l-1.388 1.387c.22.577.578 1.092 1.041 1.5a3.374 3.374 0 0 0 2.477.837 3.687 3.687 0 0 0 3.283-3.463V5.897l.002-.052zM15.423 7.94l-1.179-1.178-4.206 4.205-4.205-4.205L4.654 7.94l4.551 4.551v5.44h1.667v-5.44l4.551-4.55z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3u = /*#__PURE__*/forwardRef(SvgKidney);

var _excluded$3t = ["title", "titleId"];

var SvgLaptop = function SvgLaptop(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.2 3.286h15.669V14.42H2.199V3.286zm1.669 9.467H16.2v-7.8H3.869v7.8zm-2.833 3.193h18v1.667h-18v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3t = /*#__PURE__*/forwardRef(SvgLaptop);

var _excluded$3s = ["title", "titleId"];

var SvgLeaf = function SvgLeaf(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.333 8.865a6.206 6.206 0 0 1-1.343 3.848A6.151 6.151 0 0 1 7.465 13.8l4.791-4.789-1.188-1.192-4.8 4.8-.042-.053a6.205 6.205 0 0 1-1.236-3.7A6.176 6.176 0 0 1 11.153 2.7h6.18v6.165zm-6.18-7.848a7.856 7.856 0 0 0-7.846 7.85 7.891 7.891 0 0 0 1.571 4.707s.073.1.193.241L1.055 17.83l1.188 1.188L6.264 15l.014.012a7.788 7.788 0 0 0 4.89 1.71 7.8 7.8 0 0 0 6.137-2.96 7.89 7.89 0 0 0 1.708-4.895v-7.85h-7.86z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3s = /*#__PURE__*/forwardRef(SvgLeaf);

var _excluded$3r = ["title", "titleId"];

var SvgLeavingAnInheritance = function SvgLeavingAnInheritance(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.984 1.536a3.99 3.99 0 0 1 2.043-.56h3.999v3.995a3.992 3.992 0 0 1-6.167 3.35l-1.3 1.3-1.177-1.178 1.295-1.3a3.99 3.99 0 0 1 1.307-5.607zm3.688 5.083a2.331 2.331 0 0 0 .684-1.643l-.003-2.335h-2.329a2.332 2.332 0 0 0-2.329 2.33c0 .326.07.649.205.946l1.538-1.535 1.178 1.178-1.535 1.535a2.3 2.3 0 0 0 .946.205c.617 0 1.208-.245 1.645-.68zm-4.358 5.356h5.875v.003a.832.832 0 0 1 .589 1.422l-5.333 5.331a.834.834 0 0 1-.59.245H1.022V17.31H12.51l3.667-3.668h-4.91a2.334 2.334 0 0 1-1.285.385H6.253V12.36h3.729a.687.687 0 0 0 0-1.374H5.8L1.473 12.2l-.451-1.6 4.435-1.25a.856.856 0 0 1 .225-.032h4.3a2.356 2.356 0 0 1 2.332 2.657z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3r = /*#__PURE__*/forwardRef(SvgLeavingAnInheritance);

var _excluded$3q = ["title", "titleId"];

var SvgLeft = function SvgLeft(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "m10.5 14-3.9-4 3.9-4L12 7.5 9.4 10l2.6 2.5z"
  }));
};

var ForwardRef$3q = /*#__PURE__*/forwardRef(SvgLeft);

var _excluded$3p = ["title", "titleId"];

var SvgLeftFill = function SvgLeftFill(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.69 3.61a8.98 8.98 0 1 1-.04.04l.04-.04zm3.827 5.663-.707.707.707.707 2.92 2.921 1.415-1.414L9.638 9.98l2.214-2.214-1.414-1.414-2.921 2.92z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3p = /*#__PURE__*/forwardRef(SvgLeftFill);

var _excluded$3o = ["title", "titleId"];

var SvgLibrary = function SvgLibrary(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m14.869 2.38-3.956 1.083V1.014h-5.78v3.24H1v14.374h9.913v-8.81l2.512 9.168L19 17.46 14.869 2.38zM5.133 16.96H2.667V5.921h2.466v11.04zm4.114 0H6.8V2.681h2.447v14.28zm2.1-11.887 2.353-.647 3.251 11.865-2.359.646-3.245-11.864z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3o = /*#__PURE__*/forwardRef(SvgLibrary);

var _excluded$3n = ["title", "titleId"];

var SvgLike = function SvgLike(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.631 7.461V3.779a2.78 2.78 0 0 0-5.558 0v3.682h-4.9V19h12.566l3.1-3.124V7.461h-5.208zM8.739 3.779a1.113 1.113 0 0 1 2.225 0v3.682H8.739V3.779zM4.924 17.333H3.842v-8.2h1.082v8.2zm11.251-2.144-2.129 2.144H6.59v-8.2h9.585v6.056z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3n = /*#__PURE__*/forwardRef(SvgLike);

var _excluded$3m = ["title", "titleId"];

var SvgLink = function SvgLink(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.797 1.53c.66.312 1.254.751 1.746 1.292l.004.006a5.567 5.567 0 0 1-.357 7.847l-2.235 2.253-1.187-1.177 2.281-2.3a3.87 3.87 0 0 0 1.27-2.7 3.895 3.895 0 0 0-6.5-3.08L8.267 6.223 7.085 5.047l2.595-2.6a5.565 5.565 0 0 1 6.117-.916zm-3.528 4.91-5.885 5.885 1.181 1.181 5.886-5.885-1.182-1.181zm-3.088 9.888a3.895 3.895 0 0 1-5.226-5.776l2.28-2.3L5.05 7.077 2.814 9.33a5.568 5.568 0 0 0 3.5 9.664 4 4 0 0 1 .134.003 5.552 5.552 0 0 0 3.873-1.444l2.596-2.6-1.182-1.182-2.554 2.557z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3m = /*#__PURE__*/forwardRef(SvgLink);

var _excluded$3l = ["title", "titleId"];

var SvgList = function SvgList(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 2.167h1.649v1.667H1V2.167zm3.859 0H19v1.667H4.859V2.167zm-2.21 7H1v1.667h1.649V9.167zm2.21 0H19v1.667H4.859V9.167zm-2.21 7H1v1.667h1.649v-1.667zm2.21 0H19v1.667H4.859v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3l = /*#__PURE__*/forwardRef(SvgList);

var _excluded$3k = ["title", "titleId"];

var SvgLive = function SvgLive(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "live_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.live_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "live_svg__st0",
    d: "m19.021 4.483-4.184 4.185V4.5H1.021v10.967h13.816v-4.248l4.184 4.18V4.484zM13.17 13.8H2.688V6.165H13.17V13.8zm4.184-2.42-1.436-1.437 1.436-1.436v2.873z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "live_svg__st0",
    d: "M11.838 7.455H9.934v1.667h1.904V7.455z"
  }));
};

var ForwardRef$3k = /*#__PURE__*/forwardRef(SvgLive);

var _excluded$3j = ["title", "titleId"];

var SvgLocation = function SvgLocation(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.552 1.534a7.023 7.023 0 0 1 2.288 1.557 7.433 7.433 0 0 1-.023 10.145l-5.032 5.747-5-5.761A7.428 7.428 0 0 1 4.776 3.09a7.027 7.027 0 0 1 5-2.107h.064c.932.002 1.853.19 2.712.551zM9.79 16.447l3.771-4.306a5.784 5.784 0 0 0 .086-7.882 5.346 5.346 0 0 0-3.8-1.608h-.066A5.352 5.352 0 0 0 5.97 4.256a5.776 5.776 0 0 0 .077 7.874l3.743 4.316zM8.245 5.583a2.81 2.81 0 1 1 3.123 4.673 2.81 2.81 0 0 1-3.123-4.673zm.927 3.288a1.144 1.144 0 1 0 1.273-1.902A1.144 1.144 0 0 0 9.172 8.87z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3j = /*#__PURE__*/forwardRef(SvgLocation);

var _excluded$3i = ["title", "titleId"];

var SvgLock = function SvgLock(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.523 7.04V5.245A4.4 4.4 0 0 0 9.992 1a4.4 4.4 0 0 0-4.531 4.246V7.04h-2.12V19h13.318V7.04h-2.136zM7.128 5.245a2.736 2.736 0 0 1 2.864-2.579 2.736 2.736 0 0 1 2.865 2.58v1.792H7.128V5.246zm7.864 12.087h-4.166v-4.228H9.159v4.228H5.008V8.706h9.984v8.627z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3i = /*#__PURE__*/forwardRef(SvgLock);

var _excluded$3h = ["title", "titleId"];

var SvgLogin1 = function SvgLogin1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9 8.932A4.476 4.476 0 1 0 7.183 8.9a7.84 7.84 0 0 0-5.013 7.3V19h1.653v-2.8a6.177 6.177 0 0 1 12.354 0V19h1.653v-2.8a7.842 7.842 0 0 0-4.93-7.268zm-2.837-6.266a2.81 2.81 0 1 1-.002 5.62 2.81 2.81 0 0 1 .002-5.62z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3h = /*#__PURE__*/forwardRef(SvgLogin1);

var _excluded$3g = ["title", "titleId"];

var SvgLogin2 = function SvgLogin2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9zm4.224 14.984a7.3 7.3 0 0 1-8.454-.005v-.267a4.227 4.227 0 0 1 8.454 0v.272zM8.41 8.142a1.671 1.671 0 1 1 3.342 0 1.671 1.671 0 0 1-3.342 0zm7.361 6.367a5.872 5.872 0 0 0-3.229-4.109 3.342 3.342 0 1 0-4.973-.056A5.881 5.881 0 0 0 4.224 14.5a7.33 7.33 0 1 1 11.547.005v.004z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3g = /*#__PURE__*/forwardRef(SvgLogin2);

var _excluded$3f = ["title", "titleId"];

var SvgLove = function SvgLove(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.1 3.324-.2-.214a3.065 3.065 0 0 0-3.513-.746 3.068 3.068 0 0 0-1.029.745L13.1 3.4l-.263-.285a3.062 3.062 0 0 0-4.543 0l-.2.212a3.541 3.541 0 0 0-.548 3.883 3.232 3.232 0 0 0-.378.336l-.268.285-.262-.284a3.064 3.064 0 0 0-2.271-1.01A3.067 3.067 0 0 0 2.1 7.547l-.2.212a3.542 3.542 0 0 0 0 4.723l5 5.416 5-5.415c.048-.053.082-.114.127-.169l1.073 1.15 5-5.417a3.542 3.542 0 0 0 0-4.723zm-7.416 8.027L6.9 15.441l-3.777-4.09a1.87 1.87 0 0 1 0-2.46l.2-.214a1.4 1.4 0 0 1 2.093 0L6.9 10.288l1.493-1.61a1.425 1.425 0 0 1 2.093 0l.2.21a1.87 1.87 0 0 1-.004 2.463h.002zm6.191-4.435-3.775 4.09-.332-.36a3.509 3.509 0 0 0-.856-2.888l-.2-.21a3.068 3.068 0 0 0-2.272-1.01c-.12.004-.239.017-.357.036a1.876 1.876 0 0 1 .236-2.119l.2-.213a1.427 1.427 0 0 1 2.093 0L13.1 5.853l1.488-1.61a1.393 1.393 0 0 1 2.093 0l.2.212a1.87 1.87 0 0 1-.008 2.461h.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3f = /*#__PURE__*/forwardRef(SvgLove);

var _excluded$3e = ["title", "titleId"];

var SvgLung = function SvgLung(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.6 5.273h-.837v7.072l-1.927-1.928V2.3H9.167v8.114l-1.935 1.935v-7.08h-.836A5.436 5.436 0 0 0 1 10.654v7.314h6.232v-3.261L10 11.938l2.76 2.76v3.269H19v-7.314a5.436 5.436 0 0 0-5.4-5.38zM5.565 16.3h-2.9v-5.641a3.765 3.765 0 0 1 2.9-3.621V16.3zm11.765 0h-2.9V7.038a3.765 3.765 0 0 1 2.9 3.62V16.3z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3e = /*#__PURE__*/forwardRef(SvgLung);

var _excluded$3d = ["title", "titleId"];

var SvgMaleSymbol = function SvgMaleSymbol(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.126 1v1.667h4.026L9.816 9A5.56 5.56 0 1 0 11 10.18l6.337-6.338v4.023H19V1h-6.874zM6.542 17.333a3.872 3.872 0 1 1 3.875-3.872 3.877 3.877 0 0 1-3.875 3.872z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3d = /*#__PURE__*/forwardRef(SvgMaleSymbol);

var _excluded$3c = ["title", "titleId"];

var SvgMaleToilet = function SvgMaleToilet(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.091 6.706a4.365 4.365 0 0 0-1.275-.882 2.734 2.734 0 1 0-3.554-.038 4.391 4.391 0 0 0-2.304 2.34c-.22.53-.332 1.1-.33 1.674v6.3h1.556V19H8.85v-4.563H7.294V9.8a2.706 2.706 0 1 1 5.412 0v4.61h-1.689V19h1.667v-2.925h1.688V9.8a4.343 4.343 0 0 0-1.281-3.094zM10.06 2.667a1.065 1.065 0 1 1 0 2.131 1.065 1.065 0 0 1 0-2.13z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3c = /*#__PURE__*/forwardRef(SvgMaleToilet);

var _excluded$3b = ["title", "titleId"];

var SvgMan = function SvgMan(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.017 2.517a9 9 0 0 1 5-1.517 9.01 9.01 0 0 1 9 9 9 9 0 1 1-14-7.483zm6.14 3.283h4.864a7.32 7.32 0 0 0-8.392-2.73 3.654 3.654 0 0 0 3.528 2.73zm-5.55 10.066a7.33 7.33 0 0 0 4.41 1.469l.002-.003A7.335 7.335 0 0 0 16.9 7.463h-5.743A5.324 5.324 0 0 1 6.107 3.8a7.33 7.33 0 0 0-.5 12.066zm.697-7.84h1.593v1.667H6.304V8.026zm7.392 0h-1.593v1.667h1.593V8.026zm-5.13 5.217c.38.38.896.594 1.434.595a2.03 2.03 0 0 0 2.029-2.029h1.663a3.7 3.7 0 0 1-7.392 0h1.67c.002.538.215 1.054.596 1.434z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3b = /*#__PURE__*/forwardRef(SvgMan);

var _excluded$3a = ["title", "titleId"];

var SvgManWearingGlasses = function SvgManWearingGlasses(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zM11.14 5.8h4.865a7.32 7.32 0 0 0-8.393-2.73A3.654 3.654 0 0 0 11.14 5.8zM5.592 15.863a7.333 7.333 0 0 0 11.29-8.399h-5.742A5.324 5.324 0 0 1 6.09 3.8a7.33 7.33 0 0 0-.498 12.063zm6.07-7.535a3.082 3.082 0 1 1-1.106 3.29H9.446a3.084 3.084 0 1 1 0-1.668h1.112a3.086 3.086 0 0 1 1.106-1.622zM5.694 11.96a1.417 1.417 0 1 0 1.58-2.354 1.417 1.417 0 0 0-1.58 2.354zm7.043.001a1.418 1.418 0 1 0 1.575-2.357 1.418 1.418 0 0 0-1.575 2.357z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$3a = /*#__PURE__*/forwardRef(SvgManWearingGlasses);

var _excluded$39 = ["title", "titleId"];

var SvgManWithMustache = function SvgManWithMustache(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$39);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.011 2.533A8.98 8.98 0 0 1 10 1.02 8.987 8.987 0 0 1 18.98 10 8.98 8.98 0 1 1 5.011 2.533zm5.556 3.274H15.9A7.173 7.173 0 0 0 7.76 3.1a2.78 2.78 0 0 0 2.807 2.707zm-4.898 10A7.28 7.28 0 0 0 10 17.273a7.268 7.268 0 0 0 6.793-9.76h-6.26A4.54 4.54 0 0 1 6.067 3.9a7.28 7.28 0 0 0-.398 11.907zm2.031-1.24-1.133-1.293 3.42-2.88 3.546 2.873-1.113 1.307-2.407-1.947-2.313 1.94z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$39 = /*#__PURE__*/forwardRef(SvgManWithMustache);

var _excluded$38 = ["title", "titleId"];

var SvgMapleLeaf = function SvgMapleLeaf(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$38);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m9.964 14.693-2.613.416.279-1.056-3.643-1.379.253-.274-.628-2.258 2.4.256.026-.873 3.01 2.275-1.182-5.757 1.261.726.856-2.194.9 2.186 1.247-.718-1.178 5.757 3.007-2.273.025.873 2.4-.256-.623 2.256.253.273-3.643 1.38.28 1.058-2.687-.419v.001zm4.007.183 4.373-1.656-1.1-1.18.956-3.432-2.926.31L15.22 6.9l-2.245 1.7 1.066-5.19-2.5 1.438L9.946.99l-1.5 3.845-2.486-1.43L7.026 8.6 4.78 6.9l-.058 2.02L1.8 8.608l.955 3.432-1.1 1.18 4.373 1.656-.5 1.875 3.632-.578v2.837h1.67v-2.828l3.631.566-.495-1.872h.005z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$38 = /*#__PURE__*/forwardRef(SvgMapleLeaf);

var _excluded$37 = ["title", "titleId"];

var SvgMarketingAutomation = function SvgMarketingAutomation(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$37);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.008 15.463a5.475 5.475 0 1 0-.024 0h.024zM15.6 5.578a7.05 7.05 0 0 1 1.481 3.59H19v1.664h-1.922a7.055 7.055 0 0 1-1.488 3.581l1.362 1.362-1.177 1.177-1.363-1.362a7.17 7.17 0 0 1-3.58 1.483V19H9.167v-1.92a7.071 7.071 0 0 1-3.586-1.48l-1.356 1.352-1.177-1.177L4.4 14.423a7.072 7.072 0 0 1-1.494-3.591H1V9.168h1.9a7.089 7.089 0 0 1 1.5-3.595L3.048 4.225l1.177-1.177L5.573 4.4a7.1 7.1 0 0 1 3.594-1.5V1h1.665v1.909A7.07 7.07 0 0 1 14.423 4.4l1.352-1.352 1.178 1.177L15.6 5.578zm-4.507 4.432L9.26 8.952v2.115l1.832-1.057zM7.6 13.95l-.004.002.004-.001v-.002zm6.823-3.94L7.6 13.95V6.069l6.823 3.942z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$37 = /*#__PURE__*/forwardRef(SvgMarketingAutomation);

var _excluded$36 = ["title", "titleId"];

var SvgMask1 = function SvgMask1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$36);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.994 10.133a3.092 3.092 0 0 0-2.97-2.991V5.924l-11.97.006v1.207a3.1 3.1 0 0 0-3.06 3 3.1 3.1 0 0 0 3.06 3v1.214l11.97-.007v-1.219a3.092 3.092 0 0 0 2.97-2.992zm-16.333 0A1.422 1.422 0 0 1 4.054 8.81v2.647a1.423 1.423 0 0 1-1.393-1.324zm11.7 2.538H5.724V7.6h8.637v5.071zm1.667-1.222V8.818c.7.052 1.256.614 1.3 1.315a1.409 1.409 0 0 1-1.304 1.316h.004z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$36 = /*#__PURE__*/forwardRef(SvgMask1);

var _excluded$35 = ["title", "titleId"];

var SvgMask2 = function SvgMask2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$35);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mask_2_svg__Icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.mask_2_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "mask_2_svg__st0",
    d: "M18.011 2.124a3.392 3.392 0 0 0-2.577-.979A3.887 3.887 0 0 0 12.857 2.3l1.178 1.178c.39-.399.915-.637 1.472-.667.492-.03.973.148 1.326.492.72.823.642 2.073-.175 2.8l-4.953-4.956L1.01 11.852l1.127 1.127A3.9 3.9 0 0 0 1 15.549a3.372 3.372 0 0 0 3.413 3.575 3.9 3.9 0 0 0 2.727-1.143l1.126 1.126L18.961 8.4l-1.125-1.122a3.655 3.655 0 0 0 .175-5.154zM3.157 16.961a1.758 1.758 0 0 1-.5-1.339c.03-.553.264-1.075.656-1.466L5.962 16.8a2.008 2.008 0 0 1-2.805.161zm5.108-.21-4.9-4.9L11.706 3.5l4.9 4.9-8.341 8.351z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 10.935 11.076)",
    className: "mask_2_svg__st0",
    d: "M6.985 10.243h7.901v1.666H6.985z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 8.816 9.13)",
    className: "mask_2_svg__st0",
    d: "M4.866 8.296h7.901v1.666H4.866z"
  }));
};

var ForwardRef$35 = /*#__PURE__*/forwardRef(SvgMask2);

var _excluded$34 = ["title", "titleId"];

var SvgMassageTherapy = function SvgMassageTherapy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$34);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.964 7.721-.018-.757h-.756a12.066 12.066 0 0 0-4.871 1.131A12.088 12.088 0 0 0 10.53 3.57l-.543-.528-.542.528a12.084 12.084 0 0 0-2.79 4.522 12.551 12.551 0 0 0-4.87-1.132h-.755l-.018.757c0 .191-.078 4.705 2.79 7.36a7.254 7.254 0 0 0 5.11 1.844c.348 0 .708-.021 1.076-.056.367.035.727.056 1.075.056 1.878.07 3.71-.59 5.11-1.844 2.869-2.651 2.795-7.165 2.79-7.356zm-14.1 6.221a8.507 8.507 0 0 1-2.258-5.37c1.297.126 2.558.5 3.715 1.1-.043.365-.057.733-.043 1.1a7.116 7.116 0 0 0 2.045 4.566 5.547 5.547 0 0 1-3.456-1.396h-.003zm5.12.866a5.911 5.911 0 0 1-2.15-4.1A8.507 8.507 0 0 1 9.99 5.294a8.486 8.486 0 0 1 2.149 5.406 5.908 5.908 0 0 1-2.151 4.108h-.003zm5.129-.871a5.541 5.541 0 0 1-3.465 1.406 7.11 7.11 0 0 0 2.052-4.566c.015-.367 0-.735-.042-1.1 1.157-.6 2.419-.974 3.717-1.1a8.482 8.482 0 0 1-2.26 5.36h-.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$34 = /*#__PURE__*/forwardRef(SvgMassageTherapy);

var _excluded$33 = ["title", "titleId"];

var SvgMedicalReport = function SvgMedicalReport(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$33);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.296 1v1.79h3.038V19H3V2.79h3.129V1h7.167zm-1.667 1.667H7.796V4.5h3.833V2.667zM4.667 17.334h10V4.457h-1.371v1.71H6.129v-1.71H4.667v12.877zm4.167-9.213H10.5v1.917h1.917v1.666H10.5v1.917H8.834v-1.917H6.917v-1.666h1.917V8.121z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$33 = /*#__PURE__*/forwardRef(SvgMedicalReport);

var _excluded$32 = ["title", "titleId"];

var SvgMedicine = function SvgMedicine(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$32);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.335 1.138v4.3l2.292 2.295-.054 11.4H3.344V7.724l2.3-2.3V1.138h8.691zM12.668 2.8H7.31v1.872h5.358V2.8zM5.006 17.467h9.909l.042-9.05-2.078-2.078H7.086l-2.08 2.08v9.048zm4.165-8.66h1.666v1.916h1.917v1.667h-1.917v1.917H9.171V12.39H7.254v-1.667h1.917V8.807z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$32 = /*#__PURE__*/forwardRef(SvgMedicine);

var _excluded$31 = ["title", "titleId"];

var SvgMeetingRoom = function SvgMeetingRoom(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$31);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.93 6.186a2.1 2.1 0 1 0-1.667 0v6.83H4.7v4.817h1.669V11.35H3.93V6.186zM3.1 4.693a.43.43 0 1 1-.002-.86.43.43 0 0 1 .002.86zm13.8-2.51a2.1 2.1 0 0 0-.83 4.017v5.163h-2.439v6.485H15.3v-4.817h2.439v-6.83a2.1 2.1 0 0 0-.839-4.019zm0 2.525a.43.43 0 1 1-.002-.86.43.43 0 0 1 .002.86zM5.127 8.435h9.751v1.667H5.127V8.435z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$31 = /*#__PURE__*/forwardRef(SvgMeetingRoom);

var _excluded$30 = ["title", "titleId"];

var SvgMegaphone = function SvgMegaphone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$30);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.016 9.291a3.782 3.782 0 0 0-2.366-3.5V1.5L7.573 5.583H.984v7.425h1.328l1.878 4.825h4.987l-1.824-4.825h.22l9.077 4.075v-4.291a3.779 3.779 0 0 0 2.366-3.501zM2.653 7.252h4.035v4.087H2.653V7.252zm2.692 8.912-1.228-3.156h1.451l1.193 3.156H5.345zm9.636-1.664-6.624-2.969V7.06l6.624-2.977V14.5zm1.669-3.642V7.725a2.099 2.099 0 0 1 0 3.131v.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$30 = /*#__PURE__*/forwardRef(SvgMegaphone);

var _excluded$2$ = ["title", "titleId"];

var SvgMentalHealth = function SvgMentalHealth(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.516 8.7v.055l2.164 4.165h-2.163v4.38h-3.1v1.83h-1.666v-3.5h3.1v-4.38h1.088l-1.075-2.068-.01-.438a6.066 6.066 0 0 0-6.1-5.944H8.59A6.098 6.098 0 0 0 2.65 9.06a6.138 6.138 0 0 0 2.535 4.788l.791.57v4.71H4.311V15.27l-.1-.07A7.812 7.812 0 0 1 .983 9.1a7.717 7.717 0 0 1 2.133-5.55 7.77 7.77 0 0 1 13.4 5.15zm-4.758-1.683h2.003v1.666H10.9l-1.04-1.46-2.03 4.02L6.43 8.057l-.385.625h-2.27V7.016h1.34L6.68 4.48l1.254 2.857 1.682-3.33 2.142 3.01z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2$ = /*#__PURE__*/forwardRef(SvgMentalHealth);

var _excluded$2_ = ["title", "titleId"];

var SvgMeter = function SvgMeter(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.005 3.517A9 9 0 0 1 16.488 17.24l-1.2-1.156a7.334 7.334 0 1 0-10.479.091l-1.18 1.176A9 9 0 0 1 5.005 3.517zm3.86 7.43 4.253-4.252 1.178 1.178-4.252 4.251-1.178-1.178z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2_ = /*#__PURE__*/forwardRef(SvgMeter);

var _excluded$2Z = ["title", "titleId"];

var SvgMicrophone = function SvgMicrophone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.663 2.368a4.79 4.79 0 0 0-8.139 4.12L1.74 14.27l1.42 1.42-2.09 2.091 1.18 1.18 2.09-2.092 1.42 1.421 7.783-7.784c.24.038.482.058.724.06a4.8 4.8 0 0 0 3.4-8.2l-.004.001zM5.76 15.932l-1.66-1.66 5.785-5.788 1.661 1.662-5.786 5.786zM14.267 8.9a3.117 3.117 0 0 1-2.718-4.674l4.256 4.256a3.1 3.1 0 0 1-1.538.418zm2.717-1.6-4.256-4.254A3.115 3.115 0 0 1 16.984 7.3z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2Z = /*#__PURE__*/forwardRef(SvgMicrophone);

var _excluded$2Y = ["title", "titleId"];

var SvgMinus = function SvgMinus(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zm.625-6.927h6.894v1.667H6.553V9.167z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2Y = /*#__PURE__*/forwardRef(SvgMinus);

var _excluded$2X = ["title", "titleId"];

var SvgMobile = function SvgMobile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.208 18.953v-18h11.707v18H4.208zM5.88 17.28h8.363V2.625H5.88V17.28zm3.175-2.937h2.013v1.672H9.055v-1.672z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2X = /*#__PURE__*/forwardRef(SvgMobile);

var _excluded$2W = ["title", "titleId"];

var SvgMobileLaptop = function SvgMobileLaptop(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.038 3.286V14.88h-7.392v1.237h1.578v1.67H8.447v-1.67h1.53V14.88H7.5v2.906H1.038V7.423h1.547V3.286h16.453zM2.708 16.117h3.124V9.092H2.707v7.025zM7.5 7.423v5.788h9.87V4.955H4.254v2.468H7.5zm4.17 3.555h-1.669v1.63h1.669v-1.63zM4.92 13.86H3.618v1.67H4.92v-1.67z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2W = /*#__PURE__*/forwardRef(SvgMobileLaptop);

var _excluded$2V = ["title", "titleId"];

var SvgMoneyBag = function SvgMoneyBag(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m14.815 1-1.5 3.8h-.001a7.482 7.482 0 1 1-6.614 0L5.186 1h9.629zM12.36 2.665H7.637l.627 1.561a7.645 7.645 0 0 1 3.489.001l.607-1.562zM6.765 16.354c.958.64 2.083.981 3.235.981a5.829 5.829 0 0 0 5.822-5.822 5.821 5.821 0 1 0-9.057 4.84zm3.796-6.986A.787.787 0 0 0 10 9.153a.766.766 0 0 0-.75 1.066.764.764 0 0 0 .75.459 2.424 2.424 0 0 1 .836 4.722v.869h-1.67V15.4a2.436 2.436 0 0 1-1.642-2.29h1.669a.763.763 0 1 0 .807-.763 2.424 2.424 0 0 1-.833-4.718V6.76h1.669v.87a2.437 2.437 0 0 1 1.64 2.286h-1.67a.786.786 0 0 0-.245-.548z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2V = /*#__PURE__*/forwardRef(SvgMoneyBag);

var _excluded$2U = ["title", "titleId"];

var SvgMouse = function SvgMouse(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.896 16.764c.334-.334.522-.787.523-1.259V8.726a1.784 1.784 0 0 0-1.782-1.782H8.345a1.784 1.784 0 0 0-1.782 1.782v6.78a1.784 1.784 0 0 0 1.782 1.78h3.292c.472 0 .925-.188 1.259-.522zM10.825 5.278H11.64a3.452 3.452 0 0 1 3.448 3.448v6.78a3.451 3.451 0 0 1-3.448 3.446H8.348A3.451 3.451 0 0 1 4.9 15.505V8.726a3.452 3.452 0 0 1 3.445-3.448h.813V3.761a1.319 1.319 0 0 1 1.317-1.317h.388a.23.23 0 0 0 .23-.232V.953h1.67V2.21a1.9 1.9 0 0 1-1.9 1.9h-.038v1.168zm0 5.288H9.158v-2.13h1.667v2.13z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2U = /*#__PURE__*/forwardRef(SvgMouse);

var _excluded$2T = ["title", "titleId"];

var SvgMovMp4 = function SvgMovMp4(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zm10.496-6.879-7.59 4.381V6.069l7.59 4.382zm-3.332 0L8.409 8.955v2.991L11 10.451z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2T = /*#__PURE__*/forwardRef(SvgMovMp4);

var _excluded$2S = ["title", "titleId"];

var SvgMp3 = function SvgMp3(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zm2.652-5.466c.455-.16.949-.175 1.412-.04V7.718l6.649-1.885v7.052a2.312 2.312 0 1 1-2.313-2.313c.219.002.437.036.646.1V8.035l-3.319.94v5.1a2.307 2.307 0 1 1-3.075-2.21zm1.22 2.63a.646.646 0 0 0 .192-.455v-.01a.646.646 0 1 0-.192.464zm4.172-1.072a.647.647 0 1 0 .718-1.076.647.647 0 0 0-.718 1.076z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2S = /*#__PURE__*/forwardRef(SvgMp3);

var _excluded$2R = ["title", "titleId"];

var SvgMusic = function SvgMusic(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.845 13.33V3.756l10.047-2.739v12.418a3 3 0 1 1-1.662-2.706V3.2L9.51 5.03v10.98A3.01 3.01 0 1 1 6.5 13c.468.003.929.115 1.345.33zm-2.092 3.796a1.345 1.345 0 1 0 1.494-2.236 1.345 1.345 0 0 0-1.494 2.236zm8.386-2.6c.22.148.48.227.747.227l-.001.001a1.346 1.346 0 1 0-.746-.228zM6.013 4.487H2.212v1.665h3.8V4.487zm-.08 3.496H1.046v1.665h4.887V7.983z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2R = /*#__PURE__*/forwardRef(SvgMusic);

var _excluded$2Q = ["title", "titleId"];

var SvgNeutralEmoji = function SvgNeutralEmoji(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.047 2.608a9 9 0 0 1 5-1.517 9.01 9.01 0 0 1 9 9 9 9 0 1 1-14-7.483zm.925 13.58a7.334 7.334 0 0 0 4.075 1.236 7.342 7.342 0 0 0 7.333-7.333A7.334 7.334 0 1 0 5.972 16.19zm.362-8.737h1.593v1.667H6.334V7.451zm7.392 0h-1.593v1.667h1.593V7.451zm-7.392 4.646h7.392v1.667H6.334v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2Q = /*#__PURE__*/forwardRef(SvgNeutralEmoji);

var _excluded$2P = ["title", "titleId"];

var SvgNight = function SvgNight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.426 13.163h-1.468A7.192 7.192 0 0 1 9.75 5.832c0-1.257.323-2.493.939-3.589L11.392 1H9.96a9 9 0 1 0 7.88 13.406c.223-.4.419-.816.586-1.243zM10 17.329A7.33 7.33 0 0 1 8.61 2.8c-.348.973-.527 2-.527 3.033a8.85 8.85 0 0 0 7.513 8.9A7.347 7.347 0 0 1 10 17.329z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2P = /*#__PURE__*/forwardRef(SvgNight);

var _excluded$2O = ["title", "titleId"];

var SvgNoSmoking = function SvgNoSmoking(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9zm-7.333 9A7.328 7.328 0 0 1 14.43 4.16l-3.7 3.755h-4.7v4.046h.71l-2.515 2.55A7.3 7.3 0 0 1 2.667 10zm6.418-.418-.7.713h-.697v-.713h1.397zM10 17.333A7.3 7.3 0 0 1 5.394 15.7L15.635 5.313A7.329 7.329 0 0 1 10 17.333zM5.335 7.92H3.668v4.043h1.667V7.92zm7.453 1.662 1.642-1.667h1.586v4.046h-5.573l1.642-1.666h2.264v-.713h-1.561z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2O = /*#__PURE__*/forwardRef(SvgNoSmoking);

var _excluded$2N = ["title", "titleId"];

var SvgNonGuaranteed = function SvgNonGuaranteed(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.329c-1.65 0-3.25-.56-4.541-1.587L15.742 5.458A7.32 7.32 0 0 1 10 17.329zM2.671 10a7.32 7.32 0 0 1 11.892-5.726L4.274 14.563A7.293 7.293 0 0 1 2.671 10zM10 1a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2N = /*#__PURE__*/forwardRef(SvgNonGuaranteed);

var _excluded$2M = ["title", "titleId"];

var SvgNotification = function SvgNotification(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 15.067V8.942a5 5 0 1 1 10 0v6.125H5zm11.667 0V8.942a6.654 6.654 0 0 0-5.834-6.454V1H9.166v1.488a6.654 6.654 0 0 0-5.833 6.454v6.125H2v1.667h7.166V19h1.667v-2.266H18v-1.667h-1.333z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2M = /*#__PURE__*/forwardRef(SvgNotification);

var _excluded$2L = ["title", "titleId"];

var SvgNursingRoom = function SvgNursingRoom(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.156v-.848h-1.134a4.375 4.375 0 0 0-3.534-4.218V1H9.168v1.09a4.375 4.375 0 0 0-3.534 4.218H4.5v7.327A5.371 5.371 0 0 0 9.863 19h.274a5.371 5.371 0 0 0 5.363-5.365V7.156zM10 3.673a2.7 2.7 0 0 1 2.7 2.635H7.3A2.7 2.7 0 0 1 10 3.673zm3.837 6.09H11.47v1.664h2.367v1.608H11.47V14.7h2.209a3.705 3.705 0 0 1-3.542 2.635h-.274a3.7 3.7 0 0 1-3.7-3.7V7.972h7.674v1.791z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2L = /*#__PURE__*/forwardRef(SvgNursingRoom);

var _excluded$2K = ["title", "titleId"];

var SvgOfficeBuilding = function SvgOfficeBuilding(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.7 5.53V1.017H3.367V5.53H1.033v13.487h18V5.53H16.7zM5.033 2.684h10V5.53h-10V2.684zm6.924 14.667H8.11V14.86h3.847v2.491zm5.41 0h-3.743v-4.158H6.443v4.158H2.7V7.2h14.667v10.151zM5.353 9.184H3.686v1.667h1.667V9.184zm2.009 0h1.667v1.667H7.362V9.184zm5.343 0h-1.667v1.667h1.667V9.184zm2.009 0h1.667v1.667h-1.667V9.184z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2K = /*#__PURE__*/forwardRef(SvgOfficeBuilding);

var _excluded$2J = ["title", "titleId"];

var SvgOutPatient = function SvgOutPatient(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.414 6.75a4.473 4.473 0 0 1-1.432 2.259 7.849 7.849 0 0 1 4.829 7.236v2.888h-1.667v-2.888a6.168 6.168 0 1 0-12.333 0v2.889H2.144v-2.888a7.848 7.848 0 0 1 4.987-7.3 4.473 4.473 0 1 1 7.283-2.196zm-2.767-3.478A2.8 2.8 0 0 0 10.09 2.8a2.807 2.807 0 0 0-2.8 2.8 2.8 2.8 0 1 0 4.356-2.328zM9.16 13.632h1.667v1.918h1.916v1.667h-1.916v1.916H9.16v-1.916H7.243V15.55H9.16v-1.917z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2J = /*#__PURE__*/forwardRef(SvgOutPatient);

var _excluded$2I = ["title", "titleId"];

var SvgPalmTree = function SvgPalmTree(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.72 8.13-.12-.93A3.665 3.665 0 0 0 13.966 4h-.023a3.613 3.613 0 0 0-1.129.189L14.38 1.8l-.843-.417a3.659 3.659 0 0 0-5.281 3.368A3.663 3.663 0 0 0 2.4 7.2l-.12.93 2.22.013a3.664 3.664 0 0 0-.444 4.8l.553.761 4.56-4.236V19h1.666V9.472l4.561 4.236.552-.761a3.664 3.664 0 0 0-.444-4.8l2.216-.017zm-3.767-2.465h.013a2 2 0 0 1 1.608.811l-3.23.019a2 2 0 0 1 1.609-.83zm-3.709-2.093a2 2 0 0 1 1.571-.9l-1.769 2.7a2 2 0 0 1 .198-1.8zm-4.21 2.093h.013a2 2 0 0 1 1.609.83l-3.23-.019a2 2 0 0 1 1.608-.811zm-1 5.368a2 2 0 0 1 2.37-2.196l-2.37 2.196zm9.925 0L12.6 8.835a2 2 0 0 1 2.367 2.2l-.008-.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2I = /*#__PURE__*/forwardRef(SvgPalmTree);

var _excluded$2H = ["title", "titleId"];

var SvgPantry = function SvgPantry(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.291 1.019h5.452v1.665H6.291V1.019zm7.974 3.008v2.194a4.4 4.4 0 0 1 0 8.638v4.16H4.076V5.692H2.167V4.027h12.098zM5.742 17.354H12.6V5.692H5.742v11.662zm8.523-9.406v5.184a2.716 2.716 0 0 0 0-5.184z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2H = /*#__PURE__*/forwardRef(SvgPantry);

var _excluded$2G = ["title", "titleId"];

var SvgPaper = function SvgPaper(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.982 17.318H4.988V2.657h6.876l3.118 3.1v11.56zM12.552.987H3.318v18h13.333V5.059L12.552.987z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2G = /*#__PURE__*/forwardRef(SvgPaper);

var _excluded$2F = ["title", "titleId"];

var SvgParking1 = function SvgParking1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.926 13.58A7.334 7.334 0 0 0 10 17.333 7.341 7.341 0 0 0 17.333 10a7.334 7.334 0 1 0-11.407 6.097zM8.961 6.4h2.287a2.503 2.503 0 1 1 0 5.006H8.96v2.529H7.294V6.4h1.667zm0 3.339h2.287v.001a.836.836 0 1 0 0-1.672H8.96v1.671z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2F = /*#__PURE__*/forwardRef(SvgParking1);

var _excluded$2E = ["title", "titleId"];

var SvgPartlySunny = function SvgPartlySunny(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.025 4H6.358v2.229h1.667V4zm-5.75 2.342 1.18-1.178L5.03 6.739 3.851 7.918 2.276 6.342zM1 9.196h2.228v1.667H1V9.196zm8.666-2.757 1.577-1.576L12.42 6.04l-1.576 1.576-1.179-1.178zM3.353 12.14l-1.576 1.576 1.178 1.179 1.576-1.577-1.178-1.178zm12.668-1.105h.014a2.965 2.965 0 1 1 0 5.93H7.05a2.4 2.4 0 0 1-1.757-4.024A3.505 3.505 0 1 1 10.5 8.36a3.791 3.791 0 0 1 5.521 2.675zm-7.44-2.301A1.843 1.843 0 1 0 6.535 11.8a1.843 1.843 0 0 0 2.046-3.066zM7.05 15.298h8.985a1.3 1.3 0 0 0 0-2.6h-1.622v-1a2.129 2.129 0 0 0-2.127-2.122c-.443 0-.876.14-1.235.4.008.096.015.19.015.29a3.512 3.512 0 0 1-3.472 3.507l-.618.068a.761.761 0 0 0-.193.049l-.093-.228.093.229a.728.728 0 0 0 .267 1.407z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2E = /*#__PURE__*/forwardRef(SvgPartlySunny);

var _excluded$2D = ["title", "titleId"];

var SvgPassport = function SvgPassport(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 16.516V3.484h18v13.032H1zm1.667-1.666h14.666v-9.7H2.667v9.7zm1.98-7.76h5.088v5.819H4.647V7.09zm1.666 4.153h1.756V8.757H6.313v2.486zm9.234-3.725h-3.694v1.667h3.694V7.518zm-3.694 3.298h3.694v1.667h-3.694v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2D = /*#__PURE__*/forwardRef(SvgPassport);

var _excluded$2C = ["title", "titleId"];

var SvgPath = function SvgPath(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.427 9.981 18 7.071a3.648 3.648 0 0 0-.027-5.017 3.573 3.573 0 0 0-5.067-.001 3.646 3.646 0 0 0-.033 5.013l2.554 2.915zM14.09 3.224a1.908 1.908 0 0 1 2.697.001 2 2 0 0 1-.04 2.745l-1.316 1.489-1.306-1.492a2 2 0 0 1-.035-2.743zm1.896 1.925a.864.864 0 1 1-1.098-1.334.864.864 0 0 1 1.098 1.334zm-2.833 6.772h2.412a3.46 3.46 0 0 1 3.364 3.539A3.46 3.46 0 0 1 15.564 19h-9.89l-3.357-3.836a4.82 4.82 0 0 1 .032-6.626 4.698 4.698 0 0 1 3.32-1.389h.042a4.692 4.692 0 0 1 3.322 1.39 4.825 4.825 0 0 1 .024 6.633l-1.911 2.161h8.42a1.8 1.8 0 0 0 1.7-1.873 1.8 1.8 0 0 0-1.7-1.873h-2.412a2.373 2.373 0 0 1 0-4.741h.893v1.667h-.893a.713.713 0 0 0 0 1.408zm-10.467-.026a3.17 3.17 0 0 0 .884 2.171L5.68 16.47l2.126-2.4a3.176 3.176 0 0 0 .041-4.36 3.013 3.013 0 0 0-2.136-.894H5.67a3.017 3.017 0 0 0-2.135.894 3.171 3.171 0 0 0-.848 2.185zm2.228-1.104a1.224 1.224 0 1 1 1.556 1.89 1.224 1.224 0 0 1-1.556-1.89z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2C = /*#__PURE__*/forwardRef(SvgPath);

var _excluded$2B = ["title", "titleId"];

var SvgPause = function SvgPause(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zM8.833 5.835H7.166v8.325h1.667V5.835zm3.915 0h-1.667v8.325h1.667V5.835z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2B = /*#__PURE__*/forwardRef(SvgPause);

var _excluded$2A = ["title", "titleId"];

var SvgPause2 = function SvgPause2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.291 1h1.752v17.999H5.291V1zm7.666 0h1.752v17.854h-1.752V1z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2A = /*#__PURE__*/forwardRef(SvgPause2);

var _excluded$2z = ["title", "titleId"];

var SvgPayOrder = function SvgPayOrder(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zm6.726-9.478A.788.788 0 0 0 10 7.637a.767.767 0 0 0-.742 1.066.764.764 0 0 0 .742.462 2.427 2.427 0 0 1 .837 4.723v.871H9.166v-.87a2.44 2.44 0 0 1-1.645-2.29h1.671a.765.765 0 1 0 .808-.764 2.427 2.427 0 0 1-.834-4.724v-.87h1.671v.871a2.441 2.441 0 0 1 1.642 2.289h-1.671a.788.788 0 0 0-.246-.549z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2z = /*#__PURE__*/forwardRef(SvgPayOrder);

var _excluded$2y = ["title", "titleId"];

var SvgPayTime = function SvgPayTime(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.541 4.923a.788.788 0 0 1-.808-.763.788.788 0 0 1 .808-.76.788.788 0 0 1 .808.764H6.02a2.44 2.44 0 0 0-1.642-2.293V1H2.707v.87a2.44 2.44 0 0 0-1.645 2.29 2.46 2.46 0 0 0 2.479 2.434.766.766 0 1 1 0 1.527.787.787 0 0 1-.808-.763H1.062a2.439 2.439 0 0 0 1.645 2.289v.87h1.671v-.871a2.427 2.427 0 0 0-.837-4.723zm8.938 1.159a6.46 6.46 0 1 0 6.46 6.459 6.466 6.466 0 0 0-6.46-6.459zm0 11.352a4.894 4.894 0 1 1 4.893-4.893 4.9 4.9 0 0 1-4.893 4.893zm-1.331-6.964 1.172 1.196 2.416-2.409 1.178 1.182-3.603 3.591-2.349-2.387 1.186-1.173z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2y = /*#__PURE__*/forwardRef(SvgPayTime);

var _excluded$2x = ["title", "titleId"];

var SvgPayment = function SvgPayment(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.6 1.007H19v9.516h-8.847A5.177 5.177 0 1 1 5.6 8.679V1.007zM4.224 16.736a3.507 3.507 0 1 0 3.896-5.831 3.507 3.507 0 0 0-3.896 5.83zm3.395-7.88h9.716v-3.85H7.269v3.76c.119.026.235.056.35.09zm-.35-5.516h10.066v-.667H7.269v.667zm.924 2.993h5.444V8H8.193V6.333z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2x = /*#__PURE__*/forwardRef(SvgPayment);

var _excluded$2w = ["title", "titleId"];

var SvgPaymentDone = function SvgPaymentDone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.04 4.859a.788.788 0 0 0-.561-.215v.005a.764.764 0 1 0 0 1.527 2.427 2.427 0 0 1 .837 4.723v.871H2.645v-.87A2.44 2.44 0 0 1 1 8.605h1.671a.788.788 0 0 0 .808.764.766.766 0 1 0 0-1.527 2.427 2.427 0 0 1-.834-4.724v-.87h1.671v.871a2.44 2.44 0 0 1 1.642 2.288H4.287a.788.788 0 0 0-.247-.548zm6.609 9.468 7.173-7.16L19 8.346l-8.359 8.343-3.694-3.735 1.185-1.173 2.517 2.545z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2w = /*#__PURE__*/forwardRef(SvgPaymentDone);

var _excluded$2v = ["title", "titleId"];

var SvgPeople = function SvgPeople(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.491 7.417a.628.628 0 1 1 0 1.256.628.628 0 0 1 0-1.256zm-5.445-1.335a.628.628 0 1 1 0 1.256.628.628 0 0 1 0-1.256zM4.6 7.417a.628.628 0 1 1 0 1.256.628.628 0 0 1 0-1.256zM17.958 10.2a3.573 3.573 0 0 0-.788-.6 2.293 2.293 0 1 0-3.391-.035c-.189.101-.368.22-.536.353a3.532 3.532 0 0 0-1.517-1.653 2.293 2.293 0 1 0-3.391-.035 3.55 3.55 0 0 0-1.578 1.691 3.552 3.552 0 0 0-.475-.32 2.295 2.295 0 1 0-3.392-.033A3.564 3.564 0 0 0 1 12.711v2.874h1.667v-2.874a1.89 1.89 0 0 1 3.778 0v2.875h1.666v-4.21a1.89 1.89 0 0 1 3.778 0v4.21h1.666v-2.875a1.889 1.889 0 1 1 3.778 0v2.875H19V12.71a3.529 3.529 0 0 0-1.042-2.51z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2v = /*#__PURE__*/forwardRef(SvgPeople);

var _excluded$2u = ["title", "titleId"];

var SvgPeopleBehindDoor = function SvgPeopleBehindDoor(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 8.79h-2.94a2.941 2.941 0 0 0-.1-.564c.05 0 .1.007.152.007a2.455 2.455 0 1 0-2.42-2.055 2.862 2.862 0 0 0-2.42.69V1H1v18h10.262v-3.986l3.959-3.959c.178-.18.332-.38.457-.6H19V8.79zm-2.888-3.8a.789.789 0 1 1-.005 0h.005zM9.6 17.333H2.667V2.667H9.6v14.666zm4.448-7.456-2.781 2.78V9.214l1.059-1.059a1.218 1.218 0 0 1 1.722 1.722z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2u = /*#__PURE__*/forwardRef(SvgPeopleBehindDoor);

var _excluded$2t = ["title", "titleId"];

var SvgPeopleElder = function SvgPeopleElder(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.075 5.602c-.367.52-.894.905-1.5 1.098l1.871 2.47-1.329 1.007-2.04-2.7-1.577 3.6V19H4.83v-8.271l2-4.568a2.42 2.42 0 0 1-.2-.178 2.916 2.916 0 1 1 4.445-.381zm-3.17-.713a1.252 1.252 0 1 0 1.582-1.94 1.252 1.252 0 0 0-1.583 1.94zm3.484 5.57a2.25 2.25 0 0 1 1.573-.66 2.245 2.245 0 0 1 2.249 2.218V19h-1.667v-6.977a.572.572 0 0 0-1.144.015v.818h-1.671v-.825a2.25 2.25 0 0 1 .66-1.573z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2t = /*#__PURE__*/forwardRef(SvgPeopleElder);

var _excluded$2s = ["title", "titleId"];

var SvgPercentage = function SvgPercentage(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.518 8.03A3.515 3.515 0 1 0 4.512 1a3.515 3.515 0 0 0 .006 7.03zm0-5.363a1.848 1.848 0 1 1 0 3.697 1.848 1.848 0 0 1 0-3.697zm12.941-1.3L1.371 17.458l1.178 1.178 16.088-16.09-1.178-1.177zm-3.925 11.194a3.515 3.515 0 1 1 3.901 5.848 3.515 3.515 0 0 1-3.9-5.848zm.928 4.46a1.848 1.848 0 1 0 2.054-3.071 1.848 1.848 0 0 0-2.054 3.071z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2s = /*#__PURE__*/forwardRef(SvgPercentage);

var _excluded$2r = ["title", "titleId"];

var SvgPerson = function SvgPerson(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.835 8.621v-.054a7.766 7.766 0 0 0-13.4-5.148A7.714 7.714 0 0 0 1.3 8.97a7.81 7.81 0 0 0 3.228 6.1l.1.07V19h1.666v-4.71l-.794-.57a6.135 6.135 0 0 1-2.532-4.794 6.1 6.1 0 0 1 8.289-5.853 6.102 6.102 0 0 1 3.911 5.538l.012.438 1.075 2.067H15.17V15.5h-3.1V19h1.67v-1.837h3.1v-4.38H19l-2.165-4.162z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2r = /*#__PURE__*/forwardRef(SvgPerson);

var _excluded$2q = ["title", "titleId"];

var SvgPharmacyDelivery = function SvgPharmacyDelivery(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.637 7.645H6.992a2.673 2.673 0 1 1 0-5.345h5.645a2.673 2.673 0 1 1 0 5.345zm.711-1.962a1.007 1.007 0 0 0 0-1.422 1.007 1.007 0 0 0-.711-.294H10.68v2.01h1.957c.267 0 .522-.106.711-.294zM9.013 3.967H6.992a1.007 1.007 0 1 0 0 2.01h2.021v-2.01zm9.592 7.14a.833.833 0 0 1 .126 1.28l-5.334 5.335a.832.832 0 0 1-.589.245H.975V16.3h11.488l3.667-3.668h-4.91a2.333 2.333 0 0 1-1.285.385H6.206V11.35h3.729a.687.687 0 0 0 0-1.374H5.749l-4.323 1.21-.451-1.6L5.41 8.34a.856.856 0 0 1 .225-.031h4.3a2.356 2.356 0 0 1 2.332 2.657h5.875c.165 0 .326.049.463.14z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2q = /*#__PURE__*/forwardRef(SvgPharmacyDelivery);

var _excluded$2p = ["title", "titleId"];

var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.16 12.561-.36-.361a3.954 3.954 0 0 0-4.528-.745l-.12.059-4.708-4.7.058-.12a3.974 3.974 0 0 0-1.825-5.3 3.952 3.952 0 0 0-5.631 4.222c.14.818.53 1.571 1.12 2.155l10.028 10.044a3.976 3.976 0 0 0 6.784-2.564 4 4 0 0 0-.817-2.69zm-1.516 4.077a2.31 2.31 0 0 1-3.271 0L3.342 6.59a2.308 2.308 0 0 1 .085-3.363 2.284 2.284 0 0 1 2.523-.345 2.3 2.3 0 0 1 1.057 3.075l-.578 1.189 6.392 6.384 1.189-.584a2.285 2.285 0 0 1 2.62.432l.242.241a2.33 2.33 0 0 1-.228 3.019z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2p = /*#__PURE__*/forwardRef(SvgPhone);

var _excluded$2o = ["title", "titleId"];

var SvgPieChart = function SvgPieChart(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9zm7.285 8.167h-6.452V2.715a7.346 7.346 0 0 1 6.452 6.452zM2.667 10a7.343 7.343 0 0 1 6.5-7.285v7.63l5.392 5.392A7.326 7.326 0 0 1 2.667 10zm13.071 4.559-3.726-3.726h5.273a7.3 7.3 0 0 1-1.547 3.726z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2o = /*#__PURE__*/forwardRef(SvgPieChart);

var _excluded$2n = ["title", "titleId"];

var SvgPiggyBank = function SvgPiggyBank(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.361 6.964a2.182 2.182 0 0 0-2.691-.319 7.993 7.993 0 0 0-5.748-2.527A4.437 4.437 0 0 0 6.442 2.2l-.866-.033v2.922a5.315 5.315 0 0 0-2.483 2.864H1v5.832h1.881v4.049h5.391V15.99c.454.066.912.1 1.371.1.417 0 .834-.03 1.247-.09v1.829h5.391V12.87a5.747 5.747 0 0 0 .814-2.649 5.108 5.108 0 0 0-.5-2.18.52.52 0 0 1 .585.844l-.043.042 1.179 1.179.043-.043a2.2 2.2 0 0 0 .002-3.099zm-3.627 5.251-.12.2v3.755h-2.058v-2.285l-1.053.288a6.753 6.753 0 0 1-1.86.255 8.502 8.502 0 0 1-2-.258l-1.038-.27v2.269H4.548v-4.05H2.667v-2.5h1.71l.149-.645a3.724 3.724 0 0 1 2.23-2.616l.487-.222V4.041A2.019 2.019 0 0 1 8.6 5.222l.2.579.612-.017c3.288-.1 6.019 1.928 6.019 4.437-.06.713-.3 1.399-.697 1.994zM7.239 8.051H5.52v1.667h1.719V8.051zm1.675-1.533h2.782v1.667H8.914V6.518z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2n = /*#__PURE__*/forwardRef(SvgPiggyBank);

var _excluded$2m = ["title", "titleId"];

var SvgPill = function SvgPill(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.523 2.955a5.572 5.572 0 0 0-7.868-.375L2.78 9.464a5.565 5.565 0 0 0 3.5 9.663c.09 0 .18.006.269.006a5.558 5.558 0 0 0 3.742-1.447l6.873-6.886a5.56 5.56 0 0 0 .359-7.847v.002zm-8.368 13.51a3.9 3.9 0 0 1-5.241-5.778l2.945-2.95 5.525 5.495-3.229 3.233zm6.873-6.882-2.466 2.469-5.526-5.494L10.79 3.8a3.9 3.9 0 0 1 5.241 5.779l-.003.004z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2m = /*#__PURE__*/forwardRef(SvgPill);

var _excluded$2l = ["title", "titleId"];

var SvgPin = function SvgPin(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.2 1.074-1.181 1.18.769.767-3.634 3.632-4.7 1.063-.6-.6-1.179 1.175 4.448 4.448-5.107 5 1.165 1.192L7.3 13.918l4.461 4.46L12.94 17.2l-.6-.6 1.057-4.674 3.639-3.657.774.773 1.174-1.182L12.2 1.074zm-.324 10.012-.933 4.114L4.85 9.11l4.142-.937L12.966 4.2l2.888 2.888-3.978 3.998z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2l = /*#__PURE__*/forwardRef(SvgPin);

var _excluded$2k = ["title", "titleId"];

var SvgPipeline = function SvgPipeline(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.16 7.843v3.666H19v1.661h-7.501V7.843H8.501v5.327H1v-1.66h5.84V7.842H5.731v-1.66H9.17V4.99H7.044V3.33h5.912v1.66h-2.125v1.192h3.438v1.661H13.16zM1 16.168h18v1.661H1v-1.66z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2k = /*#__PURE__*/forwardRef(SvgPipeline);

var _excluded$2j = ["title", "titleId"];

var SvgPlanDesign = function SvgPlanDesign(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.081 12.5v-1.667h-2.562l-1.733-4.65a2.186 2.186 0 0 0-.953-3.3V1H9.167v1.881a2.185 2.185 0 0 0-.953 3.3l-1.733 4.65H3.919V12.5h1.942l-.93 2.495L3.922 17.7 5.217 19l2.421-6.5h1.529v1.18h1.666V12.5h1.528l2.421 6.5 1.3-1.3-1.01-2.71-.93-2.495 1.939.005zM10 4.381a.53.53 0 1 1 0 1.061.53.53 0 0 1 0-1.061zm.833 6.452V9.652H9.167v1.181H8.26l1.4-3.758c.224.045.456.045.68 0l1.4 3.758h-.907z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2j = /*#__PURE__*/forwardRef(SvgPlanDesign);

var _excluded$2i = ["title", "titleId"];

var SvgPlastic = function SvgPlastic(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.6 5.73 12.269 4.4V.987H7.6V4.4L6.269 5.73a2.8 2.8 0 0 0-.8 1.867v11.39H14.4V7.6a2.99 2.99 0 0 0-.8-1.87zM9.2 2.654h1.334v1.209H9.2v-1.21zM7.4 6.93 8.736 5.6h2.333L12.4 6.93c.172.179.268.418.267.667v.748h-5.6V7.6c.026-.256.145-.494.333-.67zm5.267 5.88h-5.6v-2.8h5.6v2.8zm-5.531 1.668h5.6v2.843h-5.6v-2.843z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2i = /*#__PURE__*/forwardRef(SvgPlastic);

var _excluded$2h = ["title", "titleId"];

var SvgPlate = function SvgPlate(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zm7.027-3.139A4.186 4.186 0 0 0 14.181 10h1.671A5.858 5.858 0 0 1 10 15.852v-1.671a4.186 4.186 0 0 0 2.955-1.226z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2h = /*#__PURE__*/forwardRef(SvgPlate);

var _excluded$2g = ["title", "titleId"];

var SvgPlateSpoon = function SvgPlateSpoon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.12 4.02a2.883 2.883 0 0 0-2.88 2.88v1.443a2.885 2.885 0 0 0 2.047 2.757v4.88h1.666V11.1A2.885 2.885 0 0 0 19 8.343V6.9a2.883 2.883 0 0 0-2.88-2.88zm1.213 4.323a1.214 1.214 0 0 1-2.427 0V6.9a1.214 1.214 0 0 1 2.427 0v1.443zM6.955 4.045A5.955 5.955 0 1 0 12.909 10a5.962 5.962 0 0 0-5.954-5.955zm0 10.243a4.288 4.288 0 1 1-.002-8.576 4.288 4.288 0 0 1 .002 8.576zm1.548-3.647c.084-.203.127-.421.127-.641l-.001-.012H10.3V10a3.342 3.342 0 0 1-3.345 3.343v-1.667a1.676 1.676 0 0 0 1.548-1.035z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2g = /*#__PURE__*/forwardRef(SvgPlateSpoon);

var _excluded$2f = ["title", "titleId"];

var SvgPlay1 = function SvgPlay1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.928 16.094A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zM5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm6.375 7.468L9.32 8.8v2.375l2.055-1.19zm3.342.002L7.649 14.07V5.91l7.068 4.077z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2f = /*#__PURE__*/forwardRef(SvgPlay1);

var _excluded$2e = ["title", "titleId"];

var SvgPlay2 = function SvgPlay2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.881 3.9 14.442 10 3.881 16.1V3.9zM2.205 1v18L17.8 10 2.205 1z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2e = /*#__PURE__*/forwardRef(SvgPlay2);

var _excluded$2d = ["title", "titleId"];

var SvgPlus = function SvgPlus(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.517A9 9 0 0 1 10 1a9.01 9.01 0 0 1 9 9A9 9 0 1 1 5 2.517zm.928 13.577A7.329 7.329 0 0 0 10 17.329 7.338 7.338 0 0 0 17.329 10a7.329 7.329 0 1 0-11.4 6.094zm3.239-9.541h1.666v2.613h2.614v1.667h-2.614v2.614H9.167v-2.614H6.553V9.166h2.614V6.553z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2d = /*#__PURE__*/forwardRef(SvgPlus);

var _excluded$2c = ["title", "titleId"];

var SvgPortfolioOptimization = function SvgPortfolioOptimization(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.973 18.773V1.106h17.934v17.667H.973zM17.24 4.393v-1.62H2.667v1.62H17.24zM2.667 6.06v11.046h14.6V6.06h-14.6zM5.02 7.167h1.667v3.586h.833v1.667h-.833v3.587H5.02V12.42h-.833v-1.667h.833V7.166zm5.787 0H9.14V8.38h-.833v1.666h.833v5.96h1.667v-5.96h.833V8.38h-.833V7.166zm2.446 0h1.667v5.993h.833v1.667h-.833v1.18h-1.667v-1.18h-.833V13.16h.833V7.166z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2c = /*#__PURE__*/forwardRef(SvgPortfolioOptimization);

var _excluded$2b = ["title", "titleId"];

var SvgPowerLineTower = function SvgPowerLineTower(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.616 9.421H13.8l-.534-2.073h1.679V5.676h-2.11L11.633 1H8.367l-1.2 4.676H5.053v1.672h1.679L6.2 9.421H3.384v1.667h2.385L3.732 19h12.536l-2.037-7.912h2.385V9.421zM9.633 2.667h.708l.773 3.009H8.86l.773-3.009zm-1.2 4.681h3.112l.532 2.073H7.9l.533-2.073zm5.355 8.74-2.609-2.608 1.542-1.542 1.067 4.15zm-6.53-4.171 1.563 1.563-2.642 2.643 1.079-4.206zm1.528-.829h2.428L10 12.3l-1.214-1.212zM10 14.659l2.674 2.674H7.326L10 14.659z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2b = /*#__PURE__*/forwardRef(SvgPowerLineTower);

var _excluded$2a = ["title", "titleId"];

var SvgPptWordPdf = function SvgPptWordPdf(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zM5.569 6.12h4.278v1.667H5.569V6.12zm4.278 2.664H5.569v1.667h4.278V8.784zm-4.278 2.665h8.861v1.667H5.569v-1.667zm8.861 2.662H5.569v1.667h8.861v-1.667zM10.829 6.12h3.479v4.331h-3.479V6.12z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$2a = /*#__PURE__*/forwardRef(SvgPptWordPdf);

var _excluded$29 = ["title", "titleId"];

var SvgPreferentialPremiumRates = function SvgPreferentialPremiumRates(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$29);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m13.191 7.1-1.942-4.426h3.552L16.742 7.1h-3.551zm-1.382 7.073 1.491-5.41h2.974l-4.462 5.409h-.003zm-1.821.364L8.466 8.76h3.082l-1.553 5.83-.007-.053zm-6.3-5.772h3l1.492 5.408-4.492-5.408zm1.492-6.09h3.562L6.8 7.1H3.248L5.18 2.675zM10 3.914l1.4 3.185H8.6L10 3.914zM18.542 7.1l-2.673-6.09H4.125L1.45 7.1 1 8.164 9.994 18.99 19 8.14 18.542 7.1z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$29 = /*#__PURE__*/forwardRef(SvgPreferentialPremiumRates);

var _excluded$28 = ["title", "titleId"];

var SvgPremiumDiscounts = function SvgPremiumDiscounts(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$28);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.54 7.113.44.993-.007.007-.586.714L10 18.98 3.047 10.6 1.58 8.826l-.587-.713.44-1 .16-.366 2-4.48.553-1.234h11.72l.387.88.173.394 2.114 4.806zM4.38 9.507l5.62 6.8 6.98-8.487-2.113-4.807-.114-.26H5.26l-.1.234-2 4.48-.16.366 1.38 1.674zM7.033 4.72h1.693v1.8H7.034v-1.8zM13.2 9.34h-1.693v1.8H13.2v-1.8zm-5.094 1.806L6.913 9.933l5.24-5.267 1.2 1.207-5.247 5.273z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$28 = /*#__PURE__*/forwardRef(SvgPremiumDiscounts);

var _excluded$27 = ["title", "titleId"];

var SvgPrescriptionBeingOpened = function SvgPrescriptionBeingOpened(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$27);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m8.813.989 7.85 7.85-2.922 2.923-.78-.78v8.007H3.33V5.858h4.506L5.89 3.912 8.813.989zm5.493 7.85L8.813 3.347l-.565.566 5.493 5.493.565-.565zM5 17.324h6.3V9.316L9.5 7.523H5v9.8zm2.354-7.7H9.02v1.5h1.5v1.668h-1.5v1.5H7.354v-1.5h-1.5v-1.667h1.5v-1.5z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$27 = /*#__PURE__*/forwardRef(SvgPrescriptionBeingOpened);

var _excluded$26 = ["title", "titleId"];

var SvgPriceMeter = function SvgPriceMeter(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$26);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.003 3.514a9 9 0 0 1 11.481 13.727l-1.2-1.156a7.323 7.323 0 0 0 .454-9.643l-1.68 1.679-1.178-1.178 1.68-1.68a7.331 7.331 0 0 0-9.755 10.913l-1.181 1.176a9 9 0 0 1 1.38-13.838zm5.57 5.368a.788.788 0 0 0-.562-.215.766.766 0 1 0 0 1.527 2.427 2.427 0 0 1 .837 4.723v.871H9.177v-.87a2.44 2.44 0 0 1-1.645-2.29h1.671a.765.765 0 1 0 .808-.763 2.427 2.427 0 0 1-.834-4.724v-.87h1.671v.871A2.44 2.44 0 0 1 12.49 9.43h-1.671a.788.788 0 0 0-.247-.548z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$26 = /*#__PURE__*/forwardRef(SvgPriceMeter);

var _excluded$25 = ["title", "titleId"];

var SvgPrint = function SvgPrint(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$25);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2 4.573V1H4.8v3.573H1v11.055h3.8V19h10.4v-3.372H19V4.573h-3.8zM6.466 2.667h7.063v1.906H6.466V2.667zm7.063 14.666H6.466V12.45h7.063v4.883zm3.8-3.371H15.2v-3.179H4.8v3.179H2.667V6.24h14.666l-.004 7.722z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$25 = /*#__PURE__*/forwardRef(SvgPrint);

var _excluded$24 = ["title", "titleId"];

var SvgProduct = function SvgProduct(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$24);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1 1 4.667v9.886L10 19l9-4.447V4.667L10 1zm6.616 4.5L10 8.1 3.384 5.5 10 2.8l6.616 2.7zM10 17.141l-7.333-3.623V7L10 9.892 17.333 7v6.515L10 17.141z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$24 = /*#__PURE__*/forwardRef(SvgProduct);

var _excluded$23 = ["title", "titleId"];

var SvgPromo = function SvgPromo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$23);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.7 11.963v2.71h-2.758l-1.949 1.954L8.051 14.7H5.326v-2.757L3.38 10l1.927-1.917V5.326h2.749L10 3.377l1.943 1.943h2.73v2.737l1.957 1.952-1.93 1.954zm1.655-8.323v3.722L19 10l-2.621 2.653v3.7H12.64L10 19l-2.641-2.622H3.646V12.64L1 10l2.627-2.615V3.646h3.732L10 1l2.639 2.64h3.716zm-7.214 7.454h1.68V6.57h-1.68v4.524zm1.68 2.613h-1.68v-1.575h1.68v1.575z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$23 = /*#__PURE__*/forwardRef(SvgPromo);

var _excluded$22 = ["title", "titleId"];

var SvgPuzzle = function SvgPuzzle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$22);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.105 12.866a.59.59 0 0 1-.512.252c-.229 0-.3-.062-.512-.3a1.645 1.645 0 0 0-1.235-.647 1.744 1.744 0 0 0-1.661 1.685v3.475H2.665v-3.393l.01.011a2.194 2.194 0 0 0 1.738.833 2.25 2.25 0 0 0 1.848-.922 3 3 0 0 0 .559-1.788 2.49 2.49 0 0 0-2.407-2.71 2.192 2.192 0 0 0-1.743.838V6.815h3.472a1.744 1.744 0 0 0 1.685-1.66 1.644 1.644 0 0 0-.647-1.236c-.236-.217-.3-.283-.3-.512 0-.732 1-.74 1.044-.74.044 0 1.043.008 1.043.74 0 .23-.061.295-.3.512a1.645 1.645 0 0 0-.647 1.235 1.744 1.744 0 0 0 1.689 1.661h3.476v3.475a1.743 1.743 0 0 0 1.661 1.685 1.644 1.644 0 0 0 1.235-.647c.217-.236.283-.3.512-.3.732 0 .74 1 .74 1.043a1.35 1.35 0 0 1-.228.792v.003zm-.512-3.5a2.193 2.193 0 0 0-1.737.833V5.15l-5.06.006.01-.01a2.19 2.19 0 0 0 .834-1.738A2.488 2.488 0 0 0 7.926 1a2.487 2.487 0 0 0-2.71 2.407 2.191 2.191 0 0 0 .833 1.737H1v5.146a1.743 1.743 0 0 0 1.661 1.685 1.64 1.64 0 0 0 1.239-.647c.218-.236.284-.3.513-.3.732 0 .74 1 .74 1.043a1.35 1.35 0 0 1-.228.792.592.592 0 0 1-.512.252c-.229 0-.295-.062-.513-.3a1.638 1.638 0 0 0-1.234-.648A1.743 1.743 0 0 0 1 13.858V19h13.852v-5.053a2.193 2.193 0 0 0 1.737.833 2.253 2.253 0 0 0 1.849-.922A3 3 0 0 0 19 12.074a2.487 2.487 0 0 0-2.407-2.71v.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$22 = /*#__PURE__*/forwardRef(SvgPuzzle);

var _excluded$21 = ["title", "titleId"];

var SvgQualifyContacts = function SvgQualifyContacts(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$21);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m19 10.43-3.35-3.35-1.87 1.86A7.114 7.114 0 0 0 12.22 8a4.07 4.07 0 1 0-5.57 0 7.26 7.26 0 0 0-4.47 6.7V19h1.67v-4.26a5.59 5.59 0 0 1 5.59-5.59 5.53 5.53 0 0 1 3.14 1L7 15.64V19h3.36L15 14.39V19h1.7v-4.26a7.5 7.5 0 0 0-.23-1.74L19 10.43zM9.44 7.48a2.41 2.41 0 1 1 2.4-2.42v.01a2.41 2.41 0 0 1-2.4 2.41zm.24 9.84h-1v-1l7-6.9 1 1-7 6.9z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$21 = /*#__PURE__*/forwardRef(SvgQualifyContacts);

var _excluded$20 = ["title", "titleId"];

var SvgQuestion = function SvgQuestion(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$20);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.question_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "question_svg__st0",
    d: "M17.219 4.585a9.797 9.797 0 0 0-1.6-1.641 8.921 8.921 0 0 0-5.6-1.961 8.938 8.938 0 0 0-7.04 3.394 9.049 9.049 0 0 0-1.958 5.61v9h9.009a9 9 0 0 0 7.189-14.4v-.002zM10.03 17.316H2.688V9.987a7.376 7.376 0 0 1 1.6-4.573 7.318 7.318 0 0 1 10.305-1.155c.48.392.913.837 1.293 1.327a7.33 7.33 0 0 1-5.856 11.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "question_svg__st0",
    d: "M10.507 12.661H8.84v1.67h1.667v-1.67zM10.136 5.861a2.655 2.655 0 0 0-3.151 2.616h1.666a.99.99 0 0 1 1.187-.974 1.017 1.017 0 0 1 .806.829.97.97 0 0 1-.487 1.031 2.4 2.4 0 0 0-1.309 2.116v.063h1.667v-.055a.736.736 0 0 1 .423-.652 2.63 2.63 0 0 0 1.345-2.8 2.663 2.663 0 0 0-2.147-2.174z"
  }));
};

var ForwardRef$20 = /*#__PURE__*/forwardRef(SvgQuestion);

var _excluded$1$ = ["title", "titleId"];

var SvgRadioButtonChecked = function SvgRadioButtonChecked(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.013 20",
    style: {
      enableBackground: 'new 0 0 20.0126 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.006 10c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8zm8-10c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.4-10-10-10z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.706 10c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3-1.8 0-3.3-1.5-3.3-3.3z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1$ = /*#__PURE__*/forwardRef(SvgRadioButtonChecked);

var _excluded$1_ = ["title", "titleId"];

var SvgRadioButtonCircle = function SvgRadioButtonCircle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.7 10c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3-1.8 0-3.3-1.5-3.3-3.3z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1_ = /*#__PURE__*/forwardRef(SvgRadioButtonCircle);

var _excluded$1Z = ["title", "titleId"];

var SvgRadioButtonUnchecked = function SvgRadioButtonUnchecked(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.013 20",
    style: {
      enableBackground: 'new 0 0 20.0126 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.006 10c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8zm8-10c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.4-10-10-10z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1Z = /*#__PURE__*/forwardRef(SvgRadioButtonUnchecked);

var _excluded$1Y = ["title", "titleId"];

var SvgRain = function SvgRain(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2 5.026h.22a3.58 3.58 0 0 1 3.36 4.962 3.579 3.579 0 0 1-3.36 2.195H3.849a2.846 2.846 0 0 1-.916-5.542A3.792 3.792 0 0 1 6.27 3.964a4.643 4.643 0 0 1 8.93 1.062zm-11.351 5.49H15.42a1.913 1.913 0 1 0 0-3.823h-1.844v-1.05a2.976 2.976 0 0 0-5.878-.656l-.164.729-.743-.084a2.112 2.112 0 0 0-2.33 1.81l-.086.647-.648.072a1.182 1.182 0 0 0 .122 2.355zM7.38 17.28l4.062-4.062 1.178 1.179-4.062 4.061L7.38 17.28zm-5.213 0 4.062-4.061 1.178 1.178-4.062 4.062-1.178-1.178zm14.488-4.06-4.062 4.061 1.178 1.178 4.062-4.061-1.178-1.178z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1Y = /*#__PURE__*/forwardRef(SvgRain);

var _excluded$1X = ["title", "titleId"];

var SvgReceived = function SvgReceived(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.133 5.533 8.667l1.4-1.4L9 9.333V2.067h2v7.266l2.067-2.066 1.4 1.4L10 13.133zm2.267-7.8v-2h6.866v13.4H.866v-13.4h6.8v2h-4.8v9.4h14.267v-9.4h-4.866z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1X = /*#__PURE__*/forwardRef(SvgReceived);

var _excluded$1W = ["title", "titleId"];

var SvgReception = function SvgReception(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.333 3.333H19v1.314h-1.667V3.333zm-3.202 8.557a4.153 4.153 0 0 0-1.225-2.957 4.2 4.2 0 0 0-1.075-.775 2.578 2.578 0 1 0-3.761 0 4.197 4.197 0 0 0-1.986 2.133 4.153 4.153 0 0 0-.316 1.601V15H1v1.667h18V15h-4.869v-3.11zm-4.18-6.4a.913.913 0 1 1-.644.265.913.913 0 0 1 .644-.268v.003zM12.464 15H7.435v-3.109a2.515 2.515 0 0 1 5.029 0V15zM19 5.515h-1.667V9.29H19V5.515z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1W = /*#__PURE__*/forwardRef(SvgReception);

var _excluded$1V = ["title", "titleId"];

var SvgReimbursement = function SvgReimbursement(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.565 1h12.857l.013 18-3.47-1.967-2.975 1.929-2.944-1.928L3.578 19 3.565 1zm6.43 15.974 2.913-1.888 1.86 1.054-.01-13.475H5.23l.01 13.477 1.867-1.059 2.887 1.891zm.562-10.13a.788.788 0 0 0-.562-.216v-.002a.766.766 0 1 0 0 1.528 2.427 2.427 0 0 1 .837 4.723v.871H9.161v-.87a2.44 2.44 0 0 1-1.645-2.29h1.671a.765.765 0 1 0 .808-.764A2.427 2.427 0 0 1 9.161 5.1v-.87h1.671v.87a2.442 2.442 0 0 1 1.642 2.292h-1.671a.788.788 0 0 0-.246-.549z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1V = /*#__PURE__*/forwardRef(SvgReimbursement);

var _excluded$1U = ["title", "titleId"];

var SvgReload = function SvgReload(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 0 0-9 9h1.667a7.34 7.34 0 1 1 1.106 3.867H5.95V12.2H1v4.95h1.667V15.2A9 9 0 1 0 10 1z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1U = /*#__PURE__*/forwardRef(SvgReload);

var _excluded$1T = ["title", "titleId"];

var SvgRemoveFile = function SvgRemoveFile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zM10 8.819l1.853-1.853 1.181 1.181L11.181 10l1.853 1.853-1.181 1.181L10 11.181l-1.853 1.853-1.181-1.181L8.819 10 6.966 8.147l1.181-1.181L10 8.819z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1T = /*#__PURE__*/forwardRef(SvgRemoveFile);

var _excluded$1S = ["title", "titleId"];

var SvgRestaurant = function SvgRestaurant(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.408 6.592C12.408 3.509 14.468 1 17 1h.833v18h-1.666v-5.608h-3.759v-6.8zm1.667 5.128h2.092V2.836a4.018 4.018 0 0 0-2.092 3.756v5.128zM8.743 8.88c.539-.539.842-1.27.842-2.033v-4.68h1.667v4.68a4.547 4.547 0 0 1-3.71 4.462V19H5.876v-7.691a4.546 4.546 0 0 1-3.709-4.462v-4.68h1.666v4.68a2.876 2.876 0 0 0 4.91 2.034zM6.355 2.168H4.688v4.956h1.667V2.167zm.708 0H8.73v4.956H7.063V2.167z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1S = /*#__PURE__*/forwardRef(SvgRestaurant);

var _excluded$1R = ["title", "titleId"];

var SvgRetail = function SvgRetail(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.167 17.333H3.833V7.1h2.082v1.621h1.667V7.1h4.9v1.621h1.667V7.1h2.023v10.23l-.005.003zM7.582 4.546a1.9 1.9 0 0 1 1.913-1.879h1.068a1.9 1.9 0 0 1 1.914 1.879v.89h-4.9v-.89h.005zm6.562.89v-.89A3.568 3.568 0 0 0 10.563 1H9.495a3.568 3.568 0 0 0-3.58 3.546v.89H2.167V19h15.666V5.436h-3.689z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1R = /*#__PURE__*/forwardRef(SvgRetail);

var _excluded$1Q = ["title", "titleId"];

var SvgRetirement = function SvgRetirement(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.451 17.27a100.312 100.312 0 0 0-.293-3.356l5.4-.5.317 3.624c-1.79.322-3.614.4-5.424.232zm4.965-5.513-5.429.477c-.073-.6-.167-1.162-.228-1.71l5.524-.508.133 1.741zm3.4 4.589a24.07 24.07 0 0 1-1.329.359l-.6-6.836.767-.071-.146-1.66-8 .732A58.7 58.7 0 0 0 5.642 1l-1.557.489A68.838 68.838 0 0 1 6.8 17.033a19.049 19.049 0 0 1-3.222-.908L3 17.651A20.571 20.571 0 0 0 10.351 19a23.537 23.537 0 0 0 6.956-1.094l-.482-1.56h-.009z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1Q = /*#__PURE__*/forwardRef(SvgRetirement);

var _excluded$1P = ["title", "titleId"];

var SvgRight = function SvgRight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M9.5 14 8 12.5l2.6-2.5L8 7.5 9.5 6l3.9 4z"
  }));
};

var ForwardRef$1P = /*#__PURE__*/forwardRef(SvgRight);

var _excluded$1O = ["title", "titleId"];

var SvgRightFill = function SvgRightFill(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.31 3.61a8.98 8.98 0 1 0 .04.04l-.04-.04zm-3.827 5.663.707.707-.707.707-2.92 2.921-1.415-1.414 2.214-2.214-2.214-2.214 1.414-1.414 2.921 2.92z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1O = /*#__PURE__*/forwardRef(SvgRightFill);

var _excluded$1N = ["title", "titleId"];

var SvgRisk = function SvgRisk(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 7.467 16.333 4.8l-1.2-1.2-1.2 1.2-2.666 2.667 1.2 1.2L14.333 6.8v5.4c0 1.4-1.133 2.467-2.466 2.467-1.334 0-2.4-1-2.467-2.334v-.2C9.4 9.867 7.533 8 5.267 8 3 8 1.133 9.867 1.133 12.133v4.2h1.534v-4.2c0-1.4 1.133-2.466 2.466-2.466s2.4 1 2.467 2.333v.2c0 2.267 1.867 4.133 4.133 4.133 2.267 0 4.134-1.866 4.134-4.133V6.8l1.866 1.867L19 7.467z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1N = /*#__PURE__*/forwardRef(SvgRisk);

var _excluded$1M = ["title", "titleId"];

var SvgRoad = function SvgRoad(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.173 1h1.661v18h-1.66V1zm6.658 0h-1.66v4.833h1.66V1zm0 13.167h-1.66V19h1.66v-4.833zm0-6.48h-1.66v4.391h1.66V7.687zM14.167 1h1.661v18h-1.66V1z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1M = /*#__PURE__*/forwardRef(SvgRoad);

var _excluded$1L = ["title", "titleId"];

var SvgRobot = function SvgRobot(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 2.174v6H19v1.674h-2.333v6H3.333v-6H1V8.174h2.333v-6h13.334zm-11.66 12h9.986V3.848H5.007v10.326zM8.586 6.01H6.913v2.25h1.673V6.01zm4.395 11.223H7.034v1.673h5.947v-1.673zM11.413 6.01h1.673v2.25h-1.673V6.01zM13 10.424H7v1.673h6v-1.673z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1L = /*#__PURE__*/forwardRef(SvgRobot);

var _excluded$1K = ["title", "titleId"];

var SvgRocketShip = function SvgRocketShip(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.718 14.491-.787-2.44h.002l-.3-.128a12.164 12.164 0 0 1-.227 2.218l1.312.35zm-3.59 1.41-1.284-.378v-2.837H9.165v2.895l-1.3.342a11.078 11.078 0 0 1-.081-8.208h4.449a11.17 11.17 0 0 1-.106 8.187zm-.615-9.863a15.912 15.912 0 0 0-1.5-2.414h-.006a17.707 17.707 0 0 0-1.494 2.414h3zm-6.444 6.013-.787 2.44 1.306-.348a12.335 12.335 0 0 1-.231-2.216l-.288.124zm11.223-1.241 1.965 6.09-4.283-1.139c-.177.52-.387 1.027-.627 1.52l-.31.638-2.194-.648V19H9.166v-1.688l-2.229.586-.3-.623a13.28 13.28 0 0 1-.618-1.514L1.743 16.9l1.96-6.088 1.763-.759a16.688 16.688 0 0 1 3.763-8.166l.7-.887.671.7a16.758 16.758 0 0 1 3.917 8.346l1.775.764zm-5.45-.294H9.165V8.878h1.677v1.638z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1K = /*#__PURE__*/forwardRef(SvgRocketShip);

var _excluded$1J = ["title", "titleId"];

var SvgRockingHorse = function SvgRockingHorse(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.053 12.4a7.253 7.253 0 0 1-.8 1.606V7.154h-6.9V5.433a4.365 4.365 0 0 0-3.669-4.311L4.7.96l-3.566 3.9v4H4.13v5.264a7.312 7.312 0 0 1-.883-1.725H1.5a8.984 8.984 0 0 0 17.3 0h-1.747zM2.794 7.2V5.5l2.527-2.758.094.015A2.713 2.713 0 0 1 7.7 5.435V8.81h6.9v6.97c-.58.446-1.222.801-1.907 1.055V12.4H7.69v4.459a7.287 7.287 0 0 1-1.9-1.02v-8.64H2.794zm6.553 10.045v-3.183h1.68v3.174c-.29.037-.584.056-.877.058a7.328 7.328 0 0 1-.803-.05z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1J = /*#__PURE__*/forwardRef(SvgRockingHorse);

var _excluded$1I = ["title", "titleId"];

var SvgRollOverFunds = function SvgRollOverFunds(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.061 7.885h-4.95v-1.67h2.222a7.34 7.34 0 1 0 1.06 3.794h1.668A8.993 8.993 0 1 1 17.394 4.8V2.935h1.667v4.95zm-8.999-.235h-.001.002zm.56.215a.788.788 0 0 0-.56-.215.765.765 0 1 0 0 1.527A2.427 2.427 0 0 1 10.9 13.9v.87H9.227v-.87a2.44 2.44 0 0 1-1.645-2.289h1.67a.766.766 0 1 0 .809-.763 2.427 2.427 0 0 1-.834-4.724v-.87H10.9v.871a2.439 2.439 0 0 1 1.64 2.288h-1.671a.788.788 0 0 0-.247-.548z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1I = /*#__PURE__*/forwardRef(SvgRollOverFunds);

var _excluded$1H = ["title", "titleId"];

var SvgRollOverPlan = function SvgRollOverPlan(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.445 2.935h1.666v4.95h-4.949v-1.67h2.221a7.343 7.343 0 1 0 1.062 3.794h1.666a8.994 8.994 0 1 1-1.666-5.21V2.936zM12.12 6.218H8.122v1.667h3.998V6.218zm-7.009 8.388h10V8.28h-10v6.325zm1.667-4.658h6.667v2.99H6.778v-2.99z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1H = /*#__PURE__*/forwardRef(SvgRollOverPlan);

var _excluded$1G = ["title", "titleId"];

var SvgRoosterBank = function SvgRoosterBank(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rooster_bank_svg__Layer_6",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.rooster_bank_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "rooster_bank_svg__st0",
    d: "M16.049 7.4a2.955 2.955 0 0 0-2.949 2.9h-1.42c-2.534 0-2.534-1-2.534-1.532 0-.428-.096-.85-.28-1.236h2.749V6.7c0-1.08-.289-3.571-2.919-3.678V1H7.374a4.045 4.045 0 0 0-4.042 4.039l-.015 3.044A3.212 3.212 0 0 0 1 11.129v1.548h2.019a2.123 2.123 0 0 0-.155 2.134A2.166 2.166 0 0 0 4.533 16c.678 1.518 2.383 3 5.373 3h.1c4.362 0 6.574-2.582 6.574-7.675V10.3h-1.82a1.288 1.288 0 0 1 2.575.049v2.828h1.666v-2.828A2.956 2.956 0 0 0 16.049 7.4zM5 5.043a2.379 2.379 0 0 1 2.03-2.351v1.992h1.49c.418 0 1.136.01 1.36 1.181H6.239a2.89 2.89 0 0 0-1.246.278L5 5.043zm.308 8.975a.512.512 0 0 1-.912.048c-.147-.3.179-.692.5-.973.304.289.521.62.411.925h.001zm9.6-2.052c-.154 3.7-1.682 5.364-4.895 5.364h-.1a4.042 4.042 0 0 1-3.723-1.756c.332-.249.584-.589.725-.979.238-.66.359-1.962-1.5-3.27l-.455-.315H2.677a1.551 1.551 0 0 1 1.47-1.38h.834V8.8a1.28 1.28 0 0 1 1.258-1.272c.685 0 1.24.555 1.24 1.24 0 1.459.729 3.2 4.2 3.2l3.229-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rooster_bank_svg__st0",
    d: "M8.982 13.04h3.449v1.667H8.982z"
  }));
};

var ForwardRef$1G = /*#__PURE__*/forwardRef(SvgRoosterBank);

var _excluded$1F = ["title", "titleId"];

var SvgRuler = function SvgRuler(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.633 6.455-1.222 1.222-1.966-1.967-1.18 1.179 1.966 1.969-1.03 1.033-1.1-1.1-1.185 1.177 1.1 1.1-1.032 1.033-1.963-1.964-1.18 1.18 1.966 1.969-1.032 1.033-1.1-1.1L6.492 14.4l1.1 1.1-1.138 1.142-3.09-3.093 10.18-10.187 3.09 3.093zm2.361 0-1.18-1.18-3.09-3.094L13.543 1 1.008 13.547l4.858 4.862.591.59L18.994 6.453v.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1F = /*#__PURE__*/forwardRef(SvgRuler);

var _excluded$1E = ["title", "titleId"];

var SvgSad = function SvgSad(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.087 2.608a9 9 0 0 1 5-1.517 9.01 9.01 0 0 1 9 9 9 9 0 1 1-14-7.483zm.925 13.58a7.334 7.334 0 0 0 4.075 1.236 7.342 7.342 0 0 0 7.333-7.333A7.334 7.334 0 1 0 6.012 16.19zm.383-8.779h1.591V9.09H6.395V7.41zm7.384 0h-1.591V9.09h1.591V7.41zM7.46 11.467a3.733 3.733 0 0 1 2.627-1.114 3.733 3.733 0 0 1 3.7 3.757h-1.681a2.02 2.02 0 1 0-4.038 0H6.387a3.733 3.733 0 0 1 1.073-2.643z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1E = /*#__PURE__*/forwardRef(SvgSad);

var _excluded$1D = ["title", "titleId"];

var SvgSafe = function SvgSafe(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.425 16.143h12.316V2.671H4.425v13.472zM2.758 1h15.65v16.81h-1.983V19h-1.667v-1.19H6.436V19H4.767v-1.188H2.758v-4.386H1.592v-1.669h1.166V6.846H1.592V5.177h1.166V1zm8.845 7.492c-.3-.2-.651-.307-1.011-.307v-.004a1.82 1.82 0 1 0 1.285 3.11 1.819 1.819 0 0 0-.274-2.8zm.919 4.4a3.474 3.474 0 0 1-1.93.586v-.004A3.48 3.48 0 0 1 7.118 10a3.474 3.474 0 1 1 5.404 2.893z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1D = /*#__PURE__*/forwardRef(SvgSafe);

var _excluded$1C = ["title", "titleId"];

var SvgSave1 = function SvgSave1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.173 10.986c-.337 0-.673-.04-1-.121a5.849 5.849 0 0 0-3.037-3.038 4.16 4.16 0 1 1 4.037 3.159zm-6.347 6.347a4.16 4.16 0 1 1 0-8.32 4.16 4.16 0 0 1 0 8.32zM13.173 1a5.833 5.833 0 0 0-5.826 5.827c0 .183.011.366.028.548a5.827 5.827 0 1 0 5.25 5.25c.182.017.365.028.548.028a5.827 5.827 0 1 0 0-11.653z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1C = /*#__PURE__*/forwardRef(SvgSave1);

var _excluded$1B = ["title", "titleId"];

var SvgSave2 = function SvgSave2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.405 1.007h9.178v1.667H9.405V1.007zm0 3.555h9.178v1.667H9.405V4.562zm1.832 5.22h7.346V8.118H9.47a6.602 6.602 0 0 1 1.767 1.666zm-2.048-.447a5.365 5.365 0 1 1-6.452 8.573A5.365 5.365 0 0 1 9.19 9.335zM3.896 16.7a3.71 3.71 0 1 0 4.122-6.168A3.71 3.71 0 0 0 3.896 16.7z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1B = /*#__PURE__*/forwardRef(SvgSave2);

var _excluded$1A = ["title", "titleId"];

var SvgSaveFile = function SvgSaveFile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 1h11.095l4.571 4.565V19H2.167V1zm1.669 16.33h12.326l.002-11.07-3.59-3.59H3.836v14.66zM9.162 5.091h1.677v6.956l2.831-2.832 1.186 1.186-4.859 4.859-4.853-4.853L6.33 9.221l2.832 2.832V5.091z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1A = /*#__PURE__*/forwardRef(SvgSaveFile);

var _excluded$1z = ["title", "titleId"];

var SvgScale = function SvgScale(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.067 18.989v-18h18v18h-18zm9.833-1.666h6.5V2.656H2.73v14.667h6.5v-3.765h1.67v3.765zm1.425-10c-.6-.6-1.41-.939-2.258-.943a3.214 3.214 0 0 0-3.2 3.2H5.2a4.867 4.867 0 0 1 9.733 0h-1.666a3.218 3.218 0 0 0-.942-2.258z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1z = /*#__PURE__*/forwardRef(SvgScale);

var _excluded$1y = ["title", "titleId"];

var SvgScheduleView = function SvgScheduleView(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 1v4.667h18V1H1zm16.335 3H2.665V2.667h14.67V4zM1 19h18v-4.667H1V19zm1.665-3h14.67v1.333H2.665V16zM19 12.333H1V7.667h18v4.666zm-1.665-3H2.665v1.334h14.67V9.333z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1y = /*#__PURE__*/forwardRef(SvgScheduleView);

var _excluded$1x = ["title", "titleId"];

var SvgScissors = function SvgScissors(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.665 14.1a1.618 1.618 0 1 1 3.236 0 1.618 1.618 0 0 1-3.236 0zm0-8.2a1.618 1.618 0 1 1 3.236 0 1.618 1.618 0 0 1-3.236 0zm4.9 8.2a2.62 2.62 0 0 0-.049-.539l2.736-2.735L19 15.658v-1.712L11.953 10 19 6.054V4.342l-8.731 4.807-2.748-2.736c.033-.169.048-.34.045-.513a3.325 3.325 0 1 0-.8 2.122L8.751 10l-1.985 1.978a3.264 3.264 0 1 0 .8 2.122h-.001z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1x = /*#__PURE__*/forwardRef(SvgScissors);

var _excluded$1w = ["title", "titleId"];

var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.441 1a6.544 6.544 0 0 0-5.177 10.561L1 17.821 2.182 19l6.261-6.261A6.552 6.552 0 1 0 12.441 1zm0 11.444a4.889 4.889 0 1 1 0-9.778 4.889 4.889 0 0 1 0 9.778z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1w = /*#__PURE__*/forwardRef(SvgSearch);

var _excluded$1v = ["title", "titleId"];

var SvgShare = function SvgShare(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.285 17.333a1.253 1.253 0 1 1 0-2.507 1.253 1.253 0 0 1 0 2.507zm-10.57-6.094a1.253 1.253 0 1 1 0-2.507 1.253 1.253 0 0 1 0 2.507zm10.57-8.572a1.253 1.253 0 1 1 0 2.506 1.253 1.253 0 0 1 0-2.506zm0 10.494c-.725 0-1.424.271-1.959.76L7.569 10.6c.09-.414.088-.843-.008-1.256l5.724-3.3a2.939 2.939 0 1 0-.837-1.444L6.742 7.89a2.919 2.919 0 1 0 .025 4.17l5.695 3.287a2.918 2.918 0 1 0 2.823-2.186z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1v = /*#__PURE__*/forwardRef(SvgShare);

var _excluded$1u = ["title", "titleId"];

var SvgShoppingCart = function SvgShoppingCart(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m5.136 4.5-.321-2.333L1 2.173v1.666h2.363l1.642 11.115h12.451L19 4.5H5.136zM16 13.287H6.458l-1.093-7.12H17.1l-1.1 7.12zm-8.262 2.562a1.579 1.579 0 1 0 .008 3.157 1.579 1.579 0 0 0-.008-3.157zm6.024.36a1.58 1.58 0 1 1 2.008 2.439 1.58 1.58 0 0 1-2.008-2.439z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1u = /*#__PURE__*/forwardRef(SvgShoppingCart);

var _excluded$1t = ["title", "titleId"];

var SvgShower = function SvgShower(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.729 2.252c.8-.8 1.886-1.25 3.019-1.252a4.277 4.277 0 0 1 4.267 4.271V19H14.35V5.271a2.607 2.607 0 0 0-5.213 0v1.947h3.5v1.665H3.981V7.218h3.495V5.271a4.276 4.276 0 0 1 1.253-3.019zm-2.92 7.706H4.144v2.297h1.665V9.958zm6.656 0H10.8v2.297h1.665V9.958zm-4.989 0h1.665v2.297H7.476V9.958zm4.989 3.316H10.8v2.297h1.665v-2.297zm-8.321-.018h1.665v2.297H4.144v-2.297zm4.997.018H7.476v2.297h1.665v-2.297z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1t = /*#__PURE__*/forwardRef(SvgShower);

var _excluded$1s = ["title", "titleId"];

var SvgSkippingRope = function SvgSkippingRope(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.833 1h-5.057v8.711h1.615v3.507a1.8 1.8 0 1 1-3.6 0V6.8a3.455 3.455 0 0 0-6.909-.021v3.507H2.167V19h5.057v-8.711H5.552V6.782a1.779 1.779 0 0 1 1.777-1.777 1.8 1.8 0 0 1 1.8 1.8v6.415a3.466 3.466 0 0 0 6.931 0V9.711h1.775L17.833 1zM5.557 17.333H3.833v-5.377h1.724v5.377zm10.61-9.289h-1.724V2.667h1.724v5.377z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1s = /*#__PURE__*/forwardRef(SvgSkippingRope);

var _excluded$1r = ["title", "titleId"];

var SvgSleep = function SvgSleep(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.982 3.178-2.726 2.174h2.735v1.667h-4.913V4.957l2.885-2.301h-2.885V.989h4.904v2.189zM3.954 6.78a6.667 6.667 0 0 1 3.704-1.124 6.675 6.675 0 0 1 6.667 6.667A6.667 6.667 0 1 1 3.954 6.78zm.926 9.7a5 5 0 1 0 5.555-8.313A5 5 0 0 0 4.88 16.48zm5.596-6.281H8.883v1.667h1.593v-1.667zm-5.636 0h1.593v1.667H4.84v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1r = /*#__PURE__*/forwardRef(SvgSleep);

var _excluded$1q = ["title", "titleId"];

var SvgSlipperyFloor = function SvgSlipperyFloor(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.14 5.927h-.007a2.051 2.051 0 0 0-1.658 3.226l8.567 8.676L15.856 19l-8.688-8.811a3.756 3.756 0 0 1-.443-.777H1V7.739h5.447a3.65 3.65 0 0 1 .171-.915 2.716 2.716 0 1 1 2.355-2.376c.288-.096.587-.155.89-.178l2.562-2.6 1.194 1.168-1.8 1.826c.323.165.62.377.881.628L15.766 8.4H19v1.665h-3.931l-3.541-3.587a2.01 2.01 0 0 0-1.388-.551zM5.693 5.01a1.05 1.05 0 1 0 1.166-1.746A1.05 1.05 0 0 0 5.693 5.01zM1 17.333h10.896V19H1v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1q = /*#__PURE__*/forwardRef(SvgSlipperyFloor);

var _excluded$1p = ["title", "titleId"];

var SvgSmoking = function SvgSmoking(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.062 7.641h1.667v5.115H1.062V7.641zm2.79 5.051V7.705h15.21v4.987H3.852zm1.667-1.667H17.4V9.372H5.519v1.653z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1p = /*#__PURE__*/forwardRef(SvgSmoking);

var _excluded$1o = ["title", "titleId"];

var SvgSnow = function SvgSnow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m19.123 8.806-1.189-1.189-1.539 1.539h-4.243l2.995-2.995 2.187-.001V4.479h-1.689V2.791l-1.681-.001v2.177L10.96 7.971V3.735l1.546-1.546L11.317 1l-1.194 1.194L8.929 1 7.74 2.189l1.539 1.539v4.236L6.282 4.967V2.79l-1.681.001v1.688H2.912V6.16l2.187.001 2.995 2.995H3.851L2.312 7.617 1.123 8.806 2.317 10l-1.194 1.194 1.189 1.189 1.546-1.546h4.243l-3.002 3.002H2.912v1.682l1.689-.001v1.689l1.681.001v-2.177l2.997-2.997v4.236L7.74 17.811 8.93 19l1.193-1.195L11.317 19l1.189-1.189-1.546-1.546v-4.236l3.004 3.004v2.177l1.681-.001V15.52l1.689.001v-1.682h-2.187l-3.002-3.002h4.243l1.546 1.546 1.189-1.189L17.929 10l1.194-1.194z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1o = /*#__PURE__*/forwardRef(SvgSnow);

var _excluded$1n = ["title", "titleId"];

var SvgSolutions = function SvgSolutions(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.533 1H2.867v8.17H1v1.667h1.867V19h1.666v-8.163h1.863V9.17H4.533V1zm6.3 0H9.167v3.465H7.301v1.667h1.866V19h1.666V6.132h1.865V4.465h-1.865V1zm6.3 0v12.875H19v1.667h-1.867V19h-1.666v-3.458h-1.882v-1.667h1.882V1h1.666z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1n = /*#__PURE__*/forwardRef(SvgSolutions);

var _excluded$1m = ["title", "titleId"];

var SvgSort = function SvgSort(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.695 1v14.769l2.831-2.831 1.186 1.185-4.859 4.859L1 14.129l1.186-1.186 2.832 2.832V1h1.677zm7.452 0L19 5.853l-1.186 1.186-2.832-2.831V19h-1.677V4.213l-2.831 2.832-1.186-1.186L14.147 1z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1m = /*#__PURE__*/forwardRef(SvgSort);

var _excluded$1l = ["title", "titleId"];

var SvgSoundHigh = function SvgSoundHigh(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 13.553V6.445h3.694l5.884-4.26v15.63l-5.827-4.262H1zm7.9.981V5.465L5.236 8.12H2.675v3.758H5.2l3.7 2.656zm3.594-7.665.1.1a4.292 4.292 0 0 1-.002 6.058l-.1.1-1.185-1.185.1-.1a2.613 2.613 0 0 0 0-3.69l-.1-.1 1.187-1.183zm1.856-1.657-.1-.1L13.063 6.3l.1.1a5.1 5.1 0 0 1 0 7.2l-.1.1 1.185 1.185.1-.1a6.777 6.777 0 0 0 0-9.574l.002.001zm1.926-2.455.1.12a10.976 10.976 0 0 1 .004 14.24l-.1.12-1.48-1.48.1-.1a8.013 8.013 0 0 0 0-11.319l-.1-.1 1.476-1.48z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1l = /*#__PURE__*/forwardRef(SvgSoundHigh);

var _excluded$1k = ["title", "titleId"];

var SvgSoundLow = function SvgSoundLow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.333 13.542V6.456h3.682l5.867-4.247v15.582l-5.81-4.249H3.333zm7.879.978V5.479L7.556 8.126H5v3.746h2.523l3.689 2.648zm3.579-7.642.1.1a4.279 4.279 0 0 1-.001 6.04l-.1.1-1.182-1.181.1-.1a2.601 2.601 0 0 0 0-3.679l-.1-.1 1.183-1.18z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1k = /*#__PURE__*/forwardRef(SvgSoundLow);

var _excluded$1j = ["title", "titleId"];

var SvgSoundMedium = function SvgSoundMedium(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.167 6.456v7.086h3.739l5.809 4.249V2.209L5.849 6.456H2.167zm7.879-.977v9.041l-3.69-2.648h-2.52V8.126H6.39l3.656-2.647zm3.679 1.499-.1-.1-1.183 1.18.1.1a2.6 2.6 0 0 1 0 3.679l-.1.1 1.181 1.181.1-.1a4.28 4.28 0 0 0 .002-6.04zm1.651-1.851.1.1-.002-.003a6.757 6.757 0 0 1 0 9.544l-.1.1-1.181-1.181.1-.1a5.084 5.084 0 0 0 0-7.18l-.1-.1 1.183-1.18z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1j = /*#__PURE__*/forwardRef(SvgSoundMedium);

var _excluded$1i = ["title", "titleId"];

var SvgSpeechBubbles = function SvgSpeechBubbles(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.794 8.205A6.419 6.419 0 1 0 1 7.455v6.42h6.421c.275 0 .549-.02.821-.056a5.387 5.387 0 0 0 5.373 5.147H19V13.58a5.388 5.388 0 0 0-5.206-5.376zm-5.35 3.888a4.725 4.725 0 0 1-1.023.113H2.669V7.455a4.753 4.753 0 0 1 8.594-2.816 4.753 4.753 0 0 1 .806 3.785 5.401 5.401 0 0 0-3.625 3.669zm8.887 5.2h-3.716a3.716 3.716 0 1 1 3.716-3.716v3.716z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1i = /*#__PURE__*/forwardRef(SvgSpeechBubbles);

var _excluded$1h = ["title", "titleId"];

var SvgSpellCheck = function SvgSpellCheck(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.135 11.984h-1.814L8.787 8.361H4.356l-1.541 3.623H1L5.67 1h1.815l4.65 10.984zM6.576 3.139 5.066 6.69H8.08L6.576 3.139zM17.82 8.97l1.181 1.181-7.665 7.665.003.003L10.158 19 5.27 14.112l1.181-1.181 3.704 3.703L17.82 8.97z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1h = /*#__PURE__*/forwardRef(SvgSpellCheck);

var _excluded$1g = ["title", "titleId"];

var SvgSports = function SvgSports(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.027A8.98 8.98 0 1 0 18.98 10 8.987 8.987 0 0 0 10 1.027zm6.62 5.886L13.733 7.96l-2.9-2.113V2.74a7.333 7.333 0 0 1 5.794 4.167l-.007.006zm-8.253 5.414L7.333 9.22 10 7.333l2.667 1.92-1.014 3.107-3.286-.033zm.8-9.587v3.107L6.187 8 3.373 6.92a7.333 7.333 0 0 1 5.794-4.18zM2.667 10c0-.504.05-1.006.153-1.5l2.893 1.12 1.1 3.387L5.1 15.42A7.295 7.295 0 0 1 2.667 10zm3.766 6.387L8.187 14h3.593l1.767 2.4a7.287 7.287 0 0 1-7.087 0l-.027-.013zm8.447-.967-1.747-2.373L14.28 9.52l2.853-1.04a7.334 7.334 0 0 1-2.253 6.934v.006z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1g = /*#__PURE__*/forwardRef(SvgSports);

var _excluded$1f = ["title", "titleId"];

var SvgSpotlight = function SvgSpotlight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.81 2.131-3.456 3.457 1.178 1.178 3.456-3.457-1.178-1.178zM7.324 6.25l4.081-2.575V3.3h1.669v13.332h-1.669v-.378l-4.061-2.562-6.355.037v-7.48h2.363V2.133h1.666v4.117h2.306zm.505 5.775 3.576 2.257.001-8.632-3.6 2.27H5.018v2.046H3.355V7.92h-.7v4.09l5.174.014zm6.525 2.31 1.178-1.178 3.456 3.456-1.178 1.178-3.456-3.456zm.413-5.184h4.221v1.666h-4.221V9.15z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1f = /*#__PURE__*/forwardRef(SvgSpotlight);

var _excluded$1e = ["title", "titleId"];

var SvgSprinklerSystem = function SvgSprinklerSystem(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.166 2.167h1.667v3.667H9.166V2.167zm2.372 3.684 1.197-2.782 1.531.66-1.197 2.78-1.531-.658zm3.808.325-1.716.683.617 1.55 1.716-.684-.617-1.549zM4.192 7.724l.617-1.549 1.716.684-.617 1.548-1.716-.683zm3.073-4.655-1.532.659 1.198 2.781 1.53-.659L7.266 3.07zm6.012 9.147v2.728H19v1.723h-7.446v-4.451H8.445v4.451H1v-1.723h5.723v-2.728H5.572v-1.723h3.566V9.257H6.934V7.534h6.132v1.723h-2.205v1.236h3.567v1.723h-1.151z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1e = /*#__PURE__*/forwardRef(SvgSprinklerSystem);

var _excluded$1d = ["title", "titleId"];

var SvgStage = function SvgStage(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.95 17.3v-3.448a2.838 2.838 0 0 0-5.675 0V17.3H4.657v-6.4l5.456-5.46 5.455 5.46v6.4H12.95zm-1.665 0H8.94v-3.448a1.173 1.173 0 0 1 2.345 0V17.3zm5.949 0v-7.087L10.947 4V2.635H13.1V.965h-2.353L9.29.96l-.01 3.033-6.29 6.212V17.3H1.12v1.666h17.987V17.3h-1.872z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1d = /*#__PURE__*/forwardRef(SvgStage);

var _excluded$1c = ["title", "titleId"];

var SvgStairsUp = function SvgStairsUp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.479 1.021v5.666H6.75v5.709H1v6.583h1.667v-4.917h5.75V8.354h5.729V2.687H19V1.021h-6.521z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1c = /*#__PURE__*/forwardRef(SvgStairsUp);

var _excluded$1b = ["title", "titleId"];

var SvgStar = function SvgStar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10 13.291-3.351 1.753.637-3.722L4.6 8.7l3.7-.542 1.684-3.411 1.727 3.412L15.4 8.7l-2.691 2.623.637 3.722L10 13.291zm9-5.76-6.187-.9L9.965 1 7.188 6.627 1 7.531l4.487 4.376L4.428 18.1 10 15.181l5.571 2.919-1.058-6.19L19 7.531z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1b = /*#__PURE__*/forwardRef(SvgStar);

var _excluded$1a = ["title", "titleId"];

var SvgStatement = function SvgStatement(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 3.451v13.1h18v-13.1H1zm16.333 11.431H2.667V5.118h14.666v9.764zM7.935 7.547H4.769v1.667h3.166V7.547zm2.162 1.668h1.667v3.377h-1.667V9.215zm-2.162 1.558H4.769v1.667h3.166v-1.667zm5.421-3.37h1.667v5.19h-1.667v-5.19z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$1a = /*#__PURE__*/forwardRef(SvgStatement);

var _excluded$19 = ["title", "titleId"];

var SvgStephoscope = function SvgStephoscope(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$19);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.945 11.388a2.844 2.844 0 1 0-3.769 2.684 4.216 4.216 0 0 1-4.09 3.25 4.195 4.195 0 0 1-4.188-4.2v-1.561c.083-.01.166-.015.249-.027l.063-.011a5.133 5.133 0 0 0 4-4.98V.989H7.7v1.667h1.84v3.887a3.457 3.457 0 0 1-2.66 3.346c-.26.036-.523.054-.785.054a4.307 4.307 0 0 1-.677-.043 3.456 3.456 0 0 1-2.725-3.36V2.657h1.78V.989H1.026v5.553a5.127 5.127 0 0 0 4.046 4.983c.014 0 .07.014.158.027v1.569a5.856 5.856 0 0 0 5.86 5.868 5.883 5.883 0 0 0 5.77-4.865 2.844 2.844 0 0 0 2.084-2.736zM16.1 12.563a1.176 1.176 0 1 1-.002-2.352 1.176 1.176 0 0 1 .002 2.352z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$19 = /*#__PURE__*/forwardRef(SvgStephoscope);

var _excluded$18 = ["title", "titleId"];

var SvgStorage = function SvgStorage(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$18);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 7.548V2.167h18v5.381h-1.8v10.285H2.757V7.548H1zm3.424 8.619h11.11V7.552H4.424v8.615zM2.667 5.882h14.667l-.001-2.048H2.667v2.048zm4.679 2.901h5.307v1.667H7.346V8.783z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$18 = /*#__PURE__*/forwardRef(SvgStorage);

var _excluded$17 = ["title", "titleId"];

var SvgSunny = function SvgSunny(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$17);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.814 1H9.147v3.273h1.667V1zM4.225 3.048 3.047 4.226 5.361 6.54l1.178-1.178-2.314-2.314zM10.028 5.2a4.775 4.775 0 1 0-.006 9.55 4.775 4.775 0 0 0 .006-9.55zm0 7.883a3.108 3.108 0 1 1 .002-6.218 3.108 3.108 0 0 1-.002 6.219v-.001zM4.272 9.168H1v1.667h3.272V9.168zm11.456 0H19v1.667h-3.272V9.168zm-2.267 5.474 1.179-1.178 2.313 2.313-1.178 1.178-2.314-2.313zm-4.314 1.085h1.667V19H9.147v-3.273zm6.608-12.68L13.44 5.362 14.62 6.54l2.314-2.315-1.178-1.177zM3.026 15.774l2.315-2.314 1.178 1.178-2.314 2.314-1.179-1.178z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$17 = /*#__PURE__*/forwardRef(SvgSunny);

var _excluded$16 = ["title", "titleId"];

var SvgSurprised = function SvgSurprised(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$16);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.965 2.608a9 9 0 0 1 5-1.517 9.01 9.01 0 0 1 9 9 9 9 0 1 1-14-7.483zm.926 13.58a7.334 7.334 0 0 0 4.074 1.236 7.342 7.342 0 0 0 7.335-7.333 7.334 7.334 0 1 0-11.41 6.097zm2.463-5.568a2.878 2.878 0 0 1 1.611-.464 2.86 2.86 0 0 1 2.835 2.878 2.877 2.877 0 1 1-4.446-2.414zm.933 3.43a1.2 1.2 0 0 0 .678.181 1.182 1.182 0 0 0 1.076-.747c.057-.144.085-.298.082-.453a1.2 1.2 0 1 0-1.836 1.019zM7.864 5.882H6.273v1.681h1.591v-1.68zm4.202 0h1.59v1.681h-1.59v-1.68z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$16 = /*#__PURE__*/forwardRef(SvgSurprised);

var _excluded$15 = ["title", "titleId"];

var SvgSwimmingPool = function SvgSwimmingPool(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$15);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.774 15.438a3.268 3.268 0 0 0-2.493-1.25l-.005-.667V1H13.61v3.415H6.337V1H4.671v14.5c.01.441.01.671.01.671a1.637 1.637 0 0 1-1.275-.719A3.15 3.15 0 0 0 1 14.2v1.666c.5 0 .775.269 1.175.708A3.091 3.091 0 0 0 4.6 17.833a3.1 3.1 0 0 0 2.423-1.263l.2-.223c.225-.253.529-.423.862-.483h.1c.506 0 .738.23 1.174.708a3.015 3.015 0 0 0 2.367 1.252h.044a3.1 3.1 0 0 0 2.43-1.263l.2-.223c.222-.257.528-.428.863-.483h.1c.507 0 .739.229 1.176.708A3.199 3.199 0 0 0 19 17.814v-1.667c-.495 0-.789-.229-1.226-.709zM13.61 6.081v3.526H6.337V6.081h7.273zm-.641 9.358c-.442.485-.678.718-1.194.718h-.044c-.469 0-.687-.218-1.136-.71A3.066 3.066 0 0 0 8.19 14.2h-.112c-.6-.005-1.18.21-1.631.607-.038.032-.073.068-.11.1v-3.634h7.273v3.537a5.747 5.747 0 0 0-.4.365l-.241.264z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$15 = /*#__PURE__*/forwardRef(SvgSwimmingPool);

var _excluded$14 = ["title", "titleId"];

var SvgSwitch = function SvgSwitch(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$14);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.236 3.5 7.912 2.178 9.09 1l3.5 3.5L9.09 8 7.912 6.822l1.669-1.669a5.61 5.61 0 0 0-5.4 5.6v3.453a2.452 2.452 0 1 1-1.667.073v-3.528A7.282 7.282 0 0 1 9.236 3.5zM3.459 17.333a.79.79 0 0 0 .552-1.341.785.785 0 1 0-.552 1.341zm7.942-3.096 1.182 1.175-1.196 1.203 1.203 1.196-1.175 1.182-1.203-1.196L9.016 19l-1.182-1.175 1.196-1.203-1.203-1.196 1.175-1.182 1.203 1.196 1.196-1.203zm7.523 1.175-1.182-1.175-1.196 1.203-1.203-1.196-1.176 1.182 1.204 1.196-1.197 1.203L15.356 19l1.196-1.203 1.204 1.196 1.175-1.182-1.203-1.196 1.196-1.203zm-1.013-9.046c-.402.27-.874.414-1.358.416v.004a2.451 2.451 0 1 1 2.397-2.933 2.453 2.453 0 0 1-1.04 2.513zm-1.363-2.822a.786.786 0 0 0-.555.23h.005a.787.787 0 0 0 .559 1.341.773.773 0 0 0 .718-.484.787.787 0 0 0-.726-1.087z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$14 = /*#__PURE__*/forwardRef(SvgSwitch);

var _excluded$13 = ["title", "titleId"];

var SvgSyringe = function SvgSyringe(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$13);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.721 5.753 1.18-1.183L15.3.989l-1.178 1.183 1.212 1.21-1.386 1.384-1.575-1.576-.766-.767L10.43 3.6l.767.768-9.22 9.232 1.564 1.579-2.616 2.637 1.183 1.173 2.6-2.625L6.4 18.076l9.231-9.261.772.773 1.183-1.178-.775-.776-1.684-1.69 1.391-1.387 1.203 1.196zM6.41 15.71 4.325 13.6l8.048-8.054 2.084 2.086L6.41 15.71z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$13 = /*#__PURE__*/forwardRef(SvgSyringe);

var _excluded$12 = ["title", "titleId"];

var SvgTable = function SvgTable(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$12);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.133 3.867H.866v2h18.267v-2zM5.6 9H.867v2H5.6V9zm2.067 0H12.4v2H7.667V9zm11.466 0H14.4v2h4.733V9zM.866 14.133H5.6v2H.867v-2zm11.534 0H7.667v2H12.4v-2zm2 0h4.733v2H14.4v-2z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$12 = /*#__PURE__*/forwardRef(SvgTable);

var _excluded$11 = ["title", "titleId"];

var SvgTablet = function SvgTablet(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$11);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.705 18.953v-18h14.388v18H2.705zm1.663-1.664H15.43V2.616H4.368V17.29zm4.524-3.308h2.014v1.663H8.892v-1.663z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$11 = /*#__PURE__*/forwardRef(SvgTablet);

var _excluded$10 = ["title", "titleId"];

var SvgTalking = function SvgTalking(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$10);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.694 5.603c.412.935.635 1.942.656 2.964l.002.054 2.168 4.162H9.357v4.38h-3.1V19h-1.67v-3.5h3.1v-4.384h1.084L7.696 9.049l-.012-.438a6.064 6.064 0 0 0-6.257-5.943c-.121.003-.24.014-.36.026L1 2.7V1.029l.136-.012C1.218 1.008 1.3 1 1.384 1a7.727 7.727 0 0 1 7.31 4.603zm8.186 1.56L15.71 8.35a5.068 5.068 0 0 1 0 7.336l1.17 1.188a6.739 6.739 0 0 0 0-9.712zm-2.425 1.573zm0 0a4.566 4.566 0 0 1 0 6.565l-1.17-1.186a2.9 2.9 0 0 0 0-4.192l1.17-1.187z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$10 = /*#__PURE__*/forwardRef(SvgTalking);

var _excluded$$ = ["title", "titleId"];

var SvgTarget = function SvgTarget(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.55 2.483.009-1.473-1.667-.009-.011 1.955L8.473 10.4l.012.012 1.169 1.164.004-.005 7.389-7.424 1.966.011.009-1.666-1.472-.009zM15.9 6.89a7 7 0 1 1-2.832-2.7L14.3 2.966a8.62 8.62 0 1 0 2.818 2.707L15.9 6.89zm-5.824.293a2.934 2.934 0 0 0-.376-.019 3.22 3.22 0 1 0 3.279 3.166 3.086 3.086 0 0 0-.046-.466l1.334-1.338a4.914 4.914 0 1 1-2.815-2.719l-1.376 1.376z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$$ = /*#__PURE__*/forwardRef(SvgTarget);

var _excluded$_ = ["title", "titleId"];

var SvgTeeth = function SvgTeeth(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.686 2.353a4.351 4.351 0 0 0-6.33 0L10 2.684l-.319-.33a4.352 4.352 0 0 0-6.326 0 4.645 4.645 0 0 0-1.24 3.68l2.259 12.955 5.636-4.575 5.663 4.575L17.9 6.22l.013-.206a4.645 4.645 0 0 0-1.227-3.66zm-.429 3.49-1.737 10.1-4.512-3.683-4.481 3.683L3.77 5.831a2.98 2.98 0 0 1 .9-2.436 2.689 2.689 0 0 1 3.807.105l1.461 1.52 1.57-1.46.062-.06c.034-.036.069-.07.105-.1a2.688 2.688 0 0 1 3.8.1 2.981 2.981 0 0 1 .782 2.342z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$_ = /*#__PURE__*/forwardRef(SvgTeeth);

var _excluded$Z = ["title", "titleId"];

var SvgTennis = function SvgTennis(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.355 10.785-.815.815a5.576 5.576 0 0 1-3.334 1.6L7.16 14l-4.979 5L1 17.826l4.982-5.005.8-6.042a5.563 5.563 0 0 1 1.6-3.33l.816-.815a5.643 5.643 0 0 1 7.957 0l.2.2a5.631 5.631 0 0 1 0 7.95zm-9.433.085-.182 1.376 1.381-.182a5.429 5.429 0 0 1-.534-.464l-.2-.195a5.714 5.714 0 0 1-.465-.535zm4.64.706c.132 0 .263-.007.393-.02l.007-.007a3.92 3.92 0 0 0 2.4-1.132l.816-.815a3.969 3.969 0 0 0 0-5.6l-.2-.194a3.976 3.976 0 0 0-5.6 0l-.816.815a3.969 3.969 0 0 0 0 5.6l.2.2a3.934 3.934 0 0 0 2.8 1.153zm2.21 2.453a2.716 2.716 0 1 1 3.023 4.513 2.716 2.716 0 0 1-3.022-4.513zm.925 3.13a1.051 1.051 0 1 0 1.17-1.747 1.051 1.051 0 0 0-1.17 1.747z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$Z = /*#__PURE__*/forwardRef(SvgTennis);

var _excluded$Y = ["title", "titleId"];

var SvgTheatre = function SvgTheatre(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.13 16.13a4.1 4.1 0 0 0 1.2-2.9V7.5h-8.2v5.73a4.1 4.1 0 0 0 7 2.9zM3.861 11.227a4.074 4.074 0 0 0 2.877 1.19c.242 0 .483-.02.721-.06v-2.03a.865.865 0 0 0-1.729 0H4.06a2.51 2.51 0 0 1 3.4-2.365V5.838h3.407V2.626h-8.2v5.727a4.074 4.074 0 0 0 1.195 2.875zm8.677-8.602v3.212H19v7.392a5.768 5.768 0 0 1-11.476.8A5.753 5.753 0 0 1 1 8.353V.96h11.539v1.665zm2.572 12.524a2.532 2.532 0 0 1-4.32-1.787h1.667a.865.865 0 0 0 1.729 0h1.667a2.533 2.533 0 0 1-.743 1.787z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$Y = /*#__PURE__*/forwardRef(SvgTheatre);

var _excluded$X = ["title", "titleId"];

var SvgThermometer = function SvgThermometer(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.153 1.966a3.331 3.331 0 0 0-4.712 0l-9.47 9.473v3.54l-2.844 2.833 1.18 1.177 2.848-2.838h3.522l9.476-9.471a3.34 3.34 0 0 0 0-4.714zM4.8 15.338l-.021-.021H4.8v.02zM16.974 5.5l-1.841 1.843-1.328-1.295-1.164 1.193 1.313 1.28-1.538 1.538-1.37-1.336-1.164 1.193 1.355 1.322-3.25 3.248h-2.35v-2.358l8.982-8.984a1.663 1.663 0 0 1 2.842 1.178c0 .442-.175.865-.487 1.178z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$X = /*#__PURE__*/forwardRef(SvgThermometer);

var _excluded$W = ["title", "titleId"];

var SvgThrowRubbish = function SvgThrowRubbish(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.423 10.1h2.3v1.673H8.745L5.99 9.08v9.936H4.32V6.736a2.919 2.919 0 1 1 1.673.013l3.43 3.35zm-5.11-5.263c.231.232.545.362.872.363h.005a1.235 1.235 0 1 0-.877-.363zm11.973 7.938v4.572h-4.593v-4.572h-1.67v6.242h7.932v-6.242h-1.669zm-1.301 0h-1.966v1.67h1.966v-1.67z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$W = /*#__PURE__*/forwardRef(SvgThrowRubbish);

var _excluded$V = ["title", "titleId"];

var SvgThunderstorm = function SvgThunderstorm(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.42 5.026h-.22a4.642 4.642 0 0 0-8.93-1.062A3.792 3.792 0 0 0 2.933 6.64a2.846 2.846 0 0 0 .916 5.542H8.8l-3.891 3.893h5.2l-1.746 1.746L9.542 19l4.59-4.59h-5.2l2.227-2.227h4.261a3.577 3.577 0 0 0 3.36-4.962 3.579 3.579 0 0 0-3.36-2.195zm0 5.49H3.849a1.183 1.183 0 0 1-1.182-1.181 1.2 1.2 0 0 1 1.06-1.174l.648-.072.086-.647a2.112 2.112 0 0 1 2.33-1.81l.743.084.164-.73a2.976 2.976 0 0 1 5.878.658v1.049h1.844a1.911 1.911 0 1 1 0 3.823z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$V = /*#__PURE__*/forwardRef(SvgThunderstorm);

var _excluded$U = ["title", "titleId"];

var SvgTimeline = function SvgTimeline(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.141 5.144 12.955 6.33l2.832 2.831H2.669V6.309H1v7.372h1.669v-2.843h13.124l-2.832 2.832 1.186 1.186L19 10.003l-4.859-4.859z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$U = /*#__PURE__*/forwardRef(SvgTimeline);

var _excluded$T = ["title", "titleId"];

var SvgToilets = function SvgToilets(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.498 4.147a.7.7 0 1 0 1.164.778.7.7 0 0 0-1.164-.778zm2.948.545a2.37 2.37 0 0 1-.43 1.208L19 14.693h-2.5v3.144h-1.674v-4.813h1.85l-2.095-6.17a2.377 2.377 0 0 1-.973.006l-2.082 6.164h1.843v4.813H11.7v-3.144H9.2l2.963-8.772a2.37 2.37 0 1 1 4.283-1.23zM5.133 3.953a.7.7 0 1 0-.778 1.164.7.7 0 0 0 .778-1.164zm1.94 1.022a2.37 2.37 0 0 1-.629 1.208A3.7 3.7 0 0 1 8.39 9.44v5.235H7.025v3.162H5.357v-4.83h1.365V9.44a2.027 2.027 0 0 0-4.054 0v3.59h1.258v4.8H2.258V14.7H1V9.44a3.671 3.671 0 0 1 1.082-2.613c.273-.272.587-.501.931-.677a2.37 2.37 0 1 1 4.06-1.176z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$T = /*#__PURE__*/forwardRef(SvgToilets);

var _excluded$S = ["title", "titleId"];

var SvgTombstone = function SvgTombstone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.673 7.488h6.654v1.667H6.673V7.488zm1.251 2.822h4.151v1.667H7.924V10.31zM.999 17.334h18.002v1.667H.999v-1.667zm15.668.735H15V7.666a5 5 0 0 0-10 0v10.4H3.333v-10.4a6.667 6.667 0 1 1 13.334 0v10.403z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$S = /*#__PURE__*/forwardRef(SvgTombstone);

var _excluded$R = ["title", "titleId"];

var SvgTool = function SvgTool(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10.522 9.434 6.124 6.131-1.074 1.077-6.136-6.122 1.086-1.086zm-6.3-5.211-.328.065-.728-1.081.034-.036 1.082.723-.065.329h.005zM10.5 7.07 9.377 8.2 5.851 4.662l.307-1.55L2.983 1 1 2.989l2.109 3.172 1.55-.307 3.527 3.533L7.075 10.5l8.5 8.5L19 15.568l-8.5-8.5v.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$R = /*#__PURE__*/forwardRef(SvgTool);

var _excluded$Q = ["title", "titleId"];

var SvgTool2 = function SvgTool2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m8.116 1 1.144.458a5.187 5.187 0 0 1 3.275 4.835 5.248 5.248 0 0 1-2.814 4.627V19H4.93v-8.08a5.248 5.248 0 0 1-2.814-4.627A5.185 5.185 0 0 1 5.389 1.46L6.532 1v5.094l.792.457.792-.457V1zm-.061 8.805L8.59 9.6a3.562 3.562 0 0 0 2.274-3.307A3.527 3.527 0 0 0 9.779 3.74v3.316L7.32 8.476l-2.459-1.42V3.739a3.545 3.545 0 0 0 1.2 5.861l.539.208v7.523h1.455V9.805zm8.266-3.483v3.184h1.563V19h-4.791V9.506h1.567V6.332l-1.411-1.485.7-3.847h3.087l.636 3.835-1.351 1.487zm-.697-3.655h-.286l-.297 1.646.438.462.421-.464-.276-1.644zm-.865 14.666h1.458v-6.161h-1.458v6.161z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$Q = /*#__PURE__*/forwardRef(SvgTool2);

var _excluded$P = ["title", "titleId"];

var SvgTop = function SvgTop(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M12.5 12 10 9.4 7.5 12 6 10.5l4-3.9 4 3.9z"
  }));
};

var ForwardRef$P = /*#__PURE__*/forwardRef(SvgTop);

var _excluded$O = ["title", "titleId"];

var SvgTopLeft = function SvgTopLeft(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m2.669 3.849 15.152 15.152 1.178-1.178L3.842 2.666h8.24V.999H1.001l.006 11.082 1.666-.001-.004-8.231z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$O = /*#__PURE__*/forwardRef(SvgTopLeft);

var _excluded$N = ["title", "titleId"];

var SvgTopRight = function SvgTopRight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.331 3.849 2.179 19.001l-1.178-1.178L16.158 2.666h-8.24V.999h11.081l-.006 11.082-1.666-.001.004-8.231z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$N = /*#__PURE__*/forwardRef(SvgTopRight);

var _excluded$M = ["title", "titleId"];

var SvgTouch = function SvgTouch(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.291 6.142c0 .13.008.261.023.39v3.419a5.141 5.141 0 1 1 6.908-.005V6.512a3.476 3.476 0 1 0-6.931-.37zM12.22 8.6v1.6l4.447 4.447V19H15v-3.662l-2.78-2.782v.917h-1.667v-7.02a.785.785 0 1 0-1.57 0v10.99l-3.324-3.17a.705.705 0 0 0-1-.012.7.7 0 0 0 0 .982l2.558 2.584L6.033 19l-2.549-2.581a2.362 2.362 0 0 1 3.342-3.338l.494.47v-7.1a2.452 2.452 0 0 1 4.9 0V8.6z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$M = /*#__PURE__*/forwardRef(SvgTouch);

var _excluded$L = ["title", "titleId"];

var SvgTractor = function SvgTractor(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.673 10.286V8.045h-1.251L14.792 1H5.218l-.31 3.8h-.743V2.164H2.5v4.3h2.272l-.129 1.581h-1.3v2.241H1V19h4.008v-2.669h10V19H19v-8.714h-2.327zM6.754 2.667h6.514l.481 5.378H6.315l.439-5.378zM3.342 17.333h-.675v-5.381h.675v5.381zm1.666-2.669V9.712h10v4.952h-10zm12.325 2.669h-.66v-5.381h.66v5.381zm-9.23-5.973H6.448v1.657h1.655V11.36zm3.785 0h1.655v1.657h-1.655V11.36z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$L = /*#__PURE__*/forwardRef(SvgTractor);

var _excluded$K = ["title", "titleId"];

var SvgTrain = function SvgTrain(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.384 1H2.607v14.776H5.95l-2.046 2.046L5.083 19l3.223-3.224h3.359L14.888 19l1.178-1.178-2.046-2.046h3.364V1zm-1.666 13.111H4.273v-4.89h11.445v4.89zm0-6.556H4.273V2.666h11.445v4.889zm-8.452 3.43H5.6v1.683h1.666v-1.683zm5.385 0h1.666v1.683H12.65v-1.683z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$K = /*#__PURE__*/forwardRef(SvgTrain);

var _excluded$J = ["title", "titleId"];

var SvgTraining = function SvgTraining(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.115 2.667H2.667v5.899h7.1v1.667H1V1h10.781v4.095h-1.666V2.667zm7.341 5.602A3.652 3.652 0 0 1 19 11.259v7.74h-1.663v-7.74a2.008 2.008 0 1 0-4.016 0V19h-1.667v-7.736c0-.463.087-.921.258-1.351L8.7 6.7l1.178-1.177 3 3c.101-.09.206-.175.316-.254a2.81 2.81 0 1 1 4.262 0zm-2.769-.879c.189.126.41.194.636.194h.002a1.146 1.146 0 0 0 .439-2.203 1.145 1.145 0 0 0-1.077 2.009z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$J = /*#__PURE__*/forwardRef(SvgTraining);

var _excluded$I = ["title", "titleId"];

var SvgTram = function SvgTram(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 4.148h-5.835V2.667h1.89V1H7.327v1.667h1.838v1.481H3.333v12.519h1.728l-1.155 1.155L5.084 19l2.334-2.333h5.144L14.9 19l1.178-1.178-1.155-1.155h1.748l-.004-12.519zM15 15H5v-3.862h10V15zm0-5.529H5V5.814h10v3.657zM7.884 12.24H6.217v1.684h1.667V12.24zm4.058 0h1.667v1.684h-1.667V12.24z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$I = /*#__PURE__*/forwardRef(SvgTram);

var _excluded$H = ["title", "titleId"];

var SvgTransferOfExistingAssets = function SvgTransferOfExistingAssets(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.921 7.953a6.953 6.953 0 1 0-6.952 6.952 6.961 6.961 0 0 0 6.952-6.952zm-12.241 0a5.29 5.29 0 1 1 10.58-.002 5.29 5.29 0 0 1-10.58.002zm6.12 4.094v-.838a2.127 2.127 0 0 0-.83-4.086.464.464 0 1 1 .463-.465H10.1A2.132 2.132 0 0 0 8.8 4.7v-.842H7.137V4.7a2.128 2.128 0 0 0 .832 4.086.465.465 0 1 1-.465.465H5.841a2.13 2.13 0 0 0 1.3 1.957v.838l1.66.001zm7.318-4.094c0-.551-.055-1.1-.164-1.641v-.005A6.948 6.948 0 1 1 6.323 16a8.211 8.211 0 0 0 2.343.119 5.285 5.285 0 0 0 7.42-7.466 8.03 8.03 0 0 0 .032-.7z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$H = /*#__PURE__*/forwardRef(SvgTransferOfExistingAssets);

var _excluded$G = ["title", "titleId"];

var SvgTransparentInCost = function SvgTransparentInCost(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.368 1.044V3.75H19v15.206H3.8v-2.544H1V1.044h15.368zm-13.7 1.665v12.04H3.8v-11h10.9V2.71H2.668zM14.7 14.747V5.415H5.465v9.332H14.7zM5.465 17.29h11.867V5.412h-.967v11h-10.9v.879zm4.22-5.698a.465.465 0 0 0 .328.136.464.464 0 1 0 0-.93 2.129 2.129 0 0 1-.833-4.088v-.844h1.666v.844a2.13 2.13 0 0 1 1.3 1.959h-1.665a.465.465 0 1 0-.465.465 2.129 2.129 0 0 1 .832 4.089v.839H9.183v-.839a2.133 2.133 0 0 1-1.3-1.96h1.665c0 .124.05.242.137.33z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$G = /*#__PURE__*/forwardRef(SvgTransparentInCost);

var _excluded$F = ["title", "titleId"];

var SvgTree = function SvgTree(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.235 5.054a5.38 5.38 0 0 0-5.38-4.037 5.391 5.391 0 0 0-5.5 4.252 5.531 5.531 0 0 0-3.179 4.99 5.51 5.51 0 0 0 8.045 4.896v3.862h1.667v-3.863a5.512 5.512 0 1 0 4.344-10.1h.003zm-1.808 9.055a3.846 3.846 0 0 1-2.343-.8L14.718 9.7l-1.175-1.186-2.652 2.636V5.877H9.224v5.276l-2.657-2.6L5.4 9.75l3.639 3.55c-.673.522-1.5.805-2.351.807a3.843 3.843 0 0 1-3.144-6.052A3.856 3.856 0 0 1 5.38 6.647l.474-.172.068-.5a3.693 3.693 0 0 1 3.934-3.291 3.738 3.738 0 0 1 3.868 3.2l.106.516.513.125a3.846 3.846 0 0 1-.915 7.582v.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$F = /*#__PURE__*/forwardRef(SvgTree);

var _excluded$E = ["title", "titleId"];

var SvgTrophy = function SvgTrophy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.888 11.671a5.284 5.284 0 0 0 1.4-2.857h2.549V2.736h-2.49V1H4.656v1.736h-2.49v6.078H4.72a5.3 5.3 0 0 0 4.463 4.467v4.052H5.054V19h9.9v-1.667H10.85v-4.058a5.319 5.319 0 0 0 3.038-1.604zM16.166 4.4v2.748h-.823V4.4h.823zm-12.333 0h.823v2.748h-.823V4.4zm2.49 3.712V2.665h7.353v5.257a3.61 3.61 0 0 1-1 2.6 3.678 3.678 0 0 1-6.353-2.408v-.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$E = /*#__PURE__*/forwardRef(SvgTrophy);

var _excluded$D = ["title", "titleId"];

var SvgTshirt = function SvgTshirt(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.7 17.832H15.3V9.579l1.6.621.002-.004.01.004L19 4.91l-6.586-2.741-.002.005-.012-.005-.329.746a2.26 2.26 0 0 1-2.064 1.355 2.261 2.261 0 0 1-2.064-1.355l-.329-.747-.012.005-.002-.005L1 4.91l2.088 5.29.01-.004.002.004 1.6-.618v8.25zM6.369 7.147l.015-.006v9.026h7.232V7.141l.015.006V7.14l2.327.904.878-2.224-3.64-1.516a3.925 3.925 0 0 1-3.184 1.63h-.015a3.925 3.925 0 0 1-3.185-1.63L3.164 5.82l.878 2.224 2.327-.904v.006z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$D = /*#__PURE__*/forwardRef(SvgTshirt);

var _excluded$C = ["title", "titleId"];

var SvgTurnOff = function SvgTurnOff(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.016 1h1.669v6.912H9.016V1zm3.793 2.614v-.001h-.003l.003.001zm0 0-.59 1.561a6.279 6.279 0 1 1-4.663.09l-.65-1.538a7.95 7.95 0 1 0 5.903-.113z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$C = /*#__PURE__*/forwardRef(SvgTurnOff);

var _excluded$B = ["title", "titleId"];

var SvgUnionIndustrial = function SvgUnionIndustrial(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 8.462V3.351H.966v13.333h18V6.128L7 8.462zm10.3 6.555H2.633v-10h2.7v5.467L17.3 8.151v6.866zm-8.393-2.872H5.344v1.667h3.563v-1.667zm2.336 0h3.563v1.667h-3.563v-1.667z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$B = /*#__PURE__*/forwardRef(SvgUnionIndustrial);

var _excluded$A = ["title", "titleId"];

var SvgUnlock = function SvgUnlock(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.469 1a4.536 4.536 0 0 0-4.531 4.532V7.04H1V19h13.014V7.04h-2.409V5.532a2.864 2.864 0 1 1 5.729 0V7.47H19V5.532A4.536 4.536 0 0 0 14.469 1zm-2.122 7.707v8.626h-4v-4.227H6.683v4.227H2.666V8.707h9.681z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$A = /*#__PURE__*/forwardRef(SvgUnlock);

var _excluded$z = ["title", "titleId"];

var SvgUp = function SvgUp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.176 4.197V19h1.668V4.19L16.657 10l1.179-1.179L10.012 1 2.164 8.821 3.344 10l5.832-5.803z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$z = /*#__PURE__*/forwardRef(SvgUp);

var _excluded$y = ["title", "titleId"];

var SvgUpdateRecycle = function SvgUpdateRecycle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.333 4.8V2.85H19V7.8h-4.95V6.133h2.177A7.33 7.33 0 0 0 3.005 7.8H1.273a8.993 8.993 0 0 1 16.06-3zM6.437 16.41A7.336 7.336 0 0 0 17 12.2h1.726a8.993 8.993 0 0 1-16.06 3v1.95H1v-4.946h4.95v1.662H3.773a7.325 7.325 0 0 0 2.663 2.542z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$y = /*#__PURE__*/forwardRef(SvgUpdateRecycle);

var _excluded$x = ["title", "titleId"];

var SvgUpload = function SvgUpload(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.14 16.667V4.193l-4.618 4.62-1.18-1.177L9.976 1l6.702 6.684-1.178 1.178-4.694-4.676v12.481H9.14zm-6.966.665h15.651V19H2.174v-1.668z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$x = /*#__PURE__*/forwardRef(SvgUpload);

var _excluded$w = ["title", "titleId"];

var SvgVeryHappy = function SvgVeryHappy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.949 2.608a9 9 0 0 1 5-1.517 9.01 9.01 0 0 1 9 9 9 9 0 1 1-14-7.483zm.925 13.58a7.334 7.334 0 0 0 4.075 1.236 7.341 7.341 0 0 0 7.333-7.333 7.334 7.334 0 1 0-11.408 6.097zm-1.511-5.796v-.833h11.172v.833a5.586 5.586 0 0 1-11.172 0zm3.128 3.051a3.928 3.928 0 0 0 2.458.869 3.927 3.927 0 0 0 3.831-3.086H6.118a3.927 3.927 0 0 0 1.373 2.217zm.355-7.492H6.253v1.667h1.593V5.951zm4.206 0h1.593v1.667h-1.593V5.951z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$w = /*#__PURE__*/forwardRef(SvgVeryHappy);

var _excluded$v = ["title", "titleId"];

var SvgVerySad = function SvgVerySad(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.04 2.617A9 9 0 0 1 10.042 1.1a9.011 9.011 0 0 1 9 9 9 9 0 1 1-14-7.483zm.926 13.582a7.334 7.334 0 0 0 4.075 1.235v-.001a7.342 7.342 0 0 0 7.333-7.333 7.333 7.333 0 1 0-11.408 6.098zm-.749-7.9L7.286 6.23l1.179 1.179-2.07 2.069-1.178-1.179zm7.617-2.07-1.179 1.178 2.069 2.07 1.179-1.18-2.07-2.068zM7.41 11.434a3.7 3.7 0 0 1 2.613-1.085 3.7 3.7 0 0 1 3.696 3.7h-1.662a2.029 2.029 0 0 0-4.058 0H6.329c0-.98.39-1.92 1.082-2.614z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$v = /*#__PURE__*/forwardRef(SvgVerySad);

var _excluded$u = ["title", "titleId"];

var SvgVoiceId = function SvgVoiceId(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 1h-4.98v1.67h3.31v3.32H19V1zm-1.67 16.33h-3.31V19H19v-4.98h-1.67v3.31zM2.67 14.02H1V19h4.98v-1.67H2.67v-3.31zm0-11.35h3.31V1H1v4.98h1.67V2.67zm.67 5.13h1.67v4.41H3.34V7.8zM15 7.34h1.67v5.32H15V7.34zm-2.33.98h1.67v3.35h-1.67V8.32zm-7-1.48h1.67v6.32H5.67V6.84zm4.66 0H12v6.32h-1.67V6.84zM8 5.54h1.67v8.93H8V5.54z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$u = /*#__PURE__*/forwardRef(SvgVoiceId);

var _excluded$t = ["title", "titleId"];

var SvgVoltage = function SvgVoltage(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10 5.656.467.785-4.332 7.46 2.848-.717-1.691 2.952H3.931L10 5.656zm6.061 10.48H9.218L12.3 10.81l-2.86.718L11.432 8.1l4.629 8.036zM9.99 2.307 1 17.833h18L9.99 2.307z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$t = /*#__PURE__*/forwardRef(SvgVoltage);

var _excluded$s = ["title", "titleId"];

var SvgWallet = function SvgWallet(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.227 5.96V.967L1.247 5.334v13.66H18.72V5.96h-2.493zM14.56 3.193V5.96H5.12l9.44-2.767zM2.913 17.334V7.628h14.14v4.193h-3.72v1.667h3.707v3.847H2.913z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$s = /*#__PURE__*/forwardRef(SvgWallet);

var _excluded$r = ["title", "titleId"];

var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10 1 10 18H0L10 1zm0 4.118L16.601 17H3.399L10 5.118zM11 9.6V8H9v1.6h2zm0 6.4v-5.6H9V16h2z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$r = /*#__PURE__*/forwardRef(SvgWarning);

var _excluded$q = ["title", "titleId"];

var SvgWatch = function SvgWatch(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.566 9.12V4.675h-1.348V.953h-1.667v3.723H7.88V.953H6.213v3.723H4.865V15.23h1.348v3.723H7.88V15.23h3.671v3.723h1.667V15.23h1.348v-4.444H15.6V9.12h-1.034zM12.9 13.562H6.532v-7.22H12.9v7.22z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$q = /*#__PURE__*/forwardRef(SvgWatch);

var _excluded$p = ["title", "titleId"];

var SvgWaves = function SvgWaves(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.654 6.939c-.833 0-1.638-.3-2.269-.845a1.806 1.806 0 0 0-2.192 0L1.019 4.878a3.473 3.473 0 0 1 4.54 0 1.8 1.8 0 0 0 2.19 0 3.472 3.472 0 0 1 4.54 0 1.8 1.8 0 0 0 2.191 0 3.473 3.473 0 0 1 4.539 0l-1.174 1.216a1.8 1.8 0 0 0-2.191 0 3.272 3.272 0 0 1-2.269.846 3.277 3.277 0 0 1-2.271-.846 1.8 1.8 0 0 0-2.19 0 3.47 3.47 0 0 1-2.27.845zm7.826 2.47a1.8 1.8 0 0 1-2.191 0 3.47 3.47 0 0 0-4.54 0 1.8 1.8 0 0 1-2.19 0 3.472 3.472 0 0 0-4.54 0l1.174 1.216a1.8 1.8 0 0 1 2.192 0 3.471 3.471 0 0 0 4.539 0 1.8 1.8 0 0 1 2.19 0 3.277 3.277 0 0 0 2.271.845 3.271 3.271 0 0 0 2.269-.845 1.8 1.8 0 0 1 2.191 0l1.174-1.216a3.47 3.47 0 0 0-4.539 0zm0 4.532a1.8 1.8 0 0 1-2.191 0 3.469 3.469 0 0 0-4.539 0 1.8 1.8 0 0 1-2.191 0 3.47 3.47 0 0 0-4.54 0l1.175 1.215a1.8 1.8 0 0 1 2.191 0 3.468 3.468 0 0 0 4.539 0 1.8 1.8 0 0 1 2.19 0 3.277 3.277 0 0 0 2.271.844 3.272 3.272 0 0 0 2.269-.846 1.8 1.8 0 0 1 2.191 0l1.174-1.216a3.467 3.467 0 0 0-4.539.003z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$p = /*#__PURE__*/forwardRef(SvgWaves);

var _excluded$o = ["title", "titleId"];

var SvgWebcast = function SvgWebcast(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m4.77 4.87-.825-1.526a8.993 8.993 0 0 0 0 13.312l.824-1.525a7.328 7.328 0 0 1 0-10.262zm11.285-1.526-.824 1.525a7.328 7.328 0 0 1 0 10.262l.824 1.525a8.995 8.995 0 0 0 0-13.312zM13.863 10l-6.627 4V6l6.627 4zm-3.054 0-1.9-1.1v2.2l1.9-1.1zm3.92-4.2-.866 1.6a4.67 4.67 0 0 1 0 5.2l.866 1.6a6.326 6.326 0 0 0 0-8.406V5.8zM3.673 10.003c0-1.55.569-3.045 1.598-4.203l.866 1.606a4.67 4.67 0 0 0 0 5.2l-.866 1.6a6.326 6.326 0 0 1-1.598-4.203z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$o = /*#__PURE__*/forwardRef(SvgWebcast);

var _excluded$n = ["title", "titleId"];

var SvgWheelchair = function SvgWheelchair(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.226 13.848V7.6H7.89L7.87.989H4.39v1.667h1.816l.017 5a5.7 5.7 0 1 0 4.848 1.605h4.487v4.569a2.646 2.646 0 1 0 1.667.018zm-6.149-.558a4.033 4.033 0 1 1-4.113-4.028h.161a4.035 4.035 0 0 1 3.952 4.028zm5.291 4.033a.977.977 0 1 1 0-1.954.977.977 0 0 1 0 1.954z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$n = /*#__PURE__*/forwardRef(SvgWheelchair);

var _excluded$m = ["title", "titleId"];

var SvgWifi = function SvgWifi(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.968 3.887A12.64 12.64 0 0 0 .963 7.614L2.141 8.79a11.076 11.076 0 0 1 15.645-.01L18.963 7.6a12.642 12.642 0 0 0-8.995-3.713zm0 7.507H9.96h.008zm-.004 0a2.637 2.637 0 0 1 .004 5.273 2.637 2.637 0 0 1-.004-5.273zm.694 3.32a.963.963 0 0 1-1.054.214.97.97 0 1 1 1.054-.214zm-5.729-3.152L3.75 10.384h-.002a8.82 8.82 0 0 1 12.423-.04L15 11.53a7.15 7.15 0 0 0-10.071.033z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$m = /*#__PURE__*/forwardRef(SvgWifi);

var _excluded$l = ["title", "titleId"];

var SvgWill = function SvgWill(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.262 1H2.167v18h15.666V5.565L13.262 1zm2.9 16.33H3.836V2.67h8.738l3.59 3.59-.002 11.07zM14.41 8.28H5.748v1.67h8.662V8.28zm-8.662 2.788h8.662v1.67H5.748v-1.67zm8.662 3.259h-3.797v1.67h3.797v-1.67zM8.517 5.619a1.543 1.543 0 1 1-3.086 0 1.543 1.543 0 0 1 3.086 0z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$l = /*#__PURE__*/forwardRef(SvgWill);

var _excluded$k = ["title", "titleId"];

var SvgWindTurbine = function SvgWindTurbine(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.645 12.006c-1.507-2.742-4.74-3.655-5.395-3.815a2.667 2.667 0 0 0-.327-.434 8.583 8.583 0 0 0-.933-6.18 1.244 1.244 0 0 0-1.041-.56 1.241 1.241 0 0 0-1.042.56 8.584 8.584 0 0 0-.933 6.18 2.678 2.678 0 0 0-.327.434c-.654.16-3.888 1.073-5.395 3.815a1.25 1.25 0 0 0 .974 1.843c.418.04.838.037 1.255-.007a9.057 9.057 0 0 0 4.342-1.822c.085.04.173.075.263.106v6.891h1.667v-6.87c.11-.036.216-.078.32-.127a9.057 9.057 0 0 0 4.343 1.822c.417.044.838.046 1.255.007a1.25 1.25 0 0 0 .974-1.843zM11 9.578a1.054 1.054 0 1 1-2.108 0 1.054 1.054 0 0 1 2.108 0zM9.948 3.061a7.158 7.158 0 0 1 .452 3.867 2.522 2.522 0 0 0-.906 0 7.083 7.083 0 0 1 .454-3.867zm-5.9 9.172a7.17 7.17 0 0 1 3.252-2.22c.049.305.15.6.3.87a7.13 7.13 0 0 1-3.55 1.35h-.002zm8.25-1.35c.15-.27.251-.565.3-.87a7.17 7.17 0 0 1 3.245 2.22 7.13 7.13 0 0 1-3.543-1.35h-.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$k = /*#__PURE__*/forwardRef(SvgWindTurbine);

var _excluded$j = ["title", "titleId"];

var SvgWindy = function SvgWindy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.254 5.833a2.465 2.465 0 0 0-4.93 0h1.667a.8.8 0 1 1 .8.8h-6.8V8.3h6.8a2.466 2.466 0 0 0 2.463-2.467zm2.971-.592a2.777 2.777 0 0 0-2.776 2.772h1.667a1.109 1.109 0 1 1 1.109 1.106H1v1.667h15.225a2.772 2.772 0 0 0 0-5.545zM6.129 11.743H14.2a2.465 2.465 0 1 1-2.463 2.466H13.4a.8.8 0 1 0 .8-.8H6.129v-1.666z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$j = /*#__PURE__*/forwardRef(SvgWindy);

var _excluded$i = ["title", "titleId"];

var SvgWineGlasses = function SvgWineGlasses(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.941 10.115 11.32 5.922l2.243-.868 1.621 4.194a1.048 1.048 0 0 1-.6 1.356l-.287.111a1.05 1.05 0 0 1-1.357-.6h.001zm-5.882 0a1.05 1.05 0 0 1-1.357.6l-.287-.111a1.047 1.047 0 0 1-.6-1.356l1.622-4.194 2.244.868-1.622 4.193zm11.368 4.643-1.347.521-1.354-3.5a2.63 2.63 0 0 0 .944-3.107L14.47 3 10 4.729 5.529 3 3.334 8.672a2.628 2.628 0 0 0 .94 3.105l-1.354 3.5-1.35-.519L1 16.24l4.176 1.615.573-1.483-1.347-.52 1.354-3.5c.106.015.214.022.321.023a2.645 2.645 0 0 0 2.464-1.687L10 6.915l1.459 3.773a2.645 2.645 0 0 0 2.464 1.684c.107 0 .215-.008.321-.023l1.354 3.5-1.347.521.573 1.482L19 16.237l-.573-1.482v.003z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$i = /*#__PURE__*/forwardRef(SvgWineGlasses);

var _excluded$h = ["title", "titleId"];

var SvgWoman = function SvgWoman(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.364 3.636A9 9 0 0 1 19 10v9h-1.667v-3.792a8.986 8.986 0 0 1-14.666 0V19H1v-9a9 9 0 0 1 15.364-6.364zM11.14 5.8H16a7.319 7.319 0 0 0-8.388-2.73A3.654 3.654 0 0 0 11.14 5.8zM5.592 15.863a7.33 7.33 0 0 0 7.8.638 7.333 7.333 0 0 0 3.489-9.038H11.14A5.324 5.324 0 0 1 6.09 3.8a7.33 7.33 0 0 0-.498 12.063zm.695-7.837H7.88v1.667H6.287V8.026zm7.392 0h-1.593v1.667h1.593V8.026zm-5.13 5.217c.38.38.896.594 1.434.595a2.03 2.03 0 0 0 2.029-2.029h1.667a3.7 3.7 0 0 1-7.392 0h1.667c0 .538.215 1.054.595 1.434z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$h = /*#__PURE__*/forwardRef(SvgWoman);

var _excluded$g = ["title", "titleId"];

var SvgWomanWithGlasses = function SvgWomanWithGlasses(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.364 3.636A9 9 0 0 1 19 10v9h-1.667v-3.792a8.986 8.986 0 0 1-14.666 0V19H1v-9a9 9 0 0 1 15.364-6.364zM11.14 5.8h4.865a7.32 7.32 0 0 0-8.393-2.73A3.654 3.654 0 0 0 11.14 5.8zM5.592 15.863a7.333 7.333 0 0 0 11.29-8.399h-5.742A5.324 5.324 0 0 1 6.09 3.8a7.33 7.33 0 0 0-.498 12.063zm6.07-7.535a3.082 3.082 0 1 1-1.106 3.29H9.446a3.084 3.084 0 1 1 0-1.668h1.112a3.086 3.086 0 0 1 1.106-1.622zM5.694 11.96a1.417 1.417 0 1 0 1.58-2.354 1.417 1.417 0 0 0-1.58 2.354zm7.043.001a1.418 1.418 0 1 0 1.575-2.357 1.418 1.418 0 0 0-1.575 2.357z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$g = /*#__PURE__*/forwardRef(SvgWomanWithGlasses);

var _excluded$f = ["title", "titleId"];

var SvgWork = function SvgWork(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.04 10.069v1.667H8.642l-2.75-2.688V19H4.231V6.708A2.912 2.912 0 1 1 5.9 6.72l3.421 3.349h2.719zm-7.743-5.18c.225.183.506.282.796.281h-.004a1.25 1.25 0 0 0 .363-2.45 1.252 1.252 0 0 0-1.155 2.168zm8.738 8.538 3.62-3.62 1.178 1.179-4.108 4.108H8.238v-1.667h4.797z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$f = /*#__PURE__*/forwardRef(SvgWork);

var _excluded$e = ["title", "titleId"];

var SvgWrite = function SvgWrite(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m13.216 6.97 2.415-2.42L19 7.929 13.216 13.7v4.133H1V2.17h12.216v4.8zM2.665 16.17h8.886v-1.96h-2.2v-3.37l2.2-2.2V3.83H2.665v12.338zm8.353-3.623h.994l4.634-4.621-1.015-1.017-4.613 4.62v1.018zM9.366 7.132H3.784v1.664h5.582V7.132zM7.473 9.875H3.784v1.664h3.689V9.875z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$e = /*#__PURE__*/forwardRef(SvgWrite);

var _excluded$d = ["title", "titleId"];

var SvgYearly = function SvgYearly(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "yearly_svg__Icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.yearly_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "yearly_svg__st0",
    d: "M14.71 3.33V1h-1.67v2.33H6.99V1h-1.7v2.33H2.17V19h15.66V3.33h-3.12zm1.45 14H3.83V8.8h12.33v8.53zm0-10.19H3.83V5h12.33v2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "yearly_svg__st0",
    d: "M5.81 9.64h1.63v1.67H5.81zM12.54 9.64h1.63v1.67h-1.63zM9.18 9.64h1.63v1.67H9.18zM5.81 12.23h1.63v1.67H5.81zM12.54 12.23h1.63v1.67h-1.63zM9.18 12.23h1.63v1.67H9.18zM5.81 14.82h1.63v1.67H5.81zM12.54 14.82h1.63v1.67h-1.63zM9.18 14.82h1.63v1.67H9.18z"
  }));
};

var ForwardRef$d = /*#__PURE__*/forwardRef(SvgYearly);

var _excluded$c = ["title", "titleId"];

var SvgYoyo = function SvgYoyo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.737 7.476-2.844 1.515h-4.186a.688.688 0 0 1 0-1.375h3.729V5.95h-3.729c-.457 0-.904.133-1.286.384H3.845l3.667-3.667H19V1H7.167a.833.833 0 0 0-.589.244L1.244 6.578A.833.833 0 0 0 1.833 8h3.953v4.475a3.317 3.317 0 1 0 1.667 0V8h.922c-.014.1-.021.2-.022.3a2.357 2.357 0 0 0 2.354 2.354h4.3c.076 0 .152-.01.225-.031l3.76-1.894-1.255-1.253zM8.27 15.683a1.65 1.65 0 1 1-3.302.002 1.65 1.65 0 0 1 3.302-.002z",
    style: {
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$c = /*#__PURE__*/forwardRef(SvgYoyo);

var _excluded$b = ["title", "titleId"];

var SvgZoomIn = function SvgZoomIn(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.121 1.973A6.454 6.454 0 0 1 12.537 1 6.46 6.46 0 1 1 8.6 12.578L2.179 19 1 17.822 7.422 11.4a6.455 6.455 0 0 1 1.7-9.427zm.749 9.475a4.8 4.8 0 1 0 5.334-7.981 4.8 4.8 0 0 0-5.334 7.98zm1.85-6.703h1.666v1.868h1.869v1.666h-1.869v1.9H11.72v-1.9h-1.9V6.613h1.9V4.745z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$b = /*#__PURE__*/forwardRef(SvgZoomIn);

var _excluded$a = ["title", "titleId"];

var SvgZoomOut = function SvgZoomOut(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.122 1.974A6.454 6.454 0 0 1 12.537 1 6.46 6.46 0 1 1 8.6 12.578L2.179 19 1 17.821 7.422 11.4a6.455 6.455 0 0 1 1.7-9.426zm.748 9.474a4.8 4.8 0 1 0 5.334-7.981 4.8 4.8 0 0 0-5.334 7.98zm-.05-4.835h5.435V8.28H9.82V6.613z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor'
    }
  }));
};

var ForwardRef$a = /*#__PURE__*/forwardRef(SvgZoomOut);

var _excluded$9 = ["title", "titleId"];

var SvgFacebook = function SvgFacebook(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v20h20V0Zm13.91 5.3h-1.1a1.26 1.26 0 0 0-1.42 1.37V8.3h2.42l-.39 2.53h-2V17H8.66v-6.17H6.44V8.3h2.22V6.38A3.07 3.07 0 0 1 12 3a13.46 13.46 0 0 1 1.95.17Z",
    style: {
      fill: '#1877f2'
    }
  }));
};

var ForwardRef$9 = /*#__PURE__*/forwardRef(SvgFacebook);

var _excluded$8 = ["title", "titleId"];

var SvgInstagram = function SvgInstagram(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram_svg__a",
    cx: -7.42,
    cy: 32.87,
    r: 50.81,
    gradientTransform: "matrix(.5 0 0 -.5 5 35.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fa8f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#d82d7e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram_svg__b",
    cx: 17.71,
    cy: 34.15,
    r: 44.71,
    gradientTransform: "matrix(.5 0 0 -.5 5 35.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8c3aaa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c3aaa"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 20V0h20v20Z",
    style: {
      fill: 'url(#instagram_svg__a)'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20V0h20v20Z",
    style: {
      fill: 'url(#instagram_svg__b)'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67 10A2.33 2.33 0 1 1 10 12.33 2.33 2.33 0 0 1 7.67 10m-1.26 0A3.59 3.59 0 1 0 10 6.41 3.59 3.59 0 0 0 6.41 10m6.49-3.74a.84.84 0 0 0 1.68 0 .85.85 0 0 0-.84-.84.84.84 0 0 0-.84.84M7.17 15.7a4 4 0 0 1-1.3-.24 2.16 2.16 0 0 1-.8-.53 2.08 2.08 0 0 1-.53-.8 4 4 0 0 1-.24-1.3V7.17a4 4 0 0 1 .24-1.3 2.08 2.08 0 0 1 .53-.8 2.08 2.08 0 0 1 .8-.53 4 4 0 0 1 1.3-.24h5.66a4 4 0 0 1 1.3.24 2.08 2.08 0 0 1 .8.53 2.08 2.08 0 0 1 .53.8 4 4 0 0 1 .24 1.3v5.66a4 4 0 0 1-.24 1.3 2.41 2.41 0 0 1-1.33 1.33 4 4 0 0 1-1.3.24H7.17M7.11 3a5 5 0 0 0-1.69.33 3.51 3.51 0 0 0-1.25.8 3.56 3.56 0 0 0-.8 1.24A5.16 5.16 0 0 0 3 7.11v5.78a5.16 5.16 0 0 0 .33 1.7 3.56 3.56 0 0 0 .8 1.24 3.51 3.51 0 0 0 1.25.8 5 5 0 0 0 1.73.37h5.78a5.16 5.16 0 0 0 1.7-.33 3.56 3.56 0 0 0 1.24-.8 3.42 3.42 0 0 0 .8-1.24 5.16 5.16 0 0 0 .33-1.7V7.15a5.16 5.16 0 0 0-.33-1.7 3.5 3.5 0 0 0-2-2A5.16 5.16 0 0 0 12.89 3H7.11",
    style: {
      fill: '#fff'
    }
  }));
};

var ForwardRef$8 = /*#__PURE__*/forwardRef(SvgInstagram);

var _excluded$7 = ["title", "titleId"];

var SvgLinkedin = function SvgLinkedin(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v20h20V0Zm6.08 16.74h-3v-9h3ZM4.58 6.5a1.56 1.56 0 1 1 0-3.11 1.56 1.56 0 1 1 0 3.11Zm12.29 10.24h-3v-4.82c0-1.21-.44-2-1.52-2A1.62 1.62 0 0 0 10.83 11a2 2 0 0 0-.1.73v5h-3v-9h3V9a3 3 0 0 1 2.69-1.49c2 0 3.45 1.29 3.45 4.05Z",
    style: {
      fill: '#2867b2'
    }
  }));
};

var ForwardRef$7 = /*#__PURE__*/forwardRef(SvgLinkedin);

var _excluded$6 = ["title", "titleId"];

var SvgMove = function SvgMove(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "move_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.move_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}'), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "move_svg__st1",
    d: "M12.1 7v6.2c0 .3.3.6.6.6s.6-.3.6-.6V7h-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "move_svg__st1",
    d: "M13.1 6.5c-.2-.2-.6-.2-.9 0l-.1.1-2.6 3 .9.9L13 7.4c.4-.2.4-.6.1-.9zM8 7H6.7v6.2c0 .3.3.6.6.6s.6-.3.6-.6V7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "move_svg__st1",
    d: "m10.5 9.6-2.6-3-.1-.1c-.2-.2-.6-.2-.9 0-.2.2-.2.6 0 .9l2.6 3 .1.1c.2.2.6.2.9 0 .2-.2.2-.6 0-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.8c-4.3 0-7.7-3.5-7.7-7.7 0-4.3 3.5-7.7 7.7-7.7 1.2 0 2.4.3 3.4.8.3.2.4.5.3.9-.2.3-.5.4-.9.3-.8-.5-1.8-.8-2.8-.8-3.6 0-6.4 2.9-6.4 6.4 0 3.6 2.9 6.4 6.4 6.4 3.6 0 6.4-2.9 6.4-6.4 0-1.5-.5-2.9-1.5-4.1-.2-.3-.2-.7.1-.9.3-.2.7-.2.9.1 1.1 1.4 1.7 3.1 1.7 4.9.1 4.3-3.4 7.8-7.6 7.8z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: '#00a758'
    }
  }));
};

var ForwardRef$6 = /*#__PURE__*/forwardRef(SvgMove);

var _excluded$5 = ["title", "titleId"];

var SvgSkype = function SvgSkype(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "skype_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.skype_svg__cls-1{fill:#00aff0}')), /*#__PURE__*/React.createElement("path", {
    className: "skype_svg__cls-1",
    d: "M8.5 2.56h.14-.16ZM17.4 11.27v.06a.22.22 0 0 1 0 .08V11.24ZM16.49 11.11v.12a.17.17 0 0 1 0-.07.25.25 0 0 0 0-.07ZM8.68 3.47h.13-.07ZM11.25 9.2 9.7 8.85c-.59-.13-1.27-.31-1.27-.85s.48-1 1.34-1c1.73 0 1.57 1.19 2.43 1.19a.77.77 0 0 0 .85-.72c0-1.07-1.71-1.87-3.16-1.87s-3.24.67-3.24 2.44c0 .86.3 1.77 2 2.2l2.09.52c.63.16.79.51.79.83 0 .54-.53 1.06-1.49 1.06-1.88 0-1.62-1.45-2.63-1.45a.75.75 0 0 0-.78.76c0 .87 1.06 2 3.41 2s3.34-.96 3.34-2.46c0-.93-.38-1.92-2.13-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skype_svg__cls-1",
    d: "M0 0v20h20V0Zm15.87 15.85A3.91 3.91 0 0 1 13.09 17a4 4 0 0 1-1.93-.51 6.38 6.38 0 0 1-1.15.1 6.47 6.47 0 0 1-2.58-.52 6.54 6.54 0 0 1-2.11-1.42 6.39 6.39 0 0 1-1.42-2.1A6.54 6.54 0 0 1 3.38 10a6.2 6.2 0 0 1 .1-1.14v.06-.07A3.92 3.92 0 0 1 6.91 3a4 4 0 0 1 1.84.46 6.63 6.63 0 0 1 3.83.4 6.62 6.62 0 0 1 4 6.11 7 7 0 0 1-.11 1.2 4 4 0 0 1 .5 1.91 3.9 3.9 0 0 1-1.1 2.77Z"
  }));
};

var ForwardRef$5 = /*#__PURE__*/forwardRef(SvgSkype);

var _excluded$4 = ["title", "titleId"];

var SvgTwitter = function SvgTwitter(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v20h20V0Zm15 7.46v.32a7.29 7.29 0 0 1-11.25 6.15 4.17 4.17 0 0 0 .61 0 5.16 5.16 0 0 0 3.19-1.1 2.58 2.58 0 0 1-2.4-1.78 2.61 2.61 0 0 0 .48.05 2.54 2.54 0 0 0 .68-.1 2.56 2.56 0 0 1-2.06-2.47 2.69 2.69 0 0 0 1.16.33 2.61 2.61 0 0 1-1.14-2.18 2.57 2.57 0 0 1 .35-1.29A7.28 7.28 0 0 0 9.9 8.07a2.88 2.88 0 0 1-.06-.59 2.56 2.56 0 0 1 4.43-1.75 5.25 5.25 0 0 0 1.63-.62 2.58 2.58 0 0 1-1.13 1.42 5.24 5.24 0 0 0 1.48-.41A5.44 5.44 0 0 1 15 7.46Z",
    style: {
      fill: '#1da1f2'
    }
  }));
};

var ForwardRef$4 = /*#__PURE__*/forwardRef(SvgTwitter);

var _excluded$3 = ["title", "titleId"];

var SvgWechat = function SvgWechat(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wechat_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.wechat_svg__cls-1{fill:#00bc0b}')), /*#__PURE__*/React.createElement("circle", {
    className: "wechat_svg__cls-1",
    cx: 5.82,
    cy: 6.62,
    r: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "wechat_svg__cls-1",
    d: "M11.6 9.92a.67.67 0 1 0 .66.67.66.66 0 0 0-.66-.67ZM9.75 7.4a.78.78 0 1 0 0-1.56.78.78 0 1 0 0 1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wechat_svg__cls-1",
    d: "M0 0v20h20V0Zm7.8 13.08a6.79 6.79 0 0 1-2-.28.48.48 0 0 0-.37 0l-1.26.74c-.28.16-.44 0-.36-.27l.28-1a.35.35 0 0 0-.09-.36 4.62 4.62 0 0 1-2-3.72C2 5.49 4.63 3.3 7.88 3.3c2.94 0 5.37 1.79 5.82 4.12h-.4c-3 0-5.38 2-5.38 4.45a3.49 3.49 0 0 0 .2 1.21ZM16.41 15a.25.25 0 0 0-.1.28l.23.87c.07.27-.07.37-.3.23l-1.07-.61a.32.32 0 0 0-.27 0 6 6 0 0 1-1.67.24c-2.7 0-4.89-1.83-4.89-4.08s2.19-4.09 4.89-4.09 4.9 1.83 4.9 4.09A3.84 3.84 0 0 1 16.41 15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wechat_svg__cls-1",
    d: "M14.84 9.92a.67.67 0 1 0 .67.67.67.67 0 0 0-.67-.67Z"
  }));
};

var ForwardRef$3 = /*#__PURE__*/forwardRef(SvgWechat);

var _excluded$2 = ["title", "titleId"];

var SvgYammer = function SvgYammer(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v20h20V0Zm15 5h.09a.81.81 0 0 1 .91.34.82.82 0 0 1-.18 1.07c-1.68.93-4.16 2-4.56 1.75S14.45 5.29 15 5Zm-4.12-.64L7 13.94c-.64 1.66-1.3 2.79-3.27 2.79a4.77 4.77 0 0 1-.83-.06.75.75 0 0 1 .24-1.47h.49c1.07 0 1.53-.67 2-2.09l-3.52-8.7a.87.87 0 0 1 1.61-.64L6.56 11h.05l2.7-7.14a.83.83 0 0 1 1.56.54ZM16 15a.83.83 0 0 1-.91.35l-.09-.01c-.54-.3-4.15-2.83-3.74-3.12s2.87.83 4.56 1.76A.8.8 0 0 1 16 15Zm1.28-4.12c-1.93 0-4.63-.21-4.85-.66s4.16-.93 4.78-.93h.1a.8.8 0 0 1 0 1.58Z",
    style: {
      fill: '#005db4'
    }
  }));
};

var ForwardRef$2 = /*#__PURE__*/forwardRef(SvgYammer);

var _excluded$1 = ["title", "titleId"];

var SvgYoutube = function SvgYoutube(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youtube_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.youtube_svg__cls-1{fill:red}')), /*#__PURE__*/React.createElement("path", {
    className: "youtube_svg__cls-1",
    d: "M0 0v20h20V0Zm17 12.62c-.16 1.13-.47 2.08-1.78 2.17-1.64.12-3.24.22-4.89.18l-3-.06a16 16 0 0 1-2.85-.17C3.08 14.45 3 13 2.88 11.82a20.48 20.48 0 0 1 .18-5.07 1.74 1.74 0 0 1 1.71-1.56 93 93 0 0 1 9.59-.09 6.82 6.82 0 0 1 1 .12C17 5.5 17 7.12 17.14 8.49a17.86 17.86 0 0 1-.14 4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube_svg__cls-1",
    d: "m8.58 12.1 3.68-2.1-3.68-2.13Z"
  }));
};

var ForwardRef$1 = /*#__PURE__*/forwardRef(SvgYoutube);

var _excluded = ["title", "titleId"];

var SvgZalo = function SvgZalo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "zalo_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: 'new 0 0 20 20'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.zalo_svg__st1{fill:#015bde}'), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#fff'
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "zalo_svg__st1",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0H5.7c-.3.2-.7.5-.9.7-.5.4-.8.8-1.1 1.3-.4.7-.8 1.4-1 2.2-.3.5-.4 1.1-.5 1.7-.1.3-.1.7-.1 1V8.7c0 .3 0 .5.1.8.1.7.2 1.3.4 1.9 0 .6.2 1.1.5 1.6.2.3.3.6.6.9.1.2.2.4.2.6 0 .4-.1.8-.3 1.2-.1.2-.3.4-.4.5-.1.1-.1.1 0 .2h1c.5-.1 1-.2 1.4-.4h.3c.4.3.9.5 1.3.7.7.3 1.4.5 2.1.6.6.1 1.1.2 1.7.2.3 0 .7 0 1 .1h1c.3 0 .5 0 .8-.1.7-.1 1.3-.2 2-.4.8-.2 1.6-.5 2.3-.9.7-.4 1.3-.8 1.8-1.4h.2V0z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: '#fbfcfc'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8 0c-.4.3-.8.6-1.2 1-.5.5-1 1.1-1.3 1.8-.5 1-.8 2-1 3.1-.1.7-.2 1.3-.2 2 0 1.5.2 3 .8 4.5.2.6.5 1.1.8 1.6.2.3.2.6.2 1-.1.5-.3 1-.7 1.4v.1c-.1.1-.1.1 0 .2l.3.3c.3 0 .5.2.6.4.2.2.4.5.7.7l.7.7c.2.2.4.4.6.7l.4.4s.1 0 0 .1H0V.1h.6C2.3 0 4 0 5.8 0c-.1 0-.1 0 0 0z",
    style: {
      fill: '#0067fd'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "zalo_svg__st1",
    d: "M6.6 20c0-.1-.1-.1-.1-.2l-.5-.5c-.2-.2-.5-.5-.7-.8-.3-.2-.6-.5-.9-.8l-.9-.9-.4-.4h.7c.6 0 1.2-.2 1.7-.4h.2c1 .6 2.1 1 3.2 1.3.8.2 1.6.3 2.5.3.8 0 1.6 0 2.4-.1 1.2-.2 2.4-.4 3.5-1 .7-.3 1.4-.8 2-1.3.2-.1.3-.3.4-.5v5.1s0 .1-.1.1h-1.3c-3.7.1-7.6.1-11.7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11.1V6.7c0-.1 0-.1-.1-.1h-.7c-.1 0-.1 0-.1.1v4.6c0 .2.1.2.2.3h.5c.1 0 .1 0 .1-.1.1-.2.1-.2.1-.4 0 .1 0 .1 0 0zM8.1 6.6H5c-.1 0-.1 0-.1.1V7.3c0 .1 0 .2.2.2h2.5v.1c-.8 1-1.6 2.1-2.5 3.1-.2.2-.2.4-.2.7 0 .1 0 .2.2.2H8.6c.2 0 .4-.1.4-.3v-.4c0-.1 0-.1-.1-.1H6.2v-.1c.2-.2.3-.4.5-.6.3-1 .9-1.7 1.5-2.5.2-.3.4-.5.4-.9 0-.1 0-.1-.1-.1h-.4zm4.5 4.7V7.8c0-.1 0-.1-.1-.1h-.6c-.1 0-.2 0-.2.2V8h-.1c-.5-.3-1-.4-1.5-.2C9.2 8 8.6 9 8.8 10c.2.8.9 1.4 1.7 1.5.4 0 .8-.1 1.1-.3h.1c0 .2.2.2.3.3h.2c.3-.1.4-.1.4-.2zm-1.9-.6c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1-.7-.1-1.1.5-1.1 1.1 0 .6.4 1.1 1.1 1.1zm5.8.8c-1 0-1.9-.9-1.9-1.9 0-1.1.8-2 1.9-2 1.1 0 1.9.9 1.9 1.9 0 1.1-.8 2-1.9 2zm0-.8c-.5 0-1.1-.4-1.1-1.1 0-.7.6-1.1 1.1-1.1.6 0 1.1.4 1.1 1.1 0 .6-.5 1.1-1.1 1.1z",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: '#0468fa'
    }
  }));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgZalo);

export { ForwardRef$77 as About, ForwardRef$76 as AccelerateGrowth, ForwardRef$75 as AccessibleToilet, ForwardRef$74 as AccidentalDentalCare, ForwardRef$73 as Accumulate, ForwardRef$71 as Active, ForwardRef$72 as ActiveCopy, ForwardRef$70 as AddActivity, ForwardRef$6$ as AddContact, ForwardRef$6_ as AddFile, ForwardRef$6Z as Advisor1, ForwardRef$6Y as Advisor2, ForwardRef$6X as Agent, ForwardRef$6W as Agile, ForwardRef$6V as Ai, ForwardRef$6U as Airplane, ForwardRef$6T as Alarm, ForwardRef$6S as Aluminium, ForwardRef$6R as Ambulance, ForwardRef$6Q as AngleDown, ForwardRef$6P as AngleUp, ForwardRef$6O as Apple, ForwardRef$6N as ArrowLeft, ForwardRef$6M as ArrowRight, ForwardRef$6L as Artery, ForwardRef$6K as Award, ForwardRef$6J as Baby, ForwardRef$6I as BadgeDollar, ForwardRef$6H as BadgeNo, ForwardRef$6G as BadgeOk, ForwardRef$6F as BadgeUp, ForwardRef$6E as Balance, ForwardRef$6D as Ball, ForwardRef$6C as Bandage, ForwardRef$6B as Bank, ForwardRef$6A as BeachBall, ForwardRef$6z as Bear, ForwardRef$6y as Bicycle, ForwardRef$6x as Bill, ForwardRef$6w as Binoculars, ForwardRef$6v as Biometric, ForwardRef$6u as Blog1, ForwardRef$6t as Blog2, ForwardRef$6s as Body, ForwardRef$6r as Bonus, ForwardRef$6q as Bookmark, ForwardRef$7H as BookmarkFilled, ForwardRef$6p as Bottle, ForwardRef$6o as Bottom, ForwardRef$6n as BottomLeft, ForwardRef$6m as BottomRight, ForwardRef$6l as BoxingGlove, ForwardRef$6k as Brain, ForwardRef$6j as Briefcase, ForwardRef$6i as Brightness, ForwardRef$6h as Building, ForwardRef$6g as Buildings, ForwardRef$6f as Bull, ForwardRef$6e as Bus, ForwardRef$7G as ButtonCheckmarkFilled, ForwardRef$7F as ButtonCheckmarkIcon, ForwardRef$7E as ButtonCheckmarkOutlined, ForwardRef$7A as ButtonDownFilled, ForwardRef$7z as ButtonDownIcon, ForwardRef$7y as ButtonDownOutlined, ForwardRef$7x as ButtonLeftFilled, ForwardRef$7w as ButtonLeftIcon, ForwardRef$7v as ButtonLeftOutlined, ForwardRef$7u as ButtonMinusFilled, ForwardRef$7t as ButtonMinusIcon, ForwardRef$7s as ButtonMinusOutlined, ForwardRef$7r as ButtonPlusFilled, ForwardRef$7q as ButtonPlusIcon, ForwardRef$7p as ButtonPlusOutlined, ForwardRef$7o as ButtonRightFilled, ForwardRef$7n as ButtonRightIcon, ForwardRef$7m as ButtonRightOutlined, ForwardRef$7l as ButtonUpFilled, ForwardRef$7k as ButtonUpIcon, ForwardRef$7j as ButtonUpOutlined, ForwardRef$7D as ButtonXFilled, ForwardRef$7C as ButtonXIcon, ForwardRef$7B as ButtonXOutlined, ForwardRef$6d as Cafe, ForwardRef$6c as Cake, ForwardRef$6b as Calculator, ForwardRef$6a as Callback, ForwardRef$69 as Camera, ForwardRef$68 as Car, ForwardRef$67 as CareerAdvancement, ForwardRef$7i as CaretDown, ForwardRef$7h as CaretUp, ForwardRef$66 as Carrot, ForwardRef$65 as Cart, ForwardRef$64 as Carton, ForwardRef$63 as Cash1, ForwardRef$62 as Cash2, ForwardRef$61 as CashBenefit, ForwardRef$60 as Cashier, ForwardRef$5$ as Cashless, ForwardRef$5_ as Caution, ForwardRef$5Z as Cells, ForwardRef$5Y as ChangeOfLifeInsured, ForwardRef$5X as ChangeOfLifeInsuredAlternate, ForwardRef$5W as Chart, ForwardRef$5V as Chart1, ForwardRef$5U as Chart2, ForwardRef$5T as ChartHistory, ForwardRef$7g as Check, ForwardRef$5S as CheckBox, ForwardRef$5R as CheckBoxIndeterminate, ForwardRef$5Q as CheckBoxOutlineBlank, ForwardRef$5P as Checked, ForwardRef$5O as Checklist, ForwardRef$5N as Cheque, ForwardRef$5M as Chess, ForwardRef$5L as ChildBoy, ForwardRef$5K as ChildBoy1, ForwardRef$5J as ChildGirl1, ForwardRef$5I as ChildGirl2, ForwardRef$5H as ChristmasTree, ForwardRef$5G as CircleCheckmark, ForwardRef$5F as CircleX, ForwardRef$5E as CleanRoom, ForwardRef$5D as Clock, ForwardRef$5C as ClothesHanger, ForwardRef$5B as Cloudy, ForwardRef$5A as Coffee, ForwardRef$5z as Coin, ForwardRef$5y as Collaboration, ForwardRef$5x as ComingTogether, ForwardRef$5w as Comment, ForwardRef$5v as Communication, ForwardRef$5u as CommunicationsTower, ForwardRef$5t as Compare, ForwardRef$5s as ComplimentaryBenefits, ForwardRef$5r as Conversation, ForwardRef$5q as CopyPaste, ForwardRef$5p as Corn, ForwardRef$5o as Coverage, ForwardRef$5n as CreditCard, ForwardRef$5m as CriticalIllness, ForwardRef$7f as Cross, ForwardRef$5l as Crown, ForwardRef$5k as Dacadoo, ForwardRef$5j as Date, ForwardRef$5i as DateRange, ForwardRef$5h as DayView, ForwardRef$5g as Death, ForwardRef$5f as Debt, ForwardRef$5e as Delete, ForwardRef$5d as DeleteFile, ForwardRef$5c as Desktop, ForwardRef$5b as Digital, ForwardRef$5a as DigitalCustomerLeader, ForwardRef$59 as Discount, ForwardRef$58 as Diversification, ForwardRef$57 as Dna, ForwardRef$56 as Document, ForwardRef$55 as Dollar, ForwardRef$54 as Down, ForwardRef$53 as Download, ForwardRef$52 as Drink, ForwardRef$51 as Duplicate, ForwardRef$50 as Earbuds, ForwardRef$4$ as EasyApplication, ForwardRef$4_ as Edit, ForwardRef$4Z as Education, ForwardRef$4Y as Eggs, ForwardRef$4X as Elevator, ForwardRef$4W as Email, ForwardRef$4V as EmergencyExit, ForwardRef$4U as Emotions, ForwardRef$4T as EngagementRing, ForwardRef$4S as EpsSvg, ForwardRef$4R as EstateLiquidity, ForwardRef$4Q as ExcalatorDown, ForwardRef$4P as ExcalatorUp, ForwardRef$4O as Exchange, ForwardRef$4N as Exit, ForwardRef$4M as ExpenseEfficiency, ForwardRef$4L as Export, ForwardRef$4K as Eye1, ForwardRef$4J as Eye2, ForwardRef$9 as Facebook, ForwardRef$4I as Family, ForwardRef$4H as Fax, ForwardRef$4G as FemaleSymbol, ForwardRef$4F as FemaleToilet, ForwardRef$4E as Ferry, ForwardRef$4D as FileFolder, ForwardRef$4C as Filter, ForwardRef$4B as FinancialWellness, ForwardRef$4A as Fire, ForwardRef$4z as FireExtinguisher, ForwardRef$4y as FireHose, ForwardRef$4x as FirstAid, ForwardRef$4w as Fish, ForwardRef$4v as Flag, ForwardRef$7e as FlagFilled, ForwardRef$4u as Flexibility, ForwardRef$4t as FlexibilityAlt, ForwardRef$4s as FlexibleAccess, ForwardRef$4r as Flower, ForwardRef$4q as FocusRoom, ForwardRef$4p as FormCompleted, ForwardRef$4o as FormEmpty, ForwardRef$4n as FormLong, ForwardRef$4m as FormPaper, ForwardRef$4l as FormSearch, ForwardRef$4k as FormSimple, ForwardRef$4j as Frisbee, ForwardRef$4i as Fullscreen, ForwardRef$4h as FundUnits, ForwardRef$4g as FundsSwitches, ForwardRef$4f as Game, ForwardRef$4e as Gear, ForwardRef$4d as Gift, ForwardRef$4c as Globe, ForwardRef$4b as Golf, ForwardRef$4a as Grandparents, ForwardRef$49 as Growth1, ForwardRef$48 as Growth2, ForwardRef$47 as GuaranteedCost, ForwardRef$46 as GuaranteedDeathBenefit, ForwardRef$45 as Gym, ForwardRef$44 as HackySack, ForwardRef$43 as Hamburger, ForwardRef$42 as HandWaving, ForwardRef$41 as Handshake, ForwardRef$40 as Handwashing, ForwardRef$3$ as Happy, ForwardRef$3_ as Headset, ForwardRef$3Z as Health, ForwardRef$3Y as HearingAid, ForwardRef$3X as Heart, ForwardRef$7d as HeartFilled, ForwardRef$3W as Height, ForwardRef$3V as HighPerformingTeam, ForwardRef$3U as History, ForwardRef$3T as HistoryBadge, ForwardRef$3S as Holiday, ForwardRef$3R as HolidayChair, ForwardRef$3Q as Home, ForwardRef$3P as Home2, ForwardRef$3O as Hospital, ForwardRef$3N as HospitalBed, ForwardRef$3M as Hotel, ForwardRef$3L as Hourglass, ForwardRef$3K as HusbandAndWife, ForwardRef$3J as Hypertargeting, ForwardRef$3I as IceCream, ForwardRef$3H as Id, ForwardRef$3G as Idea, ForwardRef$3F as Import, ForwardRef$3E as InPatient, ForwardRef$3D as IncomeSupport, ForwardRef$3C as Infinity, ForwardRef$3B as Info1, ForwardRef$3A as Info2, ForwardRef$8 as Instagram, ForwardRef$3z as Instrument, ForwardRef$3y as IrisId, ForwardRef$3x as JpgGifPng, ForwardRef$3w as KeepSilent, ForwardRef$3v as Key, ForwardRef$3u as Kidney, ForwardRef$3t as Laptop, ForwardRef$3s as Leaf, ForwardRef$3r as LeavingAnInheritance, ForwardRef$3q as Left, ForwardRef$3p as LeftFill, ForwardRef$3o as Library, ForwardRef$3n as Like, ForwardRef$3m as Link, ForwardRef$7 as Linkedin, ForwardRef$3l as List, ForwardRef$3k as Live, ForwardRef$3j as Location, ForwardRef$3i as Lock, ForwardRef$3h as Login1, ForwardRef$3g as Login2, ForwardRef$3f as Love, ForwardRef$3e as Lung, ForwardRef$3d as MaleSymbol, ForwardRef$3c as MaleToilet, ForwardRef$3b as Man, ForwardRef$3a as ManWearingGlasses, ForwardRef$39 as ManWithMustache, ForwardRef$38 as MapleLeaf, ForwardRef$37 as MarketingAutomation, ForwardRef$36 as Mask1, ForwardRef$35 as Mask2, ForwardRef$34 as MassageTherapy, ForwardRef$33 as MedicalReport, ForwardRef$32 as Medicine, ForwardRef$31 as MeetingRoom, ForwardRef$30 as Megaphone, ForwardRef$2$ as MentalHealth, ForwardRef$2_ as Meter, ForwardRef$2Z as Microphone, ForwardRef$2Y as Minus, ForwardRef$2X as Mobile, ForwardRef$2W as MobileLaptop, ForwardRef$2V as MoneyBag, ForwardRef$7c as MoreOptions, ForwardRef$2U as Mouse, ForwardRef$2T as MovMp4, ForwardRef$6 as Move, ForwardRef$2S as Mp3, ForwardRef$2R as Music, ForwardRef$2Q as NeutralEmoji, ForwardRef$2P as Night, ForwardRef$2O as NoSmoking, ForwardRef$2N as NonGuaranteed, ForwardRef$2M as Notification, ForwardRef$2L as NursingRoom, ForwardRef$2K as OfficeBuilding, ForwardRef$2J as OutPatient, ForwardRef$2I as PalmTree, ForwardRef$2H as Pantry, ForwardRef$2G as Paper, ForwardRef$2F as Parking1, ForwardRef$2E as PartlySunny, ForwardRef$2D as Passport, ForwardRef$2C as Path, ForwardRef$2B as Pause, ForwardRef$2A as Pause2, ForwardRef$2z as PayOrder, ForwardRef$2y as PayTime, ForwardRef$2x as Payment, ForwardRef$2w as PaymentDone, ForwardRef$2v as People, ForwardRef$2u as PeopleBehindDoor, ForwardRef$2t as PeopleElder, ForwardRef$2s as Percentage, ForwardRef$2r as Person, ForwardRef$2q as PharmacyDelivery, ForwardRef$2p as Phone, ForwardRef$2o as PieChart, ForwardRef$2n as PiggyBank, ForwardRef$2m as Pill, ForwardRef$2l as Pin, ForwardRef$7b as PinFilled, ForwardRef$2k as Pipeline, ForwardRef$2j as PlanDesign, ForwardRef$2i as Plastic, ForwardRef$2h as Plate, ForwardRef$2g as PlateSpoon, ForwardRef$2f as Play1, ForwardRef$2e as Play2, ForwardRef$2d as Plus, ForwardRef$2c as PortfolioOptimization, ForwardRef$2b as PowerLineTower, ForwardRef$2a as PptWordPdf, ForwardRef$29 as PreferentialPremiumRates, ForwardRef$28 as PremiumDiscounts, ForwardRef$27 as PrescriptionBeingOpened, ForwardRef$26 as PriceMeter, ForwardRef$25 as Print, ForwardRef$24 as Product, ForwardRef$23 as Promo, ForwardRef$22 as Puzzle, ForwardRef$21 as QualifyContacts, ForwardRef$20 as Question, ForwardRef$1$ as RadioButtonChecked, ForwardRef$1_ as RadioButtonCircle, ForwardRef$1Z as RadioButtonUnchecked, ForwardRef$1Y as Rain, ForwardRef$1X as Received, ForwardRef$1W as Reception, ForwardRef$1V as Reimbursement, ForwardRef$1U as Reload, ForwardRef$1T as RemoveFile, ForwardRef$1S as Restaurant, ForwardRef$1R as Retail, ForwardRef$1Q as Retirement, ForwardRef$1P as Right, ForwardRef$1O as RightFill, ForwardRef$1N as Risk, ForwardRef$1M as Road, ForwardRef$1L as Robot, ForwardRef$1K as RocketShip, ForwardRef$1J as RockingHorse, ForwardRef$1I as RollOverFunds, ForwardRef$1H as RollOverPlan, ForwardRef$1G as RoosterBank, ForwardRef$1F as Ruler, ForwardRef$1E as Sad, ForwardRef$1D as Safe, ForwardRef$1C as Save1, ForwardRef$1B as Save2, ForwardRef$1A as SaveFile, ForwardRef$1z as Scale, ForwardRef$1y as ScheduleView, ForwardRef$1x as Scissors, ForwardRef$1w as Search, ForwardRef$1v as Share, ForwardRef$1u as ShoppingCart, ForwardRef$1t as Shower, ForwardRef$1s as SkippingRope, ForwardRef$5 as Skype, ForwardRef$1r as Sleep, ForwardRef$1q as SlipperyFloor, ForwardRef$1p as Smoking, ForwardRef$1o as Snow, ForwardRef$1n as Solutions, ForwardRef$1m as Sort, ForwardRef$1l as SoundHigh, ForwardRef$1k as SoundLow, ForwardRef$1j as SoundMedium, ForwardRef$1i as SpeechBubbles, ForwardRef$1h as SpellCheck, ForwardRef$1g as Sports, ForwardRef$1f as Spotlight, ForwardRef$1e as SprinklerSystem, ForwardRef$1d as Stage, ForwardRef$1c as StairsUp, ForwardRef$1b as Star, ForwardRef$7a as StarBorder, ForwardRef$79 as StarFilled, ForwardRef$78 as StarHalf, ForwardRef$1a as Statement, ForwardRef$19 as Stephoscope, ForwardRef$18 as Storage, ForwardRef$17 as Sunny, ForwardRef$16 as Surprised, ForwardRef$15 as SwimmingPool, ForwardRef$14 as Switch, ForwardRef$13 as Syringe, ForwardRef$12 as Table, ForwardRef$11 as Tablet, ForwardRef$10 as Talking, ForwardRef$$ as Target, ForwardRef$_ as Teeth, ForwardRef$Z as Tennis, ForwardRef$Y as Theatre, ForwardRef$X as Thermometer, ForwardRef$W as ThrowRubbish, ForwardRef$V as Thunderstorm, ForwardRef$U as Timeline, ForwardRef$T as Toilets, ForwardRef$S as Tombstone, ForwardRef$R as Tool, ForwardRef$Q as Tool2, ForwardRef$P as Top, ForwardRef$O as TopLeft, ForwardRef$N as TopRight, ForwardRef$M as Touch, ForwardRef$L as Tractor, ForwardRef$K as Train, ForwardRef$J as Training, ForwardRef$I as Tram, ForwardRef$H as TransferOfExistingAssets, ForwardRef$G as TransparentInCost, ForwardRef$F as Tree, ForwardRef$E as Trophy, ForwardRef$D as Tshirt, ForwardRef$C as TurnOff, ForwardRef$4 as Twitter, ForwardRef$B as UnionIndustrial, ForwardRef$A as Unlock, ForwardRef$z as Up, ForwardRef$y as UpdateRecycle, ForwardRef$x as Upload, ForwardRef$w as VeryHappy, ForwardRef$v as VerySad, ForwardRef$u as VoiceId, ForwardRef$t as Voltage, ForwardRef$s as Wallet, ForwardRef$r as Warning, ForwardRef$q as Watch, ForwardRef$p as Waves, ForwardRef$o as Webcast, ForwardRef$3 as Wechat, ForwardRef$n as Wheelchair, ForwardRef$m as Wifi, ForwardRef$l as Will, ForwardRef$k as WindTurbine, ForwardRef$j as Windy, ForwardRef$i as WineGlasses, ForwardRef$h as Woman, ForwardRef$g as WomanWithGlasses, ForwardRef$f as Work, ForwardRef$e as Write, ForwardRef$2 as Yammer, ForwardRef$d as Yearly, ForwardRef$1 as Youtube, ForwardRef$c as Yoyo, ForwardRef as Zalo, ForwardRef$b as ZoomIn, ForwardRef$a as ZoomOut };
